/* eslint-disable max-lines */
import { SpaceObjectType } from '@ootk/src/main';
import { ControlSite } from '../catalog-manager/ControlSite';

export interface ControlSiteParams {
  Code: string;
  // UCode: string;
  StateC: string;
  C: string;
  TStart: string;
  TStop: string;
  // ShortName: string;
  Location: string;
  // Error: string;
  Parent: string;
  /*
   * ShortEName: string;
   * EName: string;
   * UName: string;
   */
  name: string;
  type: SpaceObjectType;
  typeExt?: string;
  lat: number;
  lon: number;
  alt: number;
  linkAehf?: boolean;
  linkWgs?: boolean;
  linkGPS?: boolean;
  linkGalileo?: boolean;
  linkBeidou?: boolean;
  linkGlonass?: boolean;
  linkIridium?: boolean;
  linkStarlink?: boolean;
}

export const controlSites = <ControlSite[]>[
  new ControlSite({
    Code: 'AAT',
    StateC: 'AAT',
    C: 'Government',
    TStart: '1841',
    TStop: '',
    name: 'Australian Antarctic Territory',
    Location: 'Davis Staton, Princess Elizabeth Land',
    lat: -68.58,
    lon: 77.97,
    alt: 0,
    Parent: 'AU',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADG',
    StateC: 'RU',
    C: 'Government',
    TStart: '1991 Jan',
    TStop: '',
    name: 'Respublika Adygeya',
    Location: 'Maykop',
    lat: 44.6,
    lon: 40.08,
    alt: 0,
    Parent: 'RU',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AF',
    StateC: 'AF',
    C: 'Government',
    TStart: '2004',
    TStop: '',
    name: 'Da Afganistan Islami Jomhoriyat',
    Location: 'Kabul',
    lat: 34.53,
    lon: 69.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AG',
    StateC: 'AG',
    C: 'Government',
    TStart: '1981',
    TStop: '',
    name: 'Antigua and Barbuda',
    Location: 'St John\'s',
    lat: 17.12,
    lon: -61.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AG',
    StateC: 'AGUK',
    C: 'Government',
    TStart: '1832',
    TStop: '1981',
    name: 'Antigua colony',
    Location: 'St John\'s',
    lat: 17.12,
    lon: -61.85,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AM',
    StateC: 'AM',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Hayastani Hanrapetut\'yun',
    Location: 'Erevan',
    lat: 40.18,
    lon: 44.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANTN',
    StateC: 'ANTN',
    C: 'Government',
    TStart: '1954',
    TStop: '2010 Oct',
    name: 'Nederlandse Antillen',
    Location: 'Willemstad',
    lat: 12.12,
    lon: -68.93,
    alt: 0,
    Parent: 'NL',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AO',
    StateC: 'AO',
    C: 'Government',
    TStart: '1975',
    TStop: '',
    name: 'Republica de Angola',
    Location: 'Luanda',
    lat: -8.84,
    lon: 13.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AQ',
    StateC: 'AQ',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Antartica',
    Location: 'Amundsen-Scott Station',
    lat: -89.99,
    lon: 139.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AR',
    StateC: 'AR',
    C: 'Government',
    TStart: '1816 Jul 9',
    TStop: '',
    name: 'Republica Argentina',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARV',
    StateC: 'ARV',
    C: 'Government',
    TStart: '1900',
    TStop: '',
    name: 'Provincia de Tierra del Fuego, Antardida e Islas del Atlantico Sur',
    Location: 'Ushuaia, Tierra del Fuego',
    lat: -54.8,
    lon: -68.3,
    alt: 0,
    Parent: 'AR',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AT',
    StateC: 'AT',
    C: 'Government',
    TStart: '1955 Jul 27',
    TStop: '',
    name: 'Republik \\"Osterreich',
    Location: 'Wien',
    lat: 48.2,
    lon: 16.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AU',
    StateC: 'AU',
    C: 'Government',
    TStart: '1901 Jan 1',
    TStop: '',
    name: 'Commonwealth of Australia',
    Location: 'Canberra',
    lat: 35.31,
    lon: 149.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AZ',
    StateC: 'AZ',
    C: 'Government',
    TStart: '1991 Oct',
    TStop: '',
    name: 'Azerbaycan Respublikasi',
    Location: 'Baku',
    lat: 40.4,
    lon: 49.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'B',
    StateC: 'B',
    C: 'Government',
    TStart: '1830 Oct 4',
    TStop: '',
    name: 'Royaume de Belgique (Koninkrijk Belgie)',
    Location: 'Brussel',
    lat: 50.85,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BASH',
    StateC: 'RU',
    C: 'Government',
    TStart: '1919 Mar',
    TStop: '',
    name: 'Respublika Bashkortostan',
    Location: 'Ufa',
    lat: 54.73,
    lon: 55.95,
    alt: 0,
    Parent: 'RU',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAT',
    StateC: 'BAT',
    C: 'Government',
    TStart: '1908',
    TStop: '',
    name: 'British Antarctic Territory',
    Location: 'Rothera',
    lat: -67.57,
    lon: -68.13,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BB',
    StateC: 'BB',
    C: 'Government',
    TStart: '1966',
    TStop: '',
    name: 'Barbados',
    Location: 'Bridgetown',
    lat: 13.11,
    lon: -59.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BB',
    StateC: 'BBUK',
    C: 'Government',
    TStart: '1628',
    TStop: '1966',
    name: 'Barbados, British self governing colony',
    Location: 'Bridgetown',
    lat: 13.11,
    lon: -59.61,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BD',
    StateC: 'BD',
    C: 'Government',
    TStart: '1971',
    TStop: '',
    name: 'Ganaprajatantri Bangladesa',
    Location: 'Dhaka',
    lat: 23.72,
    lon: 90.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BG',
    StateC: 'BG',
    C: 'Government',
    TStart: '1944',
    TStop: '1989',
    name: 'Republika B\'lgariya',
    Location: 'Sofia',
    lat: 42.7,
    lon: 23.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BG',
    StateC: 'BG',
    C: 'Government',
    TStart: '1989',
    TStop: '',
    name: 'Narodna Republika B\'lgariya',
    Location: 'Sofia',
    lat: 42.7,
    lon: 23.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BM',
    StateC: 'BM',
    C: 'Government',
    TStart: '1684',
    TStop: '',
    name: 'UK Overseas Territory of Bermuda',
    Location: 'Hamilton, Bermuda',
    lat: 32.93,
    lon: -64.78,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BO',
    StateC: 'BO',
    C: 'Government',
    TStart: '1825',
    TStop: '',
    name: 'Estado Plurinacional de Bolivia (Bulivya Mamallaqta)',
    Location: 'La Paz',
    lat: -16.5,
    lon: -68.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BR',
    StateC: 'BR',
    C: 'Government',
    TStart: '1822 Sep 7',
    TStop: '',
    name: 'Republica Federativa do Brasil',
    Location: 'Brasilia',
    lat: -15.79,
    lon: -47.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BS',
    StateC: 'BS',
    C: 'Government',
    TStart: '1964',
    TStop: '',
    name: 'Bahamas, Commonwealth of the',
    Location: 'Nassau',
    lat: 25.06,
    lon: -77.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BT',
    StateC: 'BT',
    C: 'Government',
    TStart: '1634',
    TStop: '',
    name: 'Druk Gyal Khap',
    Location: 'Thimphu',
    lat: 27.47,
    lon: 89.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BY',
    StateC: 'BY',
    C: 'Government',
    TStart: '1990 Jul 27',
    TStop: '',
    name: 'Respublika Belarus\'',
    Location: 'Minsk',
    lat: 53.9,
    lon: 27.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CA',
    StateC: 'CA',
    C: 'Government',
    TStart: '1867 Jul 1',
    TStop: '',
    name: 'Canada',
    Location: 'Ottawa, Ontario',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZR',
    StateC: 'ZR',
    C: 'Government',
    TStart: '1997',
    TStop: '',
    name: 'Republique democratique du Congo',
    Location: 'Kinshasa',
    lat: -4.33,
    lon: 15.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CH',
    StateC: 'CH',
    C: 'Government',
    TStart: '1291',
    TStop: '',
    name: 'Confoederatio Helvetica (Confederation suisse/Schweizerische Eidgenossenschaft)',
    Location: 'Bern',
    lat: 46.95,
    lon: 7.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CI',
    StateC: 'CI',
    C: 'Government',
    TStart: '1960 Aug 10',
    TStop: '',
    name: 'Republique de Cote d\'Ivoire',
    Location: 'Yamoussoukro',
    lat: 6.82,
    lon: -5.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CK',
    StateC: 'CK',
    C: 'Government',
    TStart: '1965 Aug 4',
    TStop: '',
    name: 'Cook Islands (Kuki \'Airani)',
    Location: 'Avarua, Rarotonga Island',
    lat: -21.2,
    lon: -159.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CL',
    StateC: 'CL',
    C: 'Government',
    TStart: '1818 Feb 12',
    TStop: '',
    name: 'Republica de Chile',
    Location: 'Santiago',
    lat: -33.45,
    lon: -70.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CM',
    StateC: 'CM',
    C: 'Government',
    TStart: '1960',
    TStop: '',
    name: 'Republique du Cameroun',
    Location: 'Yaounde',
    lat: 3.87,
    lon: 11.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Zhonghua Renmin Gongheguo',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-31',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Shanghai shi',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-AH',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Anhui sheng',
    Location: 'Hefei',
    lat: 31.82,
    lon: 117.23,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-HA',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Henan sheng',
    Location: 'Zhengzhou',
    lat: 34.76,
    lon: 113.68,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-HB',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Hubei sheng',
    Location: 'Wuhan',
    lat: 30.59,
    lon: 114.3,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-HL',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Heliongjiang sheng',
    Location: 'Harbin',
    lat: 45.76,
    lon: 126.64,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-HN',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Hunan sheng',
    Location: 'Changsha',
    lat: 28.23,
    lon: 112.94,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-JL',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Jilin sheng',
    Location: 'Changchun',
    lat: 43.9,
    lon: 125.33,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-JS',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Jiangsu sheng',
    Location: 'Nanjing',
    lat: 32.06,
    lon: 118.76,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-JX',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Jiangxi sheng',
    Location: 'Nanchang',
    lat: 28.68,
    lon: 115.86,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-LN',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Liaoning sheng',
    Location: 'Shenyang',
    lat: 41.8,
    lon: 123.43,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-SC',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Sichuan sheng',
    Location: 'Chengdu',
    lat: 30.66,
    lon: 104.06,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-SD',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Shandong sheng',
    Location: 'Jinan',
    lat: 36.67,
    lon: 117.02,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CN-SX',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '',
    name: 'Shanxi sheng',
    Location: 'Taiyuan',
    lat: 37.87,
    lon: 112.55,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CO',
    StateC: 'CO',
    C: 'Government',
    TStart: '1810 Jul 20',
    TStop: '',
    name: 'Republica de Colombia',
    Location: 'Bogota',
    lat: 4.71,
    lon: -74.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZR',
    StateC: 'ZR',
    C: 'Government',
    TStart: '1965 Nov 24',
    TStop: '1971',
    name: 'Republique du Congo (Leopoldville)',
    Location: 'Leopoldville',
    lat: -4.33,
    lon: 15.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CR',
    StateC: 'CR',
    C: 'Government',
    TStart: '1838',
    TStop: '',
    name: 'Republica de Costa Rica',
    Location: 'San Jose',
    lat: 9.93,
    lon: -84.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CZ',
    StateC: 'CZ',
    C: 'Government',
    TStart: '1990 Jan 1',
    TStop: '1993 Jan 1',
    name: 'Ceska a Slovenska federativni republica',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CZ',
    StateC: 'CZ',
    C: 'Government',
    TStart: '1940 Jan 1',
    TStop: '1990 Jan 1',
    name: 'Ceskoslovenska socialisticka republica',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CU',
    StateC: 'CU',
    C: 'Government',
    TStart: '1959',
    TStop: '*',
    name: 'Republica de Cuba',
    Location: 'Havana',
    lat: 23.13,
    lon: -82.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CYM',
    StateC: 'CYM',
    C: 'Government',
    TStart: '1962',
    TStop: '*',
    name: 'Cayman Islands British Overseas Territory',
    Location: 'Georgetown',
    lat: 19.3,
    lon: -81.39,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CYMRU',
    StateC: 'UK',
    C: 'Government',
    TStart: '1057',
    TStop: '',
    name: 'Cymru',
    Location: 'Caerdydd',
    lat: 51.48,
    lon: -3.18,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CZ',
    StateC: 'CZ',
    C: 'Government',
    TStart: '1993 Jan 1',
    TStop: '*',
    name: 'Ceska Republika',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'D',
    StateC: 'D',
    C: 'Government',
    TStart: '1949 May 23',
    TStop: '*',
    name: 'Bundesrepublik Deutschland',
    Location: 'Bonn, Deutschland (later Berlin)',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DAG',
    StateC: 'RU',
    C: 'Government',
    TStart: '1921',
    TStop: '*',
    name: 'Respublika Dagestan',
    Location: 'Makhachkala',
    lat: 42.97,
    lon: 47.48,
    alt: 0,
    Parent: 'RU',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DD',
    StateC: 'DD',
    C: 'Government',
    TStart: '1949 Oct 1',
    TStop: '1990 Oct 3',
    name: 'Deutsche Demokratische Republik',
    Location: 'Berlin',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DK',
    StateC: 'DK',
    C: 'Government',
    TStart: '700',
    TStop: '',
    name: 'Kongeriget Danmark',
    Location: 'Kobenhavn',
    lat: 55.68,
    lon: 12.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DML',
    StateC: 'DML',
    C: 'Government',
    TStart: '1939 Jan 14',
    TStop: '',
    name: 'Dronning Maud Land',
    Location: 'Troll, Princess Martha Coast',
    lat: -72.01,
    lon: 2.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'D',
    StateC: 'DR',
    C: 'Government',
    TStart: '1933 Feb 27',
    TStop: '1949 May 23',
    name: 'Deutsches Reich',
    Location: 'Berlin',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'D',
    StateC: 'DX',
    C: 'Government',
    TStart: '1945 May 8',
    TStop: '1949 Oct 1',
    name: 'Deutschland (occupied)',
    Location: 'Berlin',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DZ',
    StateC: 'DZ',
    C: 'Government',
    TStart: '1962 Jul 5',
    TStop: '',
    name: 'Al Jumhuriyah al Jaza\'iriyah al Dimuqratiyah ash Sha\'biyah',
    Location: 'Dzayer',
    lat: 36.75,
    lon: 3.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'E',
    StateC: 'E',
    C: 'Government',
    TStart: '1580',
    TStop: '',
    name: 'Reino de Espana',
    Location: 'Madrid',
    lat: 40.38,
    lon: -3.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EC',
    StateC: 'EC',
    C: 'Government',
    TStart: '1830',
    TStop: '',
    name: 'Republica del Ecuador',
    Location: 'Quito',
    lat: -0.23,
    lon: -78.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EE',
    StateC: 'EE',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Eesti Vabariik',
    Location: 'Tallinn',
    lat: 59.44,
    lon: 24.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EG',
    StateC: 'EG',
    C: 'Government',
    TStart: '1922 Feb 22',
    TStop: '',
    name: 'Jumhuriyat Misr al-Arabiyah',
    Location: 'al-Qahira',
    lat: 30.03,
    lon: 31.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ENG',
    StateC: 'UK',
    C: 'Government',
    TStart: '927 Jul 12',
    TStop: '',
    name: 'England',
    Location: 'London',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESCN',
    StateC: 'ESCN',
    C: 'Government',
    TStart: '1479',
    TStop: '',
    name: 'Islas Canarias',
    Location: 'Santa Cruz de Tenerife',
    lat: 28.47,
    lon: -16.25,
    alt: 0,
    Parent: 'E',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ET',
    StateC: 'ET',
    C: 'Government',
    TStart: '1941',
    TStop: '',
    name: 'ye Itiyoppya Federalawi Demokirasiyawi Ripebilik',
    Location: 'Addis Ababa',
    lat: 9.02,
    lon: 38.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'F',
    StateC: 'F',
    C: 'Government',
    TStart: '509',
    TStop: '',
    name: 'Republique Francaise',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FI',
    StateC: 'FI',
    C: 'Government',
    TStart: '1917 Dec 6',
    TStop: '',
    name: 'Suomen tasavalta',
    Location: 'Helsinki',
    lat: 60.17,
    lon: 24.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GE',
    StateC: 'GE',
    C: 'Government',
    TStart: '1991 Dec 25',
    TStop: '',
    name: 'Sakartvelo',
    Location: 'Tbilist',
    lat: 41.72,
    lon: 44.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GH',
    StateC: 'GH',
    C: 'Government',
    TStart: '1957 Mar',
    TStop: '',
    name: 'Republic of Ghana',
    Location: 'Accra',
    lat: 5.55,
    lon: -0.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GI',
    StateC: 'GI',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Gibraltar',
    Location: 'Gibraltar',
    lat: 36.13,
    lon: -5.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GL',
    StateC: 'GL',
    C: 'Government',
    TStart: '1979',
    TStop: '',
    name: 'Kalaallit Nunaat (Gronland)',
    Location: 'Nuuk (Godthab)',
    lat: 64.18,
    lon: -51.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GR',
    StateC: 'GR',
    C: 'Government',
    TStart: '1821 Mar',
    TStop: '',
    name: 'Helliniki Dhimokratia',
    Location: 'Athenai',
    lat: 37.98,
    lon: 23.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GT',
    StateC: 'GT',
    C: 'Government',
    TStart: '1821',
    TStop: '',
    name: 'Republica de Guatemala',
    Location: 'Nueva Guatemala de la Asuncion',
    lat: 14.6133,
    lon: -90.5353,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GU',
    StateC: 'GU',
    C: 'Government',
    TStart: '1898',
    TStop: '',
    name: 'Guahan (Guam)',
    Location: 'Hagatna, Guam',
    lat: 13.48,
    lon: 144.75,
    alt: 0,
    Parent: 'US',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUF',
    StateC: 'GUF',
    C: 'Government',
    TStart: '1763',
    TStop: '',
    name: 'Guyane (DOM)',
    Location: 'Cayenne',
    lat: 4.94,
    lon: -52.33,
    alt: 0,
    Parent: 'F',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HK',
    StateC: 'HK',
    C: 'Government',
    TStart: '1997 Jul 1',
    TStop: '',
    name: 'Xianggang Tebie Xingzhengqu',
    Location: 'Xianggang',
    lat: 22.3,
    lon: 114.2,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HK',
    StateC: 'HK',
    C: 'Government',
    TStart: '1842 Aug 29',
    TStop: '1997 Jul 1',
    name: 'Hong Kong Crown Colony',
    Location: 'Xianggang',
    lat: 22.3,
    lon: 114.2,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HU',
    StateC: 'HU',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Magyar Koztarsasag',
    Location: 'Budapest',
    lat: 47.49,
    lon: 19.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I',
    StateC: 'I',
    C: 'Government',
    TStart: '1861 Mar 17',
    TStop: '',
    name: 'Repubblica Italiana',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-ARAB',
    StateC: 'I-ARAB',
    C: 'Government',
    TStart: '1976',
    TStop: '',
    name: 'Arabsat, Arab League',
    Location: 'Riyadh, Saudi Arabia',
    lat: 24.63,
    lon: 46.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-CSC',
    StateC: 'I-CSC',
    C: 'Government',
    TStart: '1988 Jul',
    TStop: '',
    name: 'COSPAS-SARSAT Council',
    Location: 'Montreal, Quebec',
    lat: 45.51,
    lon: -73.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-CSC',
    StateC: 'I-CSC1',
    C: 'Government',
    TStart: '1979',
    TStop: '1988 Jul',
    name: 'COSPAS-SARSAT interim Memo of Understanding',
    Location: 'Montreal, Quebec',
    lat: 45.51,
    lon: -73.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-ELDO',
    StateC: 'I-ELDO',
    C: 'Government',
    TStart: '1964',
    TStop: '1975 Apr 30',
    name: 'Conseil Europeen Construction de Lanceurs d\'Engins Spatiaux',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-ESRO',
    StateC: 'I-ESA',
    C: 'Government',
    TStart: '1975 Apr 30',
    TStop: '*',
    name: 'European Space Agency',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-ESRO',
    StateC: 'I-ESRO',
    C: 'Government',
    TStart: '1964',
    TStop: '1975 Apr 30',
    name: 'Conseil Europeen de Recherches Spatiales',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-EUM',
    StateC: 'I-EUM',
    C: 'Government',
    TStart: '1983',
    TStop: '',
    name: 'European Meteorological Satellite Organization',
    Location: 'Darmstadt',
    lat: 49.87,
    lon: 8.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-EU',
    StateC: 'I-EU',
    C: 'Government',
    TStart: '1993 Nov 1',
    TStop: '',
    name: 'European Union',
    Location: 'Bruxelles',
    lat: 50.85,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-EUT',
    StateC: 'I-EUT',
    C: 'Government',
    TStart: '1985',
    TStop: '2001 Jul 2',
    name: 'European Telecommunications Satellite Organization',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-INM',
    StateC: 'I-INM',
    C: 'Government',
    TStart: '1979',
    TStop: '1999 Apr 1',
    name: 'International Maritime Satellite Organization',
    Location: 'London',
    lat: 51.54,
    lon: -0.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-INT',
    StateC: 'I-INT',
    C: 'Government',
    TStart: '1964',
    TStop: '2001 Jul 1',
    name: 'International Telecommunications Satellite Organization',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-ISS',
    StateC: 'I-ISS',
    C: 'Government',
    TStart: '1988',
    TStop: '',
    name: 'ISS International Partnership',
    Location: 'International Space Station c/o NASA HQ',
    lat: 38.9,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-NATO',
    StateC: 'I-NATO',
    C: 'Military',
    TStart: '1949',
    TStop: '',
    name: 'North Atlantic Treaty Organization',
    Location: 'Brussels',
    lat: 50.85,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'I-RASC',
    StateC: 'I-RASC',
    C: 'Government',
    TStart: '1993',
    TStop: '',
    name: 'Regional African Satellite Comms. Organization',
    Location: 'Abidjan, Cote d\'Ivoire',
    lat: 5.32,
    lon: -4.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ID',
    StateC: 'ID',
    C: 'Government',
    TStart: '1945 Aug 17',
    TStop: '',
    name: 'Republik Indonesia',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IE',
    StateC: 'IE',
    C: 'Government',
    TStart: '1922',
    TStop: '',
    name: 'Republic of Ireland (Poblacht na hEireann)',
    Location: 'Dublin (Baile Atha Cliath)',
    lat: 53.35,
    lon: -6.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IL',
    StateC: 'IL',
    C: 'Government',
    TStart: '1948 May 14',
    TStop: '',
    name: 'Medinat Yisra\'el',
    Location: 'Tel Aviv, Yisra\'el',
    lat: 32.07,
    lon: 34.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IN',
    StateC: 'IN',
    C: 'Government',
    TStart: '1947 Aug 15',
    TStop: '',
    name: 'Republic of India',
    Location: 'New Delhi',
    lat: 28.61,
    lon: 77.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IN-AP',
    StateC: 'IN',
    C: 'Government',
    TStart: '1953 Oct 1',
    TStop: '',
    name: 'Andhra Pradesh',
    Location: 'Amaravati',
    lat: 16.54,
    lon: 80.52,
    alt: 0,
    Parent: 'IN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IN-HR',
    StateC: 'IN',
    C: 'Government',
    TStart: '1956 Nov 1',
    TStop: '',
    name: 'Haryana',
    Location: 'Chandigarh',
    lat: 30.75,
    lon: 76.78,
    alt: 0,
    Parent: 'IN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IN-KA',
    StateC: 'IN',
    C: 'Government',
    TStart: '1973',
    TStop: '',
    name: 'Karnataka',
    Location: 'Bengaluru',
    lat: 12.98,
    lon: 77.59,
    alt: 0,
    Parent: 'IN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IN-KL',
    StateC: 'IN',
    C: 'Government',
    TStart: '1956 Nov 1',
    TStop: '',
    name: 'Kerala',
    Location: 'Thiruvananthapuram',
    lat: 8.49,
    lon: 76.95,
    alt: 0,
    Parent: 'IN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IN-PB',
    StateC: 'IN',
    C: 'Government',
    TStart: '1956 Nov 1',
    TStop: '',
    name: 'Punjab',
    Location: 'Chandigarh',
    lat: 30.75,
    lon: 76.78,
    alt: 0,
    Parent: 'IN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IQ',
    StateC: 'IQ',
    C: 'Government',
    TStart: '1919 Oct 1',
    TStop: '',
    name: 'Al Jumhuriya al Iraqiyah',
    Location: 'Baghdad',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IR',
    StateC: 'IR',
    C: 'Government',
    TStart: '1501',
    TStop: '',
    name: 'Jomhuri-ye Eslami-ye Iran',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IS',
    StateC: 'IS',
    C: 'Government',
    TStart: '930',
    TStop: '',
    name: 'Island',
    Location: 'Reykjavik',
    lat: 64.13,
    lon: -21.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'J',
    StateC: 'J',
    C: 'Government',
    TStart: '538',
    TStop: '',
    name: 'Nippon-koku',
    Location: 'Tokyo-to, Honshu, Nippon',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JO',
    StateC: 'JO',
    C: 'Government',
    TStart: '1946',
    TStop: '',
    name: 'Al-Mamlakah Al-Urdunniyah Al-Hashimiyah',
    Location: 'Amman',
    lat: 31.95,
    lon: 35.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KE',
    StateC: 'KE',
    C: 'Government',
    TStart: '1963 Dec 12',
    TStop: '',
    name: 'Jamhuri ya Kenya',
    Location: 'Nairobi',
    lat: -1.28,
    lon: 36.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KI',
    StateC: 'KI',
    C: 'Government',
    TStart: '1979',
    TStop: '',
    name: 'Kiribati',
    Location: 'South Tarawa, Tarawa Atoll',
    lat: 1.43,
    lon: 173,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KG',
    StateC: 'KG',
    C: 'Government',
    TStart: '1991 Aug',
    TStop: '',
    name: 'Kyrgyz Respublikasy',
    Location: 'Bishek',
    lat: 42.87,
    lon: 74.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KG',
    StateC: 'KG',
    C: 'Government',
    TStart: '1936',
    TStop: '1991 Aug',
    name: 'Kyrgyz Sovettik Sotsialisttik Respublikasy',
    Location: 'Frunze',
    lat: 42.87,
    lon: 74.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KH',
    StateC: 'KH',
    C: 'Government',
    TStart: '1993',
    TStop: '',
    name: 'Preah Reacheanachak Kampuchea',
    Location: 'Phnom Penh',
    lat: 11.55,
    lon: 104.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KORS',
    StateC: 'KORS',
    C: 'Government',
    TStart: '2010 Oct',
    TStop: '',
    name: 'Korsou (Curacao), Nederlandse autonomous country',
    Location: 'Willemstad',
    lat: 12.12,
    lon: -68.93,
    alt: 0,
    Parent: 'NL',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KORS',
    StateC: 'KORS',
    C: 'Government',
    TStart: '1954',
    TStop: '2010 Oct',
    name: 'Curacao, terr. in Nderlandse Antillen',
    Location: 'Willemstad',
    lat: 12.12,
    lon: -68.93,
    alt: 0,
    Parent: 'ANTN',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KP',
    StateC: 'KP',
    C: 'Government',
    TStart: '1948 Sep 9',
    TStop: '',
    name: 'Choson Minjujuui Inmin Konghwaguk',
    Location: 'Pyongyang',
    lat: 39.02,
    lon: 125.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KR',
    StateC: 'KR',
    C: 'Government',
    TStart: '1948 Aug 15',
    TStop: '',
    name: 'Daehan Min\'guk',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KW',
    StateC: 'KW',
    C: 'Government',
    TStart: '1752',
    TStop: '',
    name: 'Dawlat al-Kuwayt',
    Location: 'Kuwait City',
    lat: 29.37,
    lon: 47.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KZ',
    StateC: 'KZ',
    C: 'Government',
    TStart: '1991 Dec 16',
    TStop: '',
    name: 'Qazaqstan Respublikasy',
    Location: 'Astana',
    lat: 51.17,
    lon: 71.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'L',
    StateC: 'L',
    C: 'Government',
    TStart: '963',
    TStop: '',
    name: 'Grand Duche de Luxembourg',
    Location: 'Luxembourg',
    lat: 49.61,
    lon: 6.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LA',
    StateC: 'LA',
    C: 'Government',
    TStart: '1953',
    TStop: '',
    name: 'Sathalanalat Paxathipatai Paxaxon Lao',
    Location: 'Vientiane',
    lat: 17.97,
    lon: 102.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LB',
    StateC: 'LB',
    C: 'Government',
    TStart: '1943',
    TStop: '',
    name: 'Republique libanaise (al-Jumhuriyah al-Lubnaniyah)',
    Location: 'Beirut',
    lat: 33.89,
    lon: 35.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LK',
    StateC: 'LK',
    C: 'Government',
    TStart: '1972',
    TStop: '',
    name: 'Shri Lanka Prajatantrika Samajavadi Janarajaya',
    Location: 'Colombo/Sri Jayawardenapura Kotte',
    lat: 6.93,
    lon: -79.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LT',
    StateC: 'LT',
    C: 'Government',
    TStart: '1990 Mar 11',
    TStop: '',
    name: 'Lietuvos Respublika',
    Location: 'Vilnius',
    lat: 54.68,
    lon: 25.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LV',
    StateC: 'LV',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Latvijas Republika',
    Location: 'Riga',
    lat: 56.94,
    lon: 24.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LY',
    StateC: 'LY',
    C: 'Government',
    TStart: '1951 Dec 24',
    TStop: '',
    name: 'Al-Jamahiriyyah al-Arabiyyah al-Libiyyah as-Sab. al-Is. al-Uzma',
    Location: 'Tarabulus/Tripoli',
    lat: 32.89,
    lon: 13.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MA',
    StateC: 'MA',
    C: 'Government',
    TStart: '1956 Mar 2',
    TStop: '',
    name: 'Al Mamlakah al Maghribiyah',
    Location: 'Al-Ribat',
    lat: 34.02,
    lon: -6.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MC',
    StateC: 'MC',
    C: 'Government',
    TStart: '1297',
    TStop: '',
    name: 'Principaute de Monaco',
    Location: 'Monaco',
    lat: 43.73,
    lon: 7.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MD',
    StateC: 'MD',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Republica Moldova',
    Location: 'Chisinau',
    lat: 47.02,
    lon: 28.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MH',
    StateC: 'MH',
    C: 'Government',
    TStart: '1979',
    TStop: '',
    name: 'Republic of the Marshall Islands',
    Location: 'Majuro, Marshall Is.',
    lat: 7.08,
    lon: 171.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MN',
    StateC: 'MN',
    C: 'Government',
    TStart: '1911',
    TStop: '',
    name: 'Mongol uls',
    Location: 'Ulaanbaatar',
    lat: 47.92,
    lon: 106.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MR',
    StateC: 'MR',
    C: 'Government',
    TStart: '1960 Nov 28',
    TStop: '',
    name: 'Al-Jumhuriyyah al-Islamiyyah al-Muritaniyyah (Gannaar)',
    Location: 'Nouakchott',
    lat: 18.1,
    lon: -15.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MU',
    StateC: 'MU',
    C: 'Government',
    TStart: '1968 Mar 12',
    TStop: '',
    name: 'Republique de Maurice',
    Location: 'Port Louis, Maurice',
    lat: -20.16,
    lon: 57.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MV',
    StateC: 'MV',
    C: 'Government',
    TStart: '1965 Jul 26',
    TStop: '',
    name: 'Divehi Rajjey ge Jumhuriyya',
    Location: 'Male, Male Island',
    lat: 4.18,
    lon: 73.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MX',
    StateC: 'MX',
    C: 'Government',
    TStart: '1819 Sep 16',
    TStop: '',
    name: 'Estados Unidos Mexicanos',
    Location: 'Ciudad de Mexico',
    lat: 19.43,
    lon: -99.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MY',
    StateC: 'MY',
    C: 'Government',
    TStart: '1957 Aug 31',
    TStop: '',
    name: 'Malaysia',
    Location: 'Kuala Lumpur',
    lat: 3.13,
    lon: 101.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MYM',
    StateC: 'MYM',
    C: 'Government',
    TStart: '1989',
    TStop: '',
    name: 'Pyidaunzu Thanmada Myama Nainngandaw',
    Location: 'Naypyidaw',
    lat: 19.75,
    lon: 96.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'N',
    StateC: 'N',
    C: 'Government',
    TStart: '872',
    TStop: '',
    name: 'Kongeriket Norge',
    Location: 'Oslo, Norge',
    lat: 59.92,
    lon: 10.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NG',
    StateC: 'NG',
    C: 'Government',
    TStart: '1960 Oct 1',
    TStop: '',
    name: 'Federal Republic of Nigeria',
    Location: 'Abuja, Federal Capital Territory',
    lat: 9.07,
    lon: 7.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NL',
    StateC: 'NL',
    C: 'Government',
    TStart: '1581 Jul 26',
    TStop: '',
    name: 'Koninkrijk der Nederlanden',
    Location: 'Amsterdam, Nederland',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NP',
    StateC: 'NP',
    C: 'Government',
    TStart: '2008',
    TStop: '',
    name: 'Sanghiya Lokatantrik Ganatantra Nepal',
    Location: 'Kathmandu',
    lat: 27.7,
    lon: 85.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NZ',
    StateC: 'NZ',
    C: 'Government',
    TStart: '1907 Sep 26',
    TStop: '',
    name: 'New Zealand',
    Location: 'Wellingon, North Island, New Zealand',
    lat: -41.29,
    lon: 174.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NZRD',
    StateC: 'NZRD',
    C: 'Government',
    TStart: '1841',
    TStop: '',
    name: 'Ross Dependency, New Zealand Antarctic Territory',
    Location: 'Scott Base',
    lat: -77.85,
    lon: 166.77,
    alt: 0,
    Parent: 'NZ',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'P',
    StateC: 'P',
    C: 'Government',
    TStart: '1139 Jul 25',
    TStop: '',
    name: 'Republica Portuguesa',
    Location: 'Lisboa, Portugal',
    lat: 38.71,
    lon: -9.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PAR',
    StateC: 'PAR',
    C: 'Government',
    TStart: '1903',
    TStop: '',
    name: 'Republica de Panama',
    Location: 'Panama, Panama province',
    lat: 8.98,
    lon: -79.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PCZ',
    StateC: 'PCZ',
    C: 'Government',
    TStart: '1903',
    TStop: '1979',
    name: 'Panama Canal Zone, US territory',
    Location: 'Balboa',
    lat: 8.95,
    lon: -79.57,
    alt: 0,
    Parent: 'US',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PE',
    StateC: 'PE',
    C: 'Government',
    TStart: '1821',
    TStop: '',
    name: 'Republica del Peru (Piruw Republika)',
    Location: 'Lima',
    lat: -12.04,
    lon: -77.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PG',
    StateC: 'PG',
    C: 'Government',
    TStart: '1949',
    TStop: '',
    name: 'Independen Stet bilong Papua Niugini',
    Location: 'Port Moresby',
    lat: -9.48,
    lon: 147.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PK',
    StateC: 'PK',
    C: 'Government',
    TStart: '1947 Aug 14',
    TStop: '',
    name: 'Islami Jamhuriya-i-Pakistan',
    Location: 'Islamabad, Pakistan',
    lat: 33.72,
    lon: 73.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PH',
    StateC: 'PH',
    C: 'Government',
    TStart: '1521 Mar 16',
    TStop: '',
    name: 'Republika ng Pilipinas',
    Location: 'Lungsod ng Maynila, Pilipinas',
    lat: 14.58,
    lon: 121,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PL',
    StateC: 'PL',
    C: 'Government',
    TStart: '1989 Jan 1',
    TStop: '*',
    name: 'Rzeczpospolita Polska',
    Location: 'Warszawa, Polska',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PL',
    StateC: 'PL',
    C: 'Government',
    TStart: '1952 Jan 1',
    TStop: '1989 Jan 1',
    name: 'Polska Rzeczpospolita Ludowa',
    Location: 'Warszawa, Polska',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PR',
    StateC: 'PR',
    C: 'Government',
    TStart: '1898',
    TStop: '',
    name: 'Estado Libre Asociado de Puerto Rico',
    Location: 'San Juan',
    lat: 18.4,
    lon: -66.06,
    alt: 0,
    Parent: 'US',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PT',
    StateC: 'PT',
    C: 'Government',
    TStart: '868',
    TStop: '',
    name: 'Republica Portuguesa',
    Location: 'Lisboa',
    lat: 38.71,
    lon: -9.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PY',
    StateC: 'PY',
    C: 'Government',
    TStart: '1811',
    TStop: '',
    name: 'Republica del Paraguay',
    Location: 'Asuncion',
    lat: -25.27,
    lon: -57.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QA',
    StateC: 'QA',
    C: 'Government',
    TStart: '1878',
    TStop: '',
    name: 'Dawlat Qatar',
    Location: 'Doha, Qatar',
    lat: 25.29,
    lon: 51.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RO',
    StateC: 'RO',
    C: 'Government',
    TStart: '1859',
    TStop: '',
    name: 'Romania',
    Location: 'Bucuresti',
    lat: 44.43,
    lon: 26.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SU',
    StateC: 'RU',
    C: 'Government',
    TStart: '1991 Dec 26',
    TStop: '',
    name: 'Rossiyskaya Federatsiya',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RW',
    StateC: 'RW',
    C: 'Government',
    TStart: '1962',
    TStop: '',
    name: 'Repubulika y\'u Rwanda',
    Location: 'Kigali',
    lat: -1.94,
    lon: 30.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'S',
    StateC: 'S',
    C: 'Government',
    TStart: '970',
    TStop: '',
    name: 'Konungariket Sverige',
    Location: 'Stockholms stad, Sverige',
    lat: 59.33,
    lon: 18.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SA',
    StateC: 'SA',
    C: 'Government',
    TStart: '1926 Jan 8',
    TStop: '',
    name: 'Al Mamlakah al Arabiyah as Suudiyah',
    Location: 'ar-Riyad, Al Arabiyah',
    lat: 24.63,
    lon: 46.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCOT',
    StateC: 'UK',
    C: 'Government',
    TStart: '843',
    TStop: '',
    name: 'Scotland',
    Location: 'Edinburgh',
    lat: 55.95,
    lon: -3.19,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SD',
    StateC: 'SD',
    C: 'Government',
    TStart: '1956',
    TStop: '',
    name: 'Jumhuriyyat as-Sudan',
    Location: 'Khartoum',
    lat: 32.53,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SG',
    StateC: 'SG',
    C: 'Government',
    TStart: '1959 Jun 3',
    TStop: '',
    name: 'Republic of Singapore (Republik Singapura)',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SH',
    StateC: 'SH',
    C: 'Government',
    TStart: '1834',
    TStop: '',
    name: 'St Helena, British colony/overseas territory',
    Location: 'St Helena',
    lat: -15.95,
    lon: -5.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SI',
    StateC: 'SI',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Republika Slovenija',
    Location: 'Ljubljana',
    lat: 46.05,
    lon: 14.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SK',
    StateC: 'SK',
    C: 'Government',
    TStart: '1993 Jan',
    TStop: '',
    name: 'Slovenska republika',
    Location: 'Bratislava',
    lat: 48.14,
    lon: 17.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SR',
    StateC: 'SR',
    C: 'Government',
    TStart: '1975',
    TStop: '',
    name: 'Republiek Suriname',
    Location: 'Paramaribo',
    lat: 5.85,
    lon: -55.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SU',
    StateC: 'SU',
    C: 'Government',
    TStart: '1922 Dec 30',
    TStop: '1991 Dec 26',
    name: 'Soyuz Sovetskikh Sotsialisticheskikh Respublik',
    Location: 'Moskva, RSFSR, SSSR',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SY',
    StateC: 'SY',
    C: 'Government',
    TStart: '1944 Jan 1',
    TStop: '',
    name: 'Al-Jumhuriyyah al-\'Arabiyyah as-Suriyyah',
    Location: 'Dimashq, Suriya',
    lat: 33.51,
    lon: 36.29,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'T',
    StateC: 'T',
    C: 'Government',
    TStart: '1238',
    TStop: '',
    name: 'Ratcha Anachak Thai',
    Location: 'Bangkok, Prathet Thai',
    lat: 13.75,
    lon: 100.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TC',
    StateC: 'TC',
    C: 'Government',
    TStart: '1799',
    TStop: '',
    name: 'Turks and Caicos Islands, British Overseas Territory',
    Location: 'Cockburn Town, Grand Turk Island',
    lat: 21.46,
    lon: -71.14,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TF',
    StateC: 'TF',
    C: 'Government',
    TStart: '1955',
    TStop: '',
    name: 'Territoire des Terres australes et antarctiques francaises',
    Location: 'Port-aux-francais, Kerguelen',
    lat: -49.35,
    lon: 70.22,
    alt: 0,
    Parent: 'F',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TJ',
    StateC: 'TJ',
    C: 'Government',
    TStart: '1991 Dec',
    TStop: '',
    name: 'Jumhurii Tojikiston',
    Location: 'Dushanbe',
    lat: 38.54,
    lon: 68.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TM',
    StateC: 'TM',
    C: 'Government',
    TStart: '1991 Dec',
    TStop: '',
    name: 'Turkmenistan',
    Location: 'Ashgabat',
    lat: 37.93,
    lon: 58.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TN',
    StateC: 'TN',
    C: 'Government',
    TStart: '2014',
    TStop: '',
    name: 'al-Jumhuriyah at-Tunisiyah',
    Location: 'Tunis',
    lat: 36.81,
    lon: 10.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TO',
    StateC: 'TO',
    C: 'Government',
    TStart: '1970',
    TStop: '',
    name: 'Pule\'anga Fakatu\'i \'o Tonga',
    Location: 'Nuku\'alofa',
    lat: -21.13,
    lon: -175.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TR',
    StateC: 'TR',
    C: 'Government',
    TStart: '1919 May 19',
    TStop: '',
    name: 'Turkiye Cumhuriyeti',
    Location: 'Ankara, Turkiye',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MH',
    StateC: 'TTPI',
    C: 'Government',
    TStart: '1947 Jul 18',
    TStop: '1979',
    name: 'Trust Territory of the Pacific Islands',
    Location: 'Saipan',
    lat: 15.18,
    lon: 145.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUVA',
    StateC: 'RU',
    C: 'Government',
    TStart: '1944',
    TStop: '',
    name: 'Tyva Respublika',
    Location: 'Kyzyl',
    lat: 51.72,
    lon: 94.45,
    alt: 0,
    Parent: 'RU',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TW',
    StateC: 'TW',
    C: 'Government',
    TStart: '1949 Dec 7',
    TStop: '',
    name: 'Zhonghua Minguo',
    Location: 'Taipei, Taiwan',
    lat: 25.07,
    lon: 121.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UA',
    StateC: 'UA',
    C: 'Government',
    TStart: '1991 Dec 26',
    TStop: '',
    name: 'Ukraina',
    Location: 'Kyiv, Ukraina',
    lat: 50.45,
    lon: 30.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAE',
    StateC: 'UAE',
    C: 'Government',
    TStart: '1971 Dec 2',
    TStop: '',
    name: 'Al-Imarat al-\'Arabiya al-Muttahida',
    Location: 'Abu Dhabi',
    lat: 24.47,
    lon: 54.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAE AD',
    StateC: 'UAE',
    C: 'Government',
    TStart: '1971 Dec 2',
    TStop: '',
    name: 'Imarat Abu Zaby',
    Location: 'Abu Dhabi',
    lat: 24.47,
    lon: 54.37,
    alt: 0,
    Parent: 'UAE',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAE DB',
    StateC: 'UAE',
    C: 'Government',
    TStart: '1971 Dec 2',
    TStop: '',
    name: 'Imarat Dubayy',
    Location: 'Dubai',
    lat: 25.26,
    lon: 55.3,
    alt: 0,
    Parent: 'UAE',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAE SH',
    StateC: 'UAE',
    C: 'Government',
    TStart: '1971 Dec 2',
    TStop: '',
    name: 'Imarat As-Sariqah',
    Location: 'Sharjah',
    lat: 25.36,
    lon: 55.39,
    alt: 0,
    Parent: 'UAE',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UK',
    StateC: 'UK',
    C: 'Government',
    TStart: '1707 May 1',
    TStop: '',
    name: 'United Kingdom of Great Britain and Northern Ireland',
    Location: 'London',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UM67',
    StateC: 'UM67',
    C: 'Government',
    TStart: '1945',
    TStop: '',
    name: 'Johnston Atoll, US Minor Outlying Islands',
    Location: 'Johnston Island',
    lat: 16.74,
    lon: -169.52,
    alt: 0,
    Parent: 'US',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UM79',
    StateC: 'UM79',
    C: 'Government',
    TStart: '1945',
    TStop: '',
    name: 'Wake Island, US Minor Outlying Islands',
    Location: 'Wake Island',
    lat: 19.3,
    lon: 166.63,
    alt: 0,
    Parent: 'US',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'US',
    StateC: 'US',
    C: 'Government',
    TStart: '1776 Jul 4',
    TStop: '',
    name: 'United States of America',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UY',
    StateC: 'UY',
    C: 'Government',
    TStart: '1825',
    TStop: '',
    name: 'Republica Oriental del Uruguay',
    Location: 'Montevideo',
    lat: -34.88,
    lon: -56.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UZ',
    StateC: 'UZ',
    C: 'Government',
    TStart: '1991 Sep 1',
    TStop: '',
    name: 'O\'zbekiston Respublikasi',
    Location: 'Toshkent',
    lat: 41.3,
    lon: 69.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VE',
    StateC: 'VE',
    C: 'Government',
    TStart: '1830 Jan 13',
    TStop: '',
    name: 'Rebulica Bolivariana de Venezuela',
    Location: 'Caracas, Venezuela',
    lat: 10.48,
    lon: -66.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VN',
    StateC: 'VN',
    C: 'Government',
    TStart: '1945 Sep 2',
    TStop: '',
    name: 'Cong hoa Xo hoi Chu nghia Viet Nam',
    Location: 'Ha noi, Viet Nam',
    lat: 21.03,
    lon: 105.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YE',
    StateC: 'YE',
    C: 'Government',
    TStart: '1990 May 22',
    TStop: '',
    name: 'Al-Jumhuriyyah al-Yamaniyyah',
    Location: 'Sana\'a, al-Yamaniyyah',
    lat: 15.35,
    lon: 44.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZA',
    StateC: 'ZA',
    C: 'Government',
    TStart: '1910 May 31',
    TStop: '',
    name: 'Republic of South Africa',
    Location: 'Pretoria, Gauteng Province, South Africa',
    lat: -25.75,
    lon: 28.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZR',
    StateC: 'ZR',
    C: 'Government',
    TStart: '1971',
    TStop: '1997 May 16',
    name: 'Republique du Zaire',
    Location: 'Kinshasa',
    lat: -4.33,
    lon: 15.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'X',
    StateC: 'X',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: '',
    Location: ':',
    lat: 0,
    lon: 0.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.COUNTRY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNK',
    StateC: 'X',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: '- -',
    Location: ':',
    lat: 0,
    lon: 0.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '1GMR',
    StateC: 'US',
    C: 'Military',
    TStart: '1948',
    TStop: '1950',
    name: '1st Guided Missile Regiment, US Army, White Sands',
    Location: 'White Sands Proving Ground, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '1GMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '',
    name: '1st Guided Missile Squadron, 6540th Missile Test Wing (Mat/Snark)',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '1PBS',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '',
    name: '1st Pilotless Bomber Sqn, 6555 Guided Missile Group [TAC after 54Jan]',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '69PBS',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '',
    name: '69th Pilotless Bomber Sqn, 6555 Guided Missile Group [TAC after 54Jan]',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '1STRAD',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Jul 21',
    TStop: '1990 Jul 31',
    name: '1st Strategic Aerospace Division, SAC',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '10ADS',
    StateC: 'US',
    C: 'Military',
    TStart: '1966',
    TStop: '',
    name: 'USAF Aerospace Defence Command, 10th Aerospace Defence Sqn.',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'AFADC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '11TMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: '11th Tactical Missile Sqn, USAF',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '209FA',
    StateC: 'US',
    C: 'Military',
    TStart: '1958',
    TStop: '1964',
    name: 'US 209th Field Artillery, 333rd Artillery, 4th Missile Battalion',
    Location: 'Ft. Sill, Oklahoma',
    lat: 34.67,
    lon: -98.39,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '21AT',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2011',
    TStop: '',
    name: 'Ershiyi shiji kongjian jishu yingyong gufen youxian gongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '2GMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '',
    name: '2nd Guided Missile Squadron, 6540th Missile Test Wing (Mat/Snark)',
    Location: 'Holloman AFB, New Mexico',
    lat: 32.85,
    lon: -106.11,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '2SLS',
    StateC: 'US',
    C: 'Military',
    TStart: '1990s',
    TStop: '*',
    name: 'Boeing/USAF 2SLS',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '3GMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '1950',
    name: '3rd Guided Missile Squadron, 550th Guided Missile Wing [Lark]',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '3SLS',
    StateC: 'US',
    C: 'Military',
    TStart: '1990s',
    TStop: '*',
    name: 'USAF 3SLS',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '30FA2',
    StateC: 'US',
    C: 'Military',
    TStart: '1970s',
    TStop: '*',
    name: 'US Army 30th Field Artillery Bttn 2',
    Location: 'Ft Sill, Oklahoma',
    lat: 34.67,
    lon: -98.39,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WTR',
    StateC: 'US',
    C: 'Military',
    TStart: '1997',
    TStop: '',
    name: 'USAF 30th Space Wing',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '36AIS',
    StateC: 'I',
    C: 'Military',
    TStart: '1956',
    TStop: '1963',
    name: '36 Aerobrigata interdizione strategica (36 Strategic Interdict.Sqn)',
    Location: 'Gioia del Colle',
    lat: 40.76,
    lon: 16.93,
    alt: 0,
    Parent: 'AMI',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '321SMW',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USAF 321 Strategic Missile Wing',
    Location: 'Grand Forks AFB, N Dakota',
    lat: 47.96,
    lon: -97.4,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '341MW',
    StateC: 'US',
    C: 'Military',
    TStart: '1993',
    TStop: '2000',
    name: 'USAF 341 Missile Wing',
    Location: 'Malstrom AFB, Montana',
    lat: 47.5,
    lon: -111.19,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '341MW',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '1993',
    name: 'USAF 341 Missile Wing',
    Location: 'Malstrom AFB, Montana',
    lat: 47.5,
    lon: -111.19,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '341MW',
    StateC: 'US',
    C: 'Military',
    TStart: '2000',
    TStop: '',
    name: 'USAF 341 Space Wing',
    Location: 'Malstrom AFB, Montana',
    lat: 47.5,
    lon: -111.19,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '351SMW',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '1995',
    name: 'USAF 351 Strategic Missile Wing',
    Location: 'Whiteman AFB, Missouri',
    lat: 38.73,
    lon: -93.55,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '4SLS',
    StateC: 'US',
    C: 'Military',
    TStart: '1990s',
    TStop: '*',
    name: 'USAF 4SLS',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '40FA',
    StateC: 'US',
    C: 'Military',
    TStart: '1958',
    TStop: '1959',
    name: 'US 40th Field Artillery, 217th Field Artillery Missile Battalion',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '40FA',
    StateC: 'US',
    C: 'Military',
    TStart: '1959',
    TStop: '1964',
    name: 'US 40th Field Artillery, 333rd Artillery, 1st Missile Battalion',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '41FA1',
    StateC: 'US',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'US 41st Field Artillery, Battalion 1, US 7th Army',
    Location: 'Schwabisch Gmund, Baden:Wurttemberg',
    lat: 48.8,
    lon: 9.8,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '41FA1',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '1964',
    name: 'US 41st Field Artillery, Battalion 4',
    Location: 'Ft. Sill, Oklahoma',
    lat: 34.67,
    lon: -98.39,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '44A2',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '1991',
    name: 'US 44th Field Artillery, Battalion 2',
    Location: 'Ft. Sill, Oklahoma',
    lat: 34.67,
    lon: -98.39,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '44SMW',
    StateC: 'US',
    C: 'Military',
    TStart: '1962 Jan',
    TStop: '1991 Apr',
    name: 'USAF 44th Strategic Missile Wing',
    Location: 'Ellsworth AFB, Rapid City, S Dakota',
    lat: 44.15,
    lon: -103.07,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '4504MTW',
    StateC: 'US',
    C: 'Military',
    TStart: '1961',
    TStop: '',
    name: 'USAF 4504 Missile Training Wing',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '4505M',
    StateC: 'US',
    C: 'Military',
    TStart: '1961',
    TStop: '',
    name: 'USAF 4505 Missile Training Wing',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '91MW',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '1968',
    name: 'USAF 455th Strategic Missile Wing',
    Location: 'Minot AFB, N Dakota',
    lat: 48.42,
    lon: -101.36,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFETR',
    StateC: 'US',
    C: 'Military',
    TStart: '2021 May 11',
    TStop: '',
    name: 'Space Launch Delta 45, US Space Force',
    Location: 'Patrick SFB, Cape Canaveral, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFETR',
    StateC: 'US',
    C: 'Military',
    TStart: '1991 Nov 12',
    TStop: '2019 Dec 20',
    name: '45th Space Wing, USAF',
    Location: 'Patrick SFB, Cape Canaveral, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFETR',
    StateC: 'US',
    C: 'Military',
    TStart: '2019 Dec 20',
    TStop: '2021 May 11',
    name: '45th Space Wing, US Space Force',
    Location: 'Patrick SFB, Cape Canaveral, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '46FA2',
    StateC: 'US',
    C: 'Military',
    TStart: '1958',
    TStop: '1964',
    name: 'US 46th Field Artillery, 333rd Artillery, 2nd Missile Battalion',
    Location: 'Ft. Sill, Oklahoma',
    lat: 34.67,
    lon: -98.39,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '3GMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1951',
    TStop: '1953',
    name: '4803rd Guided Missile Squadron, 4800 Guided Missile Wing [Lark]',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '4WG',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USAF 4th Weather Group, Ft Churchill (AWS)',
    Location: 'Churchill, Manitoba',
    lat: 58.73,
    lon: -93.82,
    alt: 0,
    Parent: 'AWS',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '556SMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1958',
    TStop: '',
    name: 'USAF 556th Strategic Missile Squadron',
    Location: 'Cape Canaveral SFS, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AWS',
    StateC: 'US',
    C: 'Military',
    TStart: '2015 Mar',
    TStop: '',
    name: '557th Weather Wing',
    Location: 'Offutt AFB, Nebraska',
    lat: 41.12,
    lon: -95.91,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '564SMS',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USAF 564th Strategic Missile Squadron',
    Location: 'Malstrom AFB, Montana',
    lat: 47.5,
    lon: -111.19,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '576FTS',
    StateC: 'US',
    C: 'Military',
    TStart: '1991 Sep 1',
    TStop: '',
    name: 'USAF 576 Flight Test Squadron, SAC',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '576SMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1958 Mar 6',
    TStop: '1966 Apr 2',
    name: 'USAF 576th Strategic Missile Squadron, SAC',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '6555A',
    StateC: 'US',
    C: 'Military',
    TStart: '1951',
    TStop: '1955',
    name: 'USAF 6555th Guided Missile Sqn',
    Location: 'Cape Canaveral SFS, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '6555A',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USAF 6555 Aerospace Test Wing',
    Location: 'Cape Canaveral SFS, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '6556GMS',
    StateC: 'US',
    C: 'Military',
    TStart: '1951',
    TStop: '1955',
    name: 'USAF 6556th Guided Missile Sqn',
    Location: 'Cape Canaveral SFS, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '702SMW',
    StateC: 'US',
    C: 'Military',
    TStart: '1959',
    TStop: '1961',
    name: 'USAF 702 Strategic Missile WIng, SAC',
    Location: 'Presque Isle AFB, Maine',
    lat: 46.69,
    lon: -68.04,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '79FA2',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '1965',
    name: 'US 79th Field Artillery, Battalion 2',
    Location: 'Fort Sill, Oklahoma',
    lat: 34.67,
    lon: -98.39,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '81FA1',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US 81st Field Artillery, Battalion 1, US 7th Army',
    Location: 'Neu Ulm, Bayern',
    lat: 48.38,
    lon: 10,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '84FA3',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US 84th Field Artillery, Battalion 3, US 7th Army',
    Location: 'Heilbronn, Baden:Wurttemburg',
    lat: 49.15,
    lon: 9.22,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '90SW',
    StateC: 'US',
    C: 'Military',
    TStart: '2000',
    TStop: '',
    name: 'USAF 90th Space Wing',
    Location: 'Warren AFB, Cheyenne, Wyoming',
    lat: 41.13,
    lon: -104.87,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '90SW',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Sep 4',
    TStop: '2000',
    name: 'USAF 90th Space Wing',
    Location: 'Warren AFB, Cheyenne, Wyoming',
    lat: 41.13,
    lon: -104.87,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '90SW',
    StateC: 'US',
    C: 'Military',
    TStart: '1963 Jul 1',
    TStop: '1997 Sep 4',
    name: 'USAF 90th Strategic Missile Wing',
    Location: 'Warren AFB, Cheyenne, Wyoming',
    lat: 41.13,
    lon: -104.87,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '91MW',
    StateC: 'US',
    C: 'Military',
    TStart: '1968',
    TStop: '2008',
    name: 'USAF 91st Space Wing',
    Location: 'Minot AFB, N Dakota',
    lat: 48.42,
    lon: -101.36,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '91MW',
    StateC: 'US',
    C: 'Military',
    TStart: '2008',
    TStop: '',
    name: 'USAF 91st Missile Wing',
    Location: 'Minot AFB, N Dakota',
    lat: 48.42,
    lon: -101.36,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: '9FA3',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US 9th Field Artiller, Batallion 3',
    Location: 'Fort Sill, Oklahoma',
    lat: 34.67,
    lon: -98.39,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAFB',
    StateC: 'US',
    C: 'Military',
    TStart: '1941 Apr 13',
    TStop: '1948 Jan 13',
    name: 'Alamagordo Army Air Field',
    Location: 'Alamagordo, New Mexico',
    lat: 32.85,
    lon: -106.1,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AACH',
    StateC: 'D',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Fachhochschule Aachen',
    Location: 'Aachen',
    lat: 50.78,
    lon: 6.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AACHR',
    StateC: 'D',
    C: 'Academic',
    TStart: '1870',
    TStop: '',
    name: 'Rheinisch-Westfalische Technische Hochschule Aachen',
    Location: 'Aachen',
    lat: 50.78,
    lon: 6.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AACM',
    StateC: 'S',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'AAC Microtec AB',
    Location: 'Uppsala',
    lat: 59.86,
    lon: 17.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AADC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1991',
    TStop: '2009 Oct',
    name: 'Alaska Aerospace Development Corporation',
    Location: 'Anchorage, Alaska',
    lat: 61.22,
    lon: -149.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AAF',
    StateC: 'F',
    C: 'Military',
    TStart: '1909',
    TStop: '',
    name: 'Armee de l\'Air',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AALTO',
    StateC: 'FI',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Aalto-universitetet',
    Location: 'Helsinki',
    lat: 60.17,
    lon: 24.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AAMV',
    StateC: 'I',
    C: 'Academic',
    TStart: '2012',
    TStop: '',
    name: 'Amateurastronomen Max Valier',
    Location: 'Bolzano, Alto Adige (Sudtirol)',
    lat: 46.5,
    lon: 11.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AANII',
    StateC: 'RU',
    C: 'Government',
    TStart: '1920',
    TStop: '',
    name: 'Arkticheskiy i Antarkticheksiy Nauchno-Issledovatel\'skoe Institut',
    Location: 'Leningrad',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: 'GMS',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AAP',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '1998',
    TStop: '',
    name: 'Americom Asia Pacific (LMGT/GE Americom)',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: 'LMGT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AARH',
    StateC: 'DK',
    C: 'Academic',
    TStart: '1928',
    TStop: '',
    name: 'Aarhus Universitet',
    Location: 'Aarhus',
    lat: 56.17,
    lon: 10.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AAU',
    StateC: 'DK',
    C: 'Academic',
    TStart: '1974',
    TStop: '',
    name: 'Aalborg Universitet',
    Location: 'Aalborg',
    lat: 57.02,
    lon: 9.99,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABE',
    StateC: 'BO',
    C: 'Government',
    TStart: '2010 Apr',
    TStop: '',
    name: 'Agencia Boliviana spacial',
    Location: 'La Paz, Bolivia',
    lat: -16.5,
    lon: -68.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABAE',
    StateC: 'VE',
    C: 'Government',
    TStart: '2008',
    TStop: '',
    name: 'Agencia Bolivariana para Activadades Espaciales',
    Location: 'Caracas',
    lat: 10.48,
    lon: -66.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCW',
    StateC: 'UK',
    C: 'Academic',
    TStart: '2007 Sep',
    TStop: '',
    name: 'Prifysgol Aberystwyth (Aberystwyth University)',
    Location: 'Aberystwyth, Wales',
    lat: 52.42,
    lon: -4.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABERRY',
    StateC: 'T',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'AstroBerry Ltd.',
    Location: 'Bangkok',
    lat: 13.82,
    lon: 100.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABL',
    StateC: 'US',
    C: 'Military',
    TStart: '1945',
    TStop: '1995',
    name: 'Alleghany Ballistic Laboratories (USN/Hercules Powder Co)',
    Location: 'Cumberland:Rocket Center, West Virginia',
    lat: 39.56,
    lon: -78.83,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1944',
    TStop: '1945',
    name: 'Alleghany Ballistic Laboratories (NRDC/GWU)',
    Location: 'Cumberland:Rocket Center, West Virginia',
    lat: 39.56,
    lon: -78.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1956 Feb',
    TStop: '1961 Dec',
    name: 'U.S. Army Ballistic Missile Agency',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMDA',
    StateC: 'US',
    C: 'Military',
    TStart: '2007',
    TStop: '',
    name: 'Aegis Ballistic Missile Defense Agency',
    Location: 'Dahlgren, Virginia',
    lat: 38.34,
    lon: -77.05,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMDA1',
    StateC: 'US',
    C: 'Military',
    TStart: '1968 Aug',
    TStop: '1974',
    name: 'Advanced Ballistic Missile Defense Agency',
    Location: 'Washington, DC',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1974 May 20',
    TStop: '1985 Jul',
    name: 'US Army Ballistic Missile Defense Organization',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABS',
    StateC: 'HK',
    C: 'Commercial',
    TStart: '2006',
    TStop: '2012',
    name: 'Asia Broadcast Satellite Ltd.',
    Location: 'Hong Kong',
    lat: 22.3,
    lon: 114.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMI',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2006',
    TStop: '2006',
    name: 'Asia Broadcast Satellite Ltd.',
    Location: 'London',
    lat: 51.51,
    lon: -0.11,
    alt: 0,
    Parent: 'ABS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABSB',
    StateC: 'BM',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'Asia Broadcast Satellite Ltd.',
    Location: 'Bermuda',
    lat: 32.3,
    lon: -64.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMSCV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2006 Sep',
    TStop: '2006 Sep',
    name: 'Asia Broadcast Satellite Holdings Ltd.',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'ABS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABS',
    StateC: 'HK',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'Asia Broadcast Satellite (Hong Kong) Ltd.',
    Location: 'Hong Kong',
    lat: 22.3,
    lon: 114.2,
    alt: 0,
    Parent: 'ABSB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACAE',
    StateC: 'CR',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Asociacion Centroamericana de Aeronautica y del Espacio',
    Location: 'San Jose, Costa Rica',
    lat: 9.93,
    lon: -84.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACAP',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Aerospace Capital LLC',
    Location: 'Moskva',
    lat: 37.55,
    lon: 55.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACAST',
    StateC: 'CH',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Astrocast',
    Location: 'Lausanne',
    lat: 46.52,
    lon: 6.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACC',
    StateC: 'US',
    C: 'Military',
    TStart: '1992 Jun 1',
    TStop: '',
    name: 'Air Combat Command',
    Location: 'Langley AFB, Virginia',
    lat: 37.08,
    lon: -76.36,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACCIMT',
    StateC: 'LK',
    C: 'Government',
    TStart: '1984',
    TStop: '',
    name: 'Arthur C. Clarke Institute for Modern Technologies',
    Location: 'Moratuwa',
    lat: 6.79,
    lon: 79.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACE',
    StateC: 'US',
    C: 'Military',
    TStart: '1942 Jul 1',
    TStop: '1968 Sep 1',
    name: 'Army Map Service, US Army Corps of Engineers',
    Location: 'Bethesda, Maryland',
    lat: 38.98,
    lon: -77.11,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACES',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2006',
    name: 'Asia Cellular Satellite',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: 'PSN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACES',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '2006',
    TStop: '2015',
    name: 'Inmarsat/Asia Cellular Satellite',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: 'INMRL',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACF',
    StateC: 'F',
    C: 'Academic',
    TStart: '1898',
    TStop: '',
    name: 'Aero Club de France',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADAST',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'Ad Astra Rocket Company',
    Location: 'Houston:Webster, Texas',
    lat: 29.54,
    lon: -95.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADD',
    StateC: 'KR',
    C: 'Military',
    TStart: '1983',
    TStop: '',
    name: 'Agency for Defense Development (Daejon)',
    Location: 'Daejon',
    lat: 36.35,
    lon: 127.39,
    alt: 0,
    Parent: 'KR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADDAH',
    StateC: 'KR',
    C: 'Military',
    TStart: '1993',
    TStop: '',
    name: 'ADD Anhueng Proving Ground',
    Location: 'Anhueng, Ch\'ungch\'ong Namdo',
    lat: 36.41,
    lon: 126.1,
    alt: 0,
    Parent: 'ADD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADEL',
    StateC: 'AU',
    C: 'Academic',
    TStart: '1874',
    TStop: '',
    name: 'University of Adelaide',
    Location: 'Adelaide, South Australia',
    lat: -34.92,
    lon: 138.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CANOP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Astro Digital',
    Location: 'Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EADS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space',
    Location: 'Schiphol-Rijk, Amsterdam',
    lat: 52.31,
    lon: 4.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EADSA',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space/Aquitaine',
    Location: 'Bordeaux:St-Medard-en-Jalles',
    lat: 44.9,
    lon: -0.72,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space, Bremen',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space Satellites (D), Friedrichsafen',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADSFL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Airbus Defense and Space Inc (US)',
    Location: 'Cape Canaveral, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AECSG',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space Launch Vehicles - CSG',
    Location: 'CSG, Kourou, Guyane Francaise',
    lat: 5.23,
    lon: -52.77,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTL',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space (D), Lampoldshausen',
    Location: 'Lampoldshausen',
    lat: 49.27,
    lon: 9.4,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORLM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '2015 Jan 1',
    name: 'Airbus Defense and Space Launch Vehicles (ADS LV)',
    Location: 'Les Mureaux, Paris, France',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASA',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space Satellites/Barajas (CASA Espacio)',
    Location: 'Madrid:Barajas',
    lat: 40.47,
    lon: -3.59,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADSNA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus DS Space Systems Inc.',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FOKKS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'Airbus Defense and Space - Netherlands',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: 'ASTD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOLK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space Propulsion/Ottobrunn',
    Location: 'Munchen:Ottobrunn',
    lat: 48.07,
    lon: 11.67,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARA',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space (UK) (Corsham)',
    Location: 'Corsham, Wiltshire',
    lat: 51.43,
    lon: -2.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MATT',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space (F) Toulouse',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADSTI',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'Airbus Defense and Space - Intelligence',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVS',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2014 Jan 1',
    TStop: '',
    name: 'Airbus Defense and Space (UK)',
    Location: 'Stevenage',
    lat: 51.9,
    lon: -0.2,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADVSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Advanced Space',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AE',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1980 Mar 26',
    TStop: '2017 Mar',
    name: 'Arianespace, Inc.',
    Location: 'Paris:Evry, France',
    lat: 48.62,
    lon: 2.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEB',
    StateC: 'BR',
    C: 'Government',
    TStart: '',
    TStop: '*',
    name: 'Agencia Espacial Brasileira',
    Location: 'San Jose dos Campos, Brasil',
    lat: -23.19,
    lon: -45.88,
    alt: 0,
    Parent: 'BR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEC',
    StateC: 'US',
    C: 'Government',
    TStart: '1947 Jan 1',
    TStop: '1975 Jan 19',
    name: 'U.S. Atomic Energy Commission',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AECAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1975',
    TStop: '2004',
    name: 'AEC/Able Engineering Inc.',
    Location: 'Goleta, California',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AECSG',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2000 Jul 10',
    name: 'Aerospatiale/Kourou',
    Location: 'CSG, Kourou, Guyane Francaise',
    lat: 5.23,
    lon: -52.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEDC',
    StateC: 'US',
    C: 'Military',
    TStart: '1951',
    TStop: '',
    name: 'Arnold Engineering Development Center, Arnold AFB',
    Location: 'Tullahoma, Tennessee',
    lat: 35.38,
    lon: -86.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALPSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021 Aug',
    TStop: '',
    name: 'Aegis Aerospace',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORLM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1970',
    TStop: '1999 Jul',
    name: 'Aerospatiale/Les Mureaux',
    Location: 'Paris:Les Mureaux, Yvelines, France',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORLM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1999 Jul',
    TStop: '2000 Jul 10',
    name: 'Aerospatiale Matra Lanceurs',
    Location: 'Paris:Les Mureaux, Yvelines, France',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCT',
    StateC: 'MX',
    C: 'Government',
    TStart: '2010 Jul',
    TStop: '',
    name: 'Agencia Espacial Mexicana',
    Location: 'Ciudad de Mexico',
    lat: 19.43,
    lon: -99.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AENUT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1956',
    name: 'Aeronutronic Co.',
    Location: 'Los Angeles:Glendale, California',
    lat: 34.15,
    lon: -118.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEP',
    StateC: 'PY',
    C: 'Government',
    TStart: '2018',
    TStop: '',
    name: 'Agencia Espacial del Paraguay',
    Location: 'Asuncion',
    lat: -25.27,
    lon: -57.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AERAR',
    StateC: 'AR',
    C: 'Military',
    TStart: '1945',
    TStop: '',
    name: 'Fuerza Aerea Argentina',
    Location: 'Buenos Aires:El Palomar',
    lat: -34.62,
    lon: -58.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIAT',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1969',
    TStop: '1990',
    name: 'Aeritalia Sistemi Spaziali (Torino)',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AERO',
    StateC: 'US',
    C: 'Military',
    TStart: '1960 Jun',
    TStop: '',
    name: 'Aerospace Corp.',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEROA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1988',
    TStop: '2008',
    name: 'AeroAstro, Inc',
    Location: 'Ashburn, Virginia',
    lat: 39.04,
    lon: -77.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEROA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '2012 Jul',
    name: 'Comtech AeroAstro, Inc',
    Location: 'Ashburn, Virginia',
    lat: 39.04,
    lon: -77.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OAKAE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '2012 Jul',
    name: 'Comtech AeroAstro/Littleton',
    Location: 'Littleton, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: 'AEROA',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEROL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1960',
    name: 'Aerolab Development Co.',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEROL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1967',
    name: 'Ryan Aerolab Development Co.',
    Location: 'Pasadena/Monrovia, California',
    lat: 34.15,
    lon: -118,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AERON',
    StateC: 'F',
    C: 'Government',
    TStart: '1961',
    TStop: '2009',
    name: 'CNRS Service d\'Aeronomie (Verrieres)',
    Location: 'Paris:Verrieres-le-Buisson',
    lat: 48.75,
    lon: 2.27,
    alt: 0,
    Parent: 'CNRS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AERON',
    StateC: 'F',
    C: 'Government',
    TStart: '1958',
    TStop: '1961',
    name: 'CNRS Service d\'Aeronomie (Meudon)',
    Location: 'Paris:Meudon',
    lat: 48.81,
    lon: 2.24,
    alt: 0,
    Parent: 'CNRS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEROPH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1960',
    name: 'Aerophysics Development Corporation',
    Location: 'Santa Barbara:Goleta, California',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AES',
    StateC: 'CA',
    C: 'Government',
    TStart: '1971',
    TStop: '2002',
    name: 'Atmospheric Environment Service, Dept. of the Environment',
    Location: 'Toronto:Downsview',
    lat: 43.73,
    lon: -79.49,
    alt: 0,
    Parent: 'CA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AESCO',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1986 Apr',
    TStop: '*',
    name: 'Advanced Engineering Services Co. Ltd.',
    Location: 'Tsukuba',
    lat: 36.08,
    lon: 140.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AE',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2017 Mar',
    TStop: '',
    name: 'Arianespace SAS',
    Location: 'Paris:Evry, France',
    lat: 48.62,
    lon: 2.43,
    alt: 0,
    Parent: 'ARIG',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1970 Jan 1',
    TStop: '1998 Jun 1',
    name: 'Soc. nat. industrielle Aerospatiale (SNIAS), GT Cannes',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNCASO',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1970 Jan 1',
    TStop: '1973 Jan 1',
    name: 'Aerospatiale, Ch. Courbevoie (SEREB)',
    Location: 'Paris:Courbevoie',
    lat: 48.9,
    lon: 2.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AETE',
    StateC: 'CA',
    C: 'Military',
    TStart: '1971',
    TStop: '*',
    name: 'Aerospace Engineering Test Establishment, CFB Cold Lake',
    Location: 'Cold Lake, Alberta',
    lat: 54.46,
    lon: -110.18,
    alt: 0,
    Parent: 'CFCA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFAD',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US Air Force Armaments Directorate',
    Location: 'Eglin AFB, Florida',
    lat: 30.49,
    lon: -86.54,
    alt: 0,
    Parent: 'AFMC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1968',
    TStop: '1980',
    name: 'US Air Force Aerospace Defense Command',
    Location: 'Cheyenne Mountain, Colorado',
    lat: 38.74,
    lon: -104.85,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1946',
    TStop: '1968',
    name: 'US Air Force Air Defense Command',
    Location: 'Colorado Springs, Colorado',
    lat: 38.8,
    lon: -104.52,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFAL',
    StateC: 'US',
    C: 'Military',
    TStart: '1963',
    TStop: '1992',
    name: 'US Air Force Avionics Laboratory, USAF ASD',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'AFASD',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFAMC',
    StateC: 'US',
    C: 'Military',
    TStart: '1946 Mar',
    TStop: '1961 Apr 1',
    name: 'Air Materiel Command',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFAPL',
    StateC: 'US',
    C: 'Military',
    TStart: '1963',
    TStop: '1992',
    name: 'US Air Force Aero Propulsion Laboratory, USAF ASD',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1961',
    TStop: '1992',
    name: 'Aeronautical Systems Division, ARDC/AFSC',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '1957 Jun',
    TStop: '1961 Apr',
    name: 'US Air Force Ballistic Missile Division',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'ARDC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFBSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1979 Oct',
    TStop: '1989 Mar',
    name: 'US Air Force Ballistic Missile Office AFSC',
    Location: 'Norton AFB, San Bernardino, California',
    lat: 34.1,
    lon: -117.24,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFBSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1990 May',
    TStop: '1993 Sep',
    name: 'US Air Force Ballistic Missile Organization AFSC',
    Location: 'Norton AFB, San Bernardino, California',
    lat: 34.1,
    lon: -117.24,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFBSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1962 Sep',
    TStop: '1967 Jul',
    name: 'US Air Force Ballistic Systems Division, AFSC',
    Location: 'Norton AFB, San Bernardino, California',
    lat: 34.1,
    lon: -117.24,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFBSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1989 Mar',
    TStop: '1990 May',
    name: 'US Air Force Ballistic Systems Division, AFSC',
    Location: 'Norton AFB, San Bernardino, California',
    lat: 34.1,
    lon: -117.24,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFBSL',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Apr 1',
    TStop: '1962 Sep',
    name: 'US Air Force Ballistic Systems Division',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCER',
    StateC: 'US',
    C: 'Military',
    TStart: '1998',
    TStop: '2006',
    name: 'US Air Force Center for Research Support',
    Location: 'Schriever SFB, Colorado Springs, Colorado',
    lat: 38.8,
    lon: -104.52,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCFS',
    StateC: 'US',
    C: 'Military',
    TStart: '1945 Sep 20',
    TStop: '1949 Jul 5',
    name: 'US Air Force, Cambridge Field Station',
    Location: 'Cambridge, MA (224 Albany St)',
    lat: 42.37,
    lon: -71.11,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCFS',
    StateC: 'US',
    C: 'Military',
    TStart: '1951 Jun 28',
    TStop: '1959',
    name: 'US Air Force Cambridge Research Center',
    Location: 'Cambridge, MA',
    lat: 42.37,
    lon: -71.11,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1951 Jun 28',
    TStop: '1960 Aug 1',
    name: 'US Air Force Cambridge Research Center',
    Location: 'Bedford, MA',
    lat: 42.49,
    lon: -71.28,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1960 Aug 1',
    TStop: '1976 Jan 15',
    name: 'US Air Force Cambridge Research Laboratories',
    Location: 'Bedford, MA',
    lat: 42.49,
    lon: -71.28,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCFS',
    StateC: 'US',
    C: 'Military',
    TStart: '1949 Jul 5',
    TStop: '1951 Jun 28',
    name: 'US Air Force Cambridge Research Laboratories',
    Location: 'Cambridge, MA',
    lat: 42.37,
    lon: -71.11,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1949 Jul 5',
    TStop: '1951 Jun 28',
    name: 'US Air Force Cambridge Research Laboratories (Hanscom)',
    Location: 'Bedford, MA',
    lat: 42.49,
    lon: -71.28,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFETR',
    StateC: 'US',
    C: 'Military',
    TStart: '1964',
    TStop: '1977',
    name: 'US Air Force Eastern Test Range',
    Location: 'Patrick SFB, Cape Canaveral, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFFDL',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US Air Force Flight Dynamics Laboratory',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'AFASD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFFTC',
    StateC: 'US',
    C: 'Military',
    TStart: '1947',
    TStop: '',
    name: 'US Air Force Flight Test Center',
    Location: 'Edwards AFB, California',
    lat: 34.91,
    lon: -117.88,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFGAF',
    StateC: 'AF',
    C: 'Military',
    TStart: '1921',
    TStop: '',
    name: 'Daafghanistan Hwayay Zoak',
    Location: 'Kabul',
    lat: 34.53,
    lon: 69.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1976 Jan 15',
    TStop: '1989',
    name: 'US Air Force Geophysics Laboratory',
    Location: 'Bedford, MA',
    lat: 42.49,
    lon: -71.28,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1989',
    TStop: '1990 Dec',
    name: 'US Air Force Geophysics Laboratory (AFSC)',
    Location: 'Bedford, MA',
    lat: 42.49,
    lon: -71.28,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFGSC',
    StateC: 'US',
    C: 'Military',
    TStart: '2009 Dec 1',
    TStop: '',
    name: 'US Air Force Global Strike Command',
    Location: 'Barksdale AFB, Bossier City, Louisiana',
    lat: 32.5,
    lon: -93.66,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFIT',
    StateC: 'US',
    C: 'Military',
    TStart: '1919',
    TStop: '',
    name: 'US Air Force Institute of Technology, Wright-Patterson AFB',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFJSC',
    StateC: 'US',
    C: 'Military',
    TStart: '1976',
    TStop: '*',
    name: 'US Air Force Space Division/Houston',
    Location: 'Houston, Texas',
    lat: 29.56,
    lon: -95.12,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFLC',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Apr 1',
    TStop: '1992 Jul 1',
    name: 'US Air Force Logistics Command',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFAMC',
    StateC: 'US',
    C: 'Military',
    TStart: '1992 Jul 1',
    TStop: '',
    name: 'US Air Force Materiel Command',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFMCIT',
    StateC: 'AF',
    C: 'Government',
    TStart: '2004',
    TStop: '',
    name: 'Ministry of Communications and Information Technology',
    Location: 'Kabul',
    lat: 34.53,
    lon: 69.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFMCSW',
    StateC: 'US',
    C: 'Military',
    TStart: '2006',
    TStop: '2020 Dec 19',
    name: 'US Air Force Military Satellite Communications Wing, AFSMC, LAAFB',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSMC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1957 Sep 1',
    TStop: '1970 Aug 1',
    name: 'Air Force Missile Development Center, Holloman Air Force Base',
    Location: 'Alamagordo, New Mexico',
    lat: 32.85,
    lon: -106.11,
    alt: 0,
    Parent: 'HAFB',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFETR',
    StateC: 'US',
    C: 'Military',
    TStart: '1951',
    TStop: '1964',
    name: 'US Air Force Missile Test Center',
    Location: 'Patrick SFB, Cape Canaveral, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFOSR',
    StateC: 'US',
    C: 'Military',
    TStart: '1951 Oct',
    TStop: '',
    name: 'US Air Force Office of Scientific Research',
    Location: 'Baltimore, MD',
    lat: 39.29,
    lon: -76.62,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFOTEC',
    StateC: 'US',
    C: 'Military',
    TStart: '1974 Jan',
    TStop: '',
    name: 'US Air Force Operational Test and Evaluation Center, Kirtland AFB',
    Location: 'Kirtland AFB, Albuquerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFOTD4',
    StateC: 'US',
    C: 'Military',
    TStart: '1974 Jan',
    TStop: '',
    name: 'US Air Force Operational Test and Evaluation Center, Detachment 4',
    Location: 'Peterson SFB, Colorado',
    lat: 38.82,
    lon: -104.7,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1990 Dec',
    TStop: '1997 Oct',
    name: 'US Air Force Phillips Laboratory, Geophysics Directorate',
    Location: 'Bedford, MA',
    lat: 42.49,
    lon: -71.28,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFPS',
    StateC: 'US',
    C: 'Military',
    TStart: '1984',
    TStop: '1991',
    name: 'US Air Force HQ Payload Specialists',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FRC',
    StateC: 'US',
    C: 'Government',
    TStart: '2014 Jan 8',
    TStop: '',
    name: 'NASA Neil A. Armstrong Flight Research Center',
    Location: 'Edwards AFB, California',
    lat: 34.91,
    lon: -117.88,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFRCO',
    StateC: 'US',
    C: 'Military',
    TStart: '2003',
    TStop: '',
    name: 'US Air Force Rapid Capabilities Office',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFROM',
    StateC: 'US',
    C: 'Military',
    TStart: '1951',
    TStop: '1997',
    name: 'US Air Force Rome Labs, Griffiss AFB',
    Location: 'Rome, New York',
    lat: 43.23,
    lon: -75.41,
    alt: 0,
    Parent: 'AFMC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct',
    TStop: '',
    name: 'US Air Force Research Laboratories/RV (Space Vehicles Directorate)',
    Location: 'Kirtland AFB, Albuquerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFORS',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct',
    TStop: '2018',
    name: 'Operationally Responsive Space Office, Dept. of Defense',
    Location: 'Kirtland AFB, Albuquerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct',
    TStop: '2006',
    name: 'US Air Force Research Lab, Space Vehicles Dir., Hanscom',
    Location: 'Bedford, MA',
    lat: 42.49,
    lon: -71.28,
    alt: 0,
    Parent: 'AFRL',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFAPL',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct',
    TStop: '',
    name: 'US Air Force Research Lab, Propulsion Directorate',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFRLW',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct',
    TStop: '',
    name: 'US Air Force Research Lab, Wright',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFRPL',
    StateC: 'US',
    C: 'Military',
    TStart: '1963',
    TStop: '1992',
    name: 'US Air Force Rocket Propulsion Laboratory, USAF ASD',
    Location: 'Edwards AFB, California',
    lat: 34.91,
    lon: -117.88,
    alt: 0,
    Parent: 'AFASD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSAM',
    StateC: 'US',
    C: 'Military',
    TStart: '1959',
    TStop: '2011',
    name: 'US Air Force School of Aerospace Medicine (Brooks)',
    Location: 'Brooks AFB, San Antonio, Texas',
    lat: 29.34,
    lon: -98.44,
    alt: 0,
    Parent: 'AFMC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSC',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Apr 1',
    TStop: '1992 Jul 1',
    name: 'US Air Force Systems Command, Los Angeles AFS',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '1979 Oct',
    TStop: '1989 Mar',
    name: 'US Air Force Space Division',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFBSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1993 Sep',
    TStop: '1995 Sep',
    name: 'US Air Force Space and Missile Center (Norton)',
    Location: 'Norton AFB, San Bernardino, California',
    lat: 34.1,
    lon: -117.24,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '1992 Jul',
    TStop: '2019 Dec 20',
    name: 'US Air Force Space and Missile Center',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAFSP',
    StateC: 'US',
    C: 'Military',
    TStart: '1960 Sep',
    TStop: '1961 Sep',
    name: 'US Air Force Sec. AF, Office of Satellite and Missile Systems',
    Location: 'Arlington, Virginia / El Segundo',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSOC',
    StateC: 'US',
    C: 'Military',
    TStart: '1990 May 22',
    TStop: '',
    name: 'US Air Force Special Operations Command',
    Location: 'Eglin, Florida',
    lat: 30.49,
    lon: -86.54,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSPC',
    StateC: 'US',
    C: 'Military',
    TStart: '1982 Sep 1',
    TStop: '2019 Dec 20',
    name: 'US Air Force Space Command',
    Location: 'Peterson SFB, Colorado',
    lat: 38.82,
    lon: -104.7,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Apr 1',
    TStop: '1967 Jul',
    name: 'US Air Force Space Systems Division',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '1989 Mar',
    TStop: '1992 Jul',
    name: 'US Air Force Space Systems Division',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSTC',
    StateC: 'US',
    C: 'Military',
    TStart: '1960',
    TStop: '1994 Jan',
    name: 'US Air Force Satellite Test Center, Sunnyvale AFS',
    Location: 'Sunnyvale, California',
    lat: 37.4049,
    lon: -122.0288,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFCER',
    StateC: 'US',
    C: 'Military',
    TStart: '2006',
    TStop: '',
    name: 'US Air Force Space Test Squadron',
    Location: 'Schriever SFB, Colorado Springs, Colorado',
    lat: 38.8,
    lon: -104.52,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSWC',
    StateC: 'US',
    C: 'Military',
    TStart: '1952 Apr 1',
    TStop: '1976 Apr 1',
    name: 'US Air Force Special Weapons Center',
    Location: 'Kirtland AFB, Albequerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DASA',
    StateC: 'US',
    C: 'Military',
    TStart: '1947 Jan',
    TStop: '1959',
    name: 'US Air Force Special Weapons Project, Sandia Base',
    Location: 'Sandia AFB, Albequerque, New Mexico',
    lat: 35.04,
    lon: -106.55,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFTAC',
    StateC: 'US',
    C: 'Military',
    TStart: '1947',
    TStop: '',
    name: 'US Air Force Technical Applications Center',
    Location: 'Patrick SFB, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AWS',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct',
    TStop: '2015 Mar',
    name: 'US Air Force Weather Agency',
    Location: 'Offutt AFB, Nebraska',
    lat: 41.12,
    lon: -95.91,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '1954 Jul',
    TStop: '1957 Jun',
    name: 'US Air Force Western Development Division',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWL',
    StateC: 'US',
    C: 'Military',
    TStart: '1963',
    TStop: '1990',
    name: 'US Air Force Weapons Lab',
    Location: 'Kirtland AFB, Albequerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AGHU',
    StateC: 'PL',
    C: 'Academic',
    TStart: '1919',
    TStop: '',
    name: 'Akademia Gorniczo-Hutnicza im. Stanislawa Stazica',
    Location: 'Krakow',
    lat: 50.06,
    lon: 19.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AGILS',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'AgilSpace',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: 'STESS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AGSL',
    StateC: 'PG',
    C: 'Commercial',
    TStart: '2017 Jan',
    TStop: '',
    name: 'ABS Global Satellite Ltd.',
    Location: 'Port Moresby',
    lat: -9.48,
    lon: 147.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHAIL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1945',
    TStop: '1958',
    name: 'Airborne Instruments Laboratory',
    Location: 'Mineola New York',
    lat: 40.74,
    lon: -73.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AISTS',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Aistech Space',
    Location: 'Barcelona',
    lat: 41.39,
    lon: 2.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AJ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1947',
    TStop: '2001',
    name: 'Aerojet Engineering',
    Location: 'Azusa, California',
    lat: 34.13,
    lon: -117.91,
    alt: 0,
    Parent: 'GTRC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATLCA',
    StateC: 'US',
    C: 'Unknown',
    TStart: '2003',
    TStop: '',
    name: 'Aerojet/Camden',
    Location: 'East Camden, Arkansas',
    lat: 33.61,
    lon: -92.74,
    alt: 0,
    Parent: 'GTRC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AJ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1942',
    TStop: '1947',
    name: 'Aerojet Engineering, Pasadena',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: 'GTRC',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AJGC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1953',
    TStop: '2013 Jun',
    name: 'Aerojet General Corp.',
    Location: 'Sacramento:Rancho Cordova, California',
    lat: 38.59,
    lon: -121.3,
    alt: 0,
    Parent: 'GTRC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AJGC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013 Jun',
    TStop: '',
    name: 'Aerojet Rocketdyne',
    Location: 'Sacramento:Rancho Cordova, California',
    lat: 38.59,
    lon: -121.3,
    alt: 0,
    Parent: 'GTRC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RDYNE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013 Jun',
    TStop: '',
    name: 'Aerojet Rocketdyne/Canoga Park',
    Location: 'Canoga Park, California',
    lat: 34.2,
    lon: -118.6,
    alt: 0,
    Parent: 'GTRC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2002 Aug',
    TStop: '2013 Jun',
    name: 'Aerojet/Redmond',
    Location: 'Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: 'AJ',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PWFL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013 Jun',
    TStop: '',
    name: 'Aerojet Rocketdyne/West Palm Beach',
    Location: 'West Palm Beach, Florida',
    lat: 26.71,
    lon: -80.06,
    alt: 0,
    Parent: 'AJR',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013 Jun',
    TStop: '',
    name: 'Aerojet Rocketdyne/Redmond',
    Location: 'Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: 'AJR',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AJSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1953',
    TStop: '2013 Jun',
    name: 'Aerojet Rocketdyne Solid Propulsion Co., AF Plant 70',
    Location: 'Sacramento:Rancho Cordova, California',
    lat: 38.59,
    lon: -121.3,
    alt: 0,
    Parent: 'AJR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AJSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013 Jun',
    TStop: '',
    name: 'Aerojet Solid Propulsion Co., AF Plant 70',
    Location: 'Sacramento:Rancho Cordova, California',
    lat: 38.59,
    lon: -121.3,
    alt: 0,
    Parent: 'AJ',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AADC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009 Oct',
    TStop: '',
    name: 'Alaska Aerospace Corporation',
    Location: 'Anchorage, Alaska',
    lat: 61.22,
    lon: -149.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AKCMR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'AT&T Alascom',
    Location: 'Anchorage, Alaska',
    lat: 61.22,
    lon: -149.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AKCMR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1979',
    TStop: '1995',
    name: 'Alascom, Inc. (Pacific Telecom)',
    Location: 'Anchorage, Alaska',
    lat: 61.22,
    lon: -149.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AKCMR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1970',
    TStop: '1979',
    name: 'RCA Alaska Communications Inc. (Alascom)',
    Location: 'Anchorage, Alaska',
    lat: 61.22,
    lon: -149.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALAER',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '2006 Nov',
    name: 'Allied Aerospace',
    Location: 'Newport News, Virginia',
    lat: 37.07,
    lon: -76.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALB',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1908',
    TStop: '',
    name: 'U. Alberta',
    Location: 'Edmonton, Alberta',
    lat: 53.52,
    lon: -113.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALBA',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'Alba Orbital Ltd.',
    Location: 'Glasgow',
    lat: 55.85,
    lon: -4.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1998 Jul 1',
    TStop: '2005 Jun 1',
    name: 'Alcatel Space, Centre spatiale de Cannes-Mandelieu',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2005 Jun 1',
    TStop: '2007 Apr 10',
    name: 'Alcatel Alenia Space (F)',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SELEN',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2005 Jun 1',
    TStop: '2007 Apr 10',
    name: 'Alcatel Alenia Space (I) Roma',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALCS',
    StateC: 'US',
    C: 'Military',
    TStart: '1967',
    TStop: '',
    name: 'USAF Airborne Launch Control System',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'SAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIAT',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2005 Jun 1',
    TStop: '2007 Apr 10',
    name: 'Alcatel Alenia Space (I)',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALE',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Kabushikigaisha ALE (eru)',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIAT',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1990',
    TStop: '2005 Jun 1',
    name: 'Alenia Spazio',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SELEN',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1990',
    TStop: '2005 Jun 1',
    name: 'Alenia Spazio (Roma)',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALIEX',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'AliExpress, Alibaba Group',
    Location: 'Hangzhou, Zhejiang',
    lat: 30.25,
    lon: 120.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALMAN',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'AO Kontsern VKO Almaz-Antey',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALPSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '2021 Aug',
    name: 'Alpha Space',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ALYAH',
    StateC: 'UAE',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Al Yah Satellite Communications Co. PrJsc',
    Location: 'Abu Dhabi',
    lat: 24.47,
    lon: 54.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMAD',
    StateC: 'AM',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Armenian Air Defence',
    Location: 'Erevan',
    lat: 40.18,
    lon: 44.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMAI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Adcole Maryland Aerospace Inc',
    Location: 'Crofton, Maryland',
    lat: 39,
    lon: -76.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMBR',
    StateC: 'BR',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-Brasil',
    Location: 'Rio de Janeiro, Brasil',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1976 Mar',
    TStop: '1986',
    name: 'RCA Americom',
    Location: 'Princeton, New Jersey',
    lat: 40.35,
    lon: -74.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMCEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1959',
    TStop: '1965',
    name: 'Amcel Propulsion',
    Location: 'Swannanoa, North Carolina',
    lat: 35.6,
    lon: -82.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '2001 Nov 21',
    name: 'GE Americom',
    Location: 'Princeton, New Jersey',
    lat: 40.35,
    lon: -74.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct',
    TStop: '',
    name: 'US Army Aviation and Missile Command',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1975',
    TStop: '1976 Mar',
    name: 'RCA Global Communications Inc.',
    Location: 'Piscataway, New Jersey',
    lat: 40.55,
    lon: -74.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001 Nov 21',
    TStop: '2009 Sep',
    name: 'SES Americom',
    Location: 'Princeton, New Jersey',
    lat: 40.35,
    lon: -74.66,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMDL',
    StateC: 'D',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-Deutschland',
    Location: 'Marburg',
    lat: 50.81,
    lon: 8.77,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMEA',
    StateC: 'E',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-Espana',
    Location: 'Madrid',
    lat: 40.38,
    lon: -3.73,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMF',
    StateC: 'F',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-France',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMGU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1975',
    TStop: '',
    name: 'Amurskiy Gosurdarstvenniy Universitet',
    Location: 'Blagoveshchensk, Amur Oblast',
    lat: 50.28,
    lon: 127.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMI',
    StateC: 'I',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Aeronautica Militare Italiana',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: 'I',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMIL',
    StateC: 'IL',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-Israel',
    Location: 'Israel',
    lat: 32.07,
    lon: 34.78,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMIRK',
    StateC: 'IR',
    C: 'Academic',
    TStart: '1979',
    TStop: '',
    name: 'Daneshgah-e San\'ati-ye Amirkabir',
    Location: 'Tehran',
    lat: 35.7,
    lon: 51.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMIT',
    StateC: 'I',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-Italia',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMLU',
    StateC: 'AR',
    C: 'Academic',
    TStart: '1987 Jun',
    TStop: '',
    name: 'AMSAT-Argentina',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMNA',
    StateC: 'US',
    C: 'Academic',
    TStart: '1969 Mar 3',
    TStop: '',
    name: 'AMSAT North America (Radio Amateur Satellite Corp)',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMNL',
    StateC: 'NL',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-NL',
    Location: 'Delft',
    lat: 52.01,
    lon: 4.36,
    alt: 0,
    Parent: 'AMSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMSAT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1969 Mar 3',
    TStop: '',
    name: 'Radio Amateur Satellite Corporation',
    Location: 'Washington DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2004 Oct',
    TStop: '2012 Aug',
    name: 'AMPAC In-Space Propulsion (UK)',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004 Oct',
    TStop: '2012 Aug',
    name: 'AMPAC In-Space Propulsion',
    Location: 'Niagara Falls, New York',
    lat: 43.1,
    lon: -79.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMRU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'AMSAT-Russia',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMROC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '1996',
    name: 'American Rocket Company',
    Location: 'Camarillo, California',
    lat: 34.23,
    lon: -119.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1988 May',
    TStop: '2000 Jun',
    name: 'American Mobile Satellite Corp.',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMUK',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1975',
    TStop: '',
    name: 'AMSAT-UK',
    Location: 'Milton Keynes',
    lat: 52.04,
    lon: -0.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMVU',
    StateC: 'IN',
    C: 'Academic',
    TStart: '2001 Oct',
    TStop: '',
    name: 'AMSAT India (AMSAT-VU)',
    Location: 'Bangalore',
    lat: 12.98,
    lon: 77.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AN',
    StateC: 'SU',
    C: 'Government',
    TStart: '',
    TStop: '1991',
    name: 'Akademia Nauk SSSR',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANBEL',
    StateC: 'BY',
    C: 'Government',
    TStart: '1929',
    TStop: '',
    name: 'Natsionalnaya Akademia Navuk Belarusi',
    Location: 'Minsk, Belarus',
    lat: 53.9,
    lon: 27.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANCZ',
    StateC: 'CZ',
    C: 'Government',
    TStart: '1992',
    TStop: '',
    name: 'Akademie ved Ceske republiky',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANDRW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2015',
    name: 'Andrews Space Inc.',
    Location: 'Tukwila, Washington',
    lat: 47.47,
    lon: -122.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BKSA',
    StateC: 'MY',
    C: 'Government',
    TStart: '2002',
    TStop: '2019 Feb',
    name: 'Agensi Angkasa Negara',
    Location: 'Kuala Lumpur',
    lat: 3.13,
    lon: 101.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANNAU',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1978',
    TStop: '',
    name: 'Anna University, Chennai',
    Location: 'Chennai',
    lat: 13.08,
    lon: 80.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AN',
    StateC: 'RU',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'AN Russian Federation',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANSAL',
    StateC: 'YE',
    C: 'Military',
    TStart: '2004',
    TStop: '',
    name: 'Ansar Allah (Houthi) Revolutionary Committee Forces',
    Location: 'Sa\'dah, Yemen',
    lat: 16.99,
    lon: 43.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '2021 Oct',
    name: 'Analytical Space, Inc.',
    Location: 'Cambridge, Massachusetts',
    lat: 42.37,
    lon: -71.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANTEL',
    StateC: 'UY',
    C: 'Government',
    TStart: '1974',
    TStop: '',
    name: 'Administracion Nacional de Telecomunicaciones',
    Location: 'Montevideo',
    lat: -34.88,
    lon: -56.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANTX',
    StateC: 'IN',
    C: 'Government',
    TStart: '1992 Sep',
    TStop: '',
    name: 'Antrix, India Dept. of Space',
    Location: 'Bangalore',
    lat: 12.98,
    lon: 77.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANUC',
    StateC: 'GH',
    C: 'Academic',
    TStart: '2002',
    TStop: '',
    name: 'All Nations University College',
    Location: 'Koforidua, Eastern Region',
    lat: 6.09,
    lon: -0.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AOFTB',
    StateC: 'US',
    C: 'Military',
    TStart: '1945',
    TStop: '1950 Oct',
    name: 'US Army Ordnance, Missile Group, Ft Bliss',
    Location: 'El Paso:Ft Bliss, Texas',
    lat: 31.8,
    lon: -106.42,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AOGD',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Aoyama Gakuin Daigaku',
    Location: 'Tokyo:Shibuya',
    lat: 35.66,
    lon: 139.71,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1950 Apr',
    TStop: '1954 Jan',
    name: 'US Army Ordnance Guided Missile Center',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Dec',
    TStop: '1963 May',
    name: 'Army Ordnance Missile Command',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APAERO',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2012 Feb',
    TStop: '',
    name: 'Asia Pacific (AP) Aerospace Inc.',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APAR',
    StateC: 'AR',
    C: 'Academic',
    TStart: '2001',
    TStop: '',
    name: 'Aprize Argentina',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APGC',
    StateC: 'US',
    C: 'Military',
    TStart: '1957 Dec',
    TStop: '1968 Aug 1',
    name: 'US Air Force Air Proving Ground Center, Eglin AFB',
    Location: 'Eglin AFB, Florida',
    lat: 30.49,
    lon: -86.54,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1953',
    TStop: '',
    name: 'JHU-Applied Physics Lab',
    Location: 'Laurel, Maryland',
    lat: 39.17,
    lon: -76.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1942',
    TStop: '1977',
    name: 'JHU-Applied Physics Lab (Silver Spring)',
    Location: 'DC:Silver Spring, Maryland',
    lat: 39,
    lon: -77.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APMT',
    StateC: 'CN',
    C: 'Government',
    TStart: '1998 Mar',
    TStop: '',
    name: 'Zhongguo Yatai yidongtongxing weixing youxianzerengognsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CALT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RSRS',
    StateC: 'UK',
    C: 'Government',
    TStart: '1974',
    TStop: '1979',
    name: 'Appleton Laboratory',
    Location: 'Ditton Park, Buckinghamshire',
    lat: 51.48,
    lon: -0.57,
    alt: 0,
    Parent: 'SERC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APRZ',
    StateC: 'US',
    C: 'Academic',
    TStart: '2001 May',
    TStop: '',
    name: 'Aprize Satellite Inc.',
    Location: 'Fairfax, Virginia',
    lat: 38.85,
    lon: -77.3,
    alt: 0,
    Parent: 'SPQ',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APSCO',
    StateC: 'CN',
    C: 'Government',
    TStart: '2005',
    TStop: '',
    name: 'Yatai kongjian hezuo zuzhi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APSS',
    StateC: 'NZ',
    C: 'Academic',
    TStart: '2016',
    TStop: '',
    name: 'Auckland Programme for Space Systems, University of Auckland',
    Location: 'Auckland, New Zealand',
    lat: 36.85,
    lon: 174.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APT',
    StateC: 'HK',
    C: 'Commercial',
    TStart: '1992',
    TStop: '',
    name: 'Asia Pacific Telecom',
    Location: 'Hong Kong',
    lat: 22.3,
    lon: 114.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APTS',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Yatai weixing kuandai tongxin (Shenzhen) YG',
    Location: 'Shenzhen',
    lat: 22.54,
    lon: 114.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APW',
    StateC: 'D',
    C: 'Academic',
    TStart: '1964',
    TStop: '1973',
    name: 'Arbeitsgruppe fur physicalische Weltraumforschung, Freiburg',
    Location: 'Freiburg, Baden:Wurttemberg',
    lat: 47.98,
    lon: 7.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARAA',
    StateC: 'US',
    C: 'Military',
    TStart: '1950 Jun 29',
    TStop: '1957 Mar 21',
    name: 'Army Anti Aircraft Command',
    Location: 'Kansas City, Missouri',
    lat: 39.1,
    lon: -94.58,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARAB',
    StateC: 'SA',
    C: 'Commercial',
    TStart: '1976',
    TStop: '',
    name: 'Arabsat, Arab League',
    Location: 'Riyadh, Saudi Arabia',
    lat: 24.63,
    lon: 46.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARAD',
    StateC: 'US',
    C: 'Military',
    TStart: '1957 Mar 21',
    TStop: '1974',
    name: 'Army Air Defense Command',
    Location: 'Kansas City, Missouri',
    lat: 39.1,
    lon: -94.58,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARC',
    StateC: 'US',
    C: 'Government',
    TStart: '1939 Dec',
    TStop: '',
    name: 'NASA Ames Research Center, Moffett Field',
    Location: 'San Francisco, California',
    lat: 37.42,
    lon: -122.05,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARDC',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '1961 Apr 1',
    name: 'USAF Air Research and Development Command',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARDCA',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '1961 Apr 1',
    name: 'USAF Air Research and Development Command (AFCRL division)',
    Location: 'Cambridge, Mass.',
    lat: 42.37,
    lon: -71.11,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1958 Mar 31',
    TStop: '1961 Dec',
    name: 'Army Rocket and Guided Missile Agency',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'AOMC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGOT',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'ArgoTec srl',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GTRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Apr 27',
    TStop: '',
    name: 'Aerojet Rocketdyne Holdings',
    Location: 'Rancho Cordova, California',
    lat: 38.59,
    lon: -121.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORLM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2017 Jul 1',
    TStop: '',
    name: 'ArianeGroup',
    Location: 'Paris/Les Mureaux',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARIU',
    StateC: 'IL',
    C: 'Academic',
    TStart: '1982',
    TStop: '',
    name: 'Ariel University',
    Location: 'Ariel, West Bank, Palestine',
    lat: 32.1,
    lon: 35.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARMAD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2015',
    name: 'Armadillo Aerospace',
    Location: 'Dallas:Mesquite, Texas',
    lat: 32.78,
    lon: -96.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARMF',
    StateC: 'F',
    C: 'Military',
    TStart: '1445',
    TStop: '',
    name: 'Arm/ees francaises',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: 'F',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARMT',
    StateC: 'CN',
    C: 'Government',
    TStart: '1962 Jul',
    TStop: '',
    name: 'Hangtian dongli jishu yanjiuyuan',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARPA',
    StateC: 'US',
    C: 'Military',
    TStart: '1958 Feb 7',
    TStop: '1972 Mar 23',
    name: 'Advanced Research Projects Agency, U.S. DoD',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARPA',
    StateC: 'US',
    C: 'Military',
    TStart: '1993 Feb 22',
    TStop: '1996 Feb 10',
    name: 'Advanced Research Projects Agency, U.S. DoD',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARR',
    StateC: 'N',
    C: 'Government',
    TStart: '1962',
    TStop: '2014 Apr',
    name: 'Andoya Rakettskytefelt',
    Location: 'Andenes, Norway',
    lat: 16.02,
    lon: 69.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARR',
    StateC: 'N',
    C: 'Government',
    TStart: '2014 Apr',
    TStop: '',
    name: 'Andoya Space Center',
    Location: 'Andenes, Norway',
    lat: 16.02,
    lon: 69.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARSAT',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '2006',
    TStop: '',
    name: 'Empresa Argentina de Soluciones Satelitales S.A.',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARSL',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1965',
    TStop: '2014 Mar',
    name: 'KB Arsenal (TsKB-7) im MV Frunze',
    Location: 'Sankt-Peterburg (Leningrad)',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARSL',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '2014 Mar',
    TStop: '',
    name: 'KB Arsenal (TsKB-7) im MV Frunze, fil. ORKK',
    Location: 'Sankt-Peterburg (Leningrad)',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: 'ORKK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GIMR',
    StateC: 'US',
    C: 'Military',
    TStart: '1991 May 6',
    TStop: '',
    name: 'US Army Topographic Engineering Center',
    Location: 'Fort Belvoir, Virginia',
    lat: 38.72,
    lon: -77.15,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GIMR',
    StateC: 'US',
    C: 'Military',
    TStart: '1967 Jul 31',
    TStop: '1991 May 6',
    name: 'US Army Engineer Topographic Laboratories (TOPOCOM, later ACE)',
    Location: 'Fort Belvoir, Virginia',
    lat: 38.72,
    lon: -77.15,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACE',
    StateC: 'US',
    C: 'Military',
    TStart: '1968 Sep 1',
    TStop: '1972 Jul 1',
    name: 'US Army Topographic Command',
    Location: 'Bethesda, Maryland',
    lat: 38.98,
    lon: -77.11,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASAL',
    StateC: 'DZ',
    C: 'Government',
    TStart: '2002 Jan',
    TStop: '',
    name: 'Agence Spatiale Algerienne',
    Location: 'Dzayer (Algiers)',
    lat: 36.75,
    lon: 3.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASBC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2002 Nov',
    TStop: '2007',
    name: 'Shin Eisei Bijinesu KabushiKigaisha',
    Location: 'Tokyo:Chiyoda',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASC45',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USAF 45th Operations Group, Det 2, Ascension Island',
    Location: 'Ascension Island',
    lat: -7.98,
    lon: -14.41,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '1985',
    name: 'American Satellite Corp',
    Location: 'Germantown, Maryland',
    lat: 39.18,
    lon: -77.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASE',
    StateC: 'US',
    C: 'Academic',
    TStart: '1958',
    TStop: '',
    name: 'American Science and Engineering',
    Location: 'Cambridge, MA',
    lat: 42.37,
    lon: -71.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASELSN',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '1975',
    TStop: '',
    name: 'Askeri Eletronik Sanayi (ASELSAN) A.S.',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASES',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Shanghai Ai Yi Si Hangtian Keji YG',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: 'ASES0',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASES0',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Shanghai yuhang xitong gongcheng yanjiu suo',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORLM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2015 Jan 1',
    TStop: '2017 Jul 1',
    name: 'Airbus Safran Launchers',
    Location: 'Paris/Les Mureaux',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASGARD',
    StateC: 'AT',
    C: 'Academic',
    TStart: '2016',
    TStop: '',
    name: 'Asgardia Space',
    Location: 'Wien',
    lat: 48.2,
    lon: 16.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASI',
    StateC: 'I',
    C: 'Government',
    TStart: '1988',
    TStop: '',
    name: 'Agenzia Spaziale Italiana',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: 'I',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASIA',
    StateC: 'HK',
    C: 'Commercial',
    TStart: '1988',
    TStop: '',
    name: 'Yazhou weixing youxian gongsi (Yazhou weixing, AsiaSat)',
    Location: 'Hong Kong',
    lat: 22.3,
    lon: 114.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASID',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1927',
    TStop: '1960',
    name: 'Armstrong Siddeley',
    Location: 'Coventry',
    lat: 52.41,
    lon: -1.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASL',
    StateC: 'US',
    C: 'Military',
    TStart: '1958',
    TStop: '',
    name: 'US Army Atmospheric Sciences Laboratory',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'WSMR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASPLB',
    StateC: 'B',
    C: 'Commercial',
    TStart: '2020 Jun',
    TStop: '',
    name: 'Aerospacelab',
    Location: 'Brussels:Mont-Saint-Guibert',
    lat: 40.63,
    lon: 4.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1972',
    TStop: '1999 Jan',
    name: 'Spar Astro Aerospace, Carpinteria',
    Location: 'Carpinteria, California',
    lat: 34.4,
    lon: -119.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2000 Jul 10',
    TStop: '2003 Jun 16',
    name: 'Astrium (D), Bremen',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2000 Jul 10',
    TStop: '2003 Jun 16',
    name: 'Astrium (D), Friedrichshafen',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PHILR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '1959 Sep 30',
    name: 'Astrodyne Inc. (Phillips/NAA)',
    Location: 'McGregor, Texas',
    lat: 31.43,
    lon: -97.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTRAN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Astranis Space Technologies Corp.',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTFN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Astro-und-Feinwerktechnik Adlershof GmbH (Astrofein Technik)',
    Location: 'Berlin',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTL',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2014 Jan 1',
    name: 'Astrium (D), Lampoldshausen',
    Location: 'Lampoldshausen',
    lat: 49.27,
    lon: 9.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASA',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2006 Jul',
    TStop: '2014 Jan 1',
    name: 'EADS Astrium Satellites/Barajas (CASA Espacio)',
    Location: 'Madrid:Barajas',
    lat: 40.47,
    lon: -3.59,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ADSNA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2014 Jan 1',
    name: 'Astrium North America',
    Location: 'Houston:Webster, Texas',
    lat: 29.54,
    lon: -95.12,
    alt: 0,
    Parent: 'ADS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOLK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2006 Jul',
    TStop: '2014 Jan 1',
    name: 'Astrium Space Propulsion/Ottobrunn',
    Location: 'Munchen:Ottobrunn',
    lat: 48.07,
    lon: 11.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTRA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Atmospheric and Space Technology Research Associates LLC',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VENT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Astra Space',
    Location: 'Alameda, California',
    lat: 37.76,
    lon: -122.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Avellan Space Technology and Science',
    Location: 'Midland, Texas',
    lat: 31.94,
    lon: -102.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTSC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Astroscale Japan Inc.',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MATT',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2014 Jan 1',
    name: 'Astrium (F) Toulouse',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVS',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2014 Jan 1',
    name: 'Astrium Ltd (UK)',
    Location: 'Stevenage',
    lat: 51.9,
    lon: -0.2,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1885',
    TStop: '',
    name: 'Arizona State University',
    Location: 'Phoenix:Tempe, Arizona',
    lat: 33.42,
    lon: -111.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATSB',
    StateC: 'MY',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Astronautic Technology (M) Sdn Bhd',
    Location: 'Shah Alam, Selangor, Malaysia',
    lat: 3.07,
    lon: 101.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATECH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2014',
    name: 'Astrotech Space Operations',
    Location: 'Titusville, Florida',
    lat: 28.59,
    lon: -80.82,
    alt: 0,
    Parent: 'SHAB',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATECHS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2000',
    name: 'Astrotech Space Operations (Suborbital)',
    Location: 'Washington, DC:Greenbelt',
    lat: 38.99,
    lon: -76.89,
    alt: 0,
    Parent: 'SHAB',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHABT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2009',
    name: 'Astrotech Corp.',
    Location: 'Austin, Texas',
    lat: 30.27,
    lon: -97.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATEF',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1954',
    TStop: '1960',
    name: 'Association Technique pour l\'Etude des Fusees',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATHERM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Aerotherm Corp.',
    Location: 'Alberquerque, New Mexico',
    lat: 35.11,
    lon: -106.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1959',
    TStop: '',
    name: 'Advanced Technology, Inc. (ATI)',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990',
    TStop: '',
    name: 'Alliant Techsystems',
    Location: 'Minneapolis:Eden Prairie, Minnesota',
    lat: 44.85,
    lon: -93.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AECAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '2015 Feb 10',
    name: 'ATK Able Engineering',
    Location: 'Goleta, California',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2015 Feb 10',
    name: 'ATK Tactical Systems, Alleghany Ballistic Laboratories (USN)',
    Location: 'Cumberland:Rocket Center, West Virginia',
    lat: 39.56,
    lon: -78.83,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATKB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014',
    TStop: '2015 Feb 10',
    name: 'ATK Defense Group / Missile Products',
    Location: 'Baltimore, Maryland',
    lat: 39.28,
    lon: -76.62,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2015 Feb 10',
    name: 'Alliant Thiokol',
    Location: 'Elkton, Maryland',
    lat: 39.61,
    lon: -75.83,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GASL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '2015 Feb 10',
    name: 'ATK GASL',
    Location: 'Ronkonkoma, New York',
    lat: 40.81,
    lon: -73.13,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2015 Feb 10',
    name: 'Alliant Thiokol (Promontory)',
    Location: 'Brigham City:Promontory, Utah',
    lat: 41.62,
    lon: -112.55,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HERC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar',
    TStop: '2015 Feb 10',
    name: 'Alliant (Hercules)',
    Location: 'Salt Lake City:Magna/Bacchus, Utah',
    lat: 40.7,
    lon: -112.08,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATKL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2015 Feb ',
    name: 'ATK Launch Systems',
    Location: 'Brigham City:Promontory, Utah',
    lat: 41.62,
    lon: -112.55,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWALES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2007 Jun',
    TStop: '2015 Feb 10',
    name: 'ATK Space Division',
    Location: 'Beltsville, Maryland',
    lat: 39.04,
    lon: -76.92,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003 Nov',
    TStop: '2011 Mar',
    name: 'ATK Propulsion and Controls Div.',
    Location: 'Tullahoma, Tennessee',
    lat: 35.37,
    lon: -86.21,
    alt: 0,
    Parent: 'ATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATLA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1951',
    TStop: '',
    name: 'Atlantic Research Corp. (Alexandria)',
    Location: 'Alexandria, Virginia',
    lat: 38.8,
    lon: -77.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATLC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '',
    name: 'Atlantic Research Corp. Missile Systems Div.',
    Location: 'LA:Costa Mesa, California',
    lat: 33.67,
    lon: -117.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATLCA',
    StateC: 'US',
    C: 'Unknown',
    TStart: '',
    TStop: '2003',
    name: 'Atlantic Research Corp. (Camden)',
    Location: 'East Camden, Arkansas',
    lat: 33.61,
    lon: -92.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATLH',
    StateC: 'HU',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Advanced Technology of Laser Kft.',
    Location: 'Csapas, Hungary',
    lat: 47.62,
    lon: 19.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998',
    TStop: '2004',
    name: 'Atlantic Research Corp. (Liquid Propulsion Div).',
    Location: 'Niagara Falls, New York',
    lat: 43.1,
    lon: -79.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEROL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1968',
    name: 'Atlantic Research Corp. Missile Systems (Aerolab)',
    Location: 'Pasadena:Monrovia, California',
    lat: 34.15,
    lon: -118,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATLR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1951',
    TStop: '2003',
    name: 'Atlantic Research Corp. (Solid Propulsion Div).',
    Location: 'Gainesville, Virginia',
    lat: 38.79,
    lon: -77.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATLR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '2005',
    name: 'Aerojet Atlantic Research Corp. (Solid Propulsion Div).',
    Location: 'Gainesville, Virginia',
    lat: 38.79,
    lon: -77.62,
    alt: 0,
    Parent: 'AJGC',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Military',
    TStart: '1998',
    TStop: '2004',
    name: 'Atlantic Research Corp. UK',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATMIR',
    StateC: 'AT',
    C: 'Government',
    TStart: '1988',
    TStop: '1992',
    name: 'Projekt AUSTROMIR 91',
    Location: 'Wien',
    lat: 48.21,
    lon: 16.36,
    alt: 0,
    Parent: 'BMWFO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1996',
    name: 'American Telephone and Telegraph Co.',
    Location: 'Bedminster, New Jersey',
    lat: 40.67,
    lon: -74.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATTH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021',
    TStop: '',
    name: 'AT&T Honolulu',
    Location: 'Honolulu, Hawaii',
    lat: 21.3,
    lon: -157.82,
    alt: 0,
    Parent: 'ATT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATTS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1996',
    name: 'AT&T Skynet Satellite Services',
    Location: 'Bedminster, New Jersey',
    lat: 40.67,
    lon: -74.69,
    alt: 0,
    Parent: 'ATT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUBU',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Auburn University',
    Location: 'Auburn, Alabama',
    lat: 32.6,
    lon: -85.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUCZ',
    StateC: 'CZ',
    C: 'Government',
    TStart: '1992',
    TStop: '',
    name: 'Astronomicky\' u\'stav AV CR',
    Location: 'Ondrejov',
    lat: 49.92,
    lon: 14.78,
    alt: 0,
    Parent: 'ANCZ',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUDACY',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Audacy',
    Location: 'San Francisco:Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUDISR',
    StateC: 'AU',
    C: 'Government',
    TStart: '2009',
    TStop: '',
    name: 'Space Policy Unit, Dept of Innovation, Industry, Science and Research',
    Location: 'Canberra, ACT',
    lat: 35.31,
    lon: 149.12,
    alt: 0,
    Parent: 'AU',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUINS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Aurora Insight Inc.',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AURAK',
    StateC: 'UAE',
    C: 'Academic',
    TStart: '2009',
    TStop: '',
    name: 'American University of Ras Al Khaimah',
    Location: 'Ras al-Khaimah',
    lat: 25.78,
    lon: 55.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AURFS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1989',
    TStop: '',
    name: 'Aurora Flight Sciences',
    Location: 'Manassas, Virginia',
    lat: 38.7214,
    lon: -77.5156,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLSYS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2007 Oct',
    TStop: '2007 Dec',
    name: 'Aurora Flight Sciences/Payload Systems, Inc.',
    Location: 'Cambridge, Massachusetts',
    lat: 42.37,
    lon: -71.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUSP',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '1983',
    TStop: '2007',
    name: 'Auspace Pty',
    Location: 'Canberra:Fyshwick',
    lat: -35.33,
    lon: 149.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUSS',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '1982',
    TStop: '1992 Jan',
    name: 'Aussat Pty, Australia',
    Location: 'Sydney',
    lat: -33.87,
    lon: 151.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUT',
    StateC: 'J',
    C: 'Academic',
    TStart: '1987',
    TStop: '',
    name: 'Aichi koka daigaku',
    Location: 'Gamagori, Aichi',
    lat: 34.83,
    lon: 137.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AVANTI',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2007',
    TStop: '',
    name: 'Avanti Communications Group plc',
    Location: 'London',
    lat: 51.51,
    lon: -0.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AVCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1986',
    name: 'Avco Corporation',
    Location: 'Wilmington, Mass.',
    lat: 42.55,
    lon: -71.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AVIB',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '1961',
    TStop: '',
    name: 'Avibras Industria Aeroespacial',
    Location: 'Sao Jose dos Campos',
    lat: -23.19,
    lon: -45.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BPD',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'Avio s.p.A.',
    Location: 'Colleferro',
    lat: 41.73,
    lon: 13.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SS500',
    StateC: 'DR',
    C: 'Military',
    TStart: '1945',
    TStop: '1945',
    name: 'Altenwalde Versuchskommando',
    Location: 'Cuxhaven:Altenwalde, Germany',
    lat: 53.86,
    lon: 8.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AWS',
    StateC: 'US',
    C: 'Military',
    TStart: '1947',
    TStop: '1997 Oct',
    name: 'USAF Air Weather Service, Scott AFB',
    Location: 'St Louis:Belleville, Missouri',
    lat: 37.12,
    lon: -94.59,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AXEL',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'AXELSPACE Corporation',
    Location: 'Tokyo:Chiyoda',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AXIOM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Axiom Space, Inc.',
    Location: 'Houston, Texas',
    lat: 29.56,
    lon: -95.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AZER',
    StateC: 'AZ',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Azerkosmos, Azerbaycan Resp. Rabita va Informasiya Texnologiyalari Nazirliyi',
    Location: 'Baku',
    lat: 40.4,
    lon: 49.88,
    alt: 0,
    Parent: 'AZRITN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AZRITN',
    StateC: 'AZ',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Azerbaycan Respublikasinin Rabita va Informasiya Texnologiyalari Nazirliyi',
    Location: 'Baku',
    lat: 40.4,
    lon: 49.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BABTS',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1965',
    TStop: '',
    name: 'Babakin Science and Research Space Center',
    Location: 'Moskva:Khimki',
    lat: 55.9,
    lon: 37.45,
    alt: 0,
    Parent: 'NPOL',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAC',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1910',
    TStop: '1977 Apr',
    name: 'British Aircraft Corp.',
    Location: 'Bristol:Filton, Avon',
    lat: 51.51,
    lon: -2.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BACB',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1959',
    name: 'Bristol Aeroplane Co., Banwell Factory',
    Location: 'Bristol:Banwell, Avon',
    lat: 51.33,
    lon: -2.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAC',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1977 Apr',
    TStop: '',
    name: 'British Aerospace (BAe) Systems',
    Location: 'Bristol:Filton, Avon',
    lat: 51.51,
    lon: -2.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SANH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '',
    name: 'BAe Electronic Systems, Nashua',
    Location: 'Nashua, New Hampshire',
    lat: 42.76,
    lon: -71.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVS',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1977 Apr',
    TStop: '1994',
    name: 'British Aerospace',
    Location: 'Stevenage, Hertfordshire',
    lat: 51.9,
    lon: -0.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAJ',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1967',
    name: 'Canadian Bristol Aerojet Ltd',
    Location: 'Winnipeg, Manitoba',
    lat: 49.9,
    lon: -97.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAJ',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1997',
    name: 'Bristol Aerospace',
    Location: 'Winnipeg, Manitoba',
    lat: 49.9,
    lon: -97.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAJ',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Bristol Aerospace Ltd., Magellan Aerospace Corporation',
    Location: 'Winnipeg, Manitoba',
    lat: 49.9,
    lon: -97.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BACB',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1959',
    TStop: '1991',
    name: 'Bristol Aerojet UK, Banwell Factory',
    Location: 'Bristol:Banwell, Avon',
    lat: 51.33,
    lon: -2.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BALL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '',
    name: 'Ball Aerospace',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAS',
    StateC: 'UK',
    C: 'Government',
    TStart: '1962',
    TStop: '',
    name: 'British Antarctic Survey',
    Location: 'Cambridge, Cambridgeshire',
    lat: 52.21,
    lon: 0.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAUM',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1917',
    TStop: '',
    name: 'Moskovskiy Gosudarstvennity Tekhnicheskiy Universtitet im. NE Bauman',
    Location: 'Moskva',
    lat: 55.77,
    lon: 37.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAYI',
    StateC: 'CN',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Beijing shi bayi xuexiao',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'REYE',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2013 Nov 6',
    TStop: '2015 Aug',
    name: 'BlackBridge',
    Location: 'Brandenburg an der Havel, Brandenburg',
    lat: 52.42,
    lon: 12.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BCCT',
    StateC: 'T',
    C: 'Academic',
    TStart: '1902',
    TStop: '',
    name: 'Rongreiyn krungthephkkhristeiyn withyalay',
    Location: 'Bangkok:Bang Rak',
    lat: 13.72,
    lon: 100.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BCSCL',
    StateC: 'BD',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Bangladesh Communications Satellite Company Ltd',
    Location: 'Dhaka',
    lat: 23.72,
    lon: 90.4,
    alt: 0,
    Parent: 'BTRC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BDSAGR',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Guozhiheng Beidou hao Nianjing Nongye Keji YG',
    Location: 'Zhengzhou, Henan',
    lat: 34.75,
    lon: 113.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BENCH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'Benchmark Space',
    Location: 'Burlington, Vermont',
    lat: 44.47,
    lon: -73.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BERG',
    StateC: 'N',
    C: 'Academic',
    TStart: '1946',
    TStop: '',
    name: 'Universitetet i Bergen (UiB)',
    Location: 'Bergen',
    lat: 60.39,
    lon: 5.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELINT',
    StateC: 'BY',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'Belintersat',
    Location: 'Minsk, Belarus',
    lat: 53.9,
    lon: 27.57,
    alt: 0,
    Parent: 'ZTZM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1935',
    TStop: '1960',
    name: 'Bell Aircraft (Air Force Plant 38)',
    Location: 'Niagara Falls, New York',
    lat: 43.1,
    lon: -79.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELM',
    StateC: 'B',
    C: 'Military',
    TStart: '1949',
    TStop: '2002',
    name: 'Belgische Luchtmacht',
    Location: 'Brussel',
    lat: 50.85,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1994',
    name: 'Bell Textron (Bell Aerospace)',
    Location: 'Niagara Falls, New York',
    lat: 43.1,
    lon: -79.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BENDX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Bendix Systems Div.',
    Location: 'Ann Arbor, Michigan',
    lat: 42.28,
    lon: -83.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BERN',
    StateC: 'CH',
    C: 'Academic',
    TStart: '1834',
    TStop: '',
    name: 'Universitat Bern',
    Location: 'Berne, Berne',
    lat: 46.95,
    lon: 7.44,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BGSAT',
    StateC: 'BGN',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Bulgaria Sat AD',
    Location: 'Stara Zagora',
    lat: 42.43,
    lon: 25.65,
    alt: 0,
    Parent: 'BULSAT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BGU',
    StateC: 'IL',
    C: 'Academic',
    TStart: '1969',
    TStop: '',
    name: 'Universtitat Ben-Guriyyon ba-Negev',
    Location: 'Beersheba',
    lat: 31.26,
    lon: 34.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BHSJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Beijing hangtian shijing xinxi xishu youxian gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BIGEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '',
    name: 'Bigelow Aerospace',
    Location: 'N Las Vegas, Nevada',
    lat: 36.23,
    lon: -115.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BINA',
    StateC: 'MY',
    C: 'Commercial',
    TStart: '1993',
    TStop: '2001',
    name: 'Binariang Satellite Systems Sdn. Bhd.',
    Location: 'Kuala Lumpur',
    lat: 3.13,
    lon: 101.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BIR',
    StateC: 'UK',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Birmingham University',
    Location: 'Birmingham',
    lat: 52.45,
    lon: -1.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BISME',
    StateC: 'CN',
    C: 'Government',
    TStart: '1958 Aug 21',
    TStop: '',
    name: 'Beijing kongjian jidian yanjiu suo (Hangtian 508 Suo)',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CAST',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BIT',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1940',
    TStop: '',
    name: 'Beijing Ligong Daxue',
    Location: 'Beijing',
    lat: 39.96,
    lon: 116.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BKSA',
    StateC: 'MY',
    C: 'Government',
    TStart: '1992',
    TStop: '2002',
    name: 'Bahagian Kajian Sains Angkasa (BAKSA)',
    Location: 'Kuala Lumpur',
    lat: 3.13,
    lon: 101.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLCAN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '2021',
    name: 'Blue Canyon Technologies',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLMIT',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2001 Jun',
    TStop: '2011',
    name: 'Beijing yushi lantu xinxijishu youxiangongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '21AT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLOR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '',
    name: 'Blue Origin LLC',
    Location: 'Kent, Washington',
    lat: 47.38,
    lon: -122.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLORH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'Blue Origin LLC, Huntsville Operations',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLORTX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '',
    name: 'Blue Origin LLC, West Texas operations',
    Location: 'Van Horn, Texas',
    lat: 31.04,
    lon: -104.83,
    alt: 0,
    Parent: 'BLOR',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLOT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021',
    TStop: '',
    name: 'Blue Origin spaceflight passengers',
    Location: 'Van Horn, Texas',
    lat: 31.04,
    lon: -104.83,
    alt: 0,
    Parent: 'BLOR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990s',
    TStop: '*',
    name: 'Boeing Launch Services ()',
    Location: 'Huntington Beach, California',
    lat: 33.69,
    lon: -118,
    alt: 0,
    Parent: 'BOHB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BMWF',
    StateC: 'D',
    C: 'Government',
    TStart: '1994',
    TStop: '',
    name: 'Bundesministerium fur Bildung und Forschung',
    Location: 'Bonn',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: 'D',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BMWF',
    StateC: 'D',
    C: 'Government',
    TStart: '1969 Sep',
    TStop: '1994',
    name: 'Bundesministerium fur Bildung und Wissenschaft',
    Location: 'Bonn',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: 'D',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BME',
    StateC: 'HU',
    C: 'Academic',
    TStart: '1782',
    TStop: '',
    name: 'Budapesti Muszakies Gazdasagtudomanyi Egyetem (BME)',
    Location: 'Budapest',
    lat: 47.48,
    lon: 19.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BMFT',
    StateC: 'D',
    C: 'Government',
    TStart: '1972',
    TStop: '1994',
    name: 'Bundesministerium fur Forschung und Technologie',
    Location: 'Bonn',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: 'D',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDIO',
    StateC: 'US',
    C: 'Military',
    TStart: '1993',
    TStop: '2002',
    name: 'Ballistic Missile Defense Organization',
    Location: 'Washington,DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BMWF',
    StateC: 'D',
    C: 'Government',
    TStart: '1962',
    TStop: '1969 Sep',
    name: 'Bundesministerium fur wissenschafltiche Forschung',
    Location: 'Bonn',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: 'D',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BMWFO',
    StateC: 'AT',
    C: 'Government',
    TStart: '1848',
    TStop: '',
    name: 'Bundesministerium fur Wissenschaft und Forschung',
    Location: 'Wien',
    lat: 48.21,
    lon: 16.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BMVG',
    StateC: 'D',
    C: 'Military',
    TStart: '1955',
    TStop: '',
    name: 'Bundesministerium der Verteidigung',
    Location: 'Bonn:Hardthohe',
    lat: 50.7,
    lon: 7.04,
    alt: 0,
    Parent: 'D',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RWI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996 Dec',
    TStop: '',
    name: 'Boeing North American/Palmdale',
    Location: 'Plant 42, Palmdale, California',
    lat: 34.58,
    lon: -118.1,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BNC',
    StateC: 'UK',
    C: 'Government',
    TStart: '1958',
    TStop: '1965',
    name: 'British National Committee for Space Research, Royal Society',
    Location: 'London',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BNSC',
    StateC: 'UK',
    C: 'Government',
    TStart: '1985',
    TStop: '2010 Apr 1',
    name: 'British National Space Center',
    Location: 'Swindon',
    lat: 51.56,
    lon: -1.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BNU',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1902',
    TStop: '',
    name: 'Beijing Shifan Daxue',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BO2',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1936',
    TStop: '',
    name: 'Boeing Airplane Co Plant 2 (E Marginal Way)',
    Location: 'Seattle:Boeing Field, Washington',
    lat: 47.54,
    lon: -122.3,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1916',
    TStop: '1972',
    name: 'Boeing Airplane Co Plant 1, 27th Ave S',
    Location: 'Seattle:King, Washington',
    lat: 47.57,
    lon: -122.3,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOC3PF',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Boeing Comm. Crew Processing Facility, OFF-3',
    Location: 'Kennedy Space Center, Florida',
    lat: 28.61,
    lon: -80.6,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOCH',
    StateC: 'D',
    C: 'Academic',
    TStart: '1962',
    TStop: '',
    name: 'Ruhr-Universtitat Bochum',
    Location: 'Bochum, NordRhein:Westfalen',
    lat: 51.44,
    lon: 7.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RDYNE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996 Dec',
    TStop: '2005 Aug',
    name: 'Boeing Rocketdyne',
    Location: 'Canoga Park, California',
    lat: 34.2,
    lon: -118.6,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1916',
    TStop: '',
    name: 'Boeing Co.',
    Location: 'Seattle, Washington',
    lat: 47.54,
    lon: -122.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSEDD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2005',
    name: 'Electron Dynamic Devices, Boeing Satellite Systems',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JDA',
    StateC: 'J',
    C: 'Military',
    TStart: '2007 Jan 9',
    TStop: '',
    name: 'Boei-sho (Japan Defense Ministry)',
    Location: 'Tokyo:Ichigaya',
    lat: 35.69,
    lon: 139.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000 Oct',
    TStop: '*',
    name: 'Boeing Satellite Development Center, El Segundo',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DACHB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996 Dec',
    TStop: '',
    name: 'Boeing Space Systems (HB)',
    Location: 'Huntington Beach, California',
    lat: 33.69,
    lon: -118,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOSE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'Boeing Houston Product Support Center (HPSC)',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOHSV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '',
    name: 'Boeing Huntsville (HIA)',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDHSV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Boeing Huntsville (Cummings)',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOKSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1965',
    TStop: '',
    name: 'Boeing Space and Launch Division',
    Location: 'Titusville, Florida',
    lat: 28.52,
    lon: -80.79,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOKT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1964',
    TStop: '',
    name: 'Boeing Space Center, Kent',
    Location: 'Kent, Washington',
    lat: 47.38,
    lon: -122.23,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOL',
    StateC: 'I',
    C: 'Academic',
    TStart: '1088',
    TStop: '',
    name: 'Alma Mater Studiorum Universita di Bologna',
    Location: 'Bologna, Emilia-Romagna',
    lat: 44.49,
    lon: 11.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOLK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1968',
    name: 'B\\"olkow-Entwicklungen KG',
    Location: 'Munchen:Ottobrunn',
    lat: 48.07,
    lon: 11.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOMI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1973',
    name: 'Boeing, NASA Michoud Assembly Facility',
    Location: 'Michoud, Louisiana',
    lat: 30.02,
    lon: -89.92,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILLES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Boeing Millenium Space Systems/El Segundo factory',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'MILLEN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOMIS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Boeing SLS Operations, NASA Michoud Assembly Facility',
    Location: 'Michoud, Louisiana',
    lat: 30.02,
    lon: -89.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BONN',
    StateC: 'D',
    C: 'Academic',
    TStart: '1818',
    TStop: '',
    name: 'Rhenische Friedrich-Wilhelms-Universitat Bonn',
    Location: 'Bonn, Nordrhein:Westfalen',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BONUM',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2003',
    name: 'BONUM-1 Co., Media Most',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOOZA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1914',
    TStop: '',
    name: 'Booz Allen Hamilton',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOPBL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1987 Apr',
    TStop: '',
    name: 'Boeing/Pueblo',
    Location: 'Pueblo, Colorado',
    lat: 38.27,
    lon: -104.62,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MCDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Boeing Phantom Works, St Louis',
    Location: 'St Louis, Missouri',
    lat: 38.63,
    lon: -90.2,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOSE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2014',
    name: 'Boeing Space Exploration',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAASB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996 Dec',
    TStop: '',
    name: 'Boeing/Seal Beach',
    Location: 'Seal Beach, California',
    lat: 33.76,
    lon: -118.08,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOSL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2010',
    name: 'Sea Launch Inc.',
    Location: 'Long Beach, California',
    lat: 33.77,
    lon: -118.2,
    alt: 0,
    Parent: 'SEALP',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOTUL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '2003',
    name: 'Boeing/Tulsa, Air Force Plant 3',
    Location: 'Tulsa, Oklahoma',
    lat: 36.13,
    lon: -95.94,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOUT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1978 Nov 30',
    name: 'Boeing/Ogden, Air Force Plant 77',
    Location: 'Ogden, Utah',
    lat: 41.23,
    lon: -111.96,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BPD',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1912 Oct 26',
    TStop: '1994',
    name: 'BPD Difesa e Spazio',
    Location: 'Colleferro',
    lat: 41.73,
    lon: 13.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GFW',
    StateC: 'D',
    C: 'Government',
    TStart: '1975',
    TStop: '',
    name: 'DFVLR-BPT Bereich fur Projecttragerschaften',
    Location: 'Koln',
    lat: 50.94,
    lon: 6.95,
    alt: 0,
    Parent: 'DFVLR',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BRCTA',
    StateC: 'BR',
    C: 'Military',
    TStart: '1953',
    TStop: '',
    name: 'Comando-Geral de Tecnologia Aerospacial',
    Location: 'Sao Jose dos Campos, Brasil',
    lat: -23.19,
    lon: -45.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BREC',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1918',
    TStop: '1956',
    name: 'Bristol Engine Co.',
    Location: 'Bristol:Filton',
    lat: 51.51,
    lon: -2.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BREI',
    StateC: 'D',
    C: 'Academic',
    TStart: '1947',
    TStop: '',
    name: 'Ionospharen Institut Breisach',
    Location: 'Breisach, Baden-Wutternberg',
    lat: 48.03,
    lon: 7.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BREM',
    StateC: 'D',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Universitat Bremen',
    Location: 'Bremen, FH Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BRAC',
    StateC: 'BD',
    C: 'Academic',
    TStart: '2001',
    TStop: '',
    name: 'BRAC University',
    Location: 'Dhaka:Mohakhali',
    lat: 23.78,
    lon: 90.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BREC',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1958',
    name: 'Bristol Aero Engines',
    Location: 'Bristol:Filton',
    lat: 51.51,
    lon: -2.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BAJ',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1954',
    TStop: '1962',
    name: 'Bristol Aeroplane Co. (Canada)',
    Location: 'Winnipeg, Manitoba',
    lat: 49.9,
    lon: -97.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BRID',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '1895',
    TStop: '',
    name: 'PT Bank Rakyat Indonesia (Persero) Tbk.',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BRIS',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1909',
    TStop: '',
    name: 'Bristol University',
    Location: 'Bristol',
    lat: 51.46,
    lon: -2.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1941',
    TStop: '1992',
    name: 'US Army Ballistic Research Lab, Aberdeen Proving Ground',
    Location: 'Aberdeen, Maryland',
    lat: 39.51,
    lon: -76.17,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BROWN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1764',
    TStop: '',
    name: 'Brown University',
    Location: 'Providence, Rhode Island',
    lat: 41.83,
    lon: -71.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BRSW',
    StateC: 'D',
    C: 'Academic',
    TStart: '1968',
    TStop: '',
    name: 'Technische Universitat Braunschweig',
    Location: 'Braunschweig, Niedersachsen',
    lat: 52.27,
    lon: 10.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CELES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '',
    name: 'Brunswick Corp.',
    Location: 'Costa Mesa, California',
    lat: 33.67,
    lon: -117.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BRVCC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Brevard Community College',
    Location: 'Melbourne, Florida',
    lat: 28.17,
    lon: -80.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BSAT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1993 Apr 13',
    TStop: '',
    name: 'Kabushiikgaisha hosoeisei shisutemu',
    Location: 'Shibuya-ku, Tokyo',
    lat: 35.66,
    lon: 139.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BSB',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1986',
    TStop: '1990 Dec',
    name: 'British Satellite Broadcasting',
    Location: 'Wandsworth, London',
    lat: 51.46,
    lon: -0.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GSFC',
    StateC: 'US',
    C: 'Government',
    TStart: '1959 Jan 15',
    TStop: '1959 May 1',
    name: 'NASA Beltsville Space Center',
    Location: 'Beltsville (Greenbelt), Maryland',
    lat: 38.99,
    lon: -76.89,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BREC',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1958',
    TStop: '1966',
    name: 'Bristol Siddeley (Filton)',
    Location: 'Bristol:Filton',
    lat: 51.51,
    lon: -2.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASID',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1966',
    name: 'Bristol Siddeley (Coventry)',
    Location: 'Coventry:Ansty',
    lat: 52.45,
    lon: -1.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1959',
    TStop: '1966',
    name: 'Bristol Siddeley Engines Ltd (BSEL) Leavesden',
    Location: 'Watford:Leavesden, Hertfordshire',
    lat: 51.7,
    lon: -0.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BSB',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1990 Dec',
    TStop: '*',
    name: 'British Sky Broadcasting',
    Location: 'Isleworth, London',
    lat: 51.47,
    lon: -0.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BSKG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Mar',
    TStop: '',
    name: 'BlackSky Global',
    Location: 'Tukwila, Washington',
    lat: 47.47,
    lon: -122.26,
    alt: 0,
    Parent: 'SFLIN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUB',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2014',
    TStop: '2014',
    name: 'Berlin Space Technlogies GmBH',
    Location: 'Berlin:Aldershof',
    lat: 52.44,
    lon: 13.55,
    alt: 0,
    Parent: 'TUB1',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BSUBY',
    StateC: 'BY',
    C: 'Academic',
    TStart: '1921',
    TStop: '',
    name: 'Belaruski dzyarzhauny universitet',
    Location: 'Minsk, Belarus',
    lat: 53.9,
    lon: 27.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BTDITT',
    StateC: 'BT',
    C: 'Government',
    TStart: '2003 Aug',
    TStop: '',
    name: 'Department of Information Technology and Telecommunications, Bhutan',
    Location: 'Thimphu',
    lat: 27.47,
    lon: 89.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BTL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1925',
    TStop: '1996',
    name: 'American Telephone and Telegraph Co. Bell Telephone Laboratories',
    Location: 'Murray Hill, New Jersey',
    lat: 40.7,
    lon: -74.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BTLW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1925',
    TStop: '1996',
    name: 'American Telephone and Telegraph Co. Bell Telephone Laboratories',
    Location: 'Whippany, New Jersey',
    lat: 40.82,
    lon: -74.42,
    alt: 0,
    Parent: 'BTL',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BTRC',
    StateC: 'BD',
    C: 'Government',
    TStart: '2002',
    TStop: '',
    name: 'Banladesa Teiyogayoga Niyantrana Kamisana',
    Location: 'Dhaka',
    lat: 23.72,
    lon: 90.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BTWK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Beijing Tongxin Weixing Keji Fazhan YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1839',
    TStop: '',
    name: 'Boston University',
    Location: 'Boston, Mass.',
    lat: 42.35,
    lon: -71.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUAA',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1952 Oct',
    TStop: '',
    name: 'Beijing hangkong hangtian daxue',
    Location: 'Beijing',
    lat: 39.98,
    lon: 116.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUAER',
    StateC: 'US',
    C: 'Military',
    TStart: '1921',
    TStop: '1959',
    name: 'Bureau of Aeronautics',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUAERG',
    StateC: 'US',
    C: 'Military',
    TStart: '1946',
    TStop: '1959',
    name: 'Guided Missile Division, Bureau of Aeronautics',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'BUAER',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUCU',
    StateC: 'RO',
    C: 'Academic',
    TStart: '1864',
    TStop: '',
    name: 'Universitatea din Bucuresti',
    Location: 'Bucuresti',
    lat: 44.44,
    lon: 26.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BULSAT',
    StateC: 'BGN',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Bulsatcom AD',
    Location: 'Stara Zagora',
    lat: 42.43,
    lon: 25.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUORD',
    StateC: 'US',
    C: 'Military',
    TStart: '1862',
    TStop: '1959 Sep 1',
    name: 'Bureau of Ordnance, US Navy',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUSEK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '',
    name: 'Busek Co. Inc.',
    Location: 'Natick, Mass.',
    lat: 42.28,
    lon: -71.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUORD',
    StateC: 'US',
    C: 'Military',
    TStart: '1959 Sep 1',
    TStop: '1966 May 1',
    name: 'Bureau of Naval Weapons, US Navy',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BWB',
    StateC: 'D',
    C: 'Military',
    TStart: '1957',
    TStop: '',
    name: 'Bundesamt fur Wehrtechnik und Beschaffung',
    Location: 'Koblenz',
    lat: 50.36,
    lon: 7.6,
    alt: 0,
    Parent: 'BWEHR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BWEHR',
    StateC: 'D',
    C: 'Military',
    TStart: '1955 Nov 12',
    TStop: '',
    name: 'Bundeswehr',
    Location: 'Bonn',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BWYIC',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1957 Nov 11',
    TStop: '',
    name: 'Beijing Wan Yuan Industry Corp.',
    Location: 'Beijing:WanYuan',
    lat: 39.81,
    lon: 116.51,
    alt: 0,
    Parent: 'CALT',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BYU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1875 Oct 16',
    TStop: '',
    name: 'Brigham Young University',
    Location: 'Provo, Utah',
    lat: 40.25,
    lon: -111.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BYXYS',
    StateC: 'CN',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Beijing yaogan xinxi yanjiu suo (Zongcan hangtain jishu zhencha ju)',
    Location: 'Beijing:Qinghe',
    lat: 40.04,
    lon: 116.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'C360',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '1986',
    name: 'Cinema 360, Inc. (Consortium led by Flandrau Planetarium)',
    Location: 'Tuscon, Arizona',
    lat: 32.23,
    lon: -110.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'C3S',
    StateC: 'HU',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'C3S LLC',
    Location: 'Budapest',
    lat: 47.49,
    lon: 19.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CABVS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1973',
    TStop: '',
    name: 'Cablevision Systems Corp.',
    Location: 'Bethpage, Long Island, New York',
    lat: 40.75,
    lon: -73.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1967',
    TStop: '',
    name: 'Columbia Astrophysics Lab, Columbia University',
    Location: 'New York, New York',
    lat: 40.81,
    lon: -73.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CALET',
    StateC: 'J',
    C: 'Academic',
    TStart: '2014',
    TStop: '',
    name: 'CALET Collaboration, Science Data Analysis Center',
    Location: 'Tokyo:Shinjuku',
    lat: 35.71,
    lon: 139.72,
    alt: 0,
    Parent: 'WASEDA',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CALG',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1966',
    TStop: '',
    name: 'University of Calgary',
    Location: 'Calgary, Alberta',
    lat: 51.08,
    lon: -114.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CALP',
    StateC: 'US',
    C: 'Academic',
    TStart: '1901',
    TStop: '',
    name: 'California Polytechnic State University',
    Location: 'San Luis Obispo, California',
    lat: 35.3,
    lon: -120.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CALT',
    StateC: 'CN',
    C: 'Government',
    TStart: '1957 Nov 11',
    TStop: '',
    name: 'Zhongguo yunzaihuojian jishu yanjiu yuan',
    Location: 'Beijing:Nanyuan',
    lat: 39.78,
    lon: 116.39,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CALTQ',
    StateC: 'CN',
    C: 'Government',
    TStart: '2015',
    TStop: '',
    name: 'Zhongguo yunzaihuojian jishu yanjiu yuan [CALT sea launch]',
    Location: 'Qingdao',
    lat: 36.06,
    lon: 120.31,
    alt: 0,
    Parent: 'CALT',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAM',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1209',
    TStop: '',
    name: 'University of Cambridge',
    Location: 'Cambridge',
    lat: 52.21,
    lon: 0.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAMSAT',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2009',
    TStop: '',
    name: 'AMSAT-China (CAMSAT)',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CANON',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Kiyanondenshi',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CANOP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '2015',
    name: 'Canopus Systems US LLC',
    Location: 'Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: 'DAUR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAPSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Capella Space Corp.',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAPTU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1927',
    TStop: '',
    name: 'Capitol Technology University',
    Location: 'Laurel, Maryland',
    lat: 39.05,
    lon: -76.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CARDE',
    StateC: 'CA',
    C: 'Military',
    TStart: '1945',
    TStop: '1969',
    name: 'Canadian Armament Researcha and Development Establishment',
    Location: 'Quebec City:Valcartier, Quebec',
    lat: 46.9,
    lon: -71.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CARDU',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1883',
    TStop: '',
    name: 'Cardiff University',
    Location: 'Cardiff, Wales',
    lat: 51.49,
    lon: -3.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAREWX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'Care Weather Technologies',
    Location: 'Provo, Utah',
    lat: 40.24,
    lon: -111.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CARTH',
    StateC: 'US',
    C: 'Academic',
    TStart: '1847',
    TStop: '',
    name: 'Carthage College',
    Location: 'Kenosha, Wisconsin',
    lat: 42.62,
    lon: -87.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAS',
    StateC: 'CN',
    C: 'Government',
    TStart: '1949',
    TStop: '',
    name: 'Zhongguo kexueyuan',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIAG',
    StateC: 'CN',
    C: 'Government',
    TStart: '1958',
    TStop: '1959 Dec',
    name: 'Zhongguo kexueyuan 581 zu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASA',
    StateC: 'E',
    C: 'Commercial',
    TStart: '1986',
    TStop: '1999',
    name: 'Construcciones Aeronauticas S.A. (CASA) Espacio',
    Location: 'Madrid:Barajas',
    lat: 40.47,
    lon: -3.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASA',
    StateC: 'E',
    C: 'Commercial',
    TStart: '1924',
    TStop: '1986',
    name: 'Construcciones Aeronauticas S.A. (CASA) Espacio',
    Location: 'Madrid:Getafe',
    lat: 40.3,
    lon: -3.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASC',
    StateC: 'CN',
    C: 'Government',
    TStart: '1999 Jul',
    TStop: '',
    name: 'Zhongguo hangtian keji jituangongsi',
    Location: 'Beijing, Zhongguo',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASC',
    StateC: 'CN',
    C: 'Government',
    TStart: '1993 Jun',
    TStop: '1999 Jul',
    name: 'Zhongguo hangtian gongye zong gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHFEN',
    StateC: 'CN',
    C: 'Government',
    TStart: '1957',
    TStop: '2002',
    name: '2 yanjiuyuan 7 jixie gongye bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLREC',
    StateC: 'CN',
    C: 'Government',
    TStart: '1965',
    TStop: '1993',
    name: '6 yanjiuyuan 7 jixie gongye bu (Base 067)',
    Location: 'Fengxian region, Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLREC',
    StateC: 'CN',
    C: 'Government',
    TStart: '1993',
    TStop: '2002',
    name: '6 yanjiuyuan 7 jixie gongye bu (Base 067)',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASDN',
    StateC: 'F',
    C: 'Military',
    TStart: '1948',
    TStop: '1959 Jan',
    name: 'Comite\' d\'Action Scientifique de Defense Nationale',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIAG',
    StateC: 'CN',
    C: 'Government',
    TStart: '1959 Dec',
    TStop: '1966 Jan',
    name: 'Zhongguo kexueyuan diqiu wulisuo er bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASIC',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1999 Jul',
    TStop: '',
    name: 'Zhongguo hangtian kegong jituangongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHFEN',
    StateC: 'CN',
    C: 'Government',
    TStart: '2002',
    TStop: '2002',
    name: 'Zhongguo hangtian kegong jituan di 2 yanjiuyuan',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASIC4A',
    StateC: 'CN',
    C: 'Government',
    TStart: '2002',
    TStop: '',
    name: 'Zhongguo hangtian kegong jituan di 4 yanjiuyuan',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASIE',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Zhongguo kexueyan dianzi xue yanjiu so',
    Location: 'Beijing:Haidian,',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASIOM',
    StateC: 'CN',
    C: 'Government',
    TStart: '1956',
    TStop: '',
    name: 'Zhongguo kexueyuan lixue yanjiu suo',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CAST',
    StateC: 'CN',
    C: 'Government',
    TStart: '1968 Feb 20',
    TStop: '',
    name: 'Zhongguo kongjian jishu yanjiu yuan',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASTBZ',
    StateC: 'CN',
    C: 'Government',
    TStart: '1968 Feb 27',
    TStop: '',
    name: 'Beijing weixing zhizaochang',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CAST',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASTIX',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Zhongguo Hangtian keji guoji jiaoliu zhongxin',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CAST',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HTSTL',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2005',
    TStop: '2010',
    name: 'CASIC Space Technology Ltd',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CATAP',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Satellite Applications Catapult',
    Location: 'Harwell, Oxfordshire',
    lat: 51.58,
    lon: -1.31,
    alt: 0,
    Parent: 'OMS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CATHU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1887',
    TStop: '',
    name: 'Catholic University of America',
    Location: 'Washington, D.C',
    lat: 38.93,
    lon: -77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CATON',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Beijin kaidun huanyu keji YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CBKPL',
    StateC: 'PL',
    C: 'Government',
    TStart: '1976',
    TStop: '',
    name: 'Centrum Badan Kosmiczhnych, Polskiej Akademii Nauk',
    Location: 'Warszawa',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CBMET',
    StateC: 'AU',
    C: 'Government',
    TStart: '1955 Jun',
    TStop: '',
    name: 'Commonwealth Bureau of Meteorology',
    Location: 'Melbourne, Victoria',
    lat: -37.81,
    lon: 144.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CCSST',
    StateC: 'CN',
    C: 'Government',
    TStart: '1978',
    TStop: '1987',
    name: 'Kongjian kexue jishu zhongxin',
    Location: 'Beijing (beceame CSSAR)',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CCTV',
    StateC: 'CN',
    C: 'Government',
    TStart: '1978',
    TStop: '',
    name: 'Zhongguo zhongyang dianshitai',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CDTI',
    StateC: 'E',
    C: 'Government',
    TStart: '1998',
    TStop: '',
    name: 'Centro para al Desarrollo Technologico Industrial',
    Location: 'Madrid',
    lat: 40.45,
    lon: -3.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CEA',
    StateC: 'F',
    C: 'Government',
    TStart: '1945',
    TStop: '',
    name: 'Commissariat a l\'Energie Atomique (CEA) - Saclay',
    Location: 'Paris:Saclay, Essonne',
    lat: 48.73,
    lon: 2.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRDL',
    StateC: 'US',
    C: 'Military',
    TStart: '1981 May',
    TStop: '2010',
    name: 'US Army Communications-Electronics Materiel Readiness Command',
    Location: 'Ft Monmouth, New Jersey',
    lat: 40.31,
    lon: -74.05,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CEL',
    StateC: 'F',
    C: 'Military',
    TStart: '1967',
    TStop: '2005',
    name: 'Centre d\'Essais de Landes, DGA',
    Location: 'Biscarosse, France',
    lat: 44.45,
    lon: -1.25,
    alt: 0,
    Parent: 'DGA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CEL',
    StateC: 'F',
    C: 'Military',
    TStart: '2005',
    TStop: '2009',
    name: 'Centre d\'essais de Lancement de missiles, Site Landes',
    Location: 'Biscarosse, France',
    lat: 44.45,
    lon: -1.25,
    alt: 0,
    Parent: 'DGA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CELES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1980',
    name: 'Celesco Industries',
    Location: 'Costa Mesa, California',
    lat: 33.67,
    lon: -117.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CENTI',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Beijing weilai daohang keji YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRDL',
    StateC: 'US',
    C: 'Military',
    TStart: '1978',
    TStop: '1981 May',
    name: 'US Army Communications-Electronics Command',
    Location: 'Ft Monmouth, New Jersey',
    lat: 40.31,
    lon: -74.05,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CERHU',
    StateC: 'HU',
    C: 'Academic',
    TStart: '2012',
    TStop: '',
    name: 'MTA Energiatudomanyi Kutatokopont',
    Location: 'Budapest',
    lat: 47.49,
    lon: 19.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CERMA',
    StateC: 'F',
    C: 'Government',
    TStart: '1955',
    TStop: '1988',
    name: 'Centre d\'Enseignement et de Recherches en Medecine Aeronautique',
    Location: 'Bretigny',
    lat: 48.61,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CERN',
    StateC: 'F',
    C: 'Government',
    TStart: '1952',
    TStop: '',
    name: 'Conseil Europeene pour la Recherches Nucleaire, Geneve',
    Location: 'Geneve, Suisse',
    lat: 46.23,
    lon: 6.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CESBIO',
    StateC: 'F',
    C: 'Government',
    TStart: '1990s',
    TStop: '',
    name: 'Centre d\'Etudes Spatiales de la Biosphere',
    Location: 'Toulouse:Rangueil',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: 'TLS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CESIUM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Cesium Astro, Inc.',
    Location: 'Austin, Texas',
    lat: 30.31,
    lon: -97.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CESR',
    StateC: 'F',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Centre d\'Etudes Spatiale des Rayonnements',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIFTQ',
    StateC: 'E',
    C: 'Government',
    TStart: '1994',
    TStop: '',
    name: 'Centro de Tecnologias Fisicas "Leonardo Torres Quevedo"',
    Location: 'Madrid',
    lat: 40.38,
    lon: -3.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CFCA',
    StateC: 'CA',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Canadian Forces',
    Location: 'Ottawa',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CFTH',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1893',
    TStop: '1966',
    name: 'Compagnie Francaise Thomson-Houston',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CFTH',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1966',
    TStop: '1968',
    name: 'CFTH-Hotchkiss-Brant',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CGS',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1981',
    TStop: '2011',
    name: 'Carlo Gavazzi Space',
    Location: 'Milano',
    lat: 45.47,
    lon: 9.18,
    alt: 0,
    Parent: 'FUCHS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CGS',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2011',
    TStop: '2015',
    name: 'OHB CGS S.p.A., Compagnia Generale per lo Spazio',
    Location: 'Milano',
    lat: 45.47,
    lon: 9.18,
    alt: 0,
    Parent: 'FUCHS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CGSTL',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2014 Dec',
    TStop: '',
    name: 'Changuang weixing jishu youxian gongsi',
    Location: 'Changchun, Jilin',
    lat: 43.89,
    lon: 125.32,
    alt: 0,
    Parent: 'CIOMP',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CGSTZ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018 Jan',
    TStop: '',
    name: 'Zhejiang Changuang weixing xinxi jishu youxian gongsi',
    Location: 'Deqing, Zhejiang',
    lat: 30.54,
    lon: 119.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHAIL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '2000',
    name: 'Cutler-Hammer Airborne Instruments Laboratory',
    Location: 'Mineola and Deer Park, New York',
    lat: 40.74,
    lon: -73.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHDB',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2008 Jan 1',
    TStop: '',
    name: 'Zhongguo zhiboxing youxianggongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CHIS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHFEN',
    StateC: 'CN',
    C: 'Government',
    TStart: '2002',
    TStop: '',
    name: 'Zhongguo zhangfeng jidian jishu yanjiushejiyuan',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHIBA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1942',
    TStop: '',
    name: 'Chiba kogyo daigaku wakusei',
    Location: 'Narashino, Chiba',
    lat: 35.69,
    lon: 140.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHIC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1891',
    TStop: '',
    name: 'University of Chicago',
    Location: 'Hyde Park, Chicago, Illinois',
    lat: 41.79,
    lon: -87.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHIS',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1983',
    TStop: '2001 Dec 19',
    name: 'Zhongguo weixing tongxin gongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHIS',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2001 Dec 19',
    TStop: '2009 Apr',
    name: 'Zhongguo weixingtongxin jituangongsi (Zhongguo wei tong)',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHIS',
    StateC: 'CN',
    C: 'Government',
    TStart: '2009 Apr',
    TStop: '',
    name: 'Zhongguo weixingtongxin jituangongsi (Zhongguo wei tong)',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHORI',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1995 Apr',
    TStop: '2008 Apr',
    name: 'Zhongguo dongfangtongxin weixing youxianzerengongsi',
    Location: 'Beijing:Dong Cheng',
    lat: 39.92,
    lon: 116.41,
    alt: 0,
    Parent: 'CHIS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHOSU',
    StateC: 'KR',
    C: 'Academic',
    TStart: '1946',
    TStop: '',
    name: 'Joseon Daehakgyo',
    Location: 'Gwangju',
    lat: 35.14,
    lon: 126.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHUNG',
    StateC: 'TW',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Chunghwa Telecom (Chung-hua Tien-hsin)',
    Location: 'Taipei',
    lat: 24.82,
    lon: 120.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHRMI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1975',
    name: 'Chrysler Operations, NASA Michoud Assembly Facility',
    Location: 'Michoud, Louisiana',
    lat: 30.02,
    lon: -89.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CHRY',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1952',
    TStop: '1970s',
    name: 'Chrysler Michigan Ordnance Missile Plant',
    Location: 'Detroit:Sterling Heights, Michigan',
    lat: 42.58,
    lon: -83.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIA',
    StateC: 'US',
    C: 'Military',
    TStart: '1947 Jul 26',
    TStop: '',
    name: 'Central Intelligence Agency, USA',
    Location: 'Langley, Virginia',
    lat: 38.95,
    lon: -77.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIAB',
    StateC: 'US',
    C: 'Military',
    TStart: '1965',
    TStop: '1992 Dec 31',
    name: 'CIA Office of Development and Engineering, Dir of Sci.Tech. (NRO Program B)',
    Location: 'Langley, Virginia',
    lat: 38.95,
    lon: -77.16,
    alt: 0,
    Parent: 'NRO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIAG',
    StateC: 'CN',
    C: 'Government',
    TStart: '1966 Jan',
    TStop: '1968',
    name: 'Yingyong diqui wulisuo',
    Location: 'Beijing (beceame CSSAR)',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIEL',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Ciel Satellite Group',
    Location: 'Ottawa:Kanata, Ontario',
    lat: 45.33,
    lon: -75.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIFAS',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1968',
    TStop: '1975',
    name: 'Consortium Industrial France-Allemand pour le Satellite Symphonie',
    Location: 'Les Mureaux',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIFTQ',
    StateC: 'E',
    C: 'Government',
    TStart: '',
    TStop: '1994',
    name: 'Centro de Investigaciones Fiscas "L. Torres Quevedo"',
    Location: 'Madrid',
    lat: 40.38,
    lon: -3.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1819',
    TStop: '',
    name: 'University of Cincinatti',
    Location: 'Cincinatti, Ohio',
    lat: 39.13,
    lon: -84.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIOMP',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1952',
    TStop: '',
    name: 'Zhangchun guangxue jingmi jixie yu wuli yanjiu suo',
    Location: 'Changchun, Jilin',
    lat: 43.89,
    lon: 125.32,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CISIR',
    StateC: 'LK',
    C: 'Government',
    TStart: '1955',
    TStop: '1988',
    name: 'Ceylon Institute for Scientific and Industrial Research',
    Location: 'Colombo',
    lat: 6.93,
    lon: -79.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIAG',
    StateC: 'CN',
    C: 'Government',
    TStart: '1980',
    TStop: '1987',
    name: 'Institute for Space Physics, CAS',
    Location: 'Beijing (beceame CSSAR)',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CISP5',
    StateC: 'CN',
    C: 'Government',
    TStart: '1969',
    TStop: '1978 Nov',
    name: 'diwu yuanjiuyuan Kongian wuli ji tance jishu yanjiusuo',
    Location: 'Beijing (beceame CSSAR)',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1891',
    TStop: '',
    name: 'California Institute of Technology',
    Location: 'Pasadena, California',
    lat: 34.14,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CITED',
    StateC: 'AR',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: 'Centro de Investigaciones Cientificas y Tecnologicas para la Defensa',
    Location: 'Villa Maria, Cordoba',
    lat: -32.41,
    lon: -63.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CITEF',
    StateC: 'AR',
    C: 'Government',
    TStart: '1982',
    TStop: '1991 May 28',
    name: 'Inst.de Investigaciones Cientificas y Tech. de las Fuerzas Armadas',
    Location: 'Falda del Carmen, Cordoba',
    lat: -31.59,
    lon: -64.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CLYDE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2018 Jan',
    TStop: '',
    name: 'AAC Microtec/Clyde Space Ltd.',
    Location: 'Glasgow, Scotland',
    lat: 55.86,
    lon: -4.25,
    alt: 0,
    Parent: 'AACM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CLARK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1935',
    TStop: '',
    name: 'David Clark Co.',
    Location: 'Worcester, Massachusetts',
    lat: 42.27,
    lon: -71.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COUAL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1965',
    TStop: '',
    name: 'University of Colorado-Lab for Atmospheric and Space Physics',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'UCO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CLEM',
    StateC: 'US',
    C: 'Academic',
    TStart: '1889',
    TStop: '',
    name: 'Clemson University',
    Location: 'Clemson, S Carolina',
    lat: 34.68,
    lon: -82.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CLSR',
    StateC: 'BGN',
    C: 'Academic',
    TStart: '1975',
    TStop: '1987',
    name: 'Central Lab. for Space Research, Sofia',
    Location: 'Sofia',
    lat: 42.7,
    lon: 23.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CLYDE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2006',
    TStop: '2018 Jan',
    name: 'Clyde Space Ltd.',
    Location: 'Glasgow, Scotland',
    lat: 55.86,
    lon: -4.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CMA',
    StateC: 'CN',
    C: 'Government',
    TStart: '1941',
    TStop: '',
    name: 'zhongguo qixiang ju',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CMIK',
    StateC: 'KP',
    C: 'Military',
    TStart: '1995',
    TStop: '',
    name: 'Joseon-inmingun Jeonlyag loketeu gun',
    Location: 'Pyongyang',
    lat: 39.02,
    lon: 0.02,
    alt: 0,
    Parent: 'KPA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CMMB',
    StateC: 'HK',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Zhongguo yidong duomeiti guangbo konggu youxian gongsi',
    Location: 'Hong Kong',
    lat: 22.3,
    lon: 114.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CMSEO',
    StateC: 'CN',
    C: 'Military',
    TStart: '1999',
    TStop: '',
    name: 'zhongguo zairen hangtian gongcheng bangonghsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'ZZB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CMU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1900',
    TStop: '',
    name: 'Carnegie Mellon University',
    Location: 'Pittsburgh',
    lat: 40.44,
    lon: -79.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNAE',
    StateC: 'BR',
    C: 'Government',
    TStart: '1963',
    TStop: '1971',
    name: 'Comissao Nacional de Atividades Espaciais',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNCOS',
    StateC: 'CN',
    C: 'Military',
    TStart: '1982',
    TStop: '2008',
    name: 'Guofang kexue jishi gongye weiyuanhui',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNES',
    StateC: 'F',
    C: 'Government',
    TStart: '1962',
    TStop: '',
    name: 'Centre Nationale d\'Etudes Spatiales, Paris',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNESB',
    StateC: 'F',
    C: 'Government',
    TStart: '1962',
    TStop: '1974',
    name: 'Centre Spatiale de Bretigny',
    Location: 'Bretigny',
    lat: 48.61,
    lon: 2.3,
    alt: 0,
    Parent: 'CNES',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNEST',
    StateC: 'F',
    C: 'Government',
    TStart: '1973',
    TStop: '',
    name: 'Centre Spatiale de Toulouse',
    Location: 'Toulouse',
    lat: 43.6,
    lon: 1.44,
    alt: 0,
    Parent: 'CNES',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNET',
    StateC: 'F',
    C: 'Government',
    TStart: '1944',
    TStop: '2000 Mar 1',
    name: 'Centre National d\'etudes des telecommunications',
    Location: 'Paris:Bagneux (Issy)',
    lat: 48.8,
    lon: 2.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNIE',
    StateC: 'AR',
    C: 'Government',
    TStart: '1961',
    TStop: '1991 May 28',
    name: 'Comision Nacional de Investigationes Espaciales, Fuerza Aera Arg.',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNR',
    StateC: 'I',
    C: 'Government',
    TStart: '1923',
    TStop: '',
    name: 'Consiglio Nazionale delle Richerche',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNRS',
    StateC: 'F',
    C: 'Government',
    TStart: '1939',
    TStop: '',
    name: 'Conseil National de Recherches Scientifiques',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAI',
    StateC: 'CN',
    C: 'Government',
    TStart: '1993 Jun',
    TStop: '',
    name: 'Guojia Hangtian Ju',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNCOS',
    StateC: 'CN',
    C: 'Military',
    TStart: '2008',
    TStop: '',
    name: 'Guojia guofang keji gongye ju',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIAG',
    StateC: 'CN',
    C: 'Government',
    TStart: '2015 Jun',
    TStop: '',
    name: 'zhongguo kexueyuan guojia kongjian kexue zhongxin',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNTS',
    StateC: 'DZ',
    C: 'Government',
    TStart: '2002',
    TStop: '',
    name: 'Centre National des Techniques Spatiales',
    Location: 'Dzayer (Algiers)',
    lat: 36.75,
    lon: 3.06,
    alt: 0,
    Parent: 'ASAL',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNU',
    StateC: 'KR',
    C: 'Academic',
    TStart: '1952',
    TStop: '',
    name: 'Chungnam Daehaggyo',
    Location: 'Daejeon',
    lat: 36.35,
    lon: 127.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COEP',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1854',
    TStop: '',
    name: 'College of Engineering, Pune',
    Location: 'Pune, Maharashtra',
    lat: 18.53,
    lon: 73.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COLE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '1996',
    name: 'Coleman Research Corporation',
    Location: 'Orlando, Florida',
    lat: 28.54,
    lon: -81.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COLE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2017',
    name: 'Coleman Aerospace',
    Location: 'Orlando, Florida',
    lat: 28.54,
    lon: -81.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COLE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Coleman Aerospace/Aerojet Rocketdyne',
    Location: 'Orlando, Florida',
    lat: 28.54,
    lon: -81.38,
    alt: 0,
    Parent: 'AJR',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COLC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1983',
    TStop: '2000 Sep 1',
    name: 'Columbia Communications Corp.',
    Location: 'Honolulu, Hawaii',
    lat: 21.3,
    lon: -157.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COLC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000 Sep 1',
    TStop: '2003',
    name: 'Columbia Communications Corp. (GE Americom)',
    Location: 'Honolulu, Hawaii',
    lat: 21.3,
    lon: -157.82,
    alt: 0,
    Parent: 'AMCG',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HASTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Nov',
    TStop: '',
    name: 'Collins Aerospace (Windsor Locks)',
    Location: 'Windsor Locks, Connecticut',
    lat: 41.93,
    lon: -72.65,
    alt: 0,
    Parent: 'UTC2',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1963',
    TStop: '1998 Sep',
    name: 'Comsat General Corp., Washington D.C.',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COMAH',
    StateC: 'AR',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Universidad Nacional del Comahue (UNCOMA)',
    Location: 'Neuquen, Neuquen, Patagonia',
    lat: -38.94,
    lon: -68.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COMDEV',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1974',
    TStop: '2015',
    name: 'Com Dev International',
    Location: 'Cambridge, Ontario',
    lat: 43.37,
    lon: -80.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COMDEV',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Honeywell Aerospace (Com Dev)',
    Location: 'Cambridge, Ontario',
    lat: 43.37,
    lon: -80.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COMDUK',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '',
    TStop: '2015',
    name: 'Com Dev International/Aylesbury',
    Location: 'Aylesbury',
    lat: 51.82,
    lon: -0.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNIE',
    StateC: 'AR',
    C: 'Government',
    TStart: '1991 May 28',
    TStop: '',
    name: 'Comision Nacional de Actividades Espaciales',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CITEF',
    StateC: 'AR',
    C: 'Government',
    TStart: '1991 May 28',
    TStop: '',
    name: 'CONAE Centro Espacial Teofilo Tabanera',
    Location: 'Falda del Carmen, Cordoba',
    lat: -31.59,
    lon: -64.46,
    alt: 0,
    Parent: 'CONAB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONCOR',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1974',
    TStop: '',
    name: 'Concordia University',
    Location: 'Montreal, Quebec',
    lat: 45.51,
    lon: -73.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONIE',
    StateC: 'E',
    C: 'Government',
    TStart: '1963 Jul 8',
    TStop: '1986',
    name: 'Comision Nacional de Investigacion del Espacio',
    Location: 'Madrid:Torrejon',
    lat: 40.5,
    lon: -3.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONTF',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1976',
    TStop: '1993',
    name: 'Contel Federal Systems',
    Location: 'Fairfax, Virginia',
    lat: 38.85,
    lon: -77.3,
    alt: 0,
    Parent: 'CONTL',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONTL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1976',
    TStop: '1993',
    name: 'Contel Corporation',
    Location: 'Atlanta, Georgia',
    lat: 33.76,
    lon: -84.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '1991',
    name: 'Contel ASC Inc.',
    Location: 'Rockville, Maryland',
    lat: 39.08,
    lon: -77.15,
    alt: 0,
    Parent: 'CONTL',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONTR',
    StateC: 'CH',
    C: 'Commercial',
    TStart: '1936',
    TStop: '1999',
    name: 'Oerlikon Contraves AG',
    Location: 'Zurich',
    lat: 47.37,
    lon: 8.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONTR',
    StateC: 'CH',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2007',
    name: 'Oerlikon Contraves Space',
    Location: 'Zurich',
    lat: 47.37,
    lon: 8.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1943',
    TStop: '1953 Mar',
    name: 'Consolidated Vultee Aircraft Corp.',
    Location: 'San Diego, California',
    lat: 32.73,
    lon: -117.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '1961 Jun',
    name: 'Convair Astronautics Division',
    Location: 'San Diego:Kearny Mesa, California',
    lat: 32.83,
    lon: -117.14,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONVPO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1952',
    TStop: '1954 Apr',
    name: 'Convair Aircraft, Pomona',
    Location: 'Pomona, California',
    lat: 34.06,
    lon: -117.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COOP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1964',
    name: 'Cooper Development Corp. (CDC)',
    Location: 'Monrovia, California',
    lat: 34.15,
    lon: -118,
    alt: 0,
    Parent: 'MARQ',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COPERN',
    StateC: 'I-EU',
    C: 'Government',
    TStart: '2014',
    TStop: '',
    name: 'European Commission DG-GROW Directorate I/2, Copernicus Unit',
    Location: 'Brussel',
    lat: 50.85,
    lon: 4.35,
    alt: 0,
    Parent: 'DGGROW',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CORAT',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Coratec (Cordoba Alta Tecnologia S.E.)',
    Location: 'Cordoba, Argentina',
    lat: -31.42,
    lon: -64.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IIAE',
    StateC: 'AR',
    C: 'Academic',
    TStart: '1991',
    TStop: '',
    name: 'Instituto Universtiario Aeronautico, Fuerza Aerea Argentina',
    Location: 'Cordoba, Argentina',
    lat: -31.42,
    lon: -64.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CORN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1865',
    TStop: '',
    name: 'Cornell University',
    Location: 'Ithaca, New York',
    lat: 42.44,
    lon: -76.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COSG',
    StateC: 'US',
    C: 'Academic',
    TStart: '1989',
    TStop: '',
    name: 'Colorado Space Grant Consortium, U Colorado at Boulder',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'UCO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COSM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'COSMOS consortium (Aerospatiale/CASA/MBB/Selenia/MSDS)',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COSMOG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '2013 Jun',
    name: 'Cosmogia Inc.',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COUAL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1948',
    TStop: '1965',
    name: 'Upper Atmosphere Lab, University of Colorado',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'UCO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CPUT',
    StateC: 'ZA',
    C: 'Academic',
    TStart: '2005',
    TStop: '',
    name: 'Cape Peninsula University of Technology, Belleville Campus',
    Location: 'Cape Town:Belleville',
    lat: -33.9,
    lon: 18.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRA',
    StateC: 'I',
    C: 'Government',
    TStart: '1959',
    TStop: '',
    name: 'Centro Richerchi Aerospaziale, Roma la Sapienza',
    Location: 'Roma',
    lat: 41.9,
    lon: 12.52,
    alt: 0,
    Parent: 'CRPSM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DRTE',
    StateC: 'CA',
    C: 'Government',
    TStart: '1969',
    TStop: '',
    name: 'Communications Research Center',
    Location: 'Ottawa, Canada',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRCSS',
    StateC: 'AU',
    C: 'Government',
    TStart: '1998',
    TStop: '2005 Dec 31',
    name: 'Cooperative Research Centre for Satellite Systems',
    Location: 'Canberra:Yarralumla',
    lat: -35.31,
    lon: 149.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRI',
    StateC: 'DK',
    C: 'Commercial',
    TStart: '',
    TStop: '1997',
    name: 'Computer Resources International',
    Location: 'Kobenhavn:Rudersdal/Birkerod',
    lat: 55.83,
    lon: 12.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRL',
    StateC: 'J',
    C: 'Government',
    TStart: '1988',
    TStop: '2004',
    name: 'Communications Research Lab',
    Location: 'Kashima, Ibaraki, Japan',
    lat: 35.97,
    lon: 140.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRPSM',
    StateC: 'I',
    C: 'Academic',
    TStart: '1962',
    TStop: '',
    name: 'Centro di Ricerca Progetto San Marco',
    Location: 'Roma',
    lat: 41.9,
    lon: 12.52,
    alt: 0,
    Parent: 'ROSAP',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRR',
    StateC: 'CA',
    C: 'Government',
    TStart: '1962 Nov 1',
    TStop: '1970 Jun',
    name: 'Churchill Research Range (USAF)',
    Location: 'Churchill, Manitoba',
    lat: 58.73,
    lon: -93.82,
    alt: 0,
    Parent: 'OAR',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRR',
    StateC: 'CA',
    C: 'Government',
    TStart: '1970 Jun',
    TStop: '',
    name: 'Churchill Research Range (NRC)',
    Location: 'Churchill, Manitoba',
    lat: 58.73,
    lon: -93.82,
    alt: 0,
    Parent: 'NRCC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRS',
    StateC: 'I',
    C: 'Government',
    TStart: '1959',
    TStop: '',
    name: 'Commissione per le Richerche Spaziali (CRS)',
    Location: 'Roma',
    lat: 41.9,
    lon: 12.5,
    alt: 0,
    Parent: 'CNR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRSEA',
    StateC: 'BR',
    C: 'Government',
    TStart: '2009',
    TStop: '',
    name: 'Centro de Referencia en Sistemas Embarcados e Aerosepaciais',
    Location: 'Sao Joao da Barra, Rio de Janeiro province',
    lat: -21.64,
    lon: -41.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASDN',
    StateC: 'F',
    C: 'Government',
    TStart: '1959',
    TStop: '1962',
    name: 'Comite des Recherches Spatiales',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRTS',
    StateC: 'MA',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Centre Royal de Teledetection Spatiale',
    Location: 'Hay Ryad, Rabat',
    lat: 34.01,
    lon: -6.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSA',
    StateC: 'CA',
    C: 'Government',
    TStart: '1989 Dec 14',
    TStop: '',
    name: 'Canadian Space Agency',
    Location: 'Montreal:Saint-Hubert',
    lat: 45.48,
    lon: -73.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSAE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '2008',
    name: 'CSA Engineering',
    Location: 'Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1959',
    TStop: '2017',
    name: 'Computer Sciences Corp.',
    Location: 'Tyson\'s Corner, Virginia',
    lat: 38.92,
    lon: -77.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1975 May 1',
    TStop: '1996',
    name: 'United Technology Corp Chemical Systems Division (UTC CSD)',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: 'UTC2',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSG',
    StateC: 'F',
    C: 'Government',
    TStart: '1967',
    TStop: '',
    name: 'Centre Spatial Guyanais',
    Location: 'Kourou, Guyane',
    lat: 5.23,
    lon: -52.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSIMP',
    StateC: 'AU',
    C: 'Government',
    TStart: '1971',
    TStop: '1988',
    name: 'CSIRO Division of Atmospheric Physics',
    Location: 'Melbourne:Aspendale',
    lat: 38.03,
    lon: 145.1,
    alt: 0,
    Parent: 'CSIRO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSIAR',
    StateC: 'AU',
    C: 'Government',
    TStart: '1988',
    TStop: '',
    name: 'CSIRO Division of Atmospheric Research',
    Location: 'Melbourne:Aspendale',
    lat: 38.03,
    lon: 145.1,
    alt: 0,
    Parent: 'CSIRO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSICE',
    StateC: 'J',
    C: 'Military',
    TStart: '2003',
    TStop: '',
    name: 'Naikaku Eisei Joho Senta',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSIMP',
    StateC: 'AU',
    C: 'Government',
    TStart: '1949',
    TStop: '1971',
    name: 'CSIRO Division of Meteorological Physics',
    Location: 'Melbourne:Aspendale',
    lat: 38.03,
    lon: 145.1,
    alt: 0,
    Parent: 'CSIRO',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSIR',
    StateC: 'ZA',
    C: 'Government',
    TStart: '1945',
    TStop: '',
    name: 'Council on Scientific and Industrial Research, South Africa',
    Location: 'Pretoria',
    lat: -25.75,
    lon: 28.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSIRO',
    StateC: 'AU',
    C: 'Government',
    TStart: '1949',
    TStop: '',
    name: 'Commonwealth Scientific and Industrial Research Organization',
    Location: 'Canberra',
    lat: -35.31,
    lon: 149.12,
    alt: 0,
    Parent: 'AU',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSL',
    StateC: 'CSSR',
    C: 'Military',
    TStart: '1918',
    TStop: '1992',
    name: 'Ceskoslovenske letectvo',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CIAG',
    StateC: 'CN',
    C: 'Government',
    TStart: '1987',
    TStop: '2015 Jun',
    name: 'zhongguo kexueyuan kongjian kexue yu yingying yanjiuzhongxin',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1870',
    TStop: '',
    name: 'Colorado State University',
    Location: 'Fort Collins, Colorado',
    lat: 40.57,
    lon: -105.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSUG',
    StateC: 'F',
    C: 'Academic',
    TStart: '2016',
    TStop: '',
    name: 'Centre Spatial Universitaire de Grenoble, Universite Grenoble Alpes',
    Location: 'Grenoble',
    lat: 45.19,
    lon: 5.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSUN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1958',
    TStop: '',
    name: 'California State University, Northridge',
    Location: 'Los Angeles:Northridge, California',
    lat: 34.24,
    lon: -118.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSXT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Civilian Space Exploration Team (CSXT)',
    Location: 'Minneapolis, Minnesota',
    lat: 44.98,
    lon: -93.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSZS',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2020 Oct',
    TStop: '',
    name: 'Chang sanjiao zhi sheng',
    Location: 'Shanghai',
    lat: 31.11,
    lon: 121.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1992 Jul',
    TStop: '1997',
    name: 'CTA Space Systems Inc',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CTEL',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Zhongguo dianxin jituan gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CTYK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Changsha Tianyi Kongjian Keji yanjiuyuan youxiang gongsi (SpaceTy)',
    Location: 'Changsha, Hunan',
    lat: 28.23,
    lon: 112.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CUBESP',
    StateC: 'ZA',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'CubeSpace',
    Location: 'Stellenbosch',
    lat: -33.93,
    lon: 18.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CUBIC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1951',
    TStop: '',
    name: 'Cubic Corp.',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CULH',
    StateC: 'UK',
    C: 'Government',
    TStart: '1963',
    TStop: '',
    name: 'Culham Laboratory',
    Location: 'Abingdon, Oxfordshire',
    lat: 51.66,
    lon: -1.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CUNYME',
    StateC: 'US',
    C: 'Academic',
    TStart: '1970',
    TStop: '',
    name: 'Medgar Evers College, City University of New York',
    Location: 'New York:Brooklyn, New York',
    lat: 40.67,
    lon: -73.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CURTIN',
    StateC: 'AU',
    C: 'Academic',
    TStart: '1986',
    TStop: '',
    name: 'Curtin University',
    Location: 'Perth:Bentley, W Australia',
    lat: -32,
    lon: 115.89,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CZHJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Zhongguo Changzheng Houjian YG',
    Location: 'Beijing',
    lat: 39.78,
    lon: 116.39,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DAAFAR',
    StateC: 'CU',
    C: 'Military',
    TStart: '1959',
    TStop: '',
    name: 'Defensa Anti-Aerea y Fuerza Aerea Revolucionaria',
    Location: 'Havana',
    lat: 23.13,
    lon: -82.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DAC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1921 Jul',
    TStop: '1967 Apr 28',
    name: 'Douglas Aircraft Corp.',
    Location: 'Santa Monica, California',
    lat: 34.02,
    lon: -118.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DACC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1967 May',
    name: 'Douglas Aircraft Corp. Charlotte Ordnance Missile Plant (COMP)',
    Location: 'Charlotte, North Carolina',
    lat: 35.23,
    lon: -80.84,
    alt: 0,
    Parent: 'DAC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DACHB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1963',
    TStop: '1967 Apr 28',
    name: 'Douglas Aircraft Corp. Missiles and Space Systems Division (HB)',
    Location: 'Huntington Beach, California',
    lat: 33.69,
    lon: -118,
    alt: 0,
    Parent: 'DAC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DACM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1967',
    name: 'Douglas Aircraft Corp. Missiles and Space Systems Division (MSSD)',
    Location: 'Santa Monica, California',
    lat: 34.02,
    lon: -118.48,
    alt: 0,
    Parent: 'DAC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DAPA',
    StateC: 'KR',
    C: 'Military',
    TStart: '2006 Jan',
    TStop: '',
    name: 'Bang-wi Saeop-cheong',
    Location: 'Yongsan-gu, Seoul',
    lat: 37.54,
    lon: 126.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DARA',
    StateC: 'D',
    C: 'Government',
    TStart: '1989',
    TStop: '1997',
    name: 'Deutsche Agentur f\\"new ControlSite({u}r Raumfahrtangelegenheiten',
    Location: 'Bonn:Oberkassel',
    lat: 50.71,
    lon: 7.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DARE',
    StateC: 'NL',
    C: 'Academic',
    TStart: '2001',
    TStop: '',
    name: 'Delft Aerospace Rocket Engineering',
    Location: 'Delft',
    lat: 52.01,
    lon: 4.36,
    alt: 0,
    Parent: 'DELFT',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DARPA',
    StateC: 'US',
    C: 'Military',
    TStart: '1972 Mar 23',
    TStop: '1993 Feb 22',
    name: 'Defense Advanced Research Projects Agency',
    Location: 'Washington DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DARPA',
    StateC: 'US',
    C: 'Military',
    TStart: '1996 Feb 10',
    TStop: '',
    name: 'Defense Advanced Research Projects Agency',
    Location: 'Washington DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DART',
    StateC: 'US',
    C: 'Academic',
    TStart: '1769 Dec 13',
    TStop: '',
    name: 'Dartmouth College',
    Location: 'Hanover, New Hampshire',
    lat: 43.7,
    lon: -72.29,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DASA',
    StateC: 'US',
    C: 'Military',
    TStart: '1959 May 6',
    TStop: '1971 Nov 24',
    name: 'US Defense Atomic Support Agency',
    Location: 'Albequerque, New Mexico',
    lat: 35.11,
    lon: -106.61,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOLK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1989 Dec',
    TStop: '2000 Jul',
    name: 'Deutsche Aerospace AG (DASA)-Ottobrunn',
    Location: 'Munchen:Ottobrunn',
    lat: 48.07,
    lon: 11.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1989 Mar',
    TStop: '1995 Jan 1',
    name: 'Deutsche Aerospace AG (DASA)-Friedrichsafen (Dornier GmBH)',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1989 Dec',
    TStop: '2000 Jul 10',
    name: 'Daimler-Benz Aerospace Raumfahrt-Infrastruktur (DASA RI)',
    Location: 'Bremen, BRD',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1995 Jan 1',
    TStop: '1998 Nov 7',
    name: 'Daimler-Benz Aerospace (DASA)-Friedrichsafen (Dornier GmBH)',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1998 Nov 7',
    TStop: '2000 Jul 10',
    name: 'Daimler-Chrysler Aerospace (DASA)-Friedrichsafen',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DASST',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1951',
    TStop: '',
    name: 'Avions Marcel Dassault',
    Location: 'Bordeaux:Martignas-sur-Jalle, Gironde',
    lat: 44.84,
    lon: -0.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DAUR',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2012 Apr',
    TStop: '',
    name: 'Dauria Aerospace',
    Location: 'Moskva:Skolkovo',
    lat: 55.69,
    lon: 37.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DAWAN',
    StateC: 'CN',
    C: 'Government',
    TStart: '2018',
    TStop: '',
    name: 'Dawan qu jicheng dianluyu xitong yingyong yanjiuyuan',
    Location: 'Guangzhou',
    lat: 23.13,
    lon: 113.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DBP',
    StateC: 'D',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Deutsche Bundespost Telekom, Fernmeldetechnisches Zentralamt',
    Location: 'Darmstadt',
    lat: 49.87,
    lon: 8.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICONA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009 Aug',
    TStop: '2012 Mar',
    name: 'DBSD North America Inc.',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'DISH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICONA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Mar',
    TStop: '',
    name: 'Dish Network, DBSD assets',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'DISH',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DCA',
    StateC: 'US',
    C: 'Military',
    TStart: '1960',
    TStop: '1991 Jun 25',
    name: 'Defense Communications Agency',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DDRD',
    StateC: 'IL',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Meynhel lemeqr peytevh amets\'ey lyhemh vetshetyet teknevlevgeyt',
    Location: 'Tel Aviv',
    lat: 32.07,
    lon: 34.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1946',
    TStop: '1959',
    name: 'De Havilland Engine Co.',
    Location: 'Watford:Leavesden',
    lat: 51.7,
    lon: -0.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVS',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1953',
    TStop: '1963',
    name: 'de Havilland Aircraft',
    Location: 'Stevenage',
    lat: 51.9,
    lon: -0.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVT',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1928',
    TStop: '1967',
    name: 'De Havilland, Toronto (Special Products/Appl. Research Div)',
    Location: 'Toronto:Downsview, Ontario',
    lat: 43.73,
    lon: -79.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEIMOS',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2001 Jun',
    TStop: '2009 Sep',
    name: 'Deimos Space S.L.',
    Location: 'Madrid:Tres Cantos',
    lat: 40.6,
    lon: -3.71,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEIMI',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2006',
    TStop: '2009 Sep',
    name: 'Deimos Imaging',
    Location: 'Boecillo, Valladolid',
    lat: 41.53,
    lon: -4.7,
    alt: 0,
    Parent: 'DEIMOS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DELFT',
    StateC: 'NL',
    C: 'Academic',
    TStart: '1986',
    TStop: '',
    name: 'Technische Universiteit Delft',
    Location: 'Delft',
    lat: 52,
    lon: 4.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DENV',
    StateC: 'US',
    C: 'Academic',
    TStart: '1864',
    TStop: '',
    name: 'University of Denver',
    Location: 'Denver, Colorado',
    lat: 39.68,
    lon: -104.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAE',
    StateC: 'UK',
    C: 'Military',
    TStart: '1995 Apr 1',
    TStop: '2001 Jul 1',
    name: 'Defense Evaluation and Research Agency',
    Location: 'Farnborough, Hants',
    lat: 51.29,
    lon: -0.75,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEWC',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'DEWC Systems Pty Ltd.',
    Location: 'Adelaide:Mawson Lakes',
    lat: -34.82,
    lon: 138.61,
    alt: 0,
    Parent: 'UK',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEYA',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Fushan shunde qu deya chuangxin yanjiuyuan',
    Location: 'Shunde, Foshan',
    lat: 22.81,
    lon: 113.29,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFF',
    StateC: 'F',
    C: 'Academic',
    TStart: '1958 Mar 31',
    TStop: '',
    name: 'Deutsche-Franzosische Forschungsinstitut Saint-Louis (ISL)',
    Location: 'Saint-Louis, Haut-Rhin, Alsace',
    lat: 47.59,
    lon: 7.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFH',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2001 Aug',
    TStop: '2006',
    name: 'Hangtian DongFangHong Weixing YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CAST',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFH',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2006',
    TStop: '',
    name: 'Hangtian DongFangHong Weixing YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'ZDFH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFHS',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Shenzhen Hangtian DongFangHong HIT Weixing YG',
    Location: 'Shenzhen, Guangdong',
    lat: 22.55,
    lon: 114.1,
    alt: 0,
    Parent: 'ZDFH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFHYT',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Shenzhen Hangtian DongFangHong Weixing Yidong Tongxin YG',
    Location: 'Shenzhen, Guangdong',
    lat: 22.55,
    lon: 114.1,
    alt: 0,
    Parent: 'CAST',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FRC',
    StateC: 'US',
    C: 'Government',
    TStart: '1976 Mar 26',
    TStop: '2014 Jan 8',
    name: 'NASA Dryden Flight Research Center',
    Location: 'Edwards AFB, California',
    lat: 34.91,
    lon: -117.88,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFVLR',
    StateC: 'D',
    C: 'Government',
    TStart: '1969',
    TStop: '1989',
    name: 'DFVLR',
    Location: 'Koln',
    lat: 50.94,
    lon: 6.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DMA',
    StateC: 'F',
    C: 'Military',
    TStart: '1977',
    TStop: '',
    name: 'Delegation Generale de l\'Armament, Paris',
    Location: 'Paris:Bagneux',
    lat: 48.8,
    lon: 2.31,
    alt: 0,
    Parent: 'F',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CEL',
    StateC: 'F',
    C: 'Military',
    TStart: '2009',
    TStop: '',
    name: 'DGA Essais de missiles, Site Landes',
    Location: 'Biscarosse, France',
    lat: 44.45,
    lon: -1.25,
    alt: 0,
    Parent: 'DGA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DGGROW',
    StateC: 'I-EU',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Directorate-General for Internal Market, Industry, Entrepreneurship and SMEs',
    Location: 'Brussel',
    lat: 50.85,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EWAT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'DigitalGlobe',
    Location: 'Longmont, Colorado',
    lat: 40.17,
    lon: -105.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Jul',
    TStop: '2017 Oct',
    name: 'DigitalGlobe (Herndon)',
    Location: 'Herndon, Virginia',
    lat: 38.97,
    lon: -77.39,
    alt: 0,
    Parent: 'DGLO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIMG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Jul',
    TStop: '',
    name: 'DigitalGlobe (Thornton)',
    Location: 'Thornton, Colorado',
    lat: 39.9,
    lon: -104.95,
    alt: 0,
    Parent: 'DGLO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DHMC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1797',
    TStop: '',
    name: 'Dartmouth-Hitchcock Medical Center',
    Location: 'Lebanon, New Hampshire',
    lat: 43.68,
    lon: -72.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DHSST',
    StateC: 'US',
    C: 'Government',
    TStart: '2003',
    TStop: '',
    name: 'US Department of Homeland Security, Science and Technology Directorate',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DCA',
    StateC: 'US',
    C: 'Military',
    TStart: '1991 Jun 25',
    TStop: '',
    name: 'Defense Information Systems Agency',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DISH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008 Jan',
    TStop: '',
    name: 'Dish Network',
    Location: 'Meridian, Colorado',
    lat: 39.55,
    lon: -104.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DIYS',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '2013 Apr',
    TStop: '',
    name: 'Diysatellite',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NKAU',
    StateC: 'UA',
    C: 'Government',
    TStart: '2011',
    TStop: '',
    name: 'Derzhavne Kosmichne Agentstvo Ukrayni',
    Location: 'Kyiv, Ukraine',
    lat: 50.45,
    lon: 30.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DKJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'Zhongguo dianzi keji jituan YG',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DKJ38',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'Zhongguo dianzi keji jituan gongsi di 38 yanjiu suo',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFVLR',
    StateC: 'D',
    C: 'Government',
    TStart: '1989',
    TStop: '1997',
    name: 'Deutsche Forschungsanstalt f\\"new ControlSite({u}r Luft- und Raumfahrt,',
    Location: 'Koln',
    lat: 50.94,
    lon: 6.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DFVLR',
    StateC: 'D',
    C: 'Government',
    TStart: '1997',
    TStop: '',
    name: 'Deutsches Zentrum fur Luft- und Raumfahrt',
    Location: 'Koln',
    lat: 50.94,
    lon: 6.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DLRB',
    StateC: 'D',
    C: 'Government',
    TStart: '2006',
    TStop: '',
    name: 'DLR Institute fur Raumfahrtsysteme',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: 'DLR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DLRRA',
    StateC: 'D',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'DLR Institute fur Raumfahrtantriebe (Space propulsion)',
    Location: 'Lampoldshausen',
    lat: 49.27,
    lon: 9.4,
    alt: 0,
    Parent: 'DLR',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DARA',
    StateC: 'D',
    C: 'Government',
    TStart: '1997',
    TStop: '',
    name: 'DLR Raumfahrt-Agentur',
    Location: 'Bonn:Oberkassel',
    lat: 50.71,
    lon: 7.17,
    alt: 0,
    Parent: 'DLR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DMA',
    StateC: 'F',
    C: 'Military',
    TStart: '1961',
    TStop: '1977',
    name: 'D\\\'el\\\'egation Minist\\\'erielle pour l\'Armement',
    Location: 'Paris:Bagneux',
    lat: 48.8,
    lon: 2.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DMC',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'DMC International Imaging',
    Location: 'Guildford',
    lat: 51.24,
    lon: -0.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DMI',
    StateC: 'DK',
    C: 'Government',
    TStart: '1872',
    TStop: '',
    name: 'Danmarks Meteorologiske Institut',
    Location: 'Kobenhavn',
    lat: 55.68,
    lon: 12.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DASA',
    StateC: 'US',
    C: 'Military',
    TStart: '1971 Nov 24',
    TStop: '1996 May 31',
    name: 'Defense Nuclear Agency, DoD, USA',
    Location: 'Albequerque, New Mexico [and DC]',
    lat: 35.11,
    lon: -106.61,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DND',
    StateC: 'CA',
    C: 'Military',
    TStart: '1997',
    TStop: '',
    name: 'Directorate of Space Development (DSpaceD), Department of National Defense',
    Location: 'Ottawa',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DNE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Design Net Engineering',
    Location: 'Denver:Golden, Colorado',
    lat: 39.75,
    lon: -105.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSRI',
    StateC: 'DK',
    C: 'Government',
    TStart: '2005 Jan 1',
    TStop: '',
    name: 'Danmarks Rumcenter (Danish National Space Center)',
    Location: 'Kobenhavn:Osterbro',
    lat: 55.71,
    lon: 12.57,
    alt: 0,
    Parent: 'DTU',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DOC',
    StateC: 'US',
    C: 'Government',
    TStart: '1903',
    TStop: '*',
    name: 'Department of Commerce',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DOD',
    StateC: 'US',
    C: 'Military',
    TStart: '1947 Sep 18',
    TStop: '*',
    name: 'Department of Defense',
    Location: 'Washington, DC',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEC',
    StateC: 'US',
    C: 'Government',
    TStart: '1977 Aug 4',
    TStop: '',
    name: 'Department of Energy',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORBIT',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'D-ORBIT',
    Location: 'Lomazzo, Como',
    lat: 45.7,
    lon: 9.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1914',
    TStop: '1985',
    name: 'Dornier Flugzeugwerke (Freidrichshafen)',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1985',
    TStop: '1989 May',
    name: 'Dornier GmBH (Daimler-Benz)',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DOSAAF',
    StateC: 'SU',
    C: 'Academic',
    TStart: '1951 Aug',
    TStop: '1991 Sep 25',
    name: 'Dobrovol\'noe obshchestvo sodeystviya armii, aviatsii i flotu',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DOSH',
    StateC: 'J',
    C: 'Government',
    TStart: '1875',
    TStop: '',
    name: 'Doshisha daigaku',
    Location: 'Kyoto',
    lat: 35.03,
    lon: 135.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DOST',
    StateC: 'PH',
    C: 'Government',
    TStart: '1987',
    TStop: '',
    name: 'Kagawaran ng Agham at Teknolohiya',
    Location: 'Taguig City',
    lat: 14.52,
    lon: 121.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAE',
    StateC: 'UK',
    C: 'Military',
    TStart: '1991 Apr 1',
    TStop: '1995 Apr 1',
    name: 'Defense Research Agency',
    Location: 'Farnborough, Hants.',
    lat: 51.29,
    lon: -0.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DRAP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1973',
    TStop: '',
    name: 'Charles Stark Draper Laboratory, Inc.',
    Location: 'Cambridge, Mass.',
    lat: 42.36,
    lon: -71.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CARDE',
    StateC: 'CA',
    C: 'Military',
    TStart: '2000 Apr 1',
    TStop: '',
    name: 'Defense Research and Development Canada',
    Location: 'Quebec City:Valcartier, Quebec',
    lat: 46.9,
    lon: -71.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DRDL',
    StateC: 'IN',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Defense Research and Development Laboratory',
    Location: 'Hyderabad',
    lat: 17.37,
    lon: 78.48,
    alt: 0,
    Parent: 'DRDO',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DRDO',
    StateC: 'IN',
    C: 'Military',
    TStart: '1958',
    TStop: '',
    name: 'Defense Research and Development Organization',
    Location: 'New Delhi',
    lat: 28.61,
    lon: 77.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CARDE',
    StateC: 'CA',
    C: 'Military',
    TStart: '1969',
    TStop: '2000 Apr 1',
    name: 'DRE/Valcartier',
    Location: 'Quebec City:Valcartier, Quebec',
    lat: 46.9,
    lon: -71.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DREXEL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1891',
    TStop: '',
    name: 'Drexel University',
    Location: 'Philadelphia, Pennsylvania',
    lat: 39.95,
    lon: -75.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DRG',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1952',
    TStop: '1961',
    name: 'Deutsche Raketen Gesellschaft (Seliger)',
    Location: 'Cuxhaven',
    lat: 53.86,
    lon: 8.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DRTE',
    StateC: 'CA',
    C: 'Military',
    TStart: '1951',
    TStop: '1969',
    name: 'Defense Research Telecommunications Establishment, Canada',
    Location: 'Ottawa, Ontario',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '1992 Jul',
    name: 'Defense Systems Inc',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSIR',
    StateC: 'UK',
    C: 'Government',
    TStart: '1917',
    TStop: '1965',
    name: 'UK Dept. of Scientific and Industrial Research',
    Location: 'London',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSNC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'Kabushikigaisha di esu enu',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSRI',
    StateC: 'DK',
    C: 'Government',
    TStart: '1968',
    TStop: '2005 Jan 1',
    name: 'Dansk Rumforskningsinstitut (Danish Space Research Inst)',
    Location: 'Kobenhavn:Osterbro',
    lat: 55.71,
    lon: 12.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSSG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008 Apr',
    TStop: '',
    name: 'Deployable Space Systems',
    Location: 'Goleta, California',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WRE',
    StateC: 'AU',
    C: 'Military',
    TStart: '1978',
    TStop: '',
    name: 'Defense Science and Technology Organization, Weapons Sys Div.',
    Location: 'Adelaide:Edinburgh (Salisbury), South Australia',
    lat: -34.76,
    lon: 138.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DTI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '',
    name: 'DTI Associates (ex Astrotech assets)',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DTU',
    StateC: 'DK',
    C: 'Academic',
    TStart: '1829',
    TStop: '',
    name: 'Danmarks Tekniske Universitet',
    Location: 'Kobenhavn:Lyngby',
    lat: 55.79,
    lon: 12.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '2015',
    name: 'DirecTV',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'AT&T/DirecTV',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DTVLA',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'DirecTV Latin America',
    Location: 'Rio De Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'DTVA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DUD',
    StateC: 'US',
    C: 'Academic',
    TStart: '1852',
    TStop: '',
    name: 'Dudley Observatory',
    Location: 'Schenectady, New York',
    lat: 42.81,
    lon: -73.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILTEC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012',
    TStop: '2016 May',
    name: 'Miltec Missiles and Space Co.',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DUTH',
    StateC: 'GR',
    C: 'Academic',
    TStart: '1973',
    TStop: '',
    name: 'Demoktriteio Panepistemio Thrakes',
    Location: 'Xanthi',
    lat: 41.13,
    lon: 24.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FOKKS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2002',
    TStop: '2014',
    name: 'Dutch Space, an EADS Astrium Company',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: 'ASTD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DUTEC',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Delta-UTEC Space Research',
    Location: 'Leiden',
    lat: 52.17,
    lon: 4.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DVNG',
    StateC: 'SU',
    C: 'Government',
    TStart: '1950',
    TStop: '',
    name: 'Dal\'nevostochniy regional\'niy nauchno-issledovatel\'skiy gidrometeol. institut',
    Location: 'Vladivostok',
    lat: 43.1333,
    lon: 131.9,
    alt: 0,
    Parent: 'GMS',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DVST',
    StateC: 'TR',
    C: 'Military',
    TStart: '2017',
    TStop: '',
    name: 'Delta V Space Technologies Inc.',
    Location: 'Istanbul',
    lat: 41.01,
    lon: -28.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DYN',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1975',
    TStop: '2009',
    name: 'Dynacon Inc. Space Division',
    Location: 'Toronto:Mississauga, Ontario',
    lat: 43.6,
    lon: -79.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DYNT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Dynetics',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EAC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'Environmental Aeroscience Corporation',
    Location: 'Miami, Florida',
    lat: 25.78,
    lon: -80.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EADS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2000 Jul 10',
    TStop: '2014 Jan 1',
    name: 'European Aeronautic Defense and Space Company EADS N.V.',
    Location: 'Schiphol-Rijk, Amsterdam',
    lat: 52.28,
    lon: 4.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EADSA',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2000 Jul 10',
    TStop: '2014 Jan 1',
    name: 'EADS Astrium Aquitaine',
    Location: 'Bordeaux:St-Medard-en-Jalles',
    lat: 44.9,
    lon: -0.72,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2003 Jun 16',
    TStop: '2014 Jan 1',
    name: 'EADS Bremen',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CASA',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2004 Jan',
    TStop: '2006 Jul',
    name: 'EADS Astrium Construcciones Aeronauticas S.A. (CASA) Espacio',
    Location: 'Madrid:Barajas',
    lat: 40.47,
    lon: -3.59,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AECSG',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2000 Jul 10',
    TStop: '2014 Jan 1',
    name: 'EADS Launch Vehicles - CSG',
    Location: 'CSG, Kourou, Guyane Francaise',
    lat: 5.23,
    lon: -52.77,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORLM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2000 Jul 10',
    TStop: '2014 Jan 1',
    name: 'EADS Launch Vehicles (EADS LV)',
    Location: 'Les Mureaux, Paris, France',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOLK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2000 Jul',
    TStop: '2006 Jun',
    name: 'EADS Ottobrunn',
    Location: 'Munchen:Ottobrunn',
    lat: 48.07,
    lon: 11.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EARI',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2013',
    TStop: '',
    name: 'Earth-i Ltd.',
    Location: 'Guildford',
    lat: 51.24,
    lon: -0.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DORN',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2003 Jun 16',
    TStop: '2014 Jan 1',
    name: 'EADS Astrium Satellites (D), Friedrichsafen',
    Location: 'Friedrichsafen',
    lat: 47.65,
    lon: 9.48,
    alt: 0,
    Parent: 'EADS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ECHO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '2007 Dec',
    name: 'Echostar Communications Corp',
    Location: 'Englewood, Colorado',
    lat: 39.65,
    lon: -104.99,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ECHO23',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2019 May',
    TStop: '',
    name: 'EchoStar XXIII License Sub Ltd',
    Location: 'London',
    lat: 51.52,
    lon: -0.09,
    alt: 0,
    Parent: 'DISH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIRION',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2019 Oct',
    TStop: '',
    name: 'EchoStar Global Australia',
    Location: 'Gold Coast:Southport, Queensland',
    lat: -27.96,
    lon: 153.4,
    alt: 0,
    Parent: 'HELWE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ECHO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2007 Dec',
    TStop: '',
    name: 'Echostar Corp',
    Location: 'Englewood, Colorado',
    lat: 39.65,
    lon: -104.99,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ECHOM',
    StateC: 'IE',
    C: 'Commercial',
    TStart: '2015 Mar',
    TStop: '',
    name: 'Echostar Mobile',
    Location: 'Dublin',
    lat: 53.35,
    lon: -6.27,
    alt: 0,
    Parent: 'ECHO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ECLIP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'Ecliptic Enterprises',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EXOL',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2009',
    TStop: '2019 Jan',
    name: 'ECM Launch Services',
    Location: 'Berlin',
    lat: 52.44,
    lon: 13.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRDL',
    StateC: 'US',
    C: 'Military',
    TStart: '1962 Aug',
    TStop: '1978',
    name: 'US Army Electronics Command',
    Location: 'Ft Monmouth, NJ',
    lat: 40.31,
    lon: -74.05,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EDLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1953',
    TStop: '',
    name: 'Electronics Defense Laboratory-Sylvania',
    Location: 'San Jose:Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EELEC',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1953',
    TStop: '1960',
    name: 'English Electric Co., Stevenage',
    Location: 'Stevenage',
    lat: 51.9,
    lon: -0.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EER',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990 Dec',
    TStop: '2001',
    name: 'EER Systems Inc. Aerospace Div.',
    Location: 'Seabrook, Maryland',
    lat: 38.97,
    lon: -76.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990 Dec',
    TStop: '2001',
    name: 'EER Systems Inc. SSI Division',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EGA',
    StateC: 'EG',
    C: 'Military',
    TStart: '1960',
    TStop: '',
    name: 'Egyptian Army, Missile Division',
    Location: 'Jabal Hamzah, Egypt',
    lat: 30.12,
    lon: 30.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EGAO',
    StateC: 'EG',
    C: 'Government',
    TStart: '1960',
    TStop: '1967',
    name: 'Egyptian General Aero Organization',
    Location: 'Al Qahira',
    lat: 30.03,
    lon: 31.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EGG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1947',
    TStop: '',
    name: 'EG&G Corp.',
    Location: 'Gaithersburg, Maryland',
    lat: 39.13,
    lon: -77.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EGS',
    StateC: 'GE',
    C: 'Commercial',
    TStart: '1998',
    TStop: '',
    name: 'Energiya-GPI-Space',
    Location: 'Tbilisi',
    lat: 41.72,
    lon: 44.78,
    alt: 0,
    Parent: 'GPI',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GSAEU',
    StateC: 'I-EU',
    C: 'Government',
    TStart: '2004',
    TStop: '2010',
    name: 'European GNSS Supervisory Authority',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NARSS',
    StateC: 'EG',
    C: 'Government',
    TStart: '2017',
    TStop: '',
    name: 'Wikalat Alfada\' Almisria',
    Location: 'Al-Qahira (Cairo):El Nozha El Gedida',
    lat: 30.03,
    lon: 31.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HNS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Echostar/Hughes Satellite Systems Corp',
    Location: 'Germantown, Maryland',
    lat: 39.18,
    lon: -77.27,
    alt: 0,
    Parent: 'ECHO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EIAST',
    StateC: 'UAE',
    C: 'Government',
    TStart: '2008',
    TStop: '2015 Apr 18',
    name: 'Emirates Institution for Advanced Science and Technology',
    Location: 'Dubai',
    lat: 25.26,
    lon: 55.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ELBIT',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '1966',
    TStop: '',
    name: 'Elbit Systems Ltd.',
    Location: 'Haifa',
    lat: 32.79,
    lon: 34.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEIMOS',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2009 Sep',
    TStop: '',
    name: 'Elecnor Deimos (Tres Cantos)',
    Location: 'Madrid:Tres Cantos',
    lat: 40.6,
    lon: -3.71,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEIMI',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2009 Sep',
    TStop: '2015 Aug',
    name: 'Deimos Imaging, Elecnor Deimos',
    Location: 'Boecillo, Valladolid',
    lat: 41.53,
    lon: -4.7,
    alt: 0,
    Parent: 'ELDE',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ELDEC',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2010 Sep',
    TStop: '2015 Aug',
    name: 'Elecnor Deimos (Castilla-La Mancha)',
    Location: 'Puertollano, Castilla-La Mancha',
    lat: 38.68,
    lon: -4.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ELDO',
    StateC: 'I-ELDO',
    C: 'Government',
    TStart: '1962',
    TStop: '1975',
    name: 'Centre Europeene de Construct. de Lanceurs et d\'Engins Spatiaux',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: 'I-ELDO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ELLT',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1804',
    TStop: '1966',
    name: 'Elliott Bros (London) Space and Weapon Research Labs (Marconi)',
    Location: 'Frimley, Surrey',
    lat: 51.31,
    lon: -0.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOSL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'Energia Logistics Ltd, (ELUS)',
    Location: 'Long Beach, California',
    lat: 33.77,
    lon: -118.2,
    alt: 0,
    Parent: 'RKKE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ELV',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'ELV SpA',
    Location: 'Colleferro',
    lat: 41.73,
    lon: 13.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ELYS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Elysium Space',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMASH',
    StateC: 'RU',
    C: 'Government',
    TStart: '1990 Jan',
    TStop: '',
    name: 'NPO Energomash',
    Location: 'Moskva:Khimki',
    lat: 55.9,
    lon: 37.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMAVI',
    StateC: 'CO',
    C: 'Military',
    TStart: '1933',
    TStop: '',
    name: 'Escuela Militar de Avacion, Base Aerea Marco Fidel Suarez',
    Location: 'Cali',
    lat: 3.46,
    lon: -76.5,
    alt: 0,
    Parent: 'FACO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMBR',
    StateC: 'BR',
    C: 'Government',
    TStart: '1965',
    TStop: '1998',
    name: 'Embratel (Empresa Brasileira de Telecomunicacoes) Satellite Div',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'TELB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMBR',
    StateC: 'BR',
    C: 'Government',
    TStart: '1998',
    TStop: '2003',
    name: 'Embratel (Empresa Brasileira de Telecomunicacoes) Satellite Div',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'MCI',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMBR',
    StateC: 'BR',
    C: 'Government',
    TStart: '2003',
    TStop: '',
    name: 'Embratel (Empresa Brasileira de Telecomunicacoes) Satellite Div',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'TELMX',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPARM',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2005',
    name: 'EMS Technologies (Canada)',
    Location: 'Montreal:St-Anne-de-Bellevue, Quebec',
    lat: 45.4,
    lon: -73.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ENDUR',
    StateC: 'BGN',
    C: 'Academic',
    TStart: '2015 Jan',
    TStop: '',
    name: 'EnduroSat',
    Location: 'Sofia',
    lat: 42.7,
    lon: 23.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EOS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1980',
    name: 'Electro-Optical Systems, Inc.',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EOSAT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '1996 Nov',
    name: 'EOSAT Inc (Earth Observation Satellite Company; Hughes/RCA)',
    Location: 'Washington, DC/Lanham, Md.',
    lat: 38.97,
    lon: -76.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EOSAU',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '1983',
    TStop: '',
    name: 'Electro-Optical Systems Pty Ltd.',
    Location: 'Queanbeyan, New South Wales',
    lat: -35.35,
    lon: 149.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EPFL',
    StateC: 'CH',
    C: 'Academic',
    TStart: '1978',
    TStop: '',
    name: 'Ecole Polytechnique F\\\'ed\\\'erale de Lausanne, Ecublens campus',
    Location: 'Lausanne:Ecublens',
    lat: 46.53,
    lon: 6.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EPOS',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1976',
    TStop: '1978',
    name: 'Mikoyan i Gurevich OKB-155 EPOS',
    Location: 'Aktyubinsk',
    lat: 47.85,
    lon: 59.61,
    alt: 0,
    Parent: 'MIG',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERAU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1965',
    TStop: '',
    name: 'Embry-Riddle Aeronautical University (ERAU)',
    Location: 'Daytona Beach, Florida',
    lat: 29.19,
    lon: -81.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AEC',
    StateC: 'US',
    C: 'Government',
    TStart: '1975 Jan 19',
    TStop: '1977 Aug 4',
    name: 'Energy Research and Development Agency',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERDL',
    StateC: 'US',
    C: 'Military',
    TStart: '1942',
    TStop: '',
    name: 'US Army Engineer Research and Development Lab',
    Location: 'Springfield:Ft Belvoir, Virginia',
    lat: 38.72,
    lon: -77.15,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1969 Jan 1',
    name: 'ERNO-VFW (Entwicklungsring Nord)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: 'VFW',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1969 Jan 1',
    TStop: '1980',
    name: 'ERNO-VFW Fokker (Entwicklungsring Nord)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: 'VFWF',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1980',
    TStop: '1981',
    name: 'ERNO-VFW (Entwicklungsring Nord)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: 'VFW',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERTU',
    StateC: 'EG',
    C: 'Government',
    TStart: '1960',
    TStop: '',
    name: 'Ittihad al-Idha\'ah wal-Tilifzyun al-Misri',
    Location: '6th of October City',
    lat: 29.94,
    lon: 30.91,
    alt: 0,
    Parent: 'EG',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESA',
    StateC: 'I-ESA',
    C: 'Government',
    TStart: '1975 Apr 30',
    TStop: '',
    name: 'European Space Agency',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESHAIL',
    StateC: 'QA',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Es\'hailsat, Qatar Satellite Compnay',
    Location: 'Doha',
    lat: 25.29,
    lon: 51.53,
    alt: 0,
    Parent: 'ICTQ',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESIE',
    StateC: 'F',
    C: 'Academic',
    TStart: '1990',
    TStop: '',
    name: 'ESIEESPACE, Ecole Sup. d\'Ingenieurs en Electron. et Electrotechnique',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: 'TARTU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1964',
    TStop: '1969',
    name: 'Electromagnetic Systems Laboratory, Inc',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1969',
    TStop: '1978',
    name: 'Electromagnetic Systems Laboratory, Inc',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFETR',
    StateC: 'US',
    C: 'Military',
    TStart: '1979 Oct 1',
    TStop: '1991 Nov 12',
    name: 'Eastern Space and Missile Center',
    Location: 'Patrick SFB, Cape Canaveral, Florida',
    lat: 28.24,
    lon: -80.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESRO',
    StateC: 'I-ESRO',
    C: 'Government',
    TStart: '1962',
    TStop: '1975 Apr 30',
    name: 'Conseil Europeen de Recherches Spatiales',
    Location: 'Paris:Neuilly-sur-Seine',
    lat: 48.89,
    lon: 2.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESRWA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Earth and Space Research',
    Location: 'Seattle, Washington',
    lat: 47.61,
    lon: -122.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESSA',
    StateC: 'US',
    C: 'Government',
    TStart: '1965',
    TStop: '1970 Oct',
    name: 'Environmental Science Services Administration',
    Location: 'Suitland, Maryland',
    lat: 38.85,
    lon: -76.92,
    alt: 0,
    Parent: 'DOC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESSP',
    StateC: 'EE',
    C: 'Academic',
    TStart: '2012',
    TStop: '',
    name: 'Eesti tudengisatelliidi programm',
    Location: 'Tartu',
    lat: 58.38,
    lon: 26.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESSTI',
    StateC: 'ET',
    C: 'Government',
    TStart: '2016 Oct',
    TStop: '',
    name: 'Ethiopian Space Science and Technology Institute',
    Location: 'Addis Abbaba',
    lat: 9.05,
    lon: 38.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESTEC',
    StateC: 'I-ESA',
    C: 'Government',
    TStart: '1964',
    TStop: '',
    name: 'ESTEC',
    Location: 'Noordwijk, Nederland',
    lat: 52.23,
    lon: 4.45,
    alt: 0,
    Parent: 'I-ESA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTVE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1972',
    TStop: '1995',
    name: 'E-Systems Inc.',
    Location: 'Dallas:Garland, Texas',
    lat: 32.91,
    lon: -96.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ETAC',
    StateC: 'US',
    C: 'Military',
    TStart: '1964 Dec',
    TStop: '1975 Aug',
    name: 'Environmental Technical Applications Center, USAF',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ETAC',
    StateC: 'US',
    C: 'Military',
    TStart: '1975 Aug',
    TStop: '1995 Oct',
    name: 'Environmental Technical Applications Center, USAF',
    Location: 'St. Louis:Scott AFB, Illinois',
    lat: 38.53,
    lon: -89.87,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ETEC',
    StateC: 'BR',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Escola Municipal Presidente Tancredo de Almeida Neves',
    Location: 'Ubatuba, Sao Paolo',
    lat: -23.44,
    lon: -45.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUMET',
    StateC: 'I-EUM',
    C: 'Government',
    TStart: '1986',
    TStop: '',
    name: 'European Meteorological Satellite Organization',
    Location: 'Darmstadt',
    lat: 49.87,
    lon: 8.65,
    alt: 0,
    Parent: 'I-EUM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUPST',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1998',
    TStop: '2005 Jul',
    name: 'EuropeStar Ltd.',
    Location: 'Uxbridge, Middlesex',
    lat: 51.54,
    lon: -0.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EURAS',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'Eurasspace Gesellschaft fur Raumfahrttechnik mbH',
    Location: 'Munchen',
    lat: 48.13,
    lon: 11.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUROK',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Eurockot Launch Services GmbH (D for RU lanch vehicle)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUROL',
    StateC: 'S',
    C: 'Commercial',
    TStart: '2003 Dec',
    TStop: '',
    name: 'Eurolaunch (DLR/SSC)',
    Location: 'Kiruna',
    lat: 67.85,
    lon: 20.22,
    alt: 0,
    Parent: 'SSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUROP',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1991',
    TStop: '',
    name: 'Europropulsion (SEP/BPD)',
    Location: 'Suresnes',
    lat: 48.87,
    lon: 2.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUROPK',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1991',
    TStop: '',
    name: 'Europropulsion (SEP/BPD)',
    Location: 'Kourou',
    lat: 5.24,
    lon: -52.77,
    alt: 0,
    Parent: 'EUROP',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EURSA',
    StateC: 'MC',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Eurasiasat',
    Location: 'Monaco',
    lat: 43.73,
    lon: 7.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EURSG',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Eurasiasat-Golbasi (Satellite control center)',
    Location: 'Golbasi',
    lat: 39.8,
    lon: 32.8,
    alt: 0,
    Parent: 'EURSA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GSAEU',
    StateC: 'I-EU',
    C: 'Government',
    TStart: '2021 Jan',
    TStop: '*',
    name: 'EU Agency for the Space Programme',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAMX',
    StateC: 'MX',
    C: 'Commercial',
    TStart: '2014 Mar 7',
    TStop: '',
    name: 'Eutelsat Americas',
    Location: 'Ciudad de Mexico:Lomas de Sotelo',
    lat: 19.44,
    lon: -99.22,
    alt: 0,
    Parent: 'EUTSA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUTEL',
    StateC: 'I-EUT',
    C: 'Government',
    TStart: '1977',
    TStop: '2001 Jul',
    name: 'European Telecommunications Satellite Organization',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: 'I-EUT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EUTEL',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2001 Jul 2',
    TStop: '',
    name: 'Eutelsat SA',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EWAT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Jan',
    TStop: '2002',
    name: 'Earth Watch Inc',
    Location: 'Longmont, Colorado',
    lat: 40.17,
    lon: -105.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EXA',
    StateC: 'EC',
    C: 'Government',
    TStart: '2007 Nov',
    TStop: '',
    name: 'Agencia Especial Civil Ecuatoriana',
    Location: 'Guayaquil',
    lat: -2.18,
    lon: -79.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EXEA',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2009',
    TStop: '2021 Sep',
    name: 'exactEarth Ltd.',
    Location: 'Cambridge, Ontario',
    lat: 43.37,
    lon: -80.32,
    alt: 0,
    Parent: 'COMDEV',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EXEA',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2021 Sep',
    TStop: '',
    name: 'Spire exactEarth Ltd.',
    Location: 'Cambridge, Ontario',
    lat: 43.37,
    lon: -80.32,
    alt: 0,
    Parent: 'SPIRE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EXOL',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2019 Jan',
    TStop: '',
    name: 'EXOLaunch (ECM Launch Services)',
    Location: 'Berlin',
    lat: 52.44,
    lon: 13.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARMAD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Exos Aerospace',
    Location: 'Dallas:Caddo Mills, Texas',
    lat: 33.06,
    lon: -96.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EXPACE',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Hangtian kegong huojian jishu youxiangongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EXSEED',
    StateC: 'IN',
    C: 'Commercial',
    TStart: '2017 Apr',
    TStop: '',
    name: 'Exseed Space Innovations Pvt Ltd.',
    Location: 'Mumbai, Maharashtra',
    lat: 18.98,
    lon: 72.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAB',
    StateC: 'BR',
    C: 'Military',
    TStart: '1941',
    TStop: '',
    name: 'Forca Aerea Brasileira',
    Location: 'Brasilia',
    lat: -15.79,
    lon: -47.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FACH',
    StateC: 'CL',
    C: 'Military',
    TStart: '1930',
    TStop: '',
    name: 'Fuerza Aerea de Chile, ECS Fasat, Los Cerrillos AFB',
    Location: 'Santiago:Los Cerrillos',
    lat: -33.49,
    lon: -70.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FACO',
    StateC: 'CO',
    C: 'Military',
    TStart: '1921',
    TStop: '',
    name: 'Fuerza Aerea Colombiana',
    Location: 'Bogota',
    lat: 4.71,
    lon: -74.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993',
    TStop: '2001',
    name: 'Final Analysis Inc',
    Location: 'Greenbelt, Maryland',
    lat: 38.99,
    lon: -76.89,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAIR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1971',
    TStop: '1994',
    name: 'Fairchild Space and Electronics',
    Location: 'Germantown, Maryland',
    lat: 39.18,
    lon: -77.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAIRH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1950',
    TStop: '1961',
    name: 'Fairchild Aircraft Division',
    Location: 'Hagerstown, Maryland',
    lat: 39.64,
    lon: -77.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAIRH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1964',
    name: 'Fairchild Stratos Space Systems Division',
    Location: 'Hagerstown, Maryland',
    lat: 39.64,
    lon: -77.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAIRH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1964',
    TStop: '1971',
    name: 'Fairchild Hiller Space Systems Division',
    Location: 'Hagerstown, Maryland',
    lat: 39.64,
    lon: -77.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAIR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1964',
    TStop: '1971',
    name: 'Fairchild Hiller Space Systems (Rockville/Germantown)',
    Location: 'Germantown, Maryland',
    lat: 39.18,
    lon: -77.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAKEL',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1971',
    TStop: '2014 Mar',
    name: 'OKB Fakel',
    Location: 'Kaliningrad',
    lat: 55.03,
    lon: 22.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAKEL',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2014 Mar',
    TStop: '',
    name: 'OKB Fakel, fil. ORKK',
    Location: 'Kaliningrad',
    lat: 55.03,
    lon: 22.03,
    alt: 0,
    Parent: 'ORKK',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FANG',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Beijing Hangtian Fanghzou Kongjian Jishu YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAIC',
    StateC: 'US',
    C: 'Military',
    TStart: '1961',
    TStop: '1993 Oct 1',
    name: 'USAF Foreign Aerospace Science Technology Center (FTD)',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FATAH',
    StateC: 'IQ',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2003',
    name: 'Al Fatah Co., Baghdad',
    Location: 'Baghdad',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FBK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Facebook, Inc.',
    Location: 'Menlo Park, California',
    lat: 37.45,
    lon: -122.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FCCO',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: '4C Polito Space, 4C Controls',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FFLY',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Firefly Aerospace',
    Location: 'Austin',
    lat: 30.29,
    lon: -97.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FHWN',
    StateC: 'AT',
    C: 'Academic',
    TStart: '1994',
    TStop: '',
    name: 'Fachhochschule Wiener Neustadt',
    Location: 'Wiener Neustadt',
    lat: 47.84,
    lon: 16.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIAN',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1934',
    TStop: '',
    name: 'Fizicheskiy Institute im. PN Lebedeva Ross. AN',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'AN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIAT',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1899 Jul',
    TStop: '1969',
    name: 'Fiat',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BPD',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1994',
    TStop: '2003',
    name: 'FiatAvio spA',
    Location: 'Colleferro',
    lat: 41.73,
    lon: 13.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FING',
    StateC: 'UY',
    C: 'Academic',
    TStart: '1888',
    TStop: '',
    name: 'Facultad de Ingeneria, Universidad de la Republica',
    Location: 'Montevideo:Parque Rodo',
    lat: -34.92,
    lon: -56.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APW',
    StateC: 'D',
    C: 'Academic',
    TStart: '1980',
    TStop: '',
    name: 'Fraunhofer-Institut fur Physikalische Messtechnik',
    Location: 'Freiburg im Breslau',
    lat: 47.98,
    lon: 7.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIRES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1954',
    TStop: '1962',
    name: 'Firestone Guided Missile Division Los Angeles plant',
    Location: 'Los Angeles:South Gate, California',
    lat: 33.94,
    lon: -118.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIRES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1951',
    TStop: '1954',
    name: 'Firestone Tire and Rubber',
    Location: 'Akron, Ohio',
    lat: 41.07,
    lon: -81.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIRMA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Firmamentum',
    Location: 'Seattle:Bothell, Washington',
    lat: 47.77,
    lon: -122.2,
    alt: 0,
    Parent: 'TUI',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1966',
    TStop: '',
    name: 'Florida Inst of Technology',
    Location: 'Melbourne, Florida',
    lat: 28.07,
    lon: -80.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOM',
    StateC: 'RU',
    C: 'Government',
    TStart: '2004',
    TStop: '2016 Jan 1',
    name: 'Federal\'noe kosmicheskoe agentstvo Rossii (Roskosmos)',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKG',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergeschwader 1 or 2 (unknown)',
    Location: 'Landsberg am Lech, Bayern',
    lat: 48.05,
    lon: 10.9,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKG1',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergeschwader 1',
    Location: 'Landsberg am Lech, Bayern',
    lat: 48.05,
    lon: 10.9,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKGR11',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergruppe 11, FKG 1',
    Location: 'Landsberg am Lech, Bayern',
    lat: 48.05,
    lon: 10.9,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKGR12',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergruppe 12, FKG 1',
    Location: 'Landsberg am Lech, Bayern',
    lat: 48.05,
    lon: 10.9,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKGR13',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergruppe 13, FKG 1',
    Location: 'Landsberg am Lech, Bayern',
    lat: 48.05,
    lon: 10.9,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKG2',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergeschwader 2',
    Location: 'Geilenkirchen, Nordrhein-Westphalen',
    lat: 50.97,
    lon: 6.12,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKGR21',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergruppe 21, FKG 2',
    Location: 'Geilenkirchen, Nordrhein-Westphalen',
    lat: 50.97,
    lon: 6.12,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FKGR22',
    StateC: 'D',
    C: 'Military',
    TStart: '1964',
    TStop: '1991',
    name: 'Flugkorpergruppe 22, FKG 2',
    Location: 'Geilenkirchen, Nordrhein-Westphalen',
    lat: 50.97,
    lon: 6.12,
    alt: 0,
    Parent: 'LW',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPFL',
    StateC: 'US',
    C: 'Government',
    TStart: '2000',
    TStop: '2006 May',
    name: 'Florida Space Authority',
    Location: 'Kennedy Space Center, Florida',
    lat: 28.61,
    lon: -80.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPFL',
    StateC: 'US',
    C: 'Government',
    TStart: '2006 May',
    TStop: '',
    name: 'Space Florida',
    Location: 'Kennedy Space Center, Florida',
    lat: 28.61,
    lon: -80.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FLEET',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Fleet Space Technologies Pty Ltd',
    Location: 'Adelaide:Beverley, South Australia',
    lat: -34.89,
    lon: 138.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FMI',
    StateC: 'DK',
    C: 'Military',
    TStart: '2014',
    TStop: '',
    name: 'Forsvarets Materiel-og Indkobsstyrelse',
    Location: 'Kobenhavn:Ballerup',
    lat: 55.73,
    lon: 21.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FMV',
    StateC: 'S',
    C: 'Military',
    TStart: '1968',
    TStop: '',
    name: 'Forsvarets materielverk',
    Location: 'Stockholm',
    lat: 59.34,
    lon: 18.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FOKK',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1919',
    TStop: '1996',
    name: 'Fokker Aircraft',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FOKKS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1970',
    TStop: '1972',
    name: 'Fokker Ruimtevaart',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: 'FOKK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FOKKS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1972',
    TStop: '1996',
    name: 'Fokker Space',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: 'FOKK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FOKKS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2002',
    name: 'Fokker Space and Systems',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1976 Dec',
    TStop: '1990 Oct',
    name: 'Ford Aerospace, Palo Alto',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AENUT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1960',
    name: 'Ford Motor Co. Aeronutronic Div.',
    Location: 'Los Angeles:Glendale, California',
    lat: 34.15,
    lon: -118.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1975',
    TStop: '1976 Dec',
    name: 'Aeronutronic Ford Western Development Labs',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORNB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1975',
    TStop: '',
    name: 'Aeronutronic Ford, Newport Beach',
    Location: 'Newport Beach, California',
    lat: 33.62,
    lon: -117.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORNB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1962',
    name: 'Ford Aeronutronic Division',
    Location: 'Newport Beach, California',
    lat: 33.62,
    lon: -117.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTNF',
    StateC: 'N',
    C: 'Government',
    TStart: '1993 Jan 1',
    TStop: '',
    name: 'Norges Forskingradet',
    Location: 'Oslo',
    lat: 59.92,
    lon: 10.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FOSSA',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Fossa Systems',
    Location: 'Madrid:Pozuelo de Alarcon',
    lat: 40.44,
    lon: -3.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FPTU',
    StateC: 'VN',
    C: 'Academic',
    TStart: '2006 Sep',
    TStop: '',
    name: 'F Space Lab, Financing and Promoting Technology Corp. University',
    Location: 'Ha Noi',
    lat: 21.03,
    lon: 105.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FRANK',
    StateC: 'D',
    C: 'Academic',
    TStart: '1912',
    TStop: '',
    name: 'Johann Wolfgang Goethe University Frankfurt am Main',
    Location: 'Frankfurt am Main',
    lat: 50.13,
    lon: 8.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FRASC',
    StateC: 'I',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'CNR-Frascati',
    Location: 'Frascati',
    lat: 41.82,
    lon: 12.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FRC',
    StateC: 'US',
    C: 'Government',
    TStart: '1958',
    TStop: '1976 Mar 26',
    name: 'NASA Flight Research Center, Edwards AFB',
    Location: 'Edwards, California',
    lat: 34.91,
    lon: -117.88,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FREIB',
    StateC: 'D',
    C: 'Academic',
    TStart: '1457',
    TStop: '',
    name: 'Albert-Ludwigs-Universitat Freiburg',
    Location: 'Freiburg im Breisgau',
    lat: 47.99,
    lon: 7.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MNF',
    StateC: 'F',
    C: 'Government',
    TStart: '1993',
    TStop: '',
    name: 'Meteo-France',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KGB',
    StateC: 'RU',
    C: 'Military',
    TStart: '1995',
    TStop: '',
    name: 'Federal\'naya sluzhba bezopasnosti Rossiyskoy Federatsii',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1851',
    TStop: '',
    name: 'Florida State University',
    Location: 'Tallahassee, Florida',
    lat: 30.44,
    lon: -84.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FTB',
    StateC: 'US',
    C: 'Military',
    TStart: '1945',
    TStop: '',
    name: 'Army Air Artillery Defense School, Fort Bliss, Texas',
    Location: 'Fort Bliss, Texas',
    lat: 31.8,
    lon: -106.42,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FTB2MB',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Second Missile Battalion, Fort Bliss, Texas',
    Location: 'Fort Bliss, Texas',
    lat: 31.8,
    lon: -106.42,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FTEL',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1988',
    TStop: '2013 Jul',
    name: 'France Telecom',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUCHS',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1985',
    TStop: '',
    name: 'Fuchs-Gruppe',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUDAN',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1905',
    TStop: '',
    name: 'Fudan daxue',
    Location: 'Shanghai',
    lat: 31.3,
    lon: 121.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUKU',
    StateC: 'J',
    C: 'Academic',
    TStart: '1954',
    TStop: '',
    name: 'Fukuoka kogyo daigaku',
    Location: 'Fukuoka',
    lat: 33.7,
    lon: 130.44,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUKUI',
    StateC: 'J',
    C: 'Government',
    TStart: '1871',
    TStop: '',
    name: 'Fukui ken',
    Location: 'Fukui',
    lat: 36.06,
    lon: 131.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUSEI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1950',
    TStop: '1961',
    name: 'Fuji Seimitsu Kogyo Kabu',
    Location: 'Tokyo:Suginami (Ogikubo)',
    lat: 35.68,
    lon: 139.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUTA',
    StateC: 'NG',
    C: 'Academic',
    TStart: '1981',
    TStop: '',
    name: 'Federal University of Technology Akure',
    Location: 'Akure, Ondo',
    lat: 7.25,
    lon: 5.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'G2P',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2000',
    TStop: '',
    name: 'G2P (SNECMA Propulsion Solide/SNPE-ME)',
    Location: 'Bordeaux:Le Haillan',
    lat: 44.87,
    lon: -0.68,
    alt: 0,
    Parent: 'SNECPS',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HGS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '2006 Jul 3',
    name: 'Panamsat G2 Satellite Solutions',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GABEN',
    StateC: 'NZ',
    C: 'Academic',
    TStart: '2020',
    TStop: '',
    name: 'Gabe Newell, founder of Valve Software',
    Location: 'Auckland, New Zealand',
    lat: -36.87,
    lon: 174.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSTUS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017 Nov 13',
    TStop: '',
    name: 'General Atomics Electromagnetic System Group/Englewood',
    Location: 'Denver:Englewood, Colorado',
    lat: 39.65,
    lon: -104.99,
    alt: 0,
    Parent: 'GATOM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILTEC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016 May',
    TStop: '',
    name: 'General Atomics, Huntsville',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: 'GATOM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAISH',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1831',
    TStop: '',
    name: 'Gos. Astronomicheskiy Inst. im. Shternberg MGU',
    Location: 'Moskva:MGU',
    lat: 55.7,
    lon: 37.53,
    alt: 0,
    Parent: 'MGU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAREF',
    StateC: 'F',
    C: 'Academic',
    TStart: '1964',
    TStop: '',
    name: 'Groupe Amateur de Recherches et d\'\\\'Etudes par Fus\\\'ees XV',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GASL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '2000',
    name: 'GASL, Inc.',
    Location: 'Ronkonkoma, New Yrok',
    lat: 40.81,
    lon: -73.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GASL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2003',
    name: 'GASL, Inc. Allied Aerospace',
    Location: 'Ronkonkoma, New Yrok',
    lat: 40.81,
    lon: -73.13,
    alt: 0,
    Parent: 'ALAER',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GATOM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1973',
    TStop: '1982',
    name: 'General Atomic Co.',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GATOM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955 Jul',
    TStop: '1967',
    name: 'General Dynamics General Atomics Division',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GATOM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1973',
    name: 'Gulf General Atomic',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GATOM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '1986',
    name: 'GA Technologies Inc.',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GATOM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '',
    name: 'General Atomics',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAU',
    StateC: 'SU',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Glavnoe artilleristkoe upravlenie',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'MVS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAU4',
    StateC: 'SU',
    C: 'Military',
    TStart: '1946',
    TStop: '1953 Apr',
    name: 'Glavnoe artilleristkoe upravlenie, 4 upravlenie',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'GAU',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROGAU',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Group of Astrodynamics for the Use of Space Systems, GAUSS SrI',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PROG',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1941',
    TStop: '1961',
    name: 'Gosudarstvenniy Aviatsionniy Zavod No. 1 (Zavod \'Progress\')',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAZC',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1992',
    TStop: '2008 Dec 1',
    name: 'OAO Gazkom',
    Location: 'Moskva:Korolev, Rossiya',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAZC',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2008 Dec 1',
    TStop: '',
    name: 'OAO Gazprom Kosmichekie Sistemi',
    Location: 'Moskva:Korolev, Rossiya',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAI',
    StateC: 'CN',
    C: 'Government',
    TStart: '1956 Oct 8',
    TStop: '1964 Nov 23',
    name: 'Guofang bu di wu yanjiuyuan',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GCA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '',
    name: 'Geophysics Corporation of America',
    Location: 'Boston, Mass.',
    lat: 42.36,
    lon: -71.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GCR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1954',
    TStop: '1961',
    name: 'Grand Central Rocket, Redlands',
    Location: 'Redlands, California',
    lat: 34.05,
    lon: -117.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GCRG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1954',
    TStop: '1961',
    name: 'Grand Central Rocket, Grand Central Airport',
    Location: 'Los Angeles:Glendale, California',
    lat: 34.15,
    lon: -118.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'General Dynamics',
    Location: 'West Falls Church, Virginia',
    lat: 38.87,
    lon: -77.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961 Jun',
    TStop: '1965 Feb',
    name: 'General Dynamics Astronautics',
    Location: 'San Diego:Kearny Mesa, California',
    lat: 32.83,
    lon: -117.14,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1965 Feb',
    TStop: '1985 Mar',
    name: 'General Dynamics/Convair Division (Plant 71)',
    Location: 'San Diego:Kearny Mesa, California',
    lat: 32.83,
    lon: -117.14,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1953 Mar',
    TStop: '1985 Mar',
    name: 'General Dynamics/Convair Division (Plant 19)',
    Location: 'San Diego:SAN, California',
    lat: 32.73,
    lon: -117.19,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDCLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1988',
    TStop: '1994 May',
    name: 'General Dynamics Commercial Launch Service',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GCDX',
    StateC: 'CN',
    C: 'Government',
    TStart: '1959',
    TStop: '',
    name: 'Guojia cehui dili xinxiju',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'GZB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '2010 Apr',
    name: 'General Dynamics C4 Systems (Adv Info Systems)',
    Location: 'Gilbert, Arizona',
    lat: 33.35,
    lon: -111.79,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2002 Aug',
    name: 'General Dynamics Ordnance and Tactical Systems',
    Location: 'Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONVPO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1954 Apr',
    TStop: '1992 May',
    name: 'General Dynamics Convair - Pomona',
    Location: 'Pomona, California',
    lat: 34.06,
    lon: -117.76,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985 Mar',
    TStop: '1994 May 2',
    name: 'General Dynamics Space Systems Division',
    Location: 'San Diego:Kearny Mesa, California',
    lat: 32.83,
    lon: -117.14,
    alt: 0,
    Parent: 'GD',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GECAP',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2001',
    name: 'GE Capital Satellites (Gibraltar) Ltd.',
    Location: 'Gibraltar',
    lat: 36.13,
    lon: -5.35,
    alt: 0,
    Parent: 'GE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GECO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1878',
    TStop: '',
    name: 'General Electric Co.',
    Location: 'Schenectady, New York',
    lat: 42.81,
    lon: -73.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAEW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '1993',
    name: 'GE Astro Space, East Windsor',
    Location: 'East Windsor, New Jersey',
    lat: 40.26,
    lon: -74.53,
    alt: 0,
    Parent: 'GE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GEMTS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1945',
    TStop: '1984',
    name: 'GE Malta Rocket Test Station',
    Location: 'Malta, New York',
    lat: 42.97,
    lon: -73.8,
    alt: 0,
    Parent: 'GESNY',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GERSD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1961',
    name: 'GE Missles and Space Division',
    Location: 'Philadelphia, Pennsylvania',
    lat: 39.95,
    lon: -75.16,
    alt: 0,
    Parent: 'GE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GTRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2015 Apr 27',
    name: 'GenCorp.',
    Location: 'Cleveland, Ohio',
    lat: 41.48,
    lon: -81.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GEOOPT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'GeoOptics Inc.',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GEOST',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1983 Mar',
    TStop: '1991 May',
    name: 'Geostar Corp.',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GERSD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1993',
    name: 'GE Reentry Systems Div',
    Location: 'Philadelphia, Pennsylvania',
    lat: 39.95,
    lon: -75.16,
    alt: 0,
    Parent: 'GE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GESNY',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'General Electric Co.',
    Location: 'Schenectady, New York',
    lat: 42.81,
    lon: -73.94,
    alt: 0,
    Parent: 'GE',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GTE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994 Jul 1',
    TStop: '1995',
    name: 'GE Americom/Spacenet-McLean',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: 'AMC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GEVF',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1993',
    name: 'GE Missiles and Space Vehicles Division (MSVD)',
    Location: 'Philadelphia:King of Prussia/Valley Forge, Penn.',
    lat: 40.1,
    lon: -75.47,
    alt: 0,
    Parent: 'GE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2006 Jan',
    TStop: '2011 Jan',
    name: 'GeoEye Inc. (on Orbital campus)',
    Location: 'Dulles, Virginia',
    lat: 39.01,
    lon: -77.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011 Jan',
    TStop: '2012 Jul',
    name: 'GeoEye Inc.',
    Location: 'Herndon, Virginia',
    lat: 38.97,
    lon: -77.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIMG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2006 Jan',
    TStop: '2012 Jul',
    name: 'GeoEye Inc. (Thornton)',
    Location: 'Thornton, Colorado',
    lat: 39.9,
    lon: -104.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GFW',
    StateC: 'D',
    C: 'Government',
    TStart: '1962 Aug',
    TStop: '1975',
    name: 'Gesellschaft fur Weltraumforschung',
    Location: 'Bonn',
    lat: 50.73,
    lon: 7.1,
    alt: 0,
    Parent: 'BMFT',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GFZ',
    StateC: 'D',
    C: 'Academic',
    TStart: '1992 Jan 1',
    TStop: '',
    name: 'Geoforschungszentrum Potzdam',
    Location: 'Berlin:Potsdam',
    lat: 52.4,
    lon: 13.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GGPEN',
    StateC: 'AO',
    C: 'Government',
    TStart: '2016',
    TStop: '',
    name: 'Gabinete de Gestao do Programa Espacial Nacional',
    Location: 'Luanda',
    lat: -8.84,
    lon: 13.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GHALAM',
    StateC: 'KZ',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'JV Ghalam LLP',
    Location: 'Astana',
    lat: 51.17,
    lon: 71.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GHG',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'GHGSat Inc.',
    Location: 'Montreal',
    lat: 45.51,
    lon: -73.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GHJ',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Guojia haiyang ju',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GHRCE',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1996',
    TStop: '',
    name: 'G. H. Raisoni College of Engineering, Rashtrasant Tukadoji Maharaj Nagpur U.',
    Location: 'Nagpur',
    lat: 21.15,
    lon: 79.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GICZ',
    StateC: 'CZ',
    C: 'Commercial',
    TStart: '1920',
    TStop: '',
    name: 'Geofyzikalni Ustav Ak. ved Ceske republiky (GFU)',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GIMR',
    StateC: 'US',
    C: 'Military',
    TStart: '1960 Aug 2',
    TStop: '1967 Jul 31',
    name: 'US Army Engineer Geodesy, Intelligence and Mapping R and D Agency (under ACE)',
    Location: 'Fort Belvoir, Virginia',
    lat: 38.72,
    lon: -77.15,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GIRD',
    StateC: 'SU',
    C: 'Military',
    TStart: '1931',
    TStop: '1933',
    name: 'Gruppa izucheniya reaktivnogo dvizheniya',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GISTDA',
    StateC: 'T',
    C: 'Government',
    TStart: '2000',
    TStop: '',
    name: 'Geo-Informatics and Space Technology Development Agency',
    Location: 'Bangkok',
    lat: 13.75,
    lon: 100.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GIT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1885 Oct',
    TStop: '',
    name: 'Georgia Institute of Technology',
    Location: 'Atlanta, Georgia',
    lat: 33.76,
    lon: -84.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GK',
    StateC: 'SU',
    C: 'Government',
    TStart: '1985',
    TStop: '',
    name: 'Glavkosmos',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GKLS',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2017 Apr',
    TStop: '',
    name: 'GK Launch Services',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'GK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GKNII',
    StateC: 'SU',
    C: 'Military',
    TStart: '1920',
    TStop: '',
    name: 'Gosudarstvennu Kraznoznamenni Nauchno-Ispitatel\'niy Institut im. V.P. Chkalov',
    Location: 'Aktyubinsk',
    lat: 47.85,
    lon: 59.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GLOB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '2011',
    name: 'Globalstar Inc.',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GLOB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Globalstar Inc.',
    Location: 'Covington, Louisiana',
    lat: 30.48,
    lon: -90.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GLOB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1991',
    TStop: '2004',
    name: 'Globalstar LP',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSEDD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2000',
    name: 'Electron Dynamics Division, General Motors',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GMKK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2011 Mar',
    TStop: '',
    name: 'Gengyu Muxing (Beijing) Kongjian Keji YG',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GMS',
    StateC: 'SU',
    C: 'Government',
    TStart: '',
    TStop: '1991',
    name: 'Gidrometeorlogichesky Sluzhba (Meteorological Service), Rossiya',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GMSCO',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'GMS Cosmos / Shanghai Spacecom Satellite Technology Ltd',
    Location: 'Shanghai',
    lat: 31.03,
    lon: 121.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOBBZ',
    StateC: 'I',
    C: 'Academic',
    TStart: '2012',
    TStop: '',
    name: 'Gewerbeoberschule Max Valier, Bozen',
    Location: 'Bolzano, Alto Adige (Sudtirol)',
    lat: 45.6,
    lon: 11.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOBME',
    StateC: 'I',
    C: 'Academic',
    TStart: '2012',
    TStop: '',
    name: 'Gewerbeoberschule Oskar von Miller, Meran',
    Location: 'Merano, Alto Adige (Sudtirol)',
    lat: 46.67,
    lon: 11.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNAE',
    StateC: 'BR',
    C: 'Government',
    TStart: '1961',
    TStop: '1963',
    name: 'Grupo de Organizacao da Comissao Nacional de Atividades Espaciais',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2012 Jul',
    name: 'Goodrich Electro-Optical Systems (former Perkin-Elmer)',
    Location: 'Danbury, Connecticut',
    lat: 41.4,
    lon: -73.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOIG',
    StateC: 'SU',
    C: 'Government',
    TStart: '1969',
    TStop: '1991',
    name: 'Gosudarstvenniy Okeanographicheskiy Institut GMS SSSR',
    Location: 'Odessa',
    lat: 46.4857,
    lon: 30.7434,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOL2',
    StateC: 'SU',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'GITsIP KS (GTsIU-153), Golitsyno-2',
    Location: 'Golitsyno-2 (Krasnoznamensk)',
    lat: 55.59,
    lon: 37.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOMSP',
    StateC: 'DK',
    C: 'Commercial',
    TStart: '2007',
    TStop: '',
    name: 'GomSpace',
    Location: 'Aalborg, Denmark',
    lat: 57.05,
    lon: 9.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOS',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'German Orbital Systems GmbH',
    Location: 'Berlin',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOYR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1939',
    TStop: '1987',
    name: 'Goodyear Aerospace',
    Location: 'Akron, Ohio',
    lat: 41.07,
    lon: -81.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GOYRP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1941',
    TStop: '1987',
    name: 'Goodyear Aerospace',
    Location: 'Phoenix, Arizona',
    lat: 33.45,
    lon: -112.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GPAP',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2013',
    TStop: '',
    name: 'GP Advanced Projects srls',
    Location: 'Gussago, Brescia',
    lat: 45.6,
    lon: 10.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Military',
    TStart: '1946',
    TStop: '1947',
    name: 'Guided Projective Establishment, UK Ministry of Supply',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GPI',
    StateC: 'GE',
    C: 'Commercial',
    TStart: '1996 Aug 27',
    TStop: '',
    name: 'Gruzinskiy Politeknichesckiy Intellekt',
    Location: 'Tbilisi',
    lat: 41.72,
    lon: 44.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KS',
    StateC: 'SU',
    C: 'Government',
    TStart: '1992',
    TStop: '2001 Apr 19',
    name: 'GP Kosmicheskaya Svyas\'',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LERC',
    StateC: 'US',
    C: 'Government',
    TStart: '1999 Mar 1',
    TStop: '',
    name: 'NASA Glenn Research Center',
    Location: 'Cleveland, Ohio',
    lat: 41.41,
    lon: -81.86,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GRI',
    StateC: 'F',
    C: 'Government',
    TStart: '1961',
    TStop: '',
    name: 'Group de Recherches Ionospheriques',
    Location: 'Paris:St Maur, Val-de-Marne',
    lat: 48.8,
    lon: 2.5,
    alt: 0,
    Parent: 'CNET',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRON',
    StateC: 'NL',
    C: 'Government',
    TStart: '1960',
    TStop: '1983',
    name: 'Geofysica en Ruimtonderzoek Commissie',
    Location: 'Leiden',
    lat: 52.17,
    lon: 4.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GRU',
    StateC: 'SU',
    C: 'Military',
    TStart: '1918',
    TStop: '1991',
    name: 'Glavnoye Razvedyvatelnoe Upravleniye',
    Location: 'Mosvka NW',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'SOVA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GRU',
    StateC: 'RU',
    C: 'Military',
    TStart: '1991',
    TStop: '',
    name: 'Glavnoye Razvedyvatelnoe Upravleniye',
    Location: 'Mosvka NW',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'MORF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GRUM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1929 Dec 6',
    TStop: '1994',
    name: 'Grummann Aerospace Corporation',
    Location: 'Bethpage, New York',
    lat: 40.75,
    lon: -73.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GSAEU',
    StateC: 'I-EU',
    C: 'Government',
    TStart: '2010',
    TStop: '2021 Jan',
    name: 'European Global Navigation Satellite Systems Agency',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GSFC',
    StateC: 'US',
    C: 'Government',
    TStart: '1959 May 1',
    TStop: '*',
    name: 'NASA Goddard Space Flight Center',
    Location: 'Greenbelt, Maryland',
    lat: 38.99,
    lon: -76.89,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GSOC',
    StateC: 'D',
    C: 'Government',
    TStart: '1969',
    TStop: '',
    name: 'Deutsches Raumfahrt-Kontrollzentrum (German Space Ops Center)',
    Location: 'Munchen:Oberpfaffenhofen, Bayern',
    lat: 48.08,
    lon: 11.25,
    alt: 0,
    Parent: 'DFVLR',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GSYU',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Kabushiki-gaisha GS Yuasa Korporeshon',
    Location: 'Kyoto',
    lat: 35.01,
    lon: 135.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1941 Apr',
    TStop: '1957 Mar',
    name: 'Group Technique de Cannes (SNCASE/Aerospatiale)',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: 'SUD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GTE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1983',
    TStop: '1994 Jun 30',
    name: 'GTE Spacenet Corp',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GTRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1915',
    TStop: '1984',
    name: 'General Tire and Rubber Company',
    Location: 'Cleveland:Akron, Ohio',
    lat: 41.07,
    lon: -81.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUGK',
    StateC: 'SU',
    C: 'Government',
    TStart: '',
    TStop: '1991',
    name: 'Glavnoye Upravleniye Geodesii i Kartographii SSSR',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'MVD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1981',
    TStop: '1986 Apr 24',
    name: 'Glavnoye Upravleniye Kosmicheskhikh Sredstv',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'MO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1970 Mar',
    TStop: '1981',
    name: 'Glavnoye Upravleniye Kosmicheskhikh Sredstv',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'RVSN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUOG',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Beijing Guodian Gaokeji YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUOX',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Chengdu Guoxing Yuhang keji YG',
    Location: 'Chengdu',
    lat: 30.66,
    lon: 104.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GURVO',
    StateC: 'SU',
    C: 'Military',
    TStart: '1959 Dec',
    TStop: '1970',
    name: 'Glavnoye Upravleniye Raketnogo Vooruzheniya',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'RVSN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GWEST',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Global Western',
    Location: 'Denver, Colorado',
    lat: 39.76,
    lon: -104.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GWHYZ',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Guojia weixing haiyang yingyong zhongxin',
    Location: 'Mudanjiang, Heliongang',
    lat: 44.55,
    lon: 129.63,
    alt: 0,
    Parent: 'GHJ',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GYZ',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Guojia yaogan zhongxin',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GZB',
    StateC: 'CN',
    C: 'Government',
    TStart: '1998',
    TStop: '2018 Mar 19',
    name: 'Guotu ziyuan bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GZB',
    StateC: 'CN',
    C: 'Government',
    TStart: '2018 Mar 19',
    TStop: '',
    name: 'Zhongua renmin gongheguo ziran ziyuan bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1948',
    TStop: '1985',
    name: 'Hughes Aircraft Co., Culver City',
    Location: 'Culver City, California',
    lat: 34.01,
    lon: -118.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HACES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1985',
    name: 'Hughes Aircraft Co., El Segundo',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'HAC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1942',
    TStop: '1957 Sep 1',
    name: 'Holloman Air Development Center',
    Location: 'Alamagordo, New Mexico',
    lat: 32.85,
    lon: -106.11,
    alt: 0,
    Parent: 'HAFB',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAFB',
    StateC: 'US',
    C: 'Military',
    TStart: '1948 Jan 13',
    TStop: '',
    name: 'Holloman Air Force Base',
    Location: 'Alamagordo, New Mexico',
    lat: 32.85,
    lon: -106.11,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAL',
    StateC: 'IN',
    C: 'Commercial',
    TStart: '1940',
    TStop: '',
    name: 'Hindustan Aeronautics Ltd',
    Location: 'Bangalore',
    lat: 12.98,
    lon: 77.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAL5',
    StateC: 'US',
    C: 'Academic',
    TStart: '1997',
    TStop: '',
    name: 'Huntsville, Alabama L5 Society',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAM',
    StateC: 'US',
    C: 'Military',
    TStart: '1945',
    TStop: '',
    name: 'Holloman Aeromedical Lab, Holloman Air Force Base',
    Location: 'Alamagordo, New Mexico',
    lat: 32.85,
    lon: -106.11,
    alt: 0,
    Parent: 'HADC',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HANAU',
    StateC: 'KR',
    C: 'Academic',
    TStart: '2000',
    TStop: '2007',
    name: 'Hang\'kuk Hang-gong Daehakgyo, Space System Research Lab',
    Location: 'Seoul:Goyang',
    lat: 37.65,
    lon: 126.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HANWHA',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '1952',
    TStop: '',
    name: 'Hanwha',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAO',
    StateC: 'US',
    C: 'Academic',
    TStart: '1947',
    TStop: '',
    name: 'High Altitude Observatory (NCAR, U Colorado)',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'NCAR',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HARB',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1920',
    TStop: '',
    name: 'Haerbin gongye daxue',
    Location: 'Harbin, Heilongjiang',
    lat: 45.74,
    lon: 126.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HARK',
    StateC: 'UA',
    C: 'Commercial',
    TStart: '1959',
    TStop: '',
    name: 'NPP Khartron-Arkos Ltd (OKB-692)',
    Location: 'Kharkiv, Ukraine',
    lat: 50,
    lon: 36.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HANGSH',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015 Oct',
    TStop: '',
    name: 'Hunan Hangsheng Weixing Keji YG',
    Location: 'Changsha, Hunan',
    lat: 28.23,
    lon: 112.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HARP',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1964',
    TStop: '1966',
    name: 'High Altitude Research Project (Project HARP), McGill University',
    Location: 'Montreal',
    lat: 45.51,
    lon: -73.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HARR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '2019 Jun',
    name: 'Harris Space and Intelligence Systems',
    Location: 'Palm Bay, Florida',
    lat: 28.01,
    lon: -80.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HARR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019 Jun',
    TStop: '',
    name: 'L3Harris Space and Intelligence Systems',
    Location: 'Palm Bay, Florida',
    lat: 28.01,
    lon: -80.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HASTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1929',
    TStop: '1999 Jun',
    name: 'Hamilton Standard Corp.',
    Location: 'Windsor Locks, Connecticut',
    lat: 41.93,
    lon: -72.65,
    alt: 0,
    Parent: 'UAC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HASTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999 Jun',
    TStop: '2012 Jul',
    name: 'Hamilton Sunstrand (UTC)',
    Location: 'Windsor Locks, Connecticut',
    lat: 41.93,
    lon: -72.65,
    alt: 0,
    Parent: 'UTC2',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAVEL',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '1982',
    TStop: '',
    name: 'HAVELSAN A.S.',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HAWK',
    StateC: 'US',
    C: 'Academic',
    TStart: '2006',
    TStop: '',
    name: 'Hawk Institute for Space Sciences',
    Location: 'Pocomoke City, Maryland',
    lat: 38.07,
    lon: -75.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HBUT',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1952',
    TStop: '',
    name: 'Hubei Gongye Daxue',
    Location: 'Hongshan:Shizishan, Wuhan',
    lat: 30.48,
    lon: 114.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HCG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '1997 May',
    name: 'Hughes Communications Galaxy Inc',
    Location: 'El Segundo',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'HCI',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HCI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1997 May',
    name: 'Hughes Communications Inc.',
    Location: 'El Segundo',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'HEC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HCO',
    StateC: 'US',
    C: 'Academic',
    TStart: '1839',
    TStop: '',
    name: 'Harvard College Observatory',
    Location: 'Cambridge, Mass.',
    lat: 42.38,
    lon: -71.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HCS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '2011',
    name: 'Hughes Communications Services Inc.',
    Location: 'El Segundo',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'HEC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990 May',
    TStop: '2001',
    name: 'Hughes-Danbury Optical Systems',
    Location: 'Danbury, Connecticut',
    lat: 41.4,
    lon: -73.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HE360',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'HawkEye 360 Inc.',
    Location: 'Herndon, Virginia',
    lat: 38.97,
    lon: -77.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HEAD',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2007',
    TStop: '',
    name: 'Beijing hede yuhang jishu youxian gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HACES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2003',
    name: 'Hughes Electronics Corp.',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021 Oct',
    TStop: '',
    name: 'Hedron',
    Location: 'Cambridge, Massachusetts',
    lat: 42.37,
    lon: -71.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HEID',
    StateC: 'D',
    C: 'Academic',
    TStart: '1898',
    TStop: '',
    name: 'Landessternwarte Heidelberg-Konigstuhl (LSW)',
    Location: 'Heidelberg:Konigstuhl',
    lat: 49.4,
    lon: 8.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HELSA',
    StateC: 'GR',
    C: 'Commercial',
    TStart: '2001 Aug',
    TStop: '2013 Feb',
    name: 'HellasSat Consortium Ltd, OTE Group (Org. Telepikoinonion Ellados)',
    Location: 'Athenai:Maroussi',
    lat: 38.05,
    lon: 23.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HELSA',
    StateC: 'GR',
    C: 'Commercial',
    TStart: '2013 Feb',
    TStop: '',
    name: 'HellasSat Consortium Ltd, Arabsat',
    Location: 'Athenai:Maroussi',
    lat: 38.05,
    lon: 23.8,
    alt: 0,
    Parent: 'ARAB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HELW',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2016 Sep',
    TStop: '2019 Oct',
    name: 'Helios Wire',
    Location: 'Vancouver, British Columbia',
    lat: 49.25,
    lon: -123.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HELWE',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2019 Oct',
    TStop: '',
    name: 'Helios Wire (Echostar)',
    Location: 'Vancouver, British Columbia',
    lat: 49.25,
    lon: -123.1,
    alt: 0,
    Parent: 'ECHOC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HEMER',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Hemeria',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HEMER',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2019',
    name: 'Nexeya S.A.S./Toulouse',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HERA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Hera Systems Inc.',
    Location: 'San Jose, California',
    lat: 37.23,
    lon: -121.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPR',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2012 Apr',
    TStop: '',
    name: 'Herakles (SAFRAN/SNECMA Prop. Solide)',
    Location: 'Bordeaux:Le Haillan',
    lat: 44.87,
    lon: -0.68,
    alt: 0,
    Parent: 'SAFRAN',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDP',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2012 Apr',
    TStop: '',
    name: 'Herakles SME (former SNPE)',
    Location: 'Saint-Medard-en-Jalles, Gironde',
    lat: 44.9,
    lon: -0.72,
    alt: 0,
    Parent: 'SAFRAN',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HERC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1912',
    TStop: '1995 Mar',
    name: 'Hercules Powder Co.',
    Location: 'Salt Lake City:Magna/Bacchus, Utah',
    lat: 40.7,
    lon: -112.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PHILR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1978',
    TStop: '1996',
    name: 'Hercules Powder Co. McGregor Plant',
    Location: 'McGregor, Texas',
    lat: 31.43,
    lon: -97.42,
    alt: 0,
    Parent: 'HERC',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HERCR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1950',
    TStop: '',
    name: 'Hercules Powder Co. Radford Arsenal plant',
    Location: 'Radford, Virginia',
    lat: 37.13,
    lon: -80.57,
    alt: 0,
    Parent: 'HERC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HEXI',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1999',
    TStop: '',
    name: 'Zhonggou hexi huagong jixie gongsi (CASIC 6th Academy)',
    Location: 'Hohhot, Nei Menggu Zizhiqu',
    lat: 40.81,
    lon: 111.64,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HEXI',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1962 Jul',
    TStop: '1999',
    name: '4th Academy (Hexi) 7th jixie gongye bu',
    Location: 'Hohhot, Nei Menggu Zizhiqu',
    lat: 40.81,
    lon: 111.64,
    alt: 0,
    Parent: 'JGB7',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HGS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997 Sep',
    TStop: '2004',
    name: 'Hughes Global Services',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HGS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996 Nov',
    TStop: '1997 Sep',
    name: 'Hughes Government Services',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HHJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Hangtian henxing jishu youxian gongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HIBER',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Hiber',
    Location: 'Delft',
    lat: 52.01,
    lon: 4.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HIN',
    StateC: 'N',
    C: 'Academic',
    TStart: '1994 Aug',
    TStop: '',
    name: 'Hogskolen i Narvik',
    Location: 'Narvik',
    lat: 68.44,
    lon: 17.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HISD',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2001 Jul 17',
    TStop: '',
    name: 'Hisdesat Servicios Estrategicos SA',
    Location: 'Madrid',
    lat: 40.38,
    lon: -3.72,
    alt: 0,
    Parent: 'HISP',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HISP',
    StateC: 'E',
    C: 'Commercial',
    TStart: '1989',
    TStop: '',
    name: 'Hispasat SA',
    Location: 'Madrid',
    lat: 40.38,
    lon: -3.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HISPM',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'Hispamar Satelites S.A.',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'HISP',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HITS',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2002',
    TStop: '',
    name: 'Harbin gongye daxue shenzhen yanjiusheng yuan',
    Location: 'Shenzhen, Guangdong',
    lat: 22.55,
    lon: 114.1,
    alt: 0,
    Parent: 'HARB',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HKATG',
    StateC: 'HK',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Xianggang hangtian keji jituan',
    Location: 'Hong Kong',
    lat: 22.28,
    lon: 114.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HKKGF',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Hangtian kegong kongjian gongcheng fazhan YG',
    Location: 'Beijing',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HKU',
    StateC: 'HK',
    C: 'Academic',
    TStart: '1911',
    TStop: '',
    name: 'The University of Hong Kong',
    Location: 'Hong Kong',
    lat: 22.28,
    lon: 114.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HNS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1987',
    TStop: '2011',
    name: 'Hughes Network Systems',
    Location: 'Germantown, Maryland',
    lat: 39.18,
    lon: -77.27,
    alt: 0,
    Parent: 'HEC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COOP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1952',
    TStop: '1955',
    name: 'Horning-Cooper Inc.',
    Location: 'Monrovia, California',
    lat: 34.15,
    lon: -118,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DRG',
    StateC: 'D',
    C: 'Academic',
    TStart: '1961',
    TStop: '1993',
    name: 'Hermann-Oberth-Gesellschaft',
    Location: 'Cuxhaven',
    lat: 53.86,
    lon: 8.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HOKIT',
    StateC: 'J',
    C: 'Academic',
    TStart: '1967 Apr',
    TStop: '',
    name: 'Hokkaido kogyo daigaku',
    Location: 'Sapporo, Hokkaido',
    lat: 43.07,
    lon: 141.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HOKK',
    StateC: 'J',
    C: 'Academic',
    TStart: '1876',
    TStop: '',
    name: 'Hokkaido daigaku',
    Location: 'Sapporo, Hokkaido',
    lat: 43.07,
    lon: 141.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HONEY',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Honeywell Aerospace, Defense and Space Systems',
    Location: 'Clearwater, Florida',
    lat: 27.97,
    lon: -82.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COMDUK',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Honeywell Aerospace/Aylesbury',
    Location: 'Aylesbury',
    lat: 51.82,
    lon: -0.81,
    alt: 0,
    Parent: 'HONEY',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HORT',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Horizon Technologies',
    Location: 'Reading',
    lat: 51.46,
    lon: -0.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HORZ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'Horizons Satellite LLC (Intelsat/JSAT)',
    Location: 'Homer, Alaska ',
    lat: 59.64,
    lon: -151.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HOUS',
    StateC: 'US',
    C: 'Academic',
    TStart: '1927',
    TStop: '',
    name: 'University of Houston',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HOUW',
    StateC: 'ZA',
    C: 'Commercial',
    TStart: '1970',
    TStop: '2004',
    name: 'Houwteq (ARMSCOR)',
    Location: 'Grabouw, Western Cape',
    lat: -34.15,
    lon: 19.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HPS',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'High Performance Space Structure Systems GmbH',
    Location: 'Munchen',
    lat: 48.13,
    lon: 11.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HRBS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '1990',
    name: 'HRB-Singer Co.',
    Location: 'State College, Pennsylvania',
    lat: 40.79,
    lon: -77.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HRBS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990',
    TStop: '',
    name: 'E-Systems HRBS',
    Location: 'State College, Pennsylvania',
    lat: 40.79,
    lon: -77.86,
    alt: 0,
    Parent: 'ESYS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HQZS',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Huai\'an shi qingsahonian zonghe shijian jidi',
    Location: 'Huai\'an, Jiangsu',
    lat: 33.5,
    lon: 119.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSCIL',
    StateC: 'IL',
    C: 'Academic',
    TStart: '1994',
    TStop: '',
    name: 'Herzliya Science Center',
    Location: 'Herzliya',
    lat: 32.17,
    lon: 34.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVS',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1963',
    TStop: '1977 Apr',
    name: 'Hawker Siddeley Dynamics',
    Location: 'Stevenage',
    lat: 51.9,
    lon: -0.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSEDD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1985',
    name: 'Electron Dynamics Division, Hughes Aircraft Company',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '2000 Oct',
    name: 'Hughes Space and Comms. Co (Hughes Satellite Systems)',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'HEC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSTM',
    StateC: 'US',
    C: 'Academic',
    TStart: '2015',
    TStop: '',
    name: 'Hawaii Science and Technology Museum',
    Location: 'Hilo, Hawaii',
    lat: 19.7,
    lon: -155.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HTGC',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2017',
    TStop: '',
    name: 'Hangtian Gongcheng Daxue',
    Location: 'Beijing',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'PLA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HTSTL',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2000',
    TStop: '2005',
    name: 'Hangtian Tsinghua weixing jishu youxian gongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'TSHUA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUAMI',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Huami keji',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUAZH',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1953',
    TStop: '',
    name: 'Huazhong keji daxue',
    Location: 'Guanshan jiedao, Wuhan, Hubei',
    lat: 30.51,
    lon: 114.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUMS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1951',
    TStop: '1997',
    name: 'Hughes Missile Systems, AF Plant 44',
    Location: 'Tucson, Arizona',
    lat: 32.22,
    lon: -110.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUNTE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1957',
    TStop: '2001 Oct',
    name: 'Hunting Engineering',
    Location: 'Ampthill, Bedfordshire',
    lat: 52.03,
    lon: -0.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUOYAN',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Huoyan weizhi shuzhi keji fuwu YG',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDPO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1992 May',
    TStop: '1994',
    name: 'Hughes Missile Systems Co. Pomona',
    Location: 'Pomona, California',
    lat: 34.06,
    lon: -117.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HVP',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'HV Peenemunde',
    Location: 'Peenemunde',
    lat: 54.14,
    lon: 13.79,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HXKJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Hainan xiandai keji jituan',
    Location: 'Haikou:Daokecun',
    lat: 20.01,
    lon: 110.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HXWK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Hangzhou Xuanying Wangluo Keji YG',
    Location: 'Hangzhou',
    lat: 30.27,
    lon: 120.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HYD',
    StateC: 'CN',
    C: 'Military',
    TStart: '1998 Jan',
    TStop: '',
    name: 'ZRJ Hangtian Yuan Dadui',
    Location: 'Beijing',
    lat: 40.07,
    lon: 116.26,
    alt: 0,
    Parent: 'ZLZB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEOPS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019 Feb',
    TStop: '',
    name: 'Hypergiant Galactic Systems (SEOPS LLC)',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HYSIQ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'HySpecIQ',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAA',
    StateC: 'E',
    C: 'Academic',
    TStart: '1975',
    TStop: '',
    name: 'Instituto de Astrofisica de Andalusia (CSIC)',
    Location: 'Granada',
    lat: 37.18,
    lon: -3.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IACG',
    StateC: 'SU',
    C: 'Government',
    TStart: '1995',
    TStop: '',
    name: 'Informatsionno-analiticheskiy Tsentr TsNIImash, FTsP GLONASS',
    Location: 'Korolev:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IADN',
    StateC: 'IL',
    C: 'Military',
    TStart: '1948',
    TStop: '',
    name: 'Israeli Air Defense Network, Israel Defense Forces',
    Location: 'Palmachim AFB, Yavne:Rishin LeZion',
    lat: 31.9,
    lon: 34.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAE',
    StateC: 'BR',
    C: 'Military',
    TStart: '1969 Oct',
    TStop: '',
    name: 'Instituto de Aeronautica e Espa\\\'new ControlSite({c}o',
    Location: 'Sao Jose dos Campos, Brasil',
    lat: -23.19,
    lon: -45.88,
    alt: 0,
    Parent: 'BRCTA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAF',
    StateC: 'IL',
    C: 'Military',
    TStart: '1948',
    TStop: '2004',
    name: 'Zroa HaAvir',
    Location: 'Tel Aviv',
    lat: 32.07,
    lon: 34.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAF',
    StateC: 'IL',
    C: 'Military',
    TStart: '2004',
    TStop: '',
    name: 'Zroa HaAvir VeHahalal',
    Location: 'Tel Aviv',
    lat: 32.07,
    lon: 34.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IADN',
    StateC: 'IL',
    C: 'Military',
    TStart: '2011',
    TStop: '',
    name: 'Wing 167, Israeli Air Force',
    Location: 'Palmachim AFB, Yavne:Rishin LeZion',
    lat: 31.9,
    lon: 34.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAFE',
    StateC: 'AR',
    C: 'Government',
    TStart: '1971',
    TStop: '',
    name: 'Instituto de Astronomia y Fisica del Espacio',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAI',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '1968',
    TStop: '',
    name: 'Israeli Aircraft Industries, Mabat factory',
    Location: 'Yehud',
    lat: 32.03,
    lon: 34.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAIS',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '1993',
    TStop: '',
    name: 'IAI Space Communications Ltd.',
    Location: 'Tel Aviv:Ramat Gan',
    lat: 32.08,
    lon: 34.82,
    alt: 0,
    Parent: 'IAI',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1935',
    TStop: '',
    name: 'Institute of Aviation Medicine',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IAP',
    StateC: 'D',
    C: 'Academic',
    TStart: '1991',
    TStop: '',
    name: 'Leibniz-Institut fur Atmospharenphysik eV, Univ. Rostock',
    Location: 'K\\"ulungsborn (Rostock), Mecklenburg-Vorpommern',
    lat: 54.13,
    lon: 11.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IARI',
    StateC: 'IR',
    C: 'Government',
    TStart: '1999',
    TStop: '',
    name: 'Aerospace Research Institute',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IASB',
    StateC: 'B',
    C: 'Academic',
    TStart: '1964',
    TStop: '',
    name: 'BIRA-IASB Institut d\'Aeronomie Spatiale de Belgique',
    Location: 'Brussel:Uccle',
    lat: 50.8,
    lon: 4.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IBM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1964',
    TStop: '',
    name: 'IBM Inc.',
    Location: 'Armonk, New York',
    lat: 27.91,
    lon: -82.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IBMH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1964',
    TStop: '',
    name: 'IBM Inc.-Huntsville',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: 'IBM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IBSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1992',
    TStop: '',
    name: 'Innovative Business Solutions Inc.',
    Location: 'Largo, Florida',
    lat: 27.91,
    lon: -82.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICANS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1966 Sep',
    TStop: '1977',
    name: 'Industral Consortium Astronomical Netherlands Satellite',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICEUS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'ICEYE US',
    Location: 'San Francisco',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: 'ICEYE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICEYE',
    StateC: 'FI',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'ICEYE',
    Location: 'Helsinki',
    lat: 60.17,
    lon: 24.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICO',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1995 Jan',
    TStop: '2000 May',
    name: 'ICO Global Communications',
    Location: 'London, England',
    lat: 51.51,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000 May',
    TStop: '2010',
    name: 'ICO Global Communications (Holdings) Ltd',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'ICO Global Communications (Holdings) Ltd',
    Location: 'Kirkland, Washington',
    lat: 47.69,
    lon: -122.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICONA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2009 Aug',
    name: 'ICO North America',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'ICOH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICST',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1907',
    TStop: '',
    name: 'Imperial College of Science and Technology',
    Location: 'South Kensington, London, England',
    lat: 51.5,
    lon: -0.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICTQ',
    StateC: 'QA',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Supreme Council of Information and Communication Technology, Qatar',
    Location: 'Doha, Qatar',
    lat: 25.29,
    lon: 51.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IDF',
    StateC: 'IL',
    C: 'Military',
    TStart: '1948',
    TStop: '',
    name: 'Israel Defense Forces (IAF Israeli Air Force)',
    Location: 'Tel Aviv',
    lat: 32.07,
    lon: 34.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IDFN',
    StateC: 'IL',
    C: 'Military',
    TStart: '1948',
    TStop: '',
    name: 'Heil Hayam HaYisraeli',
    Location: 'Haifa',
    lat: 32.82,
    lon: 34.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IDG',
    StateC: 'RU',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Institut Dinamiki Geosfer',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IDRDL',
    StateC: 'IN',
    C: 'Military',
    TStart: '1962',
    TStop: '',
    name: 'Defense Research and Development Lab',
    Location: 'Hyderabad',
    lat: 17.37,
    lon: 78.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IEI',
    StateC: 'IR',
    C: 'Military',
    TStart: '1972',
    TStop: '',
    name: 'Sana-ey Electronik-e Iran',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IEM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1968',
    TStop: '1980',
    name: 'Insitut Eksperimental\'niy Meteolorologii',
    Location: 'Obninsk, Kaluga Oblast',
    lat: 55.09,
    lon: 36.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IFAMR',
    StateC: 'D',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'DLR Institut fur Physik der Atmosphare',
    Location: 'Munchen:Riem',
    lat: 48.14,
    lon: 11.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004 Oct',
    TStop: '',
    name: 'Intelsat General Corp.',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'INTELB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IHI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1853 Dec 8',
    TStop: '2007',
    name: 'Ishikawajima-Harima Jukogyo Kabushi Kigaisha',
    Location: 'Tokyo:Koto',
    lat: 35.67,
    lon: 139.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IHI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2007',
    TStop: '',
    name: 'Kabushiki-gaisha IHI',
    Location: 'Tokyo:Koto',
    lat: 35.67,
    lon: 139.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NISST',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2000 Jun',
    TStop: '',
    name: 'IHI Aerospace (former Nissan)',
    Location: 'Tomioka, Gunma',
    lat: 36.26,
    lon: 138.89,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUSEI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2000 Jun',
    TStop: '',
    name: 'IHI Aerospace, Ogikubo plant',
    Location: 'Tokyo:Suginami (Ogikubo)',
    lat: 35.68,
    lon: 139.62,
    alt: 0,
    Parent: 'IHI',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IIAE',
    StateC: 'AR',
    C: 'Government',
    TStart: '1961',
    TStop: '1991',
    name: 'Instituto de Investigacion Aeronautica y Espacial',
    Location: 'Cordoba, Argentina',
    lat: -31.42,
    lon: -64.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAS',
    StateC: 'J',
    C: 'Academic',
    TStart: '1955',
    TStop: '1964 Apr',
    name: 'Instiute of Industrial Science, Todai (Itokawa Group)',
    Location: 'Tokyo:Komaba',
    lat: 35.66,
    lon: 139.68,
    alt: 0,
    Parent: 'TOK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IISTC',
    StateC: 'J',
    C: 'Government',
    TStart: '1955',
    TStop: '1964 Apr',
    name: 'Seisangijutsu Kenkyujyo',
    Location: 'Tokyo:Chiba',
    lat: 35.61,
    lon: 140.12,
    alt: 0,
    Parent: 'TOK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IITB',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1958',
    TStop: '',
    name: 'Indian Institute of Technology, Bombay',
    Location: 'Mumbai:Powai, Maharashtra',
    lat: 19.13,
    lon: 72.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IITK',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1959',
    TStop: '',
    name: 'Indian Institute of Technology, Kanpur',
    Location: 'Kanpur:Kalyanpur, Uttar Pradesh',
    lat: 26.11,
    lon: 80.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IITM',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1971 Apr 1',
    TStop: '',
    name: 'Indian Institute of Tropical Meteorology',
    Location: 'Pune:Pashan',
    lat: 18.54,
    lon: 74.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IITMC',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1959',
    TStop: '',
    name: 'Indian Institute of Technology, Madras',
    Location: 'Chennai, Tamil Nadu',
    lat: 12.99,
    lon: 80.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IK',
    StateC: 'SU',
    C: 'Government',
    TStart: '1967 Apr',
    TStop: '',
    name: 'Interkosmos',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IKI',
    StateC: 'SU',
    C: 'Government',
    TStart: '1965',
    TStop: '',
    name: 'Institut Kosmicheksiye Issledovaniya',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ILC',
    StateC: 'DK',
    C: 'Government',
    TStart: '1962 Apr 1',
    TStop: '1968',
    name: 'Ionosphere Laboratory, DTU',
    Location: 'Kobenhavn:Lyngby',
    lat: 55.78,
    lon: 12.5,
    alt: 0,
    Parent: 'DTU',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDCLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2000',
    name: 'International Launch Services',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ILSK',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2019 Apr',
    name: 'International Launch Services, Khrunichev',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'KHRU',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ILSL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '2019 Apr',
    name: 'International Launch Services, Khrunichev',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'KHRU',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ILSL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019 Apr',
    TStop: '',
    name: 'International Launch Services, Glavkosmos',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'GK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDCLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2008',
    name: 'International Launch Services, Lockheed Martin',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IMAG',
    StateC: 'KORS',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'ImageSat International N.V.',
    Location: 'Willemstad, Curacao, Netherlands Antilles',
    lat: 12.12,
    lon: -68.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IMAGT',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'ImageSat (Tel-Aviv)',
    Location: 'Tel-Aviv',
    lat: 32.07,
    lon: 34.78,
    alt: 0,
    Parent: 'IMAG',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CERMA',
    StateC: 'F',
    C: 'Military',
    TStart: '1988',
    TStop: '',
    name: 'Institut de medecine aerospatiale du service de sante des armees',
    Location: 'Bretigny',
    lat: 48.61,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IMAX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '',
    name: 'IMAX Corporation',
    Location: 'Toronto:Missisauga, Ontario',
    lat: 43.6,
    lon: -79.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IMBP',
    StateC: 'SU',
    C: 'Government',
    TStart: '1963',
    TStop: '',
    name: 'Institut mediko-biologicheskikh problem',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IMDP',
    StateC: 'IN',
    C: 'Government',
    TStart: '1928',
    TStop: '',
    name: 'India Meteorological Department, Pune',
    Location: 'Pune',
    lat: 18.52,
    lon: 73.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PIHM',
    StateC: 'PL',
    C: 'Government',
    TStart: '1973',
    TStop: '',
    name: 'Instytut Meteorologii i Gospodarki Wodnej',
    Location: 'Warsawa',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IMICAS',
    StateC: 'CN',
    C: 'Government',
    TStart: '2017 Jan',
    TStop: '',
    name: 'Zhongguo kexueyuan weixiao weixing chuangxin yanjiuyuan',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: 'SECM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IMIS',
    StateC: 'UK',
    C: 'Military',
    TStart: '1952',
    TStop: '',
    name: 'IMI Summerfield Rocket Research Station',
    Location: 'Kidderminster:Summerfield',
    lat: 52.48,
    lon: -1.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INAF',
    StateC: 'IN',
    C: 'Military',
    TStart: '1932',
    TStop: '',
    name: 'Indian Air Force',
    Location: 'New Delhi',
    lat: 28.62,
    lon: 77.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INASAN',
    StateC: 'RU',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Institut Astronomii RAN',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'ANRF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INAV',
    StateC: 'IN',
    C: 'Military',
    TStart: '1947',
    TStop: '',
    name: 'Indian Navy (Bharatiya Nau Sena)',
    Location: 'New Delhi',
    lat: 28.61,
    lon: 77.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INAVC',
    StateC: 'IN',
    C: 'Military',
    TStart: '2012 Jun',
    TStop: '',
    name: 'Assistant Chief of Naval Staff (Comms, Space and Network-Centric Ops)',
    Location: 'New Delhi',
    lat: 28.61,
    lon: 77.21,
    alt: 0,
    Parent: 'INAV',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INCO',
    StateC: 'IN',
    C: 'Government',
    TStart: '1962',
    TStop: '1969',
    name: 'INCOSPAR (Indian Committee on Space Research), TIFR',
    Location: 'Mumbai:Colaba',
    lat: 18.91,
    lon: 72.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VSSC',
    StateC: 'IN',
    C: 'Government',
    TStart: '1962',
    TStop: '1969',
    name: 'INCOSPAR, TERLS',
    Location: 'Trivandrum',
    lat: 8.53,
    lon: 76.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INDO',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '1991 Jul 22',
    TStop: '',
    name: 'PT. Media Citra Indostar',
    Location: 'Jakarta, West Java',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SINDO',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '2003',
    TStop: '2015 Nov 19',
    name: 'PT Indosat',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SINDO',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '2015 Nov 19',
    TStop: '',
    name: 'Indosat Ooredoo',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INETI',
    StateC: 'P',
    C: 'Academic',
    TStart: '1970s',
    TStop: '',
    name: 'Instituto Nacional de Engenharia, Tecnologia e Inova\\,cao',
    Location: 'Lisboa:Alfragide, Portugal',
    lat: 38.73,
    lon: -9.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INFER',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Interferometrics Inc',
    Location: 'Chantilly, Virginia',
    lat: 38.88,
    lon: -77.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INFOC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'InFocus, Edgewood, New Mexico (40 Blanco Drive)',
    Location: 'Edgewood, New Mexico',
    lat: 35.07,
    lon: -106.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INFK',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1992',
    TStop: '2000',
    name: 'AO Informkosmos',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INMAR',
    StateC: 'I-INM',
    C: 'Government',
    TStart: '',
    TStop: '1999 Apr 15',
    name: 'International Maritime Satellite Organization',
    Location: 'London',
    lat: 51.54,
    lon: -0.1,
    alt: 0,
    Parent: 'I-INM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INMAR',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1999 Apr 15',
    TStop: '',
    name: 'International Maritime Satellite Organization Ltd,',
    Location: 'London',
    lat: 51.54,
    lon: -0.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CNAE',
    StateC: 'BR',
    C: 'Government',
    TStart: '1971',
    TStop: '',
    name: 'Instituto Nacional de Pesquisas Espacias,',
    Location: 'Sao Jose dos Campos, Brasil',
    lat: -23.19,
    lon: -45.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INPES',
    StateC: 'BR',
    C: 'Government',
    TStart: '1996',
    TStop: '',
    name: 'Centro Regional Sul de Pequisas Espaciais (CRS/INPE-MCT)',
    Location: 'Santa Maria, Rio Grande do Sul',
    lat: -29.68,
    lon: -53.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INSP4',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021 Feb',
    TStop: '2022',
    name: 'Inspiration4',
    Location: 'Hawthorne, California',
    lat: 33.92,
    lon: -118.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INSPM',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'In-Space Missions',
    Location: 'Bordon, Hampshire',
    lat: 51.12,
    lon: -0.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INSSET',
    StateC: 'F',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Institut superieur des sciences et techniques, Universite de Picardie',
    Location: 'Saint-Quentin, Aisne',
    lat: 49.85,
    lon: 3.29,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUNTE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2001 Oct',
    TStop: '2005 Aug',
    name: 'INSYS Ltd.',
    Location: 'Ampthill, Bedfordshire',
    lat: 52.03,
    lon: -0.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INTA',
    StateC: 'E',
    C: 'Government',
    TStart: '1942',
    TStop: '',
    name: 'Instituto Nacional de Tecnica Aeroespacial',
    Location: 'Madrid:Torrejon',
    lat: 40.5,
    lon: -3.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INTEL',
    StateC: 'I-INT',
    C: 'Government',
    TStart: '1964',
    TStop: '2001 Jul 18',
    name: 'INTELSAT',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'I-INT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INTELB',
    StateC: 'BM',
    C: 'Commercial',
    TStart: '2001 Jul 18',
    TStop: '2009 Dec 15',
    name: 'Intelsat Ltd.',
    Location: 'Hamilton:Pembroke, Bermuda',
    lat: 32.3,
    lon: -64.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INTELD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001 Jul 18',
    TStop: '2009 Dec 15',
    name: 'Intelsat Ltd, US headquarters',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'INTELB',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INTELB',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2009 Dec 15',
    TStop: '',
    name: 'Intelsat S.A.',
    Location: 'Luxembourg',
    lat: 49.61,
    lon: 6.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INTELD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009 Dec 15',
    TStop: '',
    name: 'Intelsat S.A., US headquarters',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'INTELS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'INVAP',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '1976',
    TStop: '',
    name: 'Investigaciones Aplicads Sociedad del Estado (INVAP SE)',
    Location: 'San Carlos de Bariloche, Rio Negro',
    lat: -41.15,
    lon: -71.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IOS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Interorbital Systems Corporation',
    Location: 'Mojave, California',
    lat: 35.05,
    lon: -118.17,
    alt: 0,
    Parent: 'INTELS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IOWASU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1858',
    TStop: '',
    name: 'Iowa State University',
    Location: 'Ames, Iowa',
    lat: 42.03,
    lon: -93.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IPN',
    StateC: 'MX',
    C: 'Academic',
    TStart: '1936',
    TStop: '',
    name: 'Instituto Politecnico Nacional',
    Location: 'Mexico City, Mexico',
    lat: 19.5,
    lon: -99.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IPSF',
    StateC: 'US',
    C: 'Academic',
    TStart: '1976',
    TStop: '',
    name: 'Irvine Public Schools Foundation',
    Location: 'Irvine, California',
    lat: 33.67,
    lon: -117.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'APW',
    StateC: 'D',
    C: 'Academic',
    TStart: '1973',
    TStop: '1980',
    name: 'Institut fur Physikalische Weltraumforschung',
    Location: 'Freiburg im Breslau',
    lat: 47.98,
    lon: 7.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IQ223',
    StateC: 'IQ',
    C: 'Military',
    TStart: '1989',
    TStop: '2003',
    name: 'Brigade 223, Iraqi Army',
    Location: 'Al Taji, Baghdad',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: 'IQA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IQ224',
    StateC: 'IQ',
    C: 'Military',
    TStart: '1976',
    TStop: '2003',
    name: 'Brigade 224, Iraqi Army',
    Location: 'Al Taji, Baghdad',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: 'IQA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IQA',
    StateC: 'IQ',
    C: 'Military',
    TStart: '1924',
    TStop: '2003',
    name: 'Iraqi Army',
    Location: 'Baghdad',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOTI',
    StateC: 'IQ',
    C: 'Military',
    TStart: '1987 Aug 1',
    TStop: '2003',
    name: 'Military Industrial Commission, Iraq',
    Location: 'Baghdad',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IQMOST',
    StateC: 'IQ',
    C: 'Government',
    TStart: '2003',
    TStop: '',
    name: 'Wezarh al\'elewm waletkenwelwejya',
    Location: 'Baghdad',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KGO',
    StateC: 'S',
    C: 'Government',
    TStart: '1987',
    TStop: '',
    name: 'Institutet for rymdfysik (IRF)',
    Location: 'Kiruna',
    lat: 67.85,
    lon: 20.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UIO',
    StateC: 'S',
    C: 'Government',
    TStart: '1986',
    TStop: '',
    name: 'Institutet for rymdfysik (IRF), Uppsala',
    Location: 'Uppsala',
    lat: 59.86,
    lon: 17.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IRGC',
    StateC: 'IR',
    C: 'Military',
    TStart: '1979',
    TStop: '',
    name: 'Sepah-e Pasdaran-e Enghelab-e Eslami (Missile Forces)',
    Location: 'Shahroud',
    lat: 36.2,
    lon: 55.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IRID',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1991',
    TStop: '2000 Dec',
    name: 'Iridium Inc.',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IRID',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000 Dec',
    TStop: '',
    name: 'Iridium Satellite LLC',
    Location: 'Washington:Bethesda, Maryland',
    lat: 38.98,
    lon: -77.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IRMB',
    StateC: 'B',
    C: 'Academic',
    TStart: '1913',
    TStop: '',
    name: 'Institut Royal Meteorologique (Koninklijk Meteorologisch Instituut)',
    Location: 'Brussel:Uccle',
    lat: 50.8,
    lon: 4.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IROST',
    StateC: 'IR',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Iranian Research Organization for Science and Technology (OSIRI)',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IRSA',
    StateC: 'IR',
    C: 'Military',
    TStart: '2004',
    TStop: '',
    name: 'Sazman Fizaii Iran (Iranian Space Agency)',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IRSS',
    StateC: 'D',
    C: 'Academic',
    TStart: '1988',
    TStop: '',
    name: 'Institut fur Raumfahrtsysteme, Universitat Stuttgart',
    Location: 'Stuttgart',
    lat: 48.78,
    lon: 9.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISA',
    StateC: 'IL',
    C: 'Government',
    TStart: '1983',
    TStop: '',
    name: 'Sokhnut heKahlal haYisraelit',
    Location: 'Tel Aviv',
    lat: 32.07,
    lon: 34.78,
    alt: 0,
    Parent: 'IL',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAC',
    StateC: 'IN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'ISRO Satellite Center',
    Location: 'Bangalore',
    lat: 12.98,
    lon: 77.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISACA',
    StateC: 'IN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'ISRO Space Applications Center',
    Location: 'Ahmedabad',
    lat: 23.03,
    lon: 72.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUPAER',
    StateC: 'F',
    C: 'Academic',
    TStart: '2007',
    TStop: '',
    name: 'Institut superieur de l\'aeronautique et de l\'espace',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAEV',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1943',
    TStop: '1952',
    name: 'Zav. 293, KB A.M. Isaev',
    Location: 'Moskva:Korolev (Podlipki)',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAS',
    StateC: 'J',
    C: 'Government',
    TStart: '1964 Apr',
    TStop: '1981 Apr',
    name: 'Ucyu Koku Kenkyujyo',
    Location: 'Tokyo:Komaba',
    lat: 35.66,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAS',
    StateC: 'J',
    C: 'Government',
    TStart: '2003 Oct 1',
    TStop: '',
    name: 'ISAS/JAXA',
    Location: 'Tokyo:Sagamihara',
    lat: 35.57,
    lon: 139.37,
    alt: 0,
    Parent: 'JAXA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAS',
    StateC: 'J',
    C: 'Government',
    TStart: '1981 Apr',
    TStop: '1989 Apr',
    name: 'Ucyu Kagaku Kenkyujyo',
    Location: 'Tokyo:Komaba',
    lat: 35.66,
    lon: 139.68,
    alt: 0,
    Parent: 'MONBU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAS',
    StateC: 'J',
    C: 'Government',
    TStart: '1989 Apr',
    TStop: '2003 Oct 1',
    name: 'Ucyu Kagaku Kenkyujyo',
    Location: 'Tokyo:Sagamihara',
    lat: 35.57,
    lon: 139.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISCAS',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Zhongguo kexueyuan ruanjian yanjiu suo',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISFC',
    StateC: 'IN',
    C: 'Military',
    TStart: '2003 Jan',
    TStop: '',
    name: 'Strategic Forces Command, Nuclear Command Authority',
    Location: 'New Delhi',
    lat: 28.61,
    lon: 77.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISIL',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2007',
    TStop: '',
    name: 'ISILaunch Services',
    Location: 'Delft',
    lat: 52.01,
    lon: 4.36,
    alt: 0,
    Parent: 'ISISBV',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISISBV',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2006 Jan',
    TStop: '',
    name: 'Innovative Solutions In Space B.V.',
    Location: 'Delft',
    lat: 52.01,
    lon: 4.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISKRM',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1946 Mar',
    TStop: '',
    name: 'MKB Iskra im. I.I. Kartukov (KB-2 Zav. 81)',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISKRP',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'OAO NPO Iskra',
    Location: 'Perm\', Permskiy Krai',
    lat: 58,
    lon: 56.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISKY',
    StateC: 'CZ',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'iSky Technology s.r.o',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISPUT',
    StateC: 'SU',
    C: 'Government',
    TStart: '1971 Nov 15',
    TStop: '',
    name: 'Intersputnik Intl. Org of Space Comms.',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISRA',
    StateC: 'SD',
    C: 'Government',
    TStart: '2013 Jun',
    TStop: '',
    name: 'Maehid abhath alfda\' wailtyran',
    Location: 'Khartoum',
    lat: 32.53,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISRO',
    StateC: 'IN',
    C: 'Government',
    TStart: '1969',
    TStop: '',
    name: 'Indian Space Research Organization',
    Location: 'Bangalore',
    lat: 12.98,
    lon: 77.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VSSC',
    StateC: 'IN',
    C: 'Government',
    TStart: '1969',
    TStop: '1971',
    name: 'ISRO/Thumba Equatorial Rocket Launch Station',
    Location: 'Trivandrum',
    lat: 8.53,
    lon: 76.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IST',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'Interstellar Technologies Inc',
    Location: 'Taiki, Tokachi, Hokkaido',
    lat: 42.5,
    lon: 143.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISTPK',
    StateC: 'PK',
    C: 'Academic',
    TStart: '2002',
    TStop: '',
    name: 'Institute of Space Technology',
    Location: 'Islamabad',
    lat: 33.72,
    lon: 73.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ITA',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '1950',
    TStop: '',
    name: 'Instituto Tecnologico de Aeronautica',
    Location: 'Sao Jose dos Campos',
    lat: -23.19,
    lon: -45.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ITBW',
    StateC: 'D',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Bundesamt f. Inf.management und Informationstechnik der Bundeswehr',
    Location: 'Koblenz',
    lat: 50.36,
    lon: 7.6,
    alt: 0,
    Parent: 'BWEHR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ITCR',
    StateC: 'CR',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Instituto Technologico de Costa Rica',
    Location: 'Cartago',
    lat: 9.85,
    lon: -83.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ITRC',
    StateC: 'IR',
    C: 'Government',
    TStart: '1970',
    TStop: '',
    name: 'Iran Telecommunication Research Center',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RNII',
    StateC: 'RU',
    C: 'Government',
    TStart: '1992',
    TStop: '',
    name: 'Issledovatel\'niy Tsentr im. M. Keldysh',
    Location: 'Moskva:Khovrino',
    lat: 55.87,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ITT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'ITT Federal Laboratories',
    Location: 'Nutley, New Jersey (San Fernando,CA)',
    lat: 40.82,
    lon: -74.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ITUTR',
    StateC: 'TR',
    C: 'Academic',
    TStart: '2007',
    TStop: '',
    name: 'Istanbul Teknik Universitesi/Space Systems Design and Test Laboratory',
    Location: 'Istanbul',
    lat: 41.11,
    lon: 29.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IUST',
    StateC: 'IR',
    C: 'Academic',
    TStart: '1929',
    TStop: '',
    name: 'Daneshgah Elm-o Sanat Iran',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IZM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1940 Jan',
    TStop: '',
    name: 'Inst. Zemnovo Magnetizma, Ionosferi i rasprostraneia radiovoli',
    Location: 'Moskva:Troitsk',
    lat: 55.49,
    lon: 37.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JNSIC',
    StateC: 'CN',
    C: 'Military',
    TStart: '2010',
    TStop: '',
    name: '061 Jidi (Base 061), CASIC',
    Location: 'Zunyi, Guizhou',
    lat: 27.68,
    lon: 106.9,
    alt: 0,
    Parent: 'CASIC4A',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JARL',
    StateC: 'J',
    C: 'Academic',
    TStart: '1926',
    TStop: '',
    name: 'Japanese Amateur Radio League',
    Location: 'Tokyo:Toshima',
    lat: 35.73,
    lon: 139.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASDA',
    StateC: 'J',
    C: 'Government',
    TStart: '2003 Oct 1',
    TStop: '',
    name: 'Ucyu Koku Kenkyu Kaihatsu Kikou',
    Location: 'Tokyo:Chofu',
    lat: 35.65,
    lon: 139.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAL',
    StateC: 'J',
    C: 'Government',
    TStart: '2003 Oct 1',
    TStop: '',
    name: 'Chofu Koku Ucyu senta',
    Location: 'Tokyo:Chofu',
    lat: 35.65,
    lon: 139.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JBO',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1957',
    TStop: '',
    name: 'Jodrell Bank Observatory, Univ. of Manchester',
    Location: 'Jodrell Bank, Cheshire, England',
    lat: 53.24,
    lon: -2.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JCAB',
    StateC: 'J',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Japan Civil Aviation Bureau (Board)',
    Location: 'Tokyo:Chiyoda',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JCSAT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1985 Apr',
    TStop: '1993 Aug',
    name: 'JCSAT (Japan Communications Satellite Corp), Nippon',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JDA',
    StateC: 'J',
    C: 'Military',
    TStart: '1954 Jul 1',
    TStop: '2007 Jan 9',
    name: 'Boei-cho (Japan Defense Agency)',
    Location: 'Tokyo:Minato/Akasaka',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JENA',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1991',
    TStop: '2010',
    name: 'DASA Jena Optronic GmbH (DJO)',
    Location: 'Jena, Thuringia',
    lat: 50.93,
    lon: 11.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JENA',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'DASA Jena Optronic GmbH (DJO)/ Astrium',
    Location: 'Jena, Thuringia',
    lat: 50.93,
    lon: 11.59,
    alt: 0,
    Parent: 'ASTD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAI',
    StateC: 'CN',
    C: 'Government',
    TStart: '1964 Nov 23',
    TStop: '1982 Apr',
    name: 'Qi Jixie gongye bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JHU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1876',
    TStop: '',
    name: 'Johns Hopkins Univ.',
    Location: 'Baltimore, Maryland',
    lat: 39.33,
    lon: -76.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JIHUA',
    StateC: 'CN',
    C: 'Government',
    TStart: '2017',
    TStop: '',
    name: 'Jihua Shiyan Shi',
    Location: 'Foshan, Guandong',
    lat: 23.02,
    lon: 113.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JIT',
    StateC: 'IN',
    C: 'Academic',
    TStart: '2011',
    TStop: '',
    name: 'Jeppiaar Institute of Technology',
    Location: 'Kunnam, Tamil Nadu',
    lat: 12.89,
    lon: 79.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JIUT',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Beijing Jiutian Weixing Keji Fazhan YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JKY',
    StateC: 'CN',
    C: 'Military',
    TStart: '1958',
    TStop: '',
    name: 'Zhongguo Renmin Jeifangung Junshi Kexue Yanjiuyuan',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JMA',
    StateC: 'J',
    C: 'Government',
    TStart: '1956',
    TStop: '',
    name: 'Kisouchou (Japan Meteorological Agency)',
    Location: 'Tokyo:Chiyoda',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JMASC',
    StateC: 'J',
    C: 'Government',
    TStart: '1978',
    TStop: '',
    name: 'JMA Meteorological Satellite Center',
    Location: 'Tokyo:Kiyose [MTSAT GMS]',
    lat: 35.79,
    lon: 139.53,
    alt: 0,
    Parent: 'JMA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JMSDF',
    StateC: 'J',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: 'Kaijyo Jieitai (Japanese Maritime Self Defense Force)',
    Location: 'Yokosuka',
    lat: 35.25,
    lon: 139.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JMSDMA',
    StateC: 'J',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: 'JMSDF, Maizuru',
    Location: 'Maizuru',
    lat: 35.47,
    lon: 135.38,
    alt: 0,
    Parent: 'JMSDF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JMSDSA',
    StateC: 'J',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: 'JMSDF, Sasebo District Force',
    Location: 'Sasebo',
    lat: 33.16,
    lon: 129.71,
    alt: 0,
    Parent: 'JMSDF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JMSDYO',
    StateC: 'J',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: 'JMSDF, Yokosuka',
    Location: 'Yokosuka',
    lat: 35.25,
    lon: 139.67,
    alt: 0,
    Parent: 'JMSDF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDAIOC',
    StateC: 'US',
    C: 'Military',
    TStart: '1988',
    TStop: '2011',
    name: 'MDA Joint National Integration Center, Schreiver AFB',
    Location: 'Colorado Springs, Colorado',
    lat: 38.8,
    lon: -104.52,
    alt: 0,
    Parent: 'MDA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JNSIC',
    StateC: 'CN',
    C: 'Military',
    TStart: '1964',
    TStop: '2010',
    name: 'Zhongguo jiangnan hangtian gongye jituan gongsi',
    Location: 'Zunyi, Guizhou',
    lat: 27.68,
    lon: -106.9,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JPL',
    StateC: 'US',
    C: 'Government',
    TStart: '1958 Dec 3',
    TStop: '',
    name: 'Jet Propulsion Lab',
    Location: 'Pasadena, California',
    lat: 34.2,
    lon: -118.17,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JPL',
    StateC: 'US',
    C: 'Military',
    TStart: '1944',
    TStop: '1958 Dec 3',
    name: 'Jet Propulsion Lab',
    Location: 'Pasadena, California',
    lat: 34.2,
    lon: -118.17,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JRG',
    StateC: 'KP',
    C: 'Military',
    TStart: '2012',
    TStop: '',
    name: 'Choson inmin\'gun Jeonlyag roketeu gun',
    Location: 'Songchong-kun',
    lat: 39.24,
    lon: 126.21,
    alt: 0,
    Parent: 'KPA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JCSAT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1993 Aug',
    TStop: '2008 Aug',
    name: 'Japan Satellite Systems Inc',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JSC',
    StateC: 'US',
    C: 'Government',
    TStart: '1973 Feb 17',
    TStop: '',
    name: 'NASA Johnson Space Flight Center',
    Location: 'Houston:Clear Lake, Texas',
    lat: 29.56,
    lon: -95.12,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JSCAO',
    StateC: 'US',
    C: 'Government',
    TStart: '1959',
    TStop: '',
    name: 'NASA Astronaut Office',
    Location: 'Houston:Clear Lake, Texas',
    lat: 29.56,
    lon: -95.12,
    alt: 0,
    Parent: 'JSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASDA',
    StateC: 'J',
    C: 'Government',
    TStart: '1963 Apr 1',
    TStop: '1964 Jun',
    name: 'Space Development Office, STA',
    Location: 'Tokyo, Nippon',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: 'STA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USEF',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2012 Mar',
    TStop: '',
    name: 'Ippan zaidan hojin uchu Shisutemu kaihatsu riyo suishin kiko.',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JTF7',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '1963',
    name: 'Joint Task Force 7 HQ',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JUNK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1958',
    TStop: '1969',
    name: 'Junkers Flugzeug- und Motorenwerke GmBH',
    Location: 'Munchen',
    lat: 48.13,
    lon: 11.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JUNO',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1988',
    TStop: '1992',
    name: 'Project Juno',
    Location: 'London',
    lat: 51.52,
    lon: -0.09,
    alt: 0,
    Parent: 'MNB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JUST',
    StateC: 'JO',
    C: 'Academic',
    TStart: '1986',
    TStop: '',
    name: 'Jami\'at Al-Ulum wa Al-Tiknolojia Al-Urdunia',
    Location: 'Al Ramtha, Irbid',
    lat: 32.48,
    lon: 35.99,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KACBS',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Kacific Broadband Satellies Ltd',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KACST',
    StateC: 'SA',
    C: 'Government',
    TStart: '1985',
    TStop: '',
    name: 'King Abdul Aziz City for Science and Technology',
    Location: 'Riyadh',
    lat: 22.31,
    lon: 39.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAFA',
    StateC: 'KR',
    C: 'Military',
    TStart: '1949',
    TStop: '',
    name: 'Gonggun Sagwan Hakgyo',
    Location: 'Cheongju, Chungbuk',
    lat: 36.63,
    lon: 127.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAGA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Kagawa Daigaku (Kagawa U.)',
    Location: 'Takamatsu, Kagawa',
    lat: 34.34,
    lon: 134.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAGO',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Kagoshima Daigaku',
    Location: 'Kagoshima',
    lat: 31.57,
    lon: 130.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAI',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1942',
    TStop: '1967',
    name: 'Kuibyshevskiy Aviatsionniy Institut',
    Location: 'Kubyshev (Samara)',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAI',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1992',
    name: 'Kuibyshevskiy Aviatsionniy Institut im. S.P. Korolev',
    Location: 'Samara (Kubyshev)',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAIFW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1943',
    TStop: '',
    name: 'Kaiser-Fleetwings',
    Location: 'Bristol, Pennsylvania',
    lat: 40.1,
    lon: -74.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAISR',
    StateC: 'KR',
    C: 'Government',
    TStart: '1989 Aug',
    TStop: '1999',
    name: 'Hanguk gwahag gisul-won Ingong-wiseong yeongusenteo',
    Location: 'Daejeon',
    lat: 36.35,
    lon: 127.39,
    alt: 0,
    Parent: 'KAIST',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAIST',
    StateC: 'KR',
    C: 'Government',
    TStart: '1971',
    TStop: '',
    name: 'Hanguk gwahag gisul-won',
    Location: 'Daejeon',
    lat: 36.35,
    lon: 127.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAIT',
    StateC: 'J',
    C: 'Academic',
    TStart: '1975',
    TStop: '',
    name: 'Kanagawa koka daigaku',
    Location: 'Atsugi, Kanagawa',
    lat: 35.43,
    lon: 139.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KARI',
    StateC: 'KR',
    C: 'Government',
    TStart: '1989 Oct',
    TStop: '',
    name: 'Han-guk Hanggong Uju Yeon-guwon (Korea Aerospace Research Inst)',
    Location: 'Daejeon',
    lat: 36.35,
    lon: 127.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRL',
    StateC: 'J',
    C: 'Government',
    TStart: '2004',
    TStop: '',
    name: 'Kashima uchuu gijutsu senta',
    Location: 'Kashima, Ibaraki, Japan',
    lat: 35.97,
    lon: 140.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAWA',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1954',
    TStop: '',
    name: 'Kawasaki Jukogyo Kokuuchu Kanpanii',
    Location: 'Gifu',
    lat: 35.42,
    lon: 136.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAZAF',
    StateC: 'KZ',
    C: 'Military',
    TStart: '1998 Jun',
    TStop: '',
    name: 'Kazakstan Respubliikasi Awe Korganis Kusteri',
    Location: 'Astana',
    lat: 51.17,
    lon: 71.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAZK',
    StateC: 'KZ',
    C: 'Government',
    TStart: '1993 Sep 25',
    TStop: '',
    name: 'Kazakstan Respublikasi Ulttik garish agenttiginin',
    Location: 'Astana',
    lat: 51.17,
    lon: 71.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAZNU',
    StateC: 'KZ',
    C: 'Academic',
    TStart: '1934',
    TStop: '',
    name: 'Al Farabi atindagi Qazaq Ulttiq Universiteti',
    Location: 'Almaty',
    lat: 43.23,
    lon: 76.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAZSOY',
    StateC: 'SU',
    C: 'Government',
    TStart: '1990',
    TStop: '',
    name: 'Kazanskoye OKB Soyuz (Zubets, MKB Soyuz)',
    Location: 'Kazan, Tartarstan',
    lat: 55.8,
    lon: 49.11,
    alt: 0,
    Parent: 'NKE',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAZSOY',
    StateC: 'SU',
    C: 'Government',
    TStart: '1978',
    TStop: '1990',
    name: 'Kazanskoye motorostroitel\'niy zavod Soyuz',
    Location: 'Kazan, Tartarstan',
    lat: 55.8,
    lon: 49.11,
    alt: 0,
    Parent: 'NKE',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOMET',
    StateC: 'SU',
    C: 'Government',
    TStart: '1962',
    TStop: '1973',
    name: 'KB-1 OKB-41 (Savin)',
    Location: 'Moskva (SE)',
    lat: 55.72,
    lon: 37.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMASH',
    StateC: 'RU',
    C: 'Government',
    TStart: '1967 Jan 1',
    TStop: '1974 Jul 11',
    name: 'KB Energomash',
    Location: 'Moskva:Khimki',
    lat: 55.9,
    lon: 37.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMASH',
    StateC: 'RU',
    C: 'Government',
    TStart: '1974 Jul 11',
    TStop: '1990 Jan',
    name: 'KB Energomash, NPO Energiya',
    Location: 'Moskva:Khimki',
    lat: 55.9,
    lon: 37.45,
    alt: 0,
    Parent: 'NPOE',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KBKHA',
    StateC: 'RU',
    C: 'Government',
    TStart: '1967',
    TStop: '',
    name: 'KB KhimAvtomatiki',
    Location: 'Voronezh',
    lat: 51.67,
    lon: 39.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KBM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1942',
    TStop: '',
    name: 'KB Mashinostroeniye (SKB-101)',
    Location: 'Mosvka:Kolomna',
    lat: 55.08,
    lon: 38.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KBPT',
    StateC: 'SU',
    C: 'Government',
    TStart: '1946',
    TStop: '',
    name: 'KBP (Instrument Design Bureau) (TSKB-14)',
    Location: 'Tula',
    lat: 54.2,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB23',
    StateC: 'RU',
    C: 'Government',
    TStart: '1981',
    TStop: '1994',
    name: 'KB Salyut',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KCHT',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Guangdong Kechuang Hangtian keji youxiang gongsi',
    Location: 'Guangdong',
    lat: 23.13,
    lon: 113.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KCST',
    StateC: 'KP',
    C: 'Military',
    TStart: '1998',
    TStop: '2013',
    name: 'Joseon ujugong gangisul wiwonhoe',
    Location: 'Pyongyang',
    lat: 39.02,
    lon: 125.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KEIO',
    StateC: 'J',
    C: 'Academic',
    TStart: '1858',
    TStop: '',
    name: 'Keio Gijuku Daigaku',
    Location: 'Tokyo:Minato',
    lat: 35.65,
    lon: 139.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KEPLER',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Kepler Communications Inc.',
    Location: 'Toronto',
    lat: 43.7,
    lon: -79.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KEPWU',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Kepler Weixing Keji (Wuhan) youxian gongsi',
    Location: 'Wuhan',
    lat: 30.58,
    lon: 114.28,
    alt: 0,
    Parent: 'SECM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KGB',
    StateC: 'SU',
    C: 'Military',
    TStart: '1954',
    TStop: '1995',
    name: 'Komitet gosudarstvennoy besopasnosti SSSR',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KGO',
    StateC: 'S',
    C: 'Government',
    TStart: '1973',
    TStop: '1987',
    name: 'Kiruna Geofysiska Institut',
    Location: 'Kiruna',
    lat: 67.85,
    lon: 20.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KGO',
    StateC: 'S',
    C: 'Government',
    TStart: '1957',
    TStop: '1973',
    name: 'Kiruna Geofysiska Observatorium',
    Location: 'Kiruna',
    lat: 67.85,
    lon: 20.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAEV',
    StateC: 'SU',
    C: 'Government',
    TStart: '1966',
    TStop: '',
    name: 'KB Khimmash',
    Location: 'Moskva:Korolev (Podlipki)',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KHRU',
    StateC: 'RU',
    C: 'Government',
    TStart: '2014 Mar',
    TStop: '',
    name: 'GKNPTs im. M.V. Khrunichev, fil. ORKK',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: 'ORKK',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KHRU',
    StateC: 'RU',
    C: 'Government',
    TStart: '1998',
    TStop: '2014 Mar',
    name: 'GKNPTs im. M.V. Khrunichev, Roskosmos',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB23',
    StateC: 'RU',
    C: 'Government',
    TStart: '1994',
    TStop: '',
    name: 'GKNPTs im. M.V. Khrunichev, KB Salyut',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: 'KHRU',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KHRU',
    StateC: 'RU',
    C: 'Government',
    TStart: '1994',
    TStop: '1998',
    name: 'GKNPTs im. M.V. Khrunichev, Zavod Khrunichev',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KHUS',
    StateC: 'KR',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Gyeonghui Daehakgyo',
    Location: 'Seoul',
    lat: 37.6,
    lon: 127.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KIEL',
    StateC: 'D',
    C: 'Academic',
    TStart: '1665',
    TStop: '',
    name: 'Universitat Kiel',
    Location: 'Kiel, Schleswig-Holstein',
    lat: 54.34,
    lon: 10.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KLEO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'KLEO Connect GmbH',
    Location: 'Berlin, Germany',
    lat: 52.51,
    lon: 13.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KLEOS',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Kleos Space SA',
    Location: 'Luxembourg',
    lat: 49.61,
    lon: 6.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB117',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1965',
    TStop: '',
    name: 'OAO Klimov / OKB im.. Klimov',
    Location: 'Sankt-Peterburg (Leningrad)',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARQ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990',
    TStop: '2000 Jun',
    name: 'Kaiser Marquardt',
    Location: 'Van Nuys, California',
    lat: 34.18,
    lon: -118.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KMIT',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1992',
    TStop: '',
    name: 'NTTs Kompleks-MIT',
    Location: 'Moskva (NE)',
    lat: 55.85,
    lon: 37.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KMUTNB',
    StateC: 'T',
    C: 'Academic',
    TStart: '1959',
    TStop: '',
    name: 'Mhawtihyalay thekhnoloyi phracxmkela phrankhrhenux',
    Location: 'Bangkok',
    lat: 13.82,
    lon: 100.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOBE',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Kobe daigaku',
    Location: 'Kobe',
    lat: 34.73,
    lon: 135.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOBN',
    StateC: 'DK',
    C: 'Academic',
    TStart: '1479',
    TStop: '',
    name: 'Kobenhavns Universitet',
    Location: 'Kobenhavn',
    lat: 55.68,
    lon: 12.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOCHI',
    StateC: 'J',
    C: 'Academic',
    TStart: '1963',
    TStop: '',
    name: 'Kochi kogyokoto senmon',
    Location: 'Nankoku, Kochi',
    lat: 33.57,
    lon: 133.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOLN',
    StateC: 'D',
    C: 'Academic',
    TStart: '1919',
    TStop: '',
    name: 'Universit\\"at zu K\\"oln',
    Location: 'Koln',
    lat: 50.94,
    lon: 6.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOMET',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1973',
    TStop: '',
    name: 'TsNII Kometa',
    Location: 'Moskva (SE)',
    lat: 55.72,
    lon: 37.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KONK',
    StateC: 'HU',
    C: 'Academic',
    TStart: '1871',
    TStop: '',
    name: 'Konkoly Thege Miklos Csillagaszati Intezet',
    Location: 'Budapest',
    lat: 47.5,
    lon: 18.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOKT',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1912',
    TStop: '',
    name: 'Krasniy Oktyabr Mash, St-Peterberg im. Klimov',
    Location: 'Sankt-Peterberg/Leningrad',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOSMT',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Tsentr Kosmonit OAO RKS (Rossiyskoe Kosmicheskiye Sistemi)',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KOUKO',
    StateC: 'J',
    C: 'Academic',
    TStart: '1962',
    TStop: '',
    name: 'Kouko-Kosen (Tokyo Met. Coll. Aero. Eng.)',
    Location: 'Tokyo:Arakawa-ku',
    lat: 35.73,
    lon: 139.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KPA',
    StateC: 'KP',
    C: 'Military',
    TStart: '1948',
    TStop: '',
    name: 'Choson inmin\'gun',
    Location: 'Pyongyang',
    lat: 39.02,
    lon: 125.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JRG',
    StateC: 'KP',
    C: 'Military',
    TStart: '1999',
    TStop: '2012',
    name: 'Choson inmin\'gun Misail jidogug',
    Location: 'Songchong-kun',
    lat: 39.24,
    lon: 126.21,
    alt: 0,
    Parent: 'KPA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KPI',
    StateC: 'UA',
    C: 'Academic',
    TStart: '1898',
    TStop: '',
    name: 'NTUU Kyiv\'skiy Politekhnichiy Institut',
    Location: 'Kyiv',
    lat: 50.45,
    lon: 30.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KPNO',
    StateC: 'US',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Kitt Peak National Observatory, Cherry St Building',
    Location: 'Tucson, Arizona',
    lat: 32.22,
    lon: -110.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KQN',
    StateC: 'VN',
    C: 'Military',
    TStart: '1959',
    TStop: '',
    name: 'Khong quan Nhan dan Viet Nam',
    Location: 'Hanoi',
    lat: 21.03,
    lon: 105.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KRAI',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '1999',
    TStop: '',
    name: 'Hangughang-gong usujan-eob',
    Location: 'Sacheon, S Gyeongsang',
    lat: 35.07,
    lon: 128.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KRAK',
    StateC: 'PL',
    C: 'Academic',
    TStart: '2018',
    TStop: '',
    name: 'Kraksat',
    Location: 'Krakow',
    lat: 50.06,
    lon: 19.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KRAS',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1935',
    TStop: '',
    name: 'Krasnoyarksiy Mash Zavod',
    Location: 'Krasnoyarsk',
    lat: 56.25,
    lon: 93.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KRAT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'Kratos Defense and Security Solutions',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HANAU',
    StateC: 'KR',
    C: 'Academic',
    TStart: '2007',
    TStop: '',
    name: 'Hang\'kuk Hang-gong Daehakgyo',
    Location: 'Seoul:Goyang',
    lat: 37.65,
    lon: 126.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KRLP',
    StateC: 'PK',
    C: 'Military',
    TStart: '1984',
    TStop: '',
    name: 'Khan Research Laboratories, Kahuta',
    Location: 'Kahuta',
    lat: 33.58,
    lon: 73.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KS',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2001 Apr 19',
    TStop: '',
    name: 'GP Kosmicheskaya Svyaz, Moskva',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KSC',
    StateC: 'US',
    C: 'Government',
    TStart: '1963 Nov',
    TStop: '',
    name: 'NASA John F. Kennedy Space Center',
    Location: 'Cape Canaveral, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KSU',
    StateC: 'SA',
    C: 'Academic',
    TStart: '1957',
    TStop: '',
    name: 'Jameiat Almalik Saeud',
    Location: 'Riyadh',
    lat: 24.72,
    lon: 46.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KTEL',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '1981',
    TStop: '2001',
    name: 'Korea Telecom',
    Location: 'Seoul:Bundang',
    lat: 37.38,
    lon: 127.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KTEL',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'KT Corp. (Korea Telecom)',
    Location: 'Seoul:Bundang',
    lat: 37.38,
    lon: 127.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KTH',
    StateC: 'S',
    C: 'Academic',
    TStart: '1827',
    TStop: '',
    name: 'Kungliga Tekniska hogskolan/Dept. of Plasma Physics',
    Location: 'Stockholm:Roslagstull',
    lat: 59.35,
    lon: 18.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KTHR',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1967',
    TStop: '',
    name: 'Kayser-Threde GmbH',
    Location: 'Munchen',
    lat: 48.13,
    lon: 11.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KTRAS',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'MKK Kosmotras',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KTSAT',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'KT Sat',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: 'KTELT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KTU',
    StateC: 'LT',
    C: 'Academic',
    TStart: '1920 Jan',
    TStop: '',
    name: 'Kauno technologijos universitetas',
    Location: 'Kaunas',
    lat: 54.9,
    lon: 23.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KUBOS',
    StateC: 'IS',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Kubos Corp.',
    Location: 'Denton, Texas',
    lat: 33.22,
    lon: -97.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NKE',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1996 Jan',
    TStop: '',
    name: 'OAO Kuznetsov',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'RU',
    C: 'Military',
    TStart: '2001 Jun 1',
    TStop: '2011 Dec 1',
    name: 'Kosmichesikiye voyska Rossii',
    Location: 'Moskva:Solnechnogorsk',
    lat: 56.18,
    lon: 36.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KYO',
    StateC: 'J',
    C: 'Academic',
    TStart: '1869',
    TStop: '',
    name: 'Kyoto daigaku (Kyodai)',
    Location: 'Kyoto',
    lat: 35.03,
    lon: 135.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KYSP',
    StateC: 'US',
    C: 'Academic',
    TStart: '2008',
    TStop: '',
    name: 'Kentucky Space, Kentucky Science and Technology Corp.',
    Location: 'Lexington, Kentucky',
    lat: 38.03,
    lon: -84.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KYUD',
    StateC: 'J',
    C: 'Academic',
    TStart: '1903',
    TStop: '',
    name: 'Kyushu daigaku (Kyudai)',
    Location: 'Fukuoaka, Fukuoka',
    lat: 33.63,
    lon: 130.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KYUT',
    StateC: 'J',
    C: 'Academic',
    TStart: '2004',
    TStop: '',
    name: 'Kyushu Kogyo Daigaku, Cent. Nanosatellite Testing, Tobata Campus',
    Location: 'Kitakyushu:Tobata, Fukuoka',
    lat: 33.89,
    lon: 130.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSEDD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '2018 Oct',
    name: 'L3, Electron Devices Division',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSEDD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005',
    TStop: '2016',
    name: 'L-3 Communications, Electron Technologies Inc.',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HSEDD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Oct',
    TStop: '',
    name: 'L3Harris Electron Devices',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LAC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1932',
    TStop: '1995 Mar 15',
    name: 'Lockheed Aircraft Corporation',
    Location: 'LA:Burbank, California',
    lat: 34.18,
    lon: -118.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LACMA',
    StateC: 'US',
    C: 'Academic',
    TStart: '1910',
    TStop: '',
    name: 'Los Angeles County Museum of Art',
    Location: 'Los Angeles, California',
    lat: 34.06,
    lon: -118.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LACU',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Lacuna Space',
    Location: 'Harwell, Oxfordshire',
    lat: 51.58,
    lon: -1.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LAMBDA',
    StateC: 'US',
    C: 'Academic',
    TStart: '2014',
    TStop: '',
    name: 'Lambda Team',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LANAST',
    StateC: 'LA',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Ongkanvithanyasad lae tekonolsiaehngsad (NAST)',
    Location: 'Vientiane',
    lat: 17.97,
    lon: 102.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LAND',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1990',
    TStop: '',
    name: 'Land Group',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LANDSP',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Beijing lanjian kongjian keji youxian gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LASL',
    StateC: 'US',
    C: 'Military',
    TStart: '1980',
    TStop: '',
    name: 'Los Alamos National Laboratory',
    Location: 'Los Alamos, New Mexico',
    lat: 35.88,
    lon: -106.32,
    alt: 0,
    Parent: 'DOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LAOJV',
    StateC: 'LA',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Lao Satellite Joint Venture Company',
    Location: 'Vientiane',
    lat: 17.97,
    lon: 102.6,
    alt: 0,
    Parent: 'LANAST',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LAPAN',
    StateC: 'ID',
    C: 'Government',
    TStart: '1964 Nov 27',
    TStop: '',
    name: 'Lembaga Penerbangan dan Antariksa Nasional/LAPAN',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LAPANR',
    StateC: 'ID',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'LAPAN Rocket Motor Lab',
    Location: 'Tarogong, W Java',
    lat: -7.21,
    lon: 107.89,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LARC',
    StateC: 'US',
    C: 'Government',
    TStart: '1917',
    TStop: '1958 Oct 1',
    name: 'NACA Langley Research Center',
    Location: 'Langley Field, Hampton, Virginia',
    lat: 37.09,
    lon: -76.38,
    alt: 0,
    Parent: 'NACA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LARC',
    StateC: 'US',
    C: 'Government',
    TStart: '1958 Oct 1',
    TStop: '',
    name: 'NASA Langley Research Center',
    Location: 'Langley Field, Hampton, Virginia',
    lat: 37.09,
    lon: -76.38,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LARCNE',
    StateC: 'US',
    C: 'Government',
    TStart: '2003',
    TStop: '',
    name: 'NASA Engineering and Safety Center, LaRC',
    Location: 'Langley Field, Hampton, Virginia',
    lat: 37.09,
    lon: -76.38,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LAS',
    StateC: 'F',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Labo. d\'Astronomie Spatiale',
    Location: 'Marseille',
    lat: 43.3,
    lon: 5.37,
    alt: 0,
    Parent: 'CNRS',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LASL',
    StateC: 'US',
    C: 'Military',
    TStart: '1947',
    TStop: '1980',
    name: 'Los Alamos Scientific Laboratory',
    Location: 'Los Alamos, New Mexico',
    lat: 35.88,
    lon: -106.32,
    alt: 0,
    Parent: 'DOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AERON',
    StateC: 'F',
    C: 'Government',
    TStart: '2009',
    TStop: '',
    name: 'CNRS Lab. Atmospheres, Milieux, Observations Spatiales (Verrieres)',
    Location: 'Paris:Verrieres-le-Buisson',
    lat: 48.75,
    lon: 2.27,
    alt: 0,
    Parent: 'CNRS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LCFE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '',
    name: 'LCF Enterprises',
    Location: 'Post Falls, Idaho',
    lat: 47.7,
    lon: -117.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LCT',
    StateC: 'F',
    C: 'Government',
    TStart: '1927',
    TStop: '',
    name: 'Laboratoire Centrale de Telecommunications',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LDSE',
    StateC: 'CN',
    C: 'Government',
    TStart: '2015',
    TStop: '',
    name: 'Yueqiu yu shenkong tance zhongdian shiyan shi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LEEDS',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1887',
    TStop: '',
    name: 'University of Leeds',
    Location: 'Leeds',
    lat: 53.81,
    lon: -1.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PMOOS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '',
    name: 'Leesona Moos Laboratories',
    Location: 'Jamaica, New York',
    lat: 40.7,
    lon: -73.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LEID',
    StateC: 'NL',
    C: 'Academic',
    TStart: '1575',
    TStop: '',
    name: 'Universiteit Leiden',
    Location: 'Leiden',
    lat: 52.16,
    lon: 4.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EOS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '',
    name: 'Loral Electro-Optical Systems, Inc.',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: 'LORC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LEOSTL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Mar',
    TStop: '',
    name: 'LeoStella LLC (SFLIN/THALES)',
    Location: 'Tukwila, Washington',
    lat: 47.47,
    lon: -122.26,
    alt: 0,
    Parent: 'SFLIN',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LERC',
    StateC: 'US',
    C: 'Government',
    TStart: '1958',
    TStop: '1999 Mar 1',
    name: 'NASA Lewis Research Center',
    Location: 'Cleveland, Ohio',
    lat: 41.41,
    lon: -81.86,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LFLT',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Shenzhen Hangxing Guangwang kongjian jishu YG',
    Location: 'Shenzhen',
    lat: 22.55,
    lon: 114.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LGAR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1971',
    TStop: '',
    name: 'L\'Garde Inc.',
    Location: 'Tustin, California',
    lat: 33.74,
    lon: -117.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LIBRE',
    StateC: 'GR',
    C: 'Academic',
    TStart: '2018',
    TStop: '',
    name: 'Libre Space Foundation',
    Location: 'Athenai',
    lat: 37.98,
    lon: 23.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LIDA',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Li ke da jiaoyu keji jituan YG',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LIEGE',
    StateC: 'B',
    C: 'Academic',
    TStart: '1817',
    TStop: '',
    name: 'Universite\' de Liege',
    Location: 'Liege, Wallonie',
    lat: 50.64,
    lon: 5.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYTC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016 Feb',
    TStop: '',
    name: 'Ligado Networks',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYTCA',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2016 Feb',
    TStop: '',
    name: 'Ligado Networks',
    Location: 'Ottawa:Gloucester, Ontario',
    lat: 45.44,
    lon: -75.61,
    alt: 0,
    Parent: 'LIGA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LII',
    StateC: 'RU',
    C: 'Military',
    TStart: '1941',
    TStop: '',
    name: 'Letno-issledovatel\'skiy institut im. M.M. Gromov',
    Location: 'Zhukovsky:Ramenskoye',
    lat: 55.57,
    lon: 38.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LINA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'LinaSpace LLC',
    Location: 'Fairfax, Virginia',
    lat: 38.85,
    lon: -77.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LINAO',
    StateC: 'DD',
    C: 'Government',
    TStart: '1905',
    TStop: '',
    name: 'Aerologisches Observatorium Lindenberg, Met. Dienst DDR',
    Location: 'Lindenberg, Brandenberg',
    lat: 52.21,
    lon: 14.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LINGZ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Beijing Ling Zhong kongjian jishu YG',
    Location: 'Beijing',
    lat: 39.79,
    lon: 116.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LINK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2014 Jan',
    TStop: '',
    name: 'Shenzhen shi lingke hangtian jishu youxian gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LIZH',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2012 Nov',
    TStop: '',
    name: 'Shanghai Lizheng weixing yingyong jishu YG',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LKA',
    StateC: 'LT',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Lietuvos Kosmoso Asociacija',
    Location: 'Vilnius',
    lat: 54.68,
    lon: 25.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1971 Jun',
    TStop: '1980',
    name: 'Lawrence Livermore Lab',
    Location: 'Livermore, California',
    lat: 37.68,
    lon: -121.77,
    alt: 0,
    Parent: 'DOE',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1980',
    TStop: '',
    name: 'Lawrence Livermore National Lab',
    Location: 'Livermore, California',
    lat: 37.68,
    lon: -121.77,
    alt: 0,
    Parent: 'DOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar 15',
    TStop: '',
    name: 'Lockheed Martin',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar 15',
    TStop: '2003 Jan',
    name: 'Lockheed Martin Astronautics',
    Location: 'Denver:Littleton, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar 15',
    TStop: '1996',
    name: 'LMA/San Diego (Kearny Mesa)',
    Location: 'San Diego:Kearny Mesa, California',
    lat: 32.83,
    lon: -117.14,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPARL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Lockheed Martin Advanced Technology Center',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'Lockheed Martin Courtland (Lawrence County)',
    Location: 'Courtland, Alabama',
    lat: 34.67,
    lon: -87.31,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998 Sep',
    TStop: '2004 Oct',
    name: 'Lockheed Martin Global Telecom/Comsat General',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTVCAM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Lockheed Martin Missiles and Fire Control/Camden',
    Location: 'Camden, Arkansas',
    lat: 33.57,
    lon: -92.84,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDCLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Lockheed Martin Commercial Launch Services',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMCSS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Lockheed Martin Commercial Space Systems/Sunnyvale',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAEW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar 15',
    TStop: '1998',
    name: 'Lockheed Martin/East Windsor',
    Location: 'East Windsor, New Jersey',
    lat: 40.26,
    lon: -74.53,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMGT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar',
    TStop: '',
    name: 'Lockheed Martin Global Telecommunications',
    Location: 'Sunnyvale, California ',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMKSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009 Jan',
    TStop: '',
    name: 'Lockheed Martin, Operations/Checkout Bldg, Kennedy Space Center',
    Location: 'Kennedy Space Center, Florida',
    lat: 28.61,
    lon: -80.6,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMI',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2006',
    name: 'Lockheed Martin Intersputnik',
    Location: 'London',
    lat: 51.51,
    lon: -0.11,
    alt: 0,
    Parent: 'LMGT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUNTE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2005 Aug',
    TStop: '',
    name: 'Lockheed Martin INSYS',
    Location: 'Ampthill, Bedfordshire',
    lat: 52.03,
    lon: -0.49,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MMMI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar 15',
    TStop: '',
    name: 'Lockheed Martin/Michoud',
    Location: 'Michoud, Louisiana',
    lat: 30.02,
    lon: -89.92,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '',
    name: 'Lockheed Martin Missiles and Fire Control - Dallas',
    Location: 'Dallas:Grand Prairie, Texas',
    lat: 32.72,
    lon: -97.02,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995 Mar 15',
    TStop: '2005',
    name: 'Lockheed Martin Missiles and Space, Sunnyvale',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2015',
    name: 'Lockheed Martin Commercial Space Systems/Newtown',
    Location: 'Newtown, Pennsylvania',
    lat: 40.23,
    lon: -74.9,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Lockheed Martin Missiles and Fire Control/Orlando',
    Location: 'Orlando, Florida',
    lat: 28.54,
    lon: -81.38,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MMPCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Lockheed Martin Pike County Operations',
    Location: 'Troy, Alabama',
    lat: 31.81,
    lon: -85.97,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPPLM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'Lockheed Martin/Palmdale',
    Location: 'Palmdale, California',
    lat: 34.58,
    lon: -118.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMSAL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Lockheed Martin Solar and Astrophysics Laboratory',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'LMATC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SANH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2000',
    name: 'Lockheed Martin Aerospace Electronics Systems/Nashua',
    Location: 'Nashua, New Hampshire',
    lat: 42.76,
    lon: -71.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961 Jun',
    TStop: '1995 Mar 15',
    name: 'Lockheed Missiles and Space Co.',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LAC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMSCV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2006 Sep',
    name: 'Lockheed Martin Space Communications Ventures',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1961 Jun',
    name: 'Lockheed Missiles and Space Division',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LAC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATECH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014 Aug',
    TStop: '',
    name: 'LM Space Operations',
    Location: 'Titusville, Florida',
    lat: 28.59,
    lon: -80.82,
    alt: 0,
    Parent: 'SHAB',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'Lockheed Martin Space Systems (Sunnyvale)',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LAC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'Lockheed Martin Space Systems (Denver), Astronautics Operations',
    Location: 'Denver:Littleton, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LMT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Lockheed Martin Telecommunications',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAEW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '1998',
    name: 'Lockheed Martin Telecommunications/East Windsor',
    Location: 'East Windsor, New Jersey',
    lat: 40.26,
    lon: -74.53,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '1999',
    name: 'Lockheed Martin Vought',
    Location: 'Dallas:Grand Prairie, Texas',
    lat: 32.72,
    lon: -97.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GEVF',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Lockheed Martin Space Systems/Valley Forge',
    Location: 'Valley Forge, Penn.',
    lat: 40.1,
    lon: -75.47,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LOFT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Loft Orbital',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990 Oct',
    TStop: '2012 Nov',
    name: 'SS/Loral',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'LORC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LORC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1948',
    TStop: '1996',
    name: 'Loral Corporation',
    Location: 'New York, New York',
    lat: 40.71,
    lon: -74.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998 Mar 20',
    TStop: '2005 Nov 21',
    name: 'Loral Orion',
    Location: 'Rockville, Maryland',
    lat: 39.08,
    lon: -77.15,
    alt: 0,
    Parent: 'LORC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LORC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Loral Space and Communications Inc.',
    Location: 'New York, New York',
    lat: 40.71,
    lon: -74.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPA',
    StateC: 'F',
    C: 'Government',
    TStart: '1955',
    TStop: '',
    name: 'Laboratoire de Physique de L\'Atmosphere, Univ. Paris',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPARL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1997',
    name: 'Lockheed Palo Alto Research Labs',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'LAC',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GCR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1974',
    name: 'Lockheed Propulsion Co',
    Location: 'Redlands, California',
    lat: 34.05,
    lon: -117.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPCE',
    StateC: 'F',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Laboratoire de Physique et Chimie de l\'Enivronnement et de l\'Espace',
    Location: 'Orleans',
    lat: 47.85,
    lon: 1.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1968',
    TStop: '',
    name: 'Lunar and Planetary Institute',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPSC',
    StateC: 'IN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'VSSC Liquid Propulsion Systems Center',
    Location: 'Trivandrum, Kerala',
    lat: 8.53,
    lon: 76.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPSCM',
    StateC: 'IN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'VSSC Liquid Propulsion Systems Center, Mahendragiri Facilities',
    Location: 'Mahendragiri, Tamil Nadu',
    lat: 8.39,
    lon: 77.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LPSP',
    StateC: 'F',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Laboratoire de Physique Stellaire et Planetaire (CNRS)',
    Location: 'Paris:Verrieres-le-Buisson, Essonne',
    lat: 48.75,
    lon: 2.27,
    alt: 0,
    Parent: 'CNRS',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LRBA',
    StateC: 'F',
    C: 'Government',
    TStart: '1946 May',
    TStop: '*',
    name: 'Laboratoire de Recherches Ballistiques et Aerodynamiques',
    Location: 'Vernon, Hte Normandie',
    lat: 49.09,
    lon: 1.49,
    alt: 0,
    Parent: 'DGA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1958',
    TStop: '1971 Jun',
    name: 'Lawrence Radiation Laboratory',
    Location: 'Livermore, California',
    lat: 37.68,
    lon: -121.77,
    alt: 0,
    Parent: 'DOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LRPG',
    StateC: 'US',
    C: 'Unknown',
    TStart: '1949',
    TStop: '1950',
    name: 'Long Range Proving Ground',
    Location: 'Cape Canaveral, Florida',
    lat: 28.47,
    lon: -80.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LRRC',
    StateC: 'US',
    C: 'Unknown',
    TStart: '2002 Mar',
    TStop: '2010',
    name: 'Lunar Rocket and Rover Co.',
    Location: 'Los Alamitos, California',
    lat: 33.8,
    lon: -118.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LRS',
    StateC: 'LB',
    C: 'Government',
    TStart: '1960',
    TStop: '1966',
    name: 'L\'Association Libanaise pour Etudes des Engins Spaciaux',
    Location: 'Beirut:Dbayeh',
    lat: 33.9,
    lon: 35.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WRE',
    StateC: 'AU',
    C: 'Military',
    TStart: '1947',
    TStop: '1955',
    name: 'Long Range Weapons Establishment',
    Location: 'Adelaide:Salisbury, S Australia',
    lat: -34.76,
    lon: 138.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LSK',
    StateC: 'DD',
    C: 'Military',
    TStart: '1956',
    TStop: '1990',
    name: 'Luftstreitkrafte der Nationalen Volksarmee',
    Location: 'Strausberg',
    lat: 13.88,
    lon: 52.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATTS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2007 Oct 31',
    name: 'Loral Skynet',
    Location: 'Bedminster, New Jersey',
    lat: 40.67,
    lon: -74.69,
    alt: 0,
    Parent: 'LORC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LSKYB',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2007 Oct 31',
    name: 'Loral Skynet do Brazil',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'LSKY',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LSPHZ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Landspace/Huzhou',
    Location: 'Huzhou City, Zhejiang',
    lat: 30.87,
    lon: 120.1,
    alt: 0,
    Parent: 'LANDSP',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYTC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010 Jul',
    TStop: '2016 Feb',
    name: 'LightSquared (Harbinger Capital Partners)',
    Location: 'New York, New York',
    lat: 40.71,
    lon: -74.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYTCA',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2010 Jul',
    TStop: '2016 Feb',
    name: 'LightSquared (Harbinger Capital Partners)',
    Location: 'Ottawa:Gloucester, Ontario',
    lat: 45.44,
    lon: -75.61,
    alt: 0,
    Parent: 'MSV',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTU',
    StateC: 'S',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Lulea tekniska universitet',
    Location: 'Lulea',
    lat: 65.62,
    lon: 22.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1976',
    name: 'Ling-Temco-Vought Missile Systems',
    Location: 'Dallas:Grand Prairie, Texas',
    lat: 32.72,
    lon: -97.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTVCAM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1995',
    name: 'LTV Camden',
    Location: 'Camden, Arkansas',
    lat: 33.57,
    lon: -92.84,
    alt: 0,
    Parent: 'LTV',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTVE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1964',
    TStop: '1972',
    name: 'LTV Electronic Systems Division',
    Location: 'Dallas:Garland, Texas',
    lat: 32.91,
    lon: -96.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTVM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1980',
    name: 'LTV, Michigan Army Missile Plant',
    Location: 'Detroit:Sterling Heights, Michigan',
    lat: 42.58,
    lon: -83.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1976',
    TStop: '1992 Aug 31',
    name: 'LTV Missiles and Space (Vought Corporation)',
    Location: 'Dallas:Grand Prairie, Texas',
    lat: 32.72,
    lon: -97.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELM',
    StateC: 'B',
    C: 'Military',
    TStart: '2002',
    TStop: '',
    name: 'Luchtcomponent',
    Location: 'Brussel',
    lat: 50.85,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LUHAN',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Luhan Gongzuo shi',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LULRZ',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Luliang shi renmin zhengfu',
    Location: 'Luliang, Shanxi',
    lat: 37.52,
    lon: 111.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LUND',
    StateC: 'S',
    C: 'Academic',
    TStart: '1666',
    TStop: '',
    name: 'Lunds universitat',
    Location: 'Lund, Scania',
    lat: 55.71,
    lon: 13.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LUX',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1961',
    TStop: '',
    name: 'Leicester University X-ray group',
    Location: 'Leicester',
    lat: 52.62,
    lon: -1.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LUXG',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'LuxGovSat S.A.',
    Location: 'Betzdorf, Luxembourg',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LUXS',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2004 Nov',
    TStop: '',
    name: 'LuxSpace Sarl (OHB)',
    Location: 'Betzdorf, Luxembourg',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: 'OHB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1992 Aug 31',
    TStop: '1996',
    name: 'Loral Vought',
    Location: 'Dallas:Grand Prairie, Texas',
    lat: 32.72,
    lon: -97.02,
    alt: 0,
    Parent: 'LORC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LVN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1954',
    TStop: '1960',
    name: 'Lockheed Aircraft Corp, Plant B-9, Missile Systems Division (X-7)',
    Location: 'Van Nuys, California',
    lat: 34.18,
    lon: -118.43,
    alt: 0,
    Parent: 'LAC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LW',
    StateC: 'D',
    C: 'Military',
    TStart: '1956',
    TStop: '',
    name: 'Luftwaffe (Bundeswehr)',
    Location: 'Koln',
    lat: 50.94,
    lon: 6.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LYK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Beijing Lingyi Kongjian Keji YG',
    Location: 'Chongqing Liangjian New Area',
    lat: 29.64,
    lon: 106.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UBIQ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019 Oct',
    TStop: '',
    name: 'Lynk Global, Inc',
    Location: 'Falls Church, Virginia',
    lat: 38.89,
    lon: -77.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'M42',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014 Aug',
    TStop: '',
    name: 'M42 Technologies',
    Location: 'Seattle, Washington',
    lat: 47.61,
    lon: -122.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAEU',
    StateC: 'MYM',
    C: 'Academic',
    TStart: '2002',
    TStop: '',
    name: 'Myanmarninengan Laykyaungg Nhang Aarkarsapanyar Takkasol',
    Location: 'Meiktila, Mandalay',
    lat: 20.89,
    lon: 95.89,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAGL',
    StateC: 'HU',
    C: 'Military',
    TStart: '1918',
    TStop: '',
    name: 'Maygar Legiero',
    Location: 'Budapest',
    lat: 47.49,
    lon: 19.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAI',
    StateC: 'CN',
    C: 'Government',
    TStart: '1982 Apr',
    TStop: '1988 Jul',
    name: 'Hangtian gongye bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAI',
    StateC: 'CN',
    C: 'Government',
    TStart: '1988 Jul',
    TStop: '1993 Jun',
    name: 'Hangkong hangtian gongye bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAIMD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Maryland Aerospace',
    Location: 'Crofton, Maryland',
    lat: 39,
    lon: -76.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAIO',
    StateC: 'SU',
    C: 'Government',
    TStart: '1933',
    TStop: '',
    name: 'Moskovskiy aviatsionniy institut im. S. Ordzhonikidze - SKB Iskra',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKB385',
    StateC: 'RU',
    C: 'Government',
    TStart: '1993',
    TStop: '',
    name: 'FGUP GRTs Makeev KB (SKB-385)',
    Location: 'Miass, Chelyabinsk',
    lat: 55,
    lon: 60.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MANU',
    StateC: 'UK',
    C: 'Academic',
    TStart: '2004',
    TStop: '',
    name: 'University of Manchester',
    Location: 'Manchester',
    lat: 53.46,
    lon: -2.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAOW',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Maowang shouyinji',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARCO',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Marconi',
    Location: 'Portsmouth',
    lat: 50.82,
    lon: -1.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARINT',
    StateC: 'UAE',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Marshall Intech (UAE Bin Ghalib Group)',
    Location: 'Dubai',
    lat: 25.26,
    lon: 55.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARQ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1948',
    TStop: '1990',
    name: 'Marquardt/Van Nuys',
    Location: 'Van Nuys, California',
    lat: 34.18,
    lon: -118.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARQO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '',
    name: 'Marquardt/Ogden',
    Location: 'Ogden, Utah',
    lat: 41.19,
    lon: -111.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1961',
    name: 'Martin-Baltimore',
    Location: 'Baltimore, Maryland',
    lat: 39.28,
    lon: -76.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1961',
    name: 'Martin-Denver',
    Location: 'Denver:Littleton, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '1961',
    name: 'Martin/Orlando',
    Location: 'Orlando, Florida',
    lat: 28.54,
    lon: -81.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MASDAR',
    StateC: 'UAE',
    C: 'Academic',
    TStart: '2007',
    TStop: '2017',
    name: 'Masdar Institute of Science and Technology',
    Location: 'Masdar City, Abu Dhabi',
    lat: 24.41,
    lon: 54.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MASDAR',
    StateC: 'UAE',
    C: 'Academic',
    TStart: '2017',
    TStop: '',
    name: 'Masdar Institute, Khalifa University',
    Location: 'Masdar City, Abu Dhabi',
    lat: 24.41,
    lon: 54.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MASTEN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Masten Space Systems, R&D Shop',
    Location: 'Mojave, California',
    lat: 35.05,
    lon: -118.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MATRA',
    StateC: 'F',
    C: 'Commercial',
    TStart: '',
    TStop: '1989',
    name: 'MATRA Espace',
    Location: 'Paris:Velizy',
    lat: 48.78,
    lon: 2.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MATT',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1968',
    TStop: '1989',
    name: 'MATRA Espace',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MATV',
    StateC: 'F',
    C: 'Commercial',
    TStart: '',
    TStop: '1989',
    name: 'MATRA Espace (Velizy)',
    Location: 'Paris:Velizy',
    lat: 48.78,
    lon: 2.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019 Feb',
    TStop: '',
    name: 'Maverick Space Systems',
    Location: 'San Luis Obispo, California',
    lat: 35.27,
    lon: -120.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDABC',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2017 Oct',
    TStop: '',
    name: 'Maxar Technologies, Ltd',
    Location: 'Richmond, British Columbia',
    lat: 49.17,
    lon: -123.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAR',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2017 Oct',
    TStop: '',
    name: 'Maxar Technologies/Robotics',
    Location: 'Brampton, Ontario',
    lat: 43.68,
    lon: -79.77,
    alt: 0,
    Parent: 'MAXAR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPARM',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2017 Oct',
    TStop: '',
    name: 'Maxar Satellite Systems',
    Location: 'Montreal:St-Anne-de-Bellevue, Quebec',
    lat: 45.4,
    lon: -73.95,
    alt: 0,
    Parent: 'MAXAR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MAXSJ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Maxar SSL/San Jose',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: 'MAXAR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019 Mar',
    TStop: '',
    name: 'Maxar Space Solutions Group',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'MAXAR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MBAK',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Martin-Baker Aircraft Ltd',
    Location: 'Higher Denham, Buckinghamshire',
    lat: 51.56,
    lon: -0.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BOLK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1968',
    TStop: '1989 Dec',
    name: 'Messerschmitt-B\\"olkow-Blohm GMbH (MBB)',
    Location: 'Munchen:Ottobrunn',
    lat: 48.07,
    lon: 11.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ERNO',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1980 Dec',
    TStop: '1989 Dec',
    name: 'MBB-ERNO (Entwicklungsring Nord)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: 'MBB',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JUNK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1969',
    TStop: '1975',
    name: 'MBB (Munchen, Junkers plant)',
    Location: 'Munchen',
    lat: 48.13,
    lon: 11.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MBCO',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1998 May',
    TStop: '2009 Mar',
    name: 'Mobile Broadcasting Corp.',
    Location: 'Tokyo:Shinagawa',
    lat: 35.6,
    lon: 139.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EIAST',
    StateC: 'UAE',
    C: 'Government',
    TStart: '2015 Apr 18',
    TStop: '',
    name: 'Mohammed bin Rashid Space Centre, EIAST',
    Location: 'Dubai',
    lat: 25.26,
    lon: 55.3,
    alt: 0,
    Parent: 'EIAST',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MCDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1938',
    TStop: '1967',
    name: 'McDonnell Aircraft',
    Location: 'St Louis, Missouri',
    lat: 38.63,
    lon: -90.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MCI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1963',
    TStop: '2003',
    name: 'MCI Communications Corp.',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFMCSW',
    StateC: 'US',
    C: 'Military',
    TStart: '2020 Dec 19',
    TStop: '',
    name: 'US Space Force Military Satellite Communications Wing, SMC, LAAFB',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSMC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDIO',
    StateC: 'US',
    C: 'Military',
    TStart: '2002',
    TStop: '',
    name: 'Missile Defense Agency',
    Location: 'Washington,DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DACHB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1996 Dec',
    name: 'McDonnell Douglas Astronautics Co.',
    Location: 'Huntington Beach, California',
    lat: 33.69,
    lon: -118,
    alt: 0,
    Parent: 'MDC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDAIOC',
    StateC: 'US',
    C: 'Military',
    TStart: '2011',
    TStop: '',
    name: 'MDA Missile Defense Integration and Operations Center, Schreiver AFB',
    Location: 'Colorado Springs, Colorado',
    lat: 38.8,
    lon: -104.52,
    alt: 0,
    Parent: 'MDA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPARM',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2005',
    TStop: '2017 Oct',
    name: 'MDA Satellite Systems',
    Location: 'Montreal:St-Anne-de-Bellevue, Quebec',
    lat: 45.4,
    lon: -73.95,
    alt: 0,
    Parent: 'MDABC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDABC',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1990',
    TStop: '2017 Oct',
    name: 'MacDonald, Dettwiler and Associates',
    Location: 'Richmond, British Columbia',
    lat: 49.17,
    lon: -123.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MCDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1996',
    name: 'MDA/St Louis',
    Location: 'St Louis, Missouri',
    lat: 38.63,
    lon: -90.2,
    alt: 0,
    Parent: 'MDC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDATH',
    StateC: 'US',
    C: 'Military',
    TStart: '2002',
    TStop: '',
    name: 'Missile Defense Agency, THAAD project office (Huntsville)',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: 'MDA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDAUK',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'MDA/UK',
    Location: 'Harwell, Oxfordshire',
    lat: 51.58,
    lon: -1.31,
    alt: 0,
    Parent: 'MDAM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1996',
    name: 'McDonnell Douglas',
    Location: 'St Louis, Missouri',
    lat: 38.63,
    lon: -90.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDD',
    StateC: 'DD',
    C: 'Government',
    TStart: '1950',
    TStop: '1991',
    name: 'Meteorologischer Dienst der DDR',
    Location: 'Berlin:Potsdam',
    lat: 52.4,
    lon: 13.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDDI',
    StateC: 'I',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Ministero della Difesa, Amministrazione Difesa',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDHSV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1997',
    name: 'McDonnell Douglas Aerospace - Huntsville',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: 'MDC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDPE',
    StateC: 'PE',
    C: 'Military',
    TStart: '1987',
    TStop: '',
    name: 'Ministerio de Defensa del Peru',
    Location: 'Lima',
    lat: -12.04,
    lon: -77.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAR',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1999 Mar',
    TStop: '2017 Oct',
    name: 'MDA (MacDonald Dettwiler Assoc.) Robotics',
    Location: 'Brampton, Ontario',
    lat: 43.68,
    lon: -79.77,
    alt: 0,
    Parent: 'MDABC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MDSSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'McDonnell Douglas Space Systems Corp. (MDSSC-HB)',
    Location: 'Huntington Beach, California',
    lat: 33.69,
    lon: -118,
    alt: 0,
    Parent: 'MDC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BINA',
    StateC: 'MY',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'MEASAT Satellite Systems Sdn Bhd.',
    Location: 'Cyberjaya, Sepang, Selangor',
    lat: 2.92,
    lon: 101.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MEGS',
    StateC: 'I',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Meggiorin Group, Brescia',
    Location: 'Brescia, Italia',
    lat: 45.54,
    lon: 10.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MEI',
    StateC: 'SU',
    C: 'Academic',
    TStart: '1930',
    TStop: '',
    name: 'Moskovskiy Energeticheskiy Institut',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MEISEI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1938',
    TStop: '',
    name: 'MeiseiDenki K.K.',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MUNIZ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005',
    TStop: '2021 Aug',
    name: 'MEI Technologies',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MUNIZ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021 Aug',
    TStop: '2021 Aug',
    name: 'Aegis Aerospace (MEI)',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: 'AEGAE',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MELB',
    StateC: 'AU',
    C: 'Academic',
    TStart: '1853',
    TStop: '',
    name: 'Melbourne University',
    Location: 'Melbourne, Victoria',
    lat: 37.79,
    lon: 144.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MELCO',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Mitsubishi Denki Kabushiki-gaisha, Kamakura Works',
    Location: 'Kamakura, Kanagawa',
    lat: 35.32,
    lon: 139.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MELSP',
    StateC: 'AU',
    C: 'Academic',
    TStart: '2016',
    TStop: '',
    name: 'Melbourne Space Program',
    Location: 'Melbourne, Victoria',
    lat: 37.79,
    lon: 144.96,
    alt: 0,
    Parent: 'MELB',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MESH',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1966',
    TStop: '1985',
    name: 'MESH Consortium (MATRA, ERNO, SAAB, HSD)',
    Location: 'Paris:Issy',
    lat: 48.83,
    lon: 2.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AES',
    StateC: 'CA',
    C: 'Government',
    TStart: '2002',
    TStop: '',
    name: 'Meteorological Service of Canada, Dept. of the Environment',
    Location: 'Toronto:Downsview',
    lat: 43.73,
    lon: -79.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'METI',
    StateC: 'J',
    C: 'Government',
    TStart: '2001 Jan',
    TStop: '',
    name: 'Keizai sangyo sho',
    Location: 'Tokyo',
    lat: 35.67,
    lon: 139.75,
    alt: 0,
    Parent: 'J',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'METP',
    StateC: 'SU',
    C: 'Government',
    TStart: '1965',
    TStop: '1991',
    name: 'Minelektrotekhprom',
    Location: 'Mosvka',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MEWTA',
    StateC: 'US',
    C: 'Military',
    TStart: '1960',
    TStop: '1970',
    name: 'Missile Electronic Warfare Techincal Area, WSMR',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'WSMR',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MGON',
    StateC: 'SU',
    C: 'Military',
    TStart: '1953',
    TStop: '1991 Dec',
    name: 'Ministerstvo Geologii i Okhrany Nedr',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MGU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1755',
    TStop: '',
    name: 'Moskovskiy Gosudarstvenniy Universitet im. M.V. Lomonosova',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MHI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1964',
    TStop: '',
    name: 'Mitsubishi Jukogyo Kabushiki-kaisha',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MHIKO',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'MHI Aerospace Systems, Komaki Minami Plant',
    Location: 'Nagoya:Komaki (Nagoya Airport)',
    lat: 35.26,
    lon: 136.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MHIME',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'MHI Guidance and Propulsion Works (MHI Meiyu)',
    Location: 'Nagoya:Komaki',
    lat: 35.26,
    lon: 136.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MHITO',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'MHI Aerospace Systems, Tobishima Plant',
    Location: 'Nagoya:Tobishima',
    lat: 35.08,
    lon: 136.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1963 May',
    TStop: '1997 Oct',
    name: 'US Army Missile Command',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '1999',
    name: 'MicroCraft Inc.(Allied Aerospace)',
    Location: 'Tullahoma, Tennessee',
    lat: 35.37,
    lon: -86.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2003 Nov',
    name: 'MicroCraft Inc.(Allied Aerospace)',
    Location: 'Tullahoma, Tennessee',
    lat: 35.37,
    lon: -86.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011 Mar',
    TStop: '',
    name: 'MicroCraft Inc',
    Location: 'Tullahoma, Tennessee',
    lat: 35.37,
    lon: -86.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICRL',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'MicroSat Lt (IAI/Rafael)',
    Location: 'Tel Aviv',
    lat: 32.07,
    lon: 34.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICROC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Microcosm Inc.',
    Location: 'Hawthorne, California',
    lat: 33.92,
    lon: -118.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICSG',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'MicroSpace RAPID Pte Ltd.',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998',
    TStop: '2012',
    name: 'Micro-Space Inc.',
    Location: 'Denver, Colorado',
    lat: 39.76,
    lon: -104.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MICSY',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'Microsat Systems Inc (MSI)',
    Location: 'Denver:Littleton, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: 'SIENV',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MIG',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1939',
    TStop: '2006',
    name: 'Mikoyan i Gurevich OKB-155',
    Location: 'Moskva',
    lat: 55.79,
    lon: 37.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MIHS',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Merritt Island High School',
    Location: 'Merritt Island, Florida',
    lat: 28.38,
    lon: -80.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILAN',
    StateC: 'I',
    C: 'Academic',
    TStart: '1924',
    TStop: '',
    name: 'Universit\\\'a degli Studi di Milano (UNIMI)',
    Location: 'Milano',
    lat: 45.46,
    lon: 9.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFMCSW',
    StateC: 'US',
    C: 'Military',
    TStart: '1990',
    TStop: '2006',
    name: 'US Air Force Milsatcom Joint Project Office, AFSMC, LAAFB',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSMC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILLEI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Millenium Engeering and Integration Services, LLC',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILLEN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2018',
    name: 'Millenium Space Systems',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILLES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014',
    TStop: '2018',
    name: 'Millenium Space Systems/El Segundo factory',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'MILLEN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MILTEC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010',
    TStop: '2012',
    name: 'Miltec Missiles and Space Co.',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MINCYT',
    StateC: 'AR',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Ministerio de Ciencia, Tecnologia e Innovacion Productiva',
    Location: 'Buenos Aires',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MINES',
    StateC: 'F',
    C: 'Academic',
    TStart: '1783',
    TStop: '',
    name: 'Ecole Nationale Superieure des Mines',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MINICU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Mini-Cubes LLC',
    Location: 'Akron, Pennsylvania',
    lat: 40.16,
    lon: -76.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MIRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '2004',
    name: 'Mission Research Corp (NH)',
    Location: 'Nashua, New Hampshire',
    lat: 42.76,
    lon: -71.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MIRCO',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2003',
    name: 'MirCorp',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MISU',
    StateC: 'S',
    C: 'Academic',
    TStart: '1947',
    TStop: '1973',
    name: 'Meteorologiska Institutionen Stockholms Universitet',
    Location: 'Stockholm',
    lat: 59.37,
    lon: 18.06,
    alt: 0,
    Parent: 'STO',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MISU',
    StateC: 'S',
    C: 'Academic',
    TStart: '1973',
    TStop: '',
    name: 'Met Inst. Stockholm (Frescati campus)',
    Location: 'Stockholm:Frescati',
    lat: 59.37,
    lon: 18.05,
    alt: 0,
    Parent: 'STO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MIT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1916',
    TStop: '',
    name: 'Mass. Inst of Technology',
    Location: 'Cambridge, Massachusetts',
    lat: 42.36,
    lon: -71.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MITLL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1951',
    TStop: '',
    name: 'Lincoln Labs, Mass. Inst of Technology',
    Location: 'Lexington, Massachusetts',
    lat: 42.46,
    lon: -71.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MITT',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1946',
    TStop: '',
    name: 'Moskovskiy institut Teplotekhniki',
    Location: 'Mosvka (NE)',
    lat: 55.86,
    lon: 37.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MKA',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'NTTs Malie Kosmicheskie Apparaty',
    Location: 'Zheleznogorsk',
    lat: 56.25,
    lon: 93.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1995',
    name: 'Martin Marietta',
    Location: 'Denver, Colorado',
    lat: 39.76,
    lon: -104.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MMA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta Astronautics',
    Location: 'Denver, Colorado',
    lat: 39.76,
    lon: -104.88,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAEW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta Astro Space/East Windsor',
    Location: 'East Windsor, New Jersey',
    lat: 40.26,
    lon: -74.53,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GDCLS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994 May',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta Commercial Launch Services',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta/Denver',
    Location: 'Denver:Littleton, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAEW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta Astro Space/East Windsor',
    Location: 'East Windsor, New Jersey',
    lat: 40.26,
    lon: -74.53,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MMMI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1973',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta/Michoud',
    Location: 'Michoud, Louisiana',
    lat: 30.02,
    lon: -89.92,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARTO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta/Orlando',
    Location: 'Orlando, Florida',
    lat: 28.54,
    lon: -81.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MMPCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta Pike County Operations',
    Location: 'Troy, Alabama',
    lat: 31.81,
    lon: -85.97,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994 May 2',
    TStop: '1995 Mar 15',
    name: 'Martin Marietta (San Diego), AF Plant 19',
    Location: 'San Diego:Kearny Mesa, California',
    lat: 32.83,
    lon: -117.14,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVS',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1994',
    TStop: '2000',
    name: 'Matra Marconi Space (Stevenage)',
    Location: 'Stevenage',
    lat: 51.9,
    lon: -0.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MATT',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1989',
    TStop: '2000',
    name: 'Matra Marconi Space (Toulouse)',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MATV',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1989',
    TStop: '2000',
    name: 'Matra Marconi Space',
    Location: 'Paris:Velizy',
    lat: 48.78,
    lon: 2.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GEVF',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993',
    TStop: '1995',
    name: 'Martin Marietta/Valley Forge',
    Location: 'Valley Forge, Penn.',
    lat: 40.1,
    lon: -75.47,
    alt: 0,
    Parent: 'MM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MNB',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1910',
    TStop: '',
    name: 'Moscow Narodny Bank Ltd.',
    Location: 'London',
    lat: 51.52,
    lon: -0.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MNF',
    StateC: 'F',
    C: 'Government',
    TStart: '1945',
    TStop: '1993',
    name: 'Meteorologie Nationale, France',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MVS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1953 Mar',
    TStop: '1991 Dec',
    name: 'MinOboroni',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOD',
    StateC: 'UK',
    C: 'Military',
    TStart: '1964',
    TStop: '',
    name: 'Ministry of Defence, London',
    Location: 'London:Whitehall',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOL',
    StateC: 'US',
    C: 'Military',
    TStart: '1965',
    TStop: '1969 Jun',
    name: 'Manned Orbiting Laboratory astronaut corps',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSSD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOLN',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1976',
    TStop: '',
    name: 'NPO Molniya, Tushino Mash. Zavod.',
    Location: 'Moskva:Tushino',
    lat: 55.83,
    lon: 37.44,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOM',
    StateC: 'SU',
    C: 'Military',
    TStart: '1965 Mar',
    TStop: '1992 Feb',
    name: 'Minobshchemash',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOMENT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Momentus Space',
    Location: 'Santa Clara, California',
    lat: 37.35,
    lon: -121.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MONBU',
    StateC: 'J',
    C: 'Government',
    TStart: '1950',
    TStop: '2001 Jan',
    name: 'Monbusho',
    Location: 'Tokyo',
    lat: 35.67,
    lon: 139.75,
    alt: 0,
    Parent: 'J',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MONBU',
    StateC: 'J',
    C: 'Government',
    TStart: '2001 Jan',
    TStop: '',
    name: 'Monbukagakusho',
    Location: 'Tokyo',
    lat: 35.67,
    lon: 139.75,
    alt: 0,
    Parent: 'J',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MONTP2',
    StateC: 'F',
    C: 'Academic',
    TStart: '2015 Jan',
    TStop: '',
    name: 'Universite de Montpellier',
    Location: 'Montpellier, Herault',
    lat: 43.63,
    lon: 3.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MONTP2',
    StateC: 'F',
    C: 'Academic',
    TStart: '1970',
    TStop: '2015 Jan',
    name: 'Universite Montpellier 2',
    Location: 'Montpellier, Herault',
    lat: 43.63,
    lon: 3.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOOG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1951',
    TStop: '',
    name: 'Moog Inc.',
    Location: 'Buffalo/East Aurora, New York',
    lat: 42.77,
    lon: -78.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CSAE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Moog CSA',
    Location: 'Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: 'MOOG',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BELL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Aug',
    TStop: '',
    name: 'Moog In-Space Propulsion',
    Location: 'Niagara Falls, New York',
    lat: 43.1,
    lon: -79.02,
    alt: 0,
    Parent: 'MOOG',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2012 Aug',
    TStop: '',
    name: 'Moog In-Space Propulsion (UK)',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: 'MOOG',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOOREF',
    StateC: 'US',
    C: 'Academic',
    TStart: '2000',
    TStop: '',
    name: 'Gordon and Betty Moore Foundation',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MORF',
    StateC: 'RU',
    C: 'Military',
    TStart: '1991 Dec',
    TStop: '',
    name: 'Min. Oboroni (Ministry of Defense), Rossiya',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2007',
    name: 'Motient Corporation',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOTO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990',
    TStop: '2008 Sep',
    name: 'Motorola Satellite Communications',
    Location: 'Phoenix:Chandler, Arizona',
    lat: 33.3,
    lon: -111.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOTOS',
    StateC: 'RU',
    C: 'Unknown',
    TStart: '1912',
    TStop: '',
    name: 'OAO Motorostroitel, Samara',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOZH',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1955',
    TStop: '1990',
    name: 'Voenniy Inzhenerniy Krasnoznamenniy Inst. im A.F. Mozhaiskiy',
    Location: 'Sankt-Peterburg',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOZH',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1990',
    TStop: '',
    name: 'Voennaya Kosmicheskaya Akademia im A.F. Mozhaiskiy',
    Location: 'Sankt-Peterburg',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPA',
    StateC: 'MN',
    C: 'Military',
    TStart: '1921',
    TStop: '1992',
    name: 'Mongolyn Ardyn Armi',
    Location: 'Ulaanbaatar',
    lat: 47.92,
    lon: 106.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPAE',
    StateC: 'D',
    C: 'Academic',
    TStart: '1957',
    TStop: '2004 Jul 1',
    name: 'Max Planck Institut fur Aeronomie - Lindau',
    Location: 'Lindau',
    lat: 47.55,
    lon: 9.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPE',
    StateC: 'D',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Max Planck Institut fur Extraterrestrische Physik',
    Location: 'Garching',
    lat: 48.25,
    lon: 11.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPIH',
    StateC: 'D',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Max Planck Institut fur Astronomie',
    Location: 'Heidelberg',
    lat: 49.42,
    lon: 8.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPIK',
    StateC: 'D',
    C: 'Academic',
    TStart: '1958',
    TStop: '',
    name: 'Max-Planck-Institut fur Kernphysik',
    Location: 'Heidelberg',
    lat: 49.42,
    lon: 8.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPAE',
    StateC: 'D',
    C: 'Academic',
    TStart: '2004 Jul 1',
    TStop: '',
    name: 'Max Planck Institut fur Sonnensystemforschung',
    Location: 'Lindau',
    lat: 47.55,
    lon: 9.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPSC',
    StateC: 'PH',
    C: 'Commercial',
    TStart: '1996 Jan',
    TStop: '2009 Nov',
    name: 'Mabuhay Philippines Satellite Corp',
    Location: 'Subic Bay',
    lat: 14.79,
    lon: 120.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPSC',
    StateC: 'PH',
    C: 'Commercial',
    TStart: '2009 Nov',
    TStop: '2009 Dec',
    name: 'Asia Broadcast Satellite (MPSC division)',
    Location: 'Subic Bay',
    lat: 14.79,
    lon: 120.23,
    alt: 0,
    Parent: 'ABS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MPU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '2016 Mar',
    TStop: '',
    name: 'Moskovskiy Politekhnicheskiy Universitet',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MRI',
    StateC: 'J',
    C: 'Government',
    TStart: '1945',
    TStop: '1980',
    name: 'JMA Meteorological Research Institute',
    Location: 'Tokyo:Suginami',
    lat: 35.68,
    lon: 139.62,
    alt: 0,
    Parent: 'JMA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MRIC',
    StateC: 'MU',
    C: 'Government',
    TStart: '2019 Sep 1',
    TStop: '',
    name: 'Mauritius Research and Innovation Council',
    Location: 'Ebene',
    lat: -20.24,
    lon: 57.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MRI',
    StateC: 'J',
    C: 'Government',
    TStart: '1980',
    TStop: '',
    name: 'JMA Meteorological Research Institute',
    Location: 'Tsukuba',
    lat: 36.08,
    lon: 140.08,
    alt: 0,
    Parent: 'JMA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MRN',
    StateC: 'US',
    C: 'Military',
    TStart: '1959',
    TStop: '',
    name: 'Meteorological Rocket Network',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'AWS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSBTR',
    StateC: 'TR',
    C: 'Military',
    TStart: '1970',
    TStop: '',
    name: 'Milli Savnunma Bakanligi',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JSC',
    StateC: 'US',
    C: 'Government',
    TStart: '1962 Mar 1',
    TStop: '1973 Feb 17',
    name: 'NASA Manned Spacecraft Center',
    Location: 'Houston:Clear Lake, Texas',
    lat: 29.56,
    lon: -95.12,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DYN',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Microsat Systems Canada Inc',
    Location: 'Toronto:Mississauga, Ontario',
    lat: 43.6,
    lon: -79.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOL',
    StateC: 'US',
    C: 'Military',
    TStart: '1978',
    TStop: '1988',
    name: 'Manned Spaceflight Engineer corps, Los Angeles AFB',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSFC',
    StateC: 'US',
    C: 'Government',
    TStart: '1960',
    TStop: '',
    name: 'NASA Marshall Space Flight Center',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSGC',
    StateC: 'US',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Montana Space Grant Consortium, Montana State University, Bozeman',
    Location: 'Bozeman, Montana',
    lat: 45.67,
    lon: -111.05,
    alt: 0,
    Parent: 'MSU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSSL',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1966',
    TStop: '',
    name: 'Mullard Space Science Laboratory',
    Location: 'Dorking, Surrey',
    lat: 51.23,
    lon: -0.33,
    alt: 0,
    Parent: 'UCL',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1893',
    TStop: '',
    name: 'Montana State University, Bozeman',
    Location: 'Bozeman, Montana',
    lat: 45.67,
    lon: -111.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSUKY',
    StateC: 'US',
    C: 'Academic',
    TStart: '1887',
    TStop: '',
    name: 'Morehead State University',
    Location: 'Morehead, Kentucky',
    lat: 38.19,
    lon: -83.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000 Jun',
    TStop: '2008 Dec',
    name: 'Mobile Satellite Ventures L.P.',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'MOTI/TMI',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSVCA',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2000 Jun',
    TStop: '2008 Dec',
    name: 'Mobile Satellite Ventures L.P.',
    Location: 'Ottawa:Gloucester, Ontario',
    lat: 45.44,
    lon: -75.61,
    alt: 0,
    Parent: 'MSV',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KS',
    StateC: 'SU',
    C: 'Government',
    TStart: '1968',
    TStop: '1992',
    name: 'MinSvyazi SSR Soyuzniy Uzel Radioveshchaniya i Radiosvyazi No. 9',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MTF',
    StateC: 'US',
    C: 'Government',
    TStart: '1962 Nov',
    TStop: '1988',
    name: 'NASA Mississippi Test Facility',
    Location: 'Pearl River, Mississippi',
    lat: 30.62,
    lon: -89.6,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '1989 Jul 1',
    name: 'Morton Thiokol Inc.',
    Location: 'Chicago, Illinois',
    lat: 41.84,
    lon: -87.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MTU',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Michigan Technological University Aerospace Enterprise',
    Location: 'Houghton, Michigan',
    lat: 47.12,
    lon: -88.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MUKD',
    StateC: 'J',
    C: 'Academic',
    TStart: '1876',
    TStop: '',
    name: 'Muroran Kogyo Daigaku',
    Location: 'Muroran, Hokkaido',
    lat: 42.38,
    lon: 141.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MUNIZ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1992',
    TStop: '2005',
    name: 'Muniz Engineering',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MV7',
    StateC: 'SU',
    C: 'Military',
    TStart: '1954',
    TStop: '1959',
    name: '7 Uprav. Ministerstvo Vooruzhie',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MVD',
    StateC: 'SU',
    C: 'Government',
    TStart: '1946',
    TStop: '1992',
    name: 'Ministerstvo Vnutrennikh DelSSSR',
    Location: 'Mosvka',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MVS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1946 Mar',
    TStop: '1950 Feb',
    name: 'Ministerstvo Voenniy Sili',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MVS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1950 Feb',
    TStop: '1953 Mar',
    name: 'Voenniy Ministerstvo SSSR ()',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MYA',
    StateC: 'SU',
    C: 'Military',
    TStart: '1976',
    TStop: '',
    name: 'Eksperimental\'niy KB im. Myasishchev',
    Location: 'Moskva:Zhukovskiy',
    lat: 55.6,
    lon: 38.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MYRI',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Myriota Pty Ltd',
    Location: 'Adelaide, South Australia',
    lat: -34.93,
    lon: 138.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BKSA',
    StateC: 'MY',
    C: 'Government',
    TStart: '2019 Feb',
    TStop: '',
    name: 'Agensi Angkasa Malaysia',
    Location: 'Kuala Lumpur',
    lat: 3.13,
    lon: 101.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1936 Jan',
    TStop: '1973',
    name: 'North American Aviation',
    Location: 'Los Angeles:Inglewood, California',
    lat: 33.96,
    lon: -118.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAAA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1946',
    TStop: '1948',
    name: 'North America Aviation - Aerophysics Laboratory',
    Location: 'Los Angeles:Inglewood, California',
    lat: 33.96,
    lon: -118.35,
    alt: 0,
    Parent: 'NAA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VULT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1948 Jul',
    TStop: '1973',
    name: 'North American Aviation, Missile Division, Downey',
    Location: 'Downey, California',
    lat: 33.94,
    lon: -118.13,
    alt: 0,
    Parent: 'NAA',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RDYNE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1948 Jul',
    TStop: '1955 Nov',
    name: 'North American Aviation, Missile Division, Propulsion Research',
    Location: 'Downey, California',
    lat: 33.94,
    lon: -118.13,
    alt: 0,
    Parent: 'NAAD',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAASB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1965',
    TStop: '1973',
    name: 'North American Aviation, Seal Beach',
    Location: 'Seal Beach, California',
    lat: 33.76,
    lon: -118.08,
    alt: 0,
    Parent: 'NAA',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASA',
    StateC: 'US',
    C: 'Government',
    TStart: '1915',
    TStop: '1958 Oct 1',
    name: 'National Advisory Council on Aeronautics',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NICS',
    StateC: 'US',
    C: 'Military',
    TStart: '1986',
    TStop: '1996 Jul 1',
    name: 'NATO Communications and Information Systems Agency',
    Location: 'Brussel:Haren',
    lat: 50.89,
    lon: 4.42,
    alt: 0,
    Parent: 'NATO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KCST',
    StateC: 'KP',
    C: 'Military',
    TStart: '2013',
    TStop: '',
    name: 'Gugga Uju Gaebalgug (Kukga uju gaebalkuk)',
    Location: 'Pyongyang',
    lat: 39.02,
    lon: 125.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAFI',
    StateC: 'US',
    C: 'Military',
    TStart: '1956',
    TStop: '1977',
    name: 'Naval Avionics Facility, Indianapolis',
    Location: 'Indianapolis, Indiana',
    lat: 39.79,
    lon: -86.15,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAG',
    StateC: 'J',
    C: 'Academic',
    TStart: '1939',
    TStop: '',
    name: 'Nagoya daigaku',
    Location: 'Nagoya',
    lat: 35.15,
    lon: 136.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAHU',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '1994',
    TStop: '2010',
    name: 'Nahuelsat SA',
    Location: 'Buenos Aires, Argentina',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAHU',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '2010',
    TStop: '2011',
    name: 'Nahuelsat SA assets, transferred to AR-SAT',
    Location: 'Buenos Aires, Argentina',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: 'ARSAT',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAIC',
    StateC: 'US',
    C: 'Military',
    TStart: '1993 Oct 1',
    TStop: '2003 Feb',
    name: 'National Air Intelligence Center',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAIR',
    StateC: 'KE',
    C: 'Academic',
    TStart: '1970',
    TStop: '',
    name: 'University of Nairobi',
    Location: 'Nairobi',
    lat: -1.28,
    lon: 38.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAKA',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'kabu Nakashimadatekkosho',
    Location: 'Hirokawa, Fukuoka',
    lat: 33.23,
    lon: 130.55,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAMFI',
    StateC: 'GR',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'NATO Missile Firing Installation, Hellenic Natural Defense General Staff',
    Location: 'Chania, Crete',
    lat: 35.52,
    lon: 24.02,
    alt: 0,
    Parent: 'NATO',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAMMO',
    StateC: 'N',
    C: 'Commercial',
    TStart: '1998',
    TStop: '',
    name: 'Nammo (Nordic Ammunition Group) Raufoss',
    Location: 'Raufoss',
    lat: 60.72,
    lon: 10.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAMTC',
    StateC: 'US',
    C: 'Military',
    TStart: '1946 Oct 1',
    TStop: '1958 Jun',
    name: 'Naval Air Missile Test Center, Point Mugu',
    Location: 'Pt. Mugu, California',
    lat: 34.12,
    lon: -119.12,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAL',
    StateC: 'J',
    C: 'Government',
    TStart: '1961 Feb',
    TStop: '2003 Oct 1',
    name: 'Koku Ucyu Gijyutsu Kenkyujyo (National Aerospace Lab)',
    Location: 'Tokyo:Chofu',
    lat: 35.65,
    lon: 139.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NANAV',
    StateC: 'LT',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'NanoAvionics',
    Location: 'Vilnius',
    lat: 54.75,
    lon: 25.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NANAVU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'NanoAvionics US',
    Location: 'Midland, Texas',
    lat: 31.94,
    lon: -102.21,
    alt: 0,
    Parent: 'NANAV',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NANR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'NanoRacks',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NANSFI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '2014 Aug',
    name: 'NanoSatisfi',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TAO',
    StateC: 'J',
    C: 'Government',
    TStart: '1988',
    TStop: '',
    name: 'National Astronomical Observatory of Japan (Mitaka)',
    Location: 'Tokyo:Mitaka',
    lat: 35.68,
    lon: 139.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NARSS',
    StateC: 'EG',
    C: 'Government',
    TStart: '1994',
    TStop: '2017',
    name: 'National Authority for Remote Sensing and Space Science',
    Location: 'Al-Qahira (Cairo):El Nozha El Gedida',
    lat: 30.03,
    lon: 31.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASA',
    StateC: 'US',
    C: 'Government',
    TStart: '1958 Oct 1',
    TStop: '',
    name: 'National Aeronautics and Space Administration',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASA',
    StateC: 'US',
    C: 'Government',
    TStart: '1958 Oct 1',
    TStop: '',
    name: 'National Aeronautics and Space Administration',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASDA',
    StateC: 'J',
    C: 'Government',
    TStart: '1969 Oct',
    TStop: '2003 Oct 1',
    name: 'Ucyu Kaihatsu Jigyoudan',
    Location: 'Tokyo, Nippon',
    lat: 35.69,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASDM',
    StateC: 'J',
    C: 'Government',
    TStart: '2000',
    TStop: '',
    name: 'NASDA Micro Space System Lab',
    Location: 'Tokyo, Nippon',
    lat: 35.69,
    lon: 139.68,
    alt: 0,
    Parent: 'NASDA',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAIC',
    StateC: 'US',
    C: 'Military',
    TStart: '2003 Feb',
    TStop: '',
    name: 'National Air and Space Intelligence Center',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAST',
    StateC: 'NP',
    C: 'Academic',
    TStart: '1982',
    TStop: '',
    name: 'Nepal Academy of Science and Technology',
    Location: 'Kathmandu:Lalitpur',
    lat: 27.65,
    lon: 85.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NATC',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Naval Air Test Center, Patuxent River, Maryland',
    Location: 'Patuxent River, Maryland',
    lat: 38.31,
    lon: -76.42,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NATO',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'North Atlantic Treaty Organization',
    Location: 'Brussel:Haren',
    lat: 50.89,
    lon: 4.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BUORD',
    StateC: 'US',
    C: 'Military',
    TStart: '1966 May 1',
    TStop: '',
    name: 'USN Naval Air Systems Command (NAVAIR)',
    Location: 'Patuxent River, Maryland',
    lat: 38.31,
    lon: -76.42,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAVAST',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '1990 Jun 12',
    name: 'USN Naval Astronautics Group',
    Location: 'Pt Mugu, California',
    lat: 34.12,
    lon: -119.12,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAVMAT',
    StateC: 'US',
    C: 'Military',
    TStart: '1966 May 1',
    TStop: '1985 May 6',
    name: 'USN Naval Material Command',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAVSEA',
    StateC: 'US',
    C: 'Military',
    TStart: '1974',
    TStop: '',
    name: 'USN Naval Sea Systems Command',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAVSPA',
    StateC: 'US',
    C: 'Military',
    TStart: '1983 Oct 1',
    TStop: '',
    name: 'US Naval Space Command (NAVSPACECOM)',
    Location: 'Dahlgren, Virginia',
    lat: 38.34,
    lon: -77.05,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAVAST',
    StateC: 'US',
    C: 'Military',
    TStart: '1990 Jun 12',
    TStop: '',
    name: 'USN Naval Satellite Operations Center',
    Location: 'Pt Mugu, California',
    lat: 34.12,
    lon: -119.12,
    alt: 0,
    Parent: 'NAVSPA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAVSPOC',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Naval Space Operations Center',
    Location: 'Dahlgren, Virginia',
    lat: 38.34,
    lon: -77.05,
    alt: 0,
    Parent: 'NAVSPA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOTS',
    StateC: 'US',
    C: 'Military',
    TStart: '1992 Jan 22',
    TStop: '',
    name: 'Naval Air Warfare Center',
    Location: 'China Lake, California',
    lat: 35.69,
    lon: -117.69,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAXS',
    StateC: 'US',
    C: 'Government',
    TStart: '1994 Sep',
    TStop: '1996 Sep',
    name: 'NASA HQ-XS (Office of Space Access and Tech., OSAT/Code X)',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NBN',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2009 Apr',
    TStop: '',
    name: 'NBN Co. Ltd. (nbn, National Broadband Network Co.)',
    Location: 'Melbourne, Victoria',
    lat: -37.81,
    lon: 144.96,
    alt: 0,
    Parent: 'AU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NBS',
    StateC: 'US',
    C: 'Government',
    TStart: '1901',
    TStop: '1988',
    name: 'National Bureau of Standards',
    Location: 'Gaithersburg, Maryland',
    lat: 39.13,
    lon: -77.23,
    alt: 0,
    Parent: 'DOC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NBSC',
    StateC: 'US',
    C: 'Government',
    TStart: '1954',
    TStop: '1988',
    name: 'National Bureau of Standards, Central Radio Propagation Lab',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'NBS',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NICS',
    StateC: 'US',
    C: 'Military',
    TStart: '1996 Jul 1',
    TStop: '',
    name: 'NATO C3 Agency (NC3A)',
    Location: 'Brussel:Haren',
    lat: 50.89,
    lon: 4.42,
    alt: 0,
    Parent: 'NATO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NCAR',
    StateC: 'US',
    C: 'Government',
    TStart: '1960',
    TStop: '',
    name: 'National Center for Atmospheric Research',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'NSF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NCKU',
    StateC: 'TW',
    C: 'Academic',
    TStart: '1931',
    TStop: '',
    name: 'Guoli Chenggong Daxue (Chengda)',
    Location: 'Tainan City',
    lat: 23,
    lon: 120.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NCST',
    StateC: 'US',
    C: 'Military',
    TStart: '1980',
    TStop: '',
    name: 'Naval Center for Space Technology',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'NRL',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NCU',
    StateC: 'TW',
    C: 'Academic',
    TStart: '1968',
    TStop: '',
    name: 'National Central University - Shuanglianpo',
    Location: 'Jhongli:Shuanglianpo',
    lat: 24.97,
    lon: 121.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NDAWN',
    StateC: 'MU',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'New Dawn Satellite Co. (Intelsat/Convergence Partners)',
    Location: 'Port Louis, Maurice',
    lat: -20.16,
    lon: 57.5,
    alt: 0,
    Parent: 'INTELS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NDRE',
    StateC: 'N',
    C: 'Military',
    TStart: '1946',
    TStop: '',
    name: 'Forsvarets forskningsinstitutt (FFI)',
    Location: 'Oslo:Kjeller',
    lat: 59.98,
    lon: 11.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NEC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '2001',
    name: 'Nippon Electric Corp., Space Div., Kamoi Works',
    Location: 'Kamoi, Shin-Yokohama',
    lat: 35.51,
    lon: 139.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NECT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2015 May 15',
    TStop: '',
    name: 'NEC supesutekunoroji kabushikigaisha',
    Location: 'Kawasaki City, Kanagawa',
    lat: 35.52,
    lon: 139.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NECT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2015 May 15',
    name: 'NEC Toshiba supesushisutemu kaubishikigahisha',
    Location: 'Kawasaki City, Kanagawa',
    lat: 35.52,
    lon: 139.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NECTF',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'NEC Toshiba Space, Fuchu works',
    Location: 'Tokyo:Fuchu',
    lat: 35.67,
    lon: 139.48,
    alt: 0,
    Parent: 'NECT',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NEC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2005',
    name: 'NEC Toshiba Space, Kamoi works',
    Location: 'Kamoi, Tokyo:Shin-Yokohama',
    lat: 35.51,
    lon: 139.57,
    alt: 0,
    Parent: 'NECT',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOSHKE',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'NEC Space, Keihin works',
    Location: 'Kawasaki City, Kanagawa',
    lat: 35.52,
    lon: 139.7,
    alt: 0,
    Parent: 'NECT',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NESC',
    StateC: 'US',
    C: 'Government',
    TStart: '1965',
    TStop: '1970 Oct',
    name: 'ESSA National Environmental Satellite Center',
    Location: 'Suitland, Maryland',
    lat: 38.85,
    lon: -76.92,
    alt: 0,
    Parent: 'ESSA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NESCOM',
    StateC: 'PK',
    C: 'Military',
    TStart: '2001',
    TStop: '',
    name: 'Pakistan National Engineering and Scientific Commission',
    Location: 'Islamabad',
    lat: 33.72,
    lon: 73.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKNDC',
    StateC: 'PK',
    C: 'Military',
    TStart: '2001',
    TStop: '',
    name: 'NESCOM, Pakistan National Defense Complex',
    Location: 'Fateh Jang',
    lat: 33.57,
    lon: 72.64,
    alt: 0,
    Parent: 'NESCOM',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKPMO',
    StateC: 'PK',
    C: 'Government',
    TStart: '2001',
    TStop: '',
    name: 'NESCOM, Project Management Organization, Pakistan',
    Location: 'Khanpur',
    lat: 28.65,
    lon: 70.68,
    alt: 0,
    Parent: 'NESCOM',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NESC',
    StateC: 'US',
    C: 'Government',
    TStart: '1980 Aug',
    TStop: '*',
    name: 'National Environmental Satellite, Data and Information Service',
    Location: 'Suitland, Maryland',
    lat: 38.85,
    lon: -76.92,
    alt: 0,
    Parent: 'NOAA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NESC',
    StateC: 'US',
    C: 'Government',
    TStart: '1970 Oct',
    TStop: '1980 Aug',
    name: 'National Environmental Satellite Service',
    Location: 'Suitland, Maryland',
    lat: 38.85,
    lon: -76.92,
    alt: 0,
    Parent: 'NOAA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NETAA',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015 Feb',
    TStop: '',
    name: 'Network Access Associates Ltd.',
    Location: 'London',
    lat: 51.5,
    lon: 0.13,
    alt: 0,
    Parent: 'ONEWEB',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NEU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1898',
    TStop: '',
    name: 'Northeastern University',
    Location: 'Boston, MA',
    lat: 42.34,
    lon: -71.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NEWSAT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2004 May',
    name: 'NewSat USA LLC',
    Location: 'Allendale, New Jersey',
    lat: 41.03,
    lon: -74.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NEWSAU',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'NewSat',
    Location: 'Melbourne, Victoria',
    lat: -37.81,
    lon: 144.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NFU',
    StateC: 'TW',
    C: 'Academic',
    TStart: '1980',
    TStop: '',
    name: 'Guoli Huwei Keji Daxue',
    Location: 'Huwei, Taiwan',
    lat: 23.72,
    lon: 120.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NGA',
    StateC: 'US',
    C: 'Military',
    TStart: '2003',
    TStop: '',
    name: 'National Geospatial Intelligence Agency, Ft Belvoir',
    Location: 'Springfield:Ft Belvoir, Virginia',
    lat: 38.72,
    lon: -77.15,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'NG Astro Aerospace, Carpinteria',
    Location: 'Carpinteria, California',
    lat: 34.4,
    lon: -119.52,
    alt: 0,
    Parent: 'NGST',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Northrop Grummann Aerospace Systems',
    Location: 'Redondo Beach, California',
    lat: 33.86,
    lon: -118.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AJ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'Northrop Grumman/Azusa',
    Location: 'Azusa, California',
    lat: 34.13,
    lon: -117.91,
    alt: 0,
    Parent: 'GTRC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NGCOM',
    StateC: 'NG',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Nigcomsat (Nigerian Comm. Sat. Ltd, Federal Ministry of Science and Tech)',
    Location: 'Abuja, Federal Capital Territory',
    lat: 9.07,
    lon: 7.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OATK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'Northrop Grumman Innovation Systems',
    Location: 'Washington:Dulles, Virginia',
    lat: 39.01,
    lon: -77.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'NGIS/Orbital ATK DSG Missile Products (Rocket Center, WV)',
    Location: 'Cumberland:Rocket Center, West Virginia',
    lat: 39.56,
    lon: -78.83,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATKB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'NGIS Defense Systems Group / Missile Products',
    Location: 'Baltimore, Maryland',
    lat: 39.28,
    lon: -76.62,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'NGIS Flight Systems Group',
    Location: 'Phoenix:Chandler, Arizona',
    lat: 33.3,
    lon: -111.83,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'Northrop Grumman Space Systems Group (SSG)',
    Location: 'Washington:Dulles, Virginia',
    lat: 39.01,
    lon: -77.43,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'NGIS DSG Missile Products (Elkton)',
    Location: 'Elkton, Maryland',
    lat: 39.61,
    lon: -75.83,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GASL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'Northrop Grumman DSG Missile Products (Ronkonkoma)',
    Location: 'Ronkonkoma, New York',
    lat: 40.81,
    lon: -73.13,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'Northrop Grumman Civil Sats. and Nat. Security Systems',
    Location: 'Gilbert, Arizona',
    lat: 33.35,
    lon: -111.79,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AECAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'Northrop Grumman Space Components (Goleta)',
    Location: 'Goleta, California',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HERC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'NGIS / ATK Aerospace Group Headquarters',
    Location: 'Salt Lake City:West Valley City (Magna), Utah',
    lat: 40.69,
    lon: -111.99,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'NGIS FSG Test Services (Promontory)',
    Location: 'Brigham City:Promontory, Utah',
    lat: 41.62,
    lon: -112.55,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWALES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'Northrop Grumman Space Systems (Beltsville)',
    Location: 'Beltsville, Maryland',
    lat: 39.04,
    lon: -76.92,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSCW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018 Jun 7',
    TStop: '',
    name: 'NGIS Launch Systems (Wallops)',
    Location: 'Wallops Island, Virginia',
    lat: 37.84,
    lon: -75.49,
    alt: 0,
    Parent: 'NGIS',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NGNW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'Northrop Grumman NovaWorks',
    Location: 'Redondo Beach, California',
    lat: 33.86,
    lon: -118.38,
    alt: 0,
    Parent: 'NGST',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2002 Jul 1',
    TStop: '2009',
    name: 'Northrop Grummann Space Technology',
    Location: 'Redondo Beach, California',
    lat: 33.86,
    lon: -118.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NHK',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1925 Mar',
    TStop: '',
    name: 'Nippon Hoso Kyokai',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NICP',
    StateC: 'N',
    C: 'Government',
    TStart: '1927',
    TStop: '1972 Jan',
    name: 'Norsk Institutt for Kosmisk Fysikk',
    Location: 'Tromso',
    lat: 69.68,
    lon: 18.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NICS',
    StateC: 'US',
    C: 'Military',
    TStart: '1971 Mar',
    TStop: '1986',
    name: 'NATO Integrated Communications Management Agency',
    Location: 'Brussel:Haren',
    lat: 50.89,
    lon: 4.42,
    alt: 0,
    Parent: 'NATO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIHON',
    StateC: 'J',
    C: 'Academic',
    TStart: '1889',
    TStop: '',
    name: 'Nihon Daigaku',
    Location: 'Tokyo:Chiyoda',
    lat: 35.69,
    lon: 139.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RNII',
    StateC: 'SU',
    C: 'Government',
    TStart: '1950',
    TStop: '1965',
    name: 'Nauchno-issledovatel\'niy institut 1 (RNII)',
    Location: 'Moskva:Khovrino',
    lat: 55.87,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIIM',
    StateC: 'SU',
    C: 'Unknown',
    TStart: '1958',
    TStop: '1981',
    name: 'NII-1 Fil. (Sverdlovsk)',
    Location: 'Nishnyaya Salda, Sverdlovsk Oblast',
    lat: 58.07,
    lon: 60.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NII125',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1947',
    TStop: '1980',
    name: 'NII-125 (Zhukov)',
    Location: 'Mosvka:Lyubertsy/Dzerzhinskiy',
    lat: 55.67,
    lon: 37.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSKHM',
    StateC: 'SU',
    C: 'Military',
    TStart: '1937',
    TStop: '1969',
    name: 'Nauchno-issledovaltel\'skiy institut No. 6',
    Location: 'Mosvka',
    lat: 55.68,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NII88',
    StateC: 'SU',
    C: 'Military',
    TStart: '1946 May',
    TStop: '1967',
    name: 'NII-88 (Nauchno-Issledovatel\'niy Institut 88)',
    Location: 'Moskva:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NII88A',
    StateC: 'SU',
    C: 'Military',
    TStart: '1946 May',
    TStop: '1967',
    name: 'NII-88 civilian launches (not in RVSN list)',
    Location: 'Moskva:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIIEM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1960',
    TStop: '',
    name: 'FGUP NII Elektromekhaniki',
    Location: 'Mosvka:Istra',
    lat: 55.92,
    lon: 36.87,
    alt: 0,
    Parent: 'VNIEM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIIKP',
    StateC: 'SU',
    C: 'Government',
    TStart: '1978',
    TStop: '2009',
    name: 'NII Kosmicheskovo Priborostroeniya',
    Location: 'Moskva:Lefortovo',
    lat: 55.77,
    lon: 37.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIIM',
    StateC: 'SU',
    C: 'Unknown',
    TStart: '1981',
    TStop: '',
    name: 'NII Mashinostroeniya',
    Location: 'Nishnyaya Salda, Sverdlovsk Oblast',
    lat: 58.07,
    lon: 60.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIIKP',
    StateC: 'SU',
    C: 'Government',
    TStart: '1963',
    TStop: '1978',
    name: 'NII Priborostroeniya',
    Location: 'Moskva:Lefortovo',
    lat: 55.77,
    lon: 37.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIIPP',
    StateC: 'SU',
    C: 'Government',
    TStart: '1986',
    TStop: '',
    name: 'Nauchno-Issledovatelskiy Institut Pretsizionnogo Priborostroyeniya',
    Location: 'Mosvka',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKB30',
    StateC: 'SU',
    C: 'Military',
    TStart: '1975',
    TStop: '',
    name: 'NII RadioPriborostroeniya',
    Location: 'Mosvka:Sokol',
    lat: 55.8,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RNII',
    StateC: 'SU',
    C: 'Government',
    TStart: '1965',
    TStop: '1992',
    name: 'NII Thermal Processes (Keldysh)',
    Location: 'Moskva:Khovrino',
    lat: 55.87,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1964 Feb 1',
    TStop: '1967',
    name: 'NIKE-X Project Office',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Dec',
    TStop: '1964 Feb 1',
    name: 'Nike-Zeus Project Office',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USAMC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIKUS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1946',
    TStop: '',
    name: 'Nikon USA',
    Location: 'Melville, New York',
    lat: 40.79,
    lon: -73.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NILE',
    StateC: 'EG',
    C: 'Government',
    TStart: '1996 Jul',
    TStop: '',
    name: 'Nilesat Inc',
    Location: 'El Sadis Min Uktober (6th of October City)',
    lat: 29.94,
    lon: 30.91,
    alt: 0,
    Parent: 'ERTU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIMHB',
    StateC: 'BG',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Natsionalen institut po meteorologia i khidrologia (Akhtopol)',
    Location: 'Akhtopol',
    lat: 42.1,
    lon: 27.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NINGX',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Ningxia Jingui xinxi jishu YG',
    Location: 'Zhongwei, Ningxia',
    lat: 37.51,
    lon: 105.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIPR',
    StateC: 'J',
    C: 'Government',
    TStart: '1973 Sep 29',
    TStop: '',
    name: 'Kokuritsu kyokuchi kenkyuusho',
    Location: 'Tokyo:Itabashi',
    lat: 35.77,
    lon: 139.68,
    alt: 0,
    Parent: 'MONBU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIRFI',
    StateC: 'SU',
    C: 'Government',
    TStart: '1956',
    TStop: '1977',
    name: 'Nauchno-issledovatel\'skiy Radiofisicheskiy Institut',
    Location: 'Gorky (Nizhniy Novgorod)',
    lat: 56.33,
    lon: 44.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NISCA',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'North Idaho STEM Charter Academy',
    Location: 'Rathdrum, Idaho',
    lat: 47.81,
    lon: -116.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUSEI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1966',
    TStop: '2000 Jun',
    name: 'Nissan Motor Co Ltd',
    Location: 'Tokyo:Suginami (Ogikubo)',
    lat: 35.68,
    lon: 139.62,
    alt: 0,
    Parent: 'NISSY',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NISST',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1998 Apr',
    TStop: '2000 Jun',
    name: 'Nissan (Solid propulsion plant)',
    Location: 'Tomioka, Gunma',
    lat: 36.26,
    lon: 138.89,
    alt: 0,
    Parent: 'NISSY',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NISSY',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1949',
    TStop: '',
    name: 'Nissan',
    Location: 'Yokohama',
    lat: 35.44,
    lon: 139.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NBS',
    StateC: 'US',
    C: 'Government',
    TStart: '1988',
    TStop: '',
    name: 'National Institute of Standards and Technology',
    Location: 'Gaithersburg, Maryland',
    lat: 39.13,
    lon: -77.23,
    alt: 0,
    Parent: 'DOC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIUTN',
    StateC: 'IN',
    C: 'Academic',
    TStart: '2004',
    TStop: '',
    name: 'Noorul Islam University, Kanyakumari, Tiruvannamalai',
    Location: 'Tiruvannamalai, Tamil Nadu',
    lat: 8.08,
    lon: 77.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIVR',
    StateC: 'NL',
    C: 'Government',
    TStart: '',
    TStop: '2009',
    name: 'Nederlands Instituut voor Vliegtuigontwikkeling en Ruimtevaart',
    Location: 'Delft',
    lat: 52.01,
    lon: 4.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NJU',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1902',
    TStop: '',
    name: 'Nanjing Daxue',
    Location: 'Nanjing, Jiangsu',
    lat: 32.03,
    lon: 118.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NJUST',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1953',
    TStop: '',
    name: 'Nanjing Ligong Daxue (Nanligong)',
    Location: 'Nanjing, Jiangsu',
    lat: 32.03,
    lon: 118.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NKAU',
    StateC: 'UA',
    C: 'Government',
    TStart: '1992',
    TStop: '2011',
    name: 'Natsionalnie Kosmichne Agentstvo Ukrayni',
    Location: 'Kyiv, Ukraine',
    lat: 50.45,
    lon: 30.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NKE',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1994 Jan',
    TStop: '1996 Jan',
    name: 'AO STNK Dvigateli NK',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MVS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1934',
    TStop: '1946 Mar',
    name: 'Narodniy Kommosariat Oborony SSSR',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NLR',
    StateC: 'NL',
    C: 'Unknown',
    TStart: '1961',
    TStop: '',
    name: 'Nationaal Lucht-en Ruimtevaartlaboratorium (National Aerospace Lab)',
    Location: 'Amsterdam',
    lat: 52.37,
    lon: 4.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAMTC',
    StateC: 'US',
    C: 'Military',
    TStart: '1959 Jan 7',
    TStop: '1975 Apr 26',
    name: 'US Naval Missile Center',
    Location: 'Pt Mugu. California',
    lat: 34.12,
    lon: -119.12,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NMCOL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1889',
    TStop: '1960',
    name: 'New Mexico College',
    Location: 'Las Cruces, New Mexico',
    lat: 32.28,
    lon: -106.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NMIC',
    StateC: 'UK',
    C: 'Government',
    TStart: '2010',
    TStop: '',
    name: 'National Maritime Information Centre',
    Location: 'Portsmouth, Hampshire',
    lat: 50.86,
    lon: -1.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NMIT',
    StateC: 'IN',
    C: 'Academic',
    TStart: '2001',
    TStop: '',
    name: 'Nitte Meenakshi Institute of Technology',
    Location: 'Bengaluru (Bangalore:Govindapura)',
    lat: 13.13,
    lon: 77.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSSA',
    StateC: 'US',
    C: 'Military',
    TStart: '1964',
    TStop: '1968',
    name: 'USN Manned Orbiting Laboratory Field Office',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NMSA',
    StateC: 'AR',
    C: 'Government',
    TStart: '1932',
    TStop: '',
    name: 'Servicio Meteorologico Nacional Argentino',
    Location: 'La Rioja/Buenos Aires',
    lat: -29.41,
    lon: -66.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NMSPA',
    StateC: 'US',
    C: 'Government',
    TStart: '2005',
    TStop: '',
    name: 'New Mexico Spaceport Authority',
    Location: 'Las Cruces, New Mexico',
    lat: 32.28,
    lon: -106.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NMCOL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'New Mexico State University',
    Location: 'Las Cruces, New Mexico',
    lat: 32.28,
    lon: -106.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NMTECH',
    StateC: 'US',
    C: 'Academic',
    TStart: '1889',
    TStop: '',
    name: 'New Mexico Institute of Mining and Technology',
    Location: 'Socorro, New Mexico',
    lat: 34.07,
    lon: -106.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESSA',
    StateC: 'US',
    C: 'Government',
    TStart: '1970 Oct 3',
    TStop: '',
    name: 'National Oceanic and Atmospheric Administration',
    Location: 'Suitland, Maryland',
    lat: 38.85,
    lon: -76.92,
    alt: 0,
    Parent: 'DOC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOBY',
    StateC: 'J',
    C: 'Academic',
    TStart: '1978',
    TStop: '',
    name: 'Nobeyama Radio Observatory',
    Location: 'Nobeyama',
    lat: 35.94,
    lon: 138.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOL',
    StateC: 'US',
    C: 'Military',
    TStart: '1929',
    TStop: '1993',
    name: 'Naval Ordnance Lab',
    Location: 'White Oak, Maryland',
    lat: 39.04,
    lon: -76.99,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NONAN',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2009',
    TStop: '2015',
    name: 'NovaNano',
    Location: 'Lyon/Saint-Didier',
    lat: 45.81,
    lon: 4.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1954 Oct 1',
    TStop: '1970',
    name: 'Nord Aviation',
    Location: 'Bourges, Cher',
    lat: 47.08,
    lon: 2.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1921',
    TStop: '1954 Oct 1',
    name: 'Societe Nationale de Constructions Aeronautiques du Nord',
    Location: 'Bourges, Cher',
    lat: 47.08,
    lon: 2.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORLM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1921',
    TStop: '1970',
    name: 'Nord Aviation',
    Location: 'Paris:Les Mureaux, Yvelines',
    lat: 48.99,
    lon: 1.92,
    alt: 0,
    Parent: 'NORD',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORSM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1970',
    name: 'Nord Aviation/St-Medard',
    Location: 'St-Medard-en-Jalles',
    lat: 44.9,
    lon: -0.72,
    alt: 0,
    Parent: 'SAFRAN',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORTH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1939',
    TStop: '1962 Jul',
    name: 'Northrop Corporation',
    Location: 'Hawthorne, California',
    lat: 33.92,
    lon: -118.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMCEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1965',
    TStop: '1971',
    name: 'Northrop Carolina, Chemtronics Site',
    Location: 'Asheville:Swannanoa, North Carolina',
    lat: 35.6,
    lon: -82.39,
    alt: 0,
    Parent: 'NORTH',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NORTH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962 Jul',
    TStop: '2002 Jul',
    name: 'Northrop Space Laboratories, Northrop Corp.',
    Location: 'Hawthorne, California',
    lat: 33.92,
    lon: -118.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOTS',
    StateC: 'US',
    C: 'Military',
    TStart: '1943',
    TStop: '1967',
    name: 'Naval Ordnance Test Station',
    Location: 'China Lake, California',
    lat: 35.69,
    lon: -117.69,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOTT',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1881',
    TStop: '',
    name: 'University of Nottingham',
    Location: 'Nottingham',
    lat: 52.94,
    lon: -1.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOVSU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1958',
    TStop: '',
    name: 'Novosibirskiy gosudarstvenniy universitet',
    Location: 'Novosibirsk',
    lat: 54.85,
    lon: 83.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOVTR',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1947',
    TStop: '',
    name: 'OKB Novator',
    Location: 'Yekaterinburg (Sverdlovsk)',
    lat: 56.83,
    lon: 60.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPL',
    StateC: 'IN',
    C: 'Government',
    TStart: '1947',
    TStop: '',
    name: 'National Physical Lab',
    Location: 'New Delhi',
    lat: 28.61,
    lon: 77.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB1',
    StateC: 'SU',
    C: 'Government',
    TStart: '1974 Jul',
    TStop: '1994',
    name: 'NPO Energiya',
    Location: 'Korolev:Podlipki, Moskva, Rossiya',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPOL',
    StateC: 'RU',
    C: 'Government',
    TStart: '1965',
    TStop: '2014 Mar',
    name: 'NPO Lavochkin',
    Location: 'Moskva:Khimki',
    lat: 55.9,
    lon: 37.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPOL',
    StateC: 'RU',
    C: 'Government',
    TStart: '2014 Mar',
    TStop: '',
    name: 'NPO Lavochkin, fil. ORKK',
    Location: 'Moskva:Khimki',
    lat: 55.9,
    lon: 37.45,
    alt: 0,
    Parent: 'ORKK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB52',
    StateC: 'SU',
    C: 'Military',
    TStart: '1983',
    TStop: '2014 Mar',
    name: 'NPO Mashinostroenie',
    Location: 'Moskva:Reutov',
    lat: 55.75,
    lon: 37.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB52',
    StateC: 'SU',
    C: 'Military',
    TStart: '2014 Mar',
    TStop: '',
    name: 'NPO Mashinostroenie, fil. ORKK',
    Location: 'Moskva:Reutov',
    lat: 55.75,
    lon: 37.87,
    alt: 0,
    Parent: 'ORKK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPOPM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1977',
    TStop: '1994',
    name: 'NPO Prikladnoi Mekhaniki',
    Location: 'Zheleznogorsk (Krasnoyarsk-26)',
    lat: 56.25,
    lon: 93.53,
    alt: 0,
    Parent: 'MOM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPOPM',
    StateC: 'RU',
    C: 'Government',
    TStart: '1994',
    TStop: '2006',
    name: 'NPO Prikladnoi Mekhaniki',
    Location: 'Zheleznogorsk (Krasnoyarsk-26)',
    lat: 56.25,
    lon: 93.53,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NKE',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1981',
    TStop: '1994 Jan',
    name: 'NPO Trud',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NRCC',
    StateC: 'CA',
    C: 'Government',
    TStart: '1932',
    TStop: '',
    name: 'National Research Council',
    Location: 'Ottawa',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NRL',
    StateC: 'US',
    C: 'Military',
    TStart: '1923',
    TStop: '',
    name: 'Naval Research Lab',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NRLC',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '1992 Dec 31',
    name: 'NRO Program C, NRL',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NRO',
    StateC: 'US',
    C: 'Military',
    TStart: '1960 Aug 25',
    TStop: '1994',
    name: 'National Reconnaissance Office',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NRO',
    StateC: 'US',
    C: 'Military',
    TStart: '1994',
    TStop: '',
    name: 'National Reconnaissance Office',
    Location: 'Chantilly, Virginia',
    lat: 38.88,
    lon: -77.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NROD',
    StateC: 'US',
    C: 'Military',
    TStart: '1960',
    TStop: '1992',
    name: 'NRO Program D, Headquarters USAF',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: 'NRO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSA',
    StateC: 'US',
    C: 'Military',
    TStart: '1952 Nov 4',
    TStop: '',
    name: 'National Security Agency',
    Location: 'Ft. Meade, Maryland',
    lat: 39.11,
    lon: -76.74,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '1982',
    TStop: '2005 Dec 1',
    name: 'Nordiska Satellite AB',
    Location: 'Stockholm:Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSC',
    StateC: 'N',
    C: 'Government',
    TStart: '1987',
    TStop: '',
    name: 'Norsk Romsenter',
    Location: 'Oslo',
    lat: 59.92,
    lon: 10.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NASDA',
    StateC: 'J',
    C: 'Government',
    TStart: '1964 Jun',
    TStop: '1969 Oct',
    name: 'National Space Development Center, STA',
    Location: 'Tokyo, Nippon',
    lat: 35.69,
    lon: 139.68,
    alt: 0,
    Parent: 'STA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSF',
    StateC: 'US',
    C: 'Government',
    TStart: '1950 May',
    TStop: '',
    name: 'National Science Foundation',
    Location: 'Washington, DC:Arlington',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSIL',
    StateC: 'IN',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'New Space India Ltd.',
    Location: 'Bengaluru',
    lat: 12.98,
    lon: 77.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'NearSpaceLaunch',
    Location: 'Upland, Indiana',
    lat: 40.47,
    lon: -85.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSLC',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'NSLComm',
    Location: 'Tel-Aviv:Airport City',
    lat: 31.99,
    lon: 34.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSMC',
    StateC: 'CN',
    C: 'Government',
    TStart: '1971',
    TStop: '',
    name: 'guojia weixing qixiang zhongxin',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'CMA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIVR',
    StateC: 'NL',
    C: 'Government',
    TStart: '2009',
    TStop: '',
    name: 'Netherlands Space Office',
    Location: 'Den Haag',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSPO',
    StateC: 'TW',
    C: 'Government',
    TStart: '2005 Apr',
    TStop: '',
    name: 'Guojia Taikong Zhongxin',
    Location: 'Taipei:HsinChu, Taiwan',
    lat: 24.82,
    lon: 120.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSPO',
    StateC: 'TW',
    C: 'Government',
    TStart: '1991 Oct',
    TStop: '2005 Apr',
    name: 'Taikong Jihua Shi',
    Location: 'Taipei:HsinChu, Taiwan',
    lat: 24.82,
    lon: 120.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSRDA',
    StateC: 'NG',
    C: 'Government',
    TStart: '1998',
    TStop: '',
    name: 'National Space Research Development Agency, Nigeria',
    Location: 'Abuju:Garki, Nigeria',
    lat: 9.07,
    lon: 7.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSROC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '',
    name: 'NASA Sounding Rocket Operations Contract',
    Location: 'Wallops Island, Virginia',
    lat: 37.84,
    lon: -75.49,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1998 Oct',
    TStop: '2006 Sep',
    name: 'New Skies Satellites N.V.',
    Location: '\'s:Gravenhage',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSSA',
    StateC: 'US',
    C: 'Military',
    TStart: '1968',
    TStop: '',
    name: 'USN Navy Space Systems Activity (NSSA, NAVSPASYSACT)',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSWCPH',
    StateC: 'US',
    C: 'Military',
    TStart: '1963',
    TStop: '',
    name: 'Naval Surface Warfare Center Port Hueneme',
    Location: 'Port Hueneme, California',
    lat: 34.16,
    lon: -119.19,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSWCWS',
    StateC: 'US',
    C: 'Military',
    TStart: '1963',
    TStop: '',
    name: 'Naval Surface Warfare Center Port Hueneme, White Sands Det.',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTNF',
    StateC: 'N',
    C: 'Government',
    TStart: '1946',
    TStop: '1993 Jan 1',
    name: 'Norges Teknisk-Naturvitenskapelige Forskningsrad',
    Location: 'Oslo',
    lat: 59.92,
    lon: 10.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTNU',
    StateC: 'N',
    C: 'Government',
    TStart: '1996',
    TStop: '*',
    name: 'Norges teknisk-naturvitenskapelige universitet',
    Location: 'Trondheim',
    lat: 63.42,
    lon: 10.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTOU',
    StateC: 'TW',
    C: 'Academic',
    TStart: '1953',
    TStop: '',
    name: 'Guoli Taiwan Haiyang Daxue',
    Location: 'Zhongzheng, Keelung',
    lat: 25.15,
    lon: 121.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTSOMZ',
    StateC: 'RU',
    C: 'Government',
    TStart: '1999',
    TStop: '',
    name: 'Nauchniy Tsentr Operativnovo Monitoringa Zemli',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1985',
    TStop: '*',
    name: 'Nippon Denshin Denwa Kabushiki-gaisha (NTT)',
    Location: 'Chiyoda-ku, Tokyo',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1953',
    TStop: '1985',
    name: 'Nippon Denshin Denwa Kosha (NTT)',
    Location: 'Chiyoda-ku, Tokyo',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: 'NTT',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTTDM',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1992 Jul',
    TStop: '',
    name: 'NTT DoMoCo',
    Location: 'Nagata-cho, Chiyoda-ku, Tokyo',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: 'NTT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NTU',
    StateC: 'SG',
    C: 'Academic',
    TStart: '1991',
    TStop: '',
    name: 'Nanyang Technological University',
    Location: 'Singapore',
    lat: 1.34,
    lon: 103.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NUAA',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1952',
    TStop: '',
    name: 'Nanjing Hangkong Hangtian Daxue',
    Location: 'Nanjing, Jiangsu',
    lat: 32.04,
    lon: 118.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NUDTC',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1970',
    TStop: '',
    name: 'Guofang Keji Daxue Yan',
    Location: 'Changsha, Hunan',
    lat: 28.23,
    lon: 112.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NUM',
    StateC: 'MN',
    C: 'Academic',
    TStart: '1942',
    TStop: '',
    name: 'Mongol Ulsyn Ikh Surguuli',
    Location: 'Ulaanbaatar',
    lat: 47.92,
    lon: 106.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NUS',
    StateC: 'SG',
    C: 'Academic',
    TStart: '1980',
    TStop: '',
    name: 'National University of Singapore',
    Location: 'Singapore:Kent Ridge',
    lat: 1.3,
    lon: 103.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NUSC',
    StateC: 'US',
    C: 'Military',
    TStart: '1945',
    TStop: '',
    name: 'Naval Underwater Systems Center',
    Location: 'New London, Connecticut',
    lat: 41.36,
    lon: -72.1,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NUSS',
    StateC: 'J',
    C: 'Government',
    TStart: '2012',
    TStop: '',
    name: 'Naikaku-fu uchu senryaku-shitsu',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NVART',
    StateC: 'US',
    C: 'Academic',
    TStart: '1931',
    TStop: '',
    name: 'Nevada Museum of Art',
    Location: 'Reno, Nevada',
    lat: 39.53,
    lon: -119.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NOTS',
    StateC: 'US',
    C: 'Military',
    TStart: '1967',
    TStop: '1992 Jan',
    name: 'Naval Weapons Center',
    Location: 'China Lake, California',
    lat: 35.69,
    lon: -117.69,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NWNAZ',
    StateC: 'US',
    C: 'Academic',
    TStart: '1913',
    TStop: '',
    name: 'Northwest Nazarene University',
    Location: 'Nampa, Idaho',
    lat: 43.56,
    lon: -116.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZWO',
    StateC: 'NL',
    C: 'Government',
    TStart: '1988',
    TStop: '',
    name: 'Nederlandse Organisatie voor Wetenschappelijk Onderzoek',
    Location: '\'s:Gravenhage',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NWPU',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1938',
    TStop: '',
    name: 'Xibei Gongye Daxue',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.24,
    lon: 108.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NWU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1851',
    TStop: '',
    name: 'Northwestern University',
    Location: 'Evanston, Illinois',
    lat: 42.05,
    lon: -87.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NWURKS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'NovaWurks',
    Location: 'Los Alamitos, California',
    lat: 33.8,
    lon: -118.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NYBB2',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'New York Broadband II',
    Location: 'New York, New York',
    lat: 40.71,
    lon: -74.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NYSH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014 Aug',
    TStop: '2016 Apr',
    name: 'New York Satellite Holdings LLC',
    Location: 'New York:Queens, New York',
    lat: 40.75,
    lon: -73.87,
    alt: 0,
    Parent: 'NYBB2',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NYU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1831',
    TStop: '',
    name: 'New York University',
    Location: 'New York, New York',
    lat: 40.73,
    lon: -74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'O3B',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2007',
    TStop: '2017 May',
    name: 'O3B Networks Ltd.',
    Location: 'St John, Jersey, Channel Islands',
    lat: 49.24,
    lon: -2.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'O3B',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2017 May',
    TStop: '',
    name: 'SES O3B Networks Ltd.',
    Location: 'St John, Jersey, Channel Islands',
    lat: 49.24,
    lon: -2.13,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OAKAE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Jul',
    TStop: '',
    name: 'Oakman Aerospace Inc.',
    Location: 'Littleton, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OAR',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Apr 1',
    TStop: '1970 Jul 1',
    name: 'US Air Force Office of Aerospace Research',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OATK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK',
    Location: 'Washington:Dulles, Virginia',
    lat: 39.01,
    lon: -77.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK DSG Missile Products (Rocket Center, WV)',
    Location: 'Cumberland:Rocket Center, West Virginia',
    lat: 39.56,
    lon: -78.83,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATKB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'OATK Defense Systems Group / Missile Products',
    Location: 'Baltimore, Maryland',
    lat: 39.28,
    lon: -76.62,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK Flight Systems Group (FSG)',
    Location: 'Phoenix:Chandler, Arizona',
    lat: 33.3,
    lon: -111.83,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK Space Systems Group (SSG)',
    Location: 'Washington:Dulles, Virginia',
    lat: 38.95,
    lon: -77.45,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'OATK DSG Missile Products (Elkton)',
    Location: 'Elkton, Maryland',
    lat: 39.61,
    lon: -75.83,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GASL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK DSG Missile Products (Ronkonkoma)',
    Location: 'Ronkonkoma, New York',
    lat: 40.18,
    lon: -73.13,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK Civil Sats. and Nat. Security Systems',
    Location: 'Gilbert, Arizona',
    lat: 33.35,
    lon: -111.79,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AECAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK Space Components (Goleta)',
    Location: 'Goleta, California',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HERC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'OATK / ATK Aerospace Group Headquarters',
    Location: 'Salt Lake City:West Valley City (Magna), Utah',
    lat: 40.69,
    lon: -111.99,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'OATK FSG Test Services (Promontory)',
    Location: 'Brigham City:Promontory, Utah',
    lat: 41.62,
    lon: -112.55,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWALES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'Orbital ATK Space Systems (Beltsville)',
    Location: 'Beltsville, Maryland',
    lat: 39.04,
    lon: -76.92,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSCW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Feb 10',
    TStop: '2018 Jun 7',
    name: 'OATK Launch Systems (Wallops)',
    Location: 'Wallops Island, Virginia',
    lat: 37.83,
    lon: -75.48,
    alt: 0,
    Parent: 'OATK',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'POL',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1965',
    TStop: '1990',
    name: 'KB Omsk Aviatsionniy Zavod',
    Location: 'Omsk',
    lat: 54.98,
    lon: 73.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OCO',
    StateC: 'US',
    C: 'Military',
    TStart: '1832',
    TStop: '1962',
    name: 'Office of the Chief of Ordnance',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OCOS',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Open Cosmos Ltd.',
    Location: 'Didcot, Oxfordshire',
    lat: 51.61,
    lon: -1.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ODU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1930',
    TStop: '',
    name: 'Old Dominion University',
    Location: 'Norfolk, Virginia',
    lat: 36.89,
    lon: -76.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONTR',
    StateC: 'CH',
    C: 'Commercial',
    TStart: '2007',
    TStop: '2009 Jul',
    name: 'Oerlikon Space',
    Location: 'Zurich',
    lat: 47.37,
    lon: 8.55,
    alt: 0,
    Parent: 'CONTR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OFAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Orbit Fab',
    Location: 'San Francisco',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OFO',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'Xiaohuang che',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OFX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Orbital Effects',
    Location: 'Ann Arbor, Michigan',
    lat: 42.28,
    lon: -83.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OHB',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1985',
    TStop: '',
    name: 'OHB (Orbital Hochtechnologie Bremen System GmbH)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.8,
    alt: 0,
    Parent: 'FUCHS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSCS',
    StateC: 'S',
    C: 'Commercial',
    TStart: '2011 Jul',
    TStop: '',
    name: 'OHB Sweden AB',
    Location: 'Stockholm:Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: 'OHB',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CGS',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'OHB-I (Compagnia Generale per lo Spazio)',
    Location: 'Milano',
    lat: 45.47,
    lon: 9.18,
    alt: 0,
    Parent: 'OHB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OHIOU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1804',
    TStop: '',
    name: 'Ohio University',
    Location: 'Athens, Ohio',
    lat: 39.32,
    lon: -82.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OIT',
    StateC: 'J',
    C: 'Academic',
    TStart: '1922',
    TStop: '',
    name: 'Osaka kogyo daigaku',
    Location: 'Osaka City/Asahi',
    lat: 34.73,
    lon: 135.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB1',
    StateC: 'SU',
    C: 'Government',
    TStart: '1946',
    TStop: '1966 Mar 6',
    name: 'OKB-1 im. S.P. Korolev',
    Location: 'Korolev:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPOPM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1959 Jun 4',
    TStop: '1961 Dec',
    name: 'OKB-1 Filial No. 2',
    Location: 'Zheleznogorsk (Krasnoyarsk-26)',
    lat: 56.25,
    lon: 93.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSSKB',
    StateC: 'SU',
    C: 'Government',
    TStart: '1959 Jul 23',
    TStop: '1967',
    name: 'OKB-1 Filial No. 3',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPOPM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1961 Dec',
    TStop: '1977',
    name: 'OKB-10 (Reshetnev)',
    Location: 'Zheleznogorsk (Krasnoyarsk-26)',
    lat: 56.25,
    lon: 93.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAZSOY',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1953',
    TStop: '1978',
    name: 'Kazan OKB-16 (Zubets)',
    Location: 'Kazan, Tartarstan',
    lat: 55.8,
    lon: 49.11,
    alt: 0,
    Parent: 'NKE',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB117',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1942',
    TStop: '1965',
    name: 'OKB-117 (Klimov/Izotov)',
    Location: 'Sankt-Peterburg (Leningrad)',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KBKHA',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1957',
    TStop: '1967',
    name: 'OKB-154 (Kosberg)',
    Location: 'Voronezh',
    lat: 51.67,
    lon: 39.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ISAEV',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1952',
    TStop: '1966',
    name: 'OKB-2 (Isaev)',
    Location: 'Moskva:Korolev (Podlipki)',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB23',
    StateC: 'SU',
    C: 'Military',
    TStart: '1951 Mar',
    TStop: '1960',
    name: 'OKB-23 (Myasishchev)',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NKE',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1946 Apr',
    TStop: '1981',
    name: 'OKBS-276 (N.D. Kuznetsov)',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EMASH',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1946 Jul 3',
    TStop: '1967',
    name: 'OKB-456 (Glushko)',
    Location: 'Moskva:Khimki',
    lat: 55.9,
    lon: 37.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB52',
    StateC: 'SU',
    C: 'Military',
    TStart: '1954',
    TStop: '1966',
    name: 'OKB-52 (Chelomey)',
    Location: 'Moskva:Reutov',
    lat: 55.75,
    lon: 37.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB23',
    StateC: 'SU',
    C: 'Military',
    TStart: '1960',
    TStop: '1981',
    name: 'OKB-52 Fil. 1 (Chelomey)',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YUZH',
    StateC: 'SU',
    C: 'Military',
    TStart: '1954',
    TStop: '1965',
    name: 'OKB-586 (KB M. K. Yangel)',
    Location: 'Dnepropetrovsk',
    lat: 48.45,
    lon: 34.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'POL',
    StateC: 'SU',
    C: 'Military',
    TStart: '1961',
    TStop: '1965',
    name: 'OKB-586 Filial No. 1',
    Location: 'Omsk',
    lat: 54.98,
    lon: 73.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB9',
    StateC: 'SU',
    C: 'Military',
    TStart: '1942',
    TStop: '1970',
    name: 'OKB-9 (V.F. Petrov) of Uralmashzavod',
    Location: 'Sverdlovsk (Ekaterinburg)',
    lat: 56.83,
    lon: 60.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KBKHA',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1946 Apr',
    TStop: '1957',
    name: 'OKB zavoda N154',
    Location: 'Voronezh',
    lat: 51.67,
    lon: 39.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1890',
    TStop: '',
    name: 'Oklahoma State University',
    Location: 'Stillwater, Oklahoma',
    lat: 36.12,
    lon: -97.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '1997',
    name: 'Olin Aerospace',
    Location: 'Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ABMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1954 Jan',
    TStop: '1956 Feb',
    name: 'Redstone Arsenal, Ordnance Missle Lab, Guided Missle Div',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'ORDRSA',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OMNIE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014 May',
    TStop: '',
    name: 'OmniEarth LLC',
    Location: 'Arlington, Virginia',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OMNISP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'OmniSpace LLC',
    Location: 'Tysons Corner, Virginia',
    lat: 38.92,
    lon: -77.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OMS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Orbital Micro Systems',
    Location: 'Boulder, Colorado',
    lat: 40.02,
    lon: -105.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OMSUK',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Orbital Micro Systems UK',
    Location: 'Harwell, Oxfordshire',
    lat: 51.58,
    lon: -1.31,
    alt: 0,
    Parent: 'OMS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSTC',
    StateC: 'US',
    C: 'Military',
    TStart: '1994 Jan',
    TStop: '2014 Apr',
    name: 'US Air Force Satellite Control Facility, Onizuka AFS',
    Location: 'Sunnyvale, California',
    lat: 37.4049,
    lon: -122.0288,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONDAS',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Ondas Media',
    Location: 'Madrid, Espana',
    lat: 40.38,
    lon: -3.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONERA',
    StateC: 'F',
    C: 'Military',
    TStart: '1946',
    TStop: '',
    name: 'Office National d\'Etudes et de Recherches Aerospatiales',
    Location: 'Paris:Chatillon ()',
    lat: 48.8,
    lon: 2.29,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONEWEB',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'One Web',
    Location: 'London:Westminster',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONEWUS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'One Web (Florida)',
    Location: 'Cape Canaveral, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONI',
    StateC: 'AU',
    C: 'Military',
    TStart: '2018 Dec',
    TStop: '',
    name: 'Office of National Intelligence',
    Location: 'Canberra',
    lat: -35.29,
    lon: 149.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAVMAT',
    StateC: 'US',
    C: 'Military',
    TStart: '1942 Jan',
    TStop: '1966 May 1',
    name: 'Office of Naval Material, US Navy',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONR',
    StateC: 'US',
    C: 'Military',
    TStart: '1946',
    TStop: '',
    name: 'Office of Naval Research',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONRS',
    StateC: 'US',
    C: 'Academic',
    TStart: '1970',
    TStop: '1988',
    name: 'Office Of Naval Research, Scripps Inst. of Oceanography',
    Location: 'San Diego:La Jolla, California',
    lat: 32.85,
    lon: -117.28,
    alt: 0,
    Parent: 'ONR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONUSJ',
    StateC: 'AR',
    C: 'Academic',
    TStart: '1947',
    TStop: '1973',
    name: 'Universidad Nacional de Cuyo, Fac. of Engineering, San Juan',
    Location: 'Mendoza:San Juan',
    lat: -31.54,
    lon: -68.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OPM',
    StateC: 'F',
    C: 'Academic',
    TStart: '1874',
    TStop: '',
    name: 'Observatoire de Paris-Meudon',
    Location: 'Paris:Meudon',
    lat: 48.81,
    lon: 2.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OPNAV',
    StateC: 'US',
    C: 'Military',
    TStart: '1915',
    TStop: '',
    name: 'Office of the Chief of Naval Operations',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUSS',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '1992 Jan',
    TStop: '2001',
    name: 'Optus Communications Pty.',
    Location: 'Sydney',
    lat: -33.87,
    lon: 151.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OPTEV',
    StateC: 'US',
    C: 'Military',
    TStart: '1947 Dec',
    TStop: '1959 May',
    name: 'US Navy Operational Development Force',
    Location: 'Norfolk, Virginia',
    lat: 36.95,
    lon: -76.31,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OPTEV',
    StateC: 'US',
    C: 'Military',
    TStart: '1959 May',
    TStop: '',
    name: 'US Navy Operational Test and Evaluation Force',
    Location: 'Norfolk, Virginia',
    lat: 36.95,
    lon: -76.31,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AUSS',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'SingTel Optus Communications Pty',
    Location: 'Sydney',
    lat: -33.87,
    lon: 151.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OPU',
    StateC: 'J',
    C: 'Academic',
    TStart: '1883',
    TStop: '',
    name: 'Osaka furitsu daigaku (Fudai)',
    Location: 'Osaka:Sakai',
    lat: 34.55,
    lon: 135.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OQT',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'OQ Technology',
    Location: 'Wasserbilling, Luxembourg',
    lat: 49.71,
    lon: 6.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OQTR',
    StateC: 'RW',
    C: 'Commercial',
    TStart: '2021',
    TStop: '',
    name: 'OQ Technology (Kigali)',
    Location: 'Kigali',
    lat: -1.94,
    lon: 30.06,
    alt: 0,
    Parent: 'OQT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FTEL',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2013 Jul',
    TStop: '',
    name: 'Orange S.A.',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993',
    TStop: '',
    name: 'Orbcomm Inc.',
    Location: 'New York:Fort Lee, New Jersey',
    lat: 40.85,
    lon: -73.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1992',
    TStop: '2006 Jan',
    name: 'Orbimage Inc (Orbital Imaging Corp)',
    Location: 'Washington:Dulles, Virginia',
    lat: 39.01,
    lon: -77.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBSK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Orbital Sidekick',
    Location: 'San Francisco',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBSKW',
    StateC: 'KW',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Orbital Space (Kuwait)',
    Location: 'Kuwait City',
    lat: 29.37,
    lon: 47.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBSP',
    StateC: 'UAE',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'Orbital Space (Dubai)',
    Location: 'Dubai',
    lat: 25.26,
    lon: 55.3,
    alt: 0,
    Parent: 'ORBSKW',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBTEC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1988',
    TStop: '',
    name: 'Orbitec (Orbital Technologies Corporation)',
    Location: 'Madison, Wisconsin',
    lat: 43.07,
    lon: -89.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZAV47',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1961 Oct 15',
    TStop: '1986 Apr 7',
    name: 'Orenburgskiy Mashinostroitelniy Zavod',
    Location: 'Orenburg',
    lat: 51.78,
    lon: 55.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORL',
    StateC: 'F',
    C: 'Academic',
    TStart: '1230',
    TStop: '',
    name: 'Universite\' d\'Orleans',
    Location: 'Orleans',
    lat: 47.85,
    lon: 1.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORD',
    StateC: 'US',
    C: 'Military',
    TStart: '1944',
    TStop: '1949 Oct',
    name: 'US Army Ordnance Dept. HQ, White Sands Proving Ground',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'OCO',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1950',
    TStop: '1958 Mar 31',
    name: 'US Army Ordnance, Redstone Arsenal Ordnance Missile Lab',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'OCO',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '1998 Mar',
    name: 'Orion Satellite Corp.',
    Location: 'Rockville, Maryland',
    lat: 39.08,
    lon: -77.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORIAS',
    StateC: 'F',
    C: 'Academic',
    TStart: '1960',
    TStop: '*',
    name: 'Institut d\'Astrophysique Spatiale (IAS), Uni. Paris XI',
    Location: 'Paris:Orsay, Essonne',
    lat: 48.7,
    lon: 2.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORKK',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2014 Mar 4',
    TStop: '2016 Jan 1',
    name: 'Ob\'edinennoy Raketno-Kosmicheskoy Korporatsii',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSAKA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1931',
    TStop: '',
    name: 'Osaka daigaku (Handai)',
    Location: 'Osaka',
    lat: 34.82,
    lon: 135.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '1993',
    name: 'Orbital Sciences Corp.',
    Location: 'Fairfax, Virginia',
    lat: 38.85,
    lon: -77.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSCAR',
    StateC: 'US',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Project OSCAR Inc.',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1988',
    TStop: '2015 Feb 10',
    name: 'Orbital Sciences Corp./Chandler',
    Location: 'Phoenix:Chandler, Arizona',
    lat: 33.3,
    lon: -111.83,
    alt: 0,
    Parent: 'OSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993',
    TStop: '2015 Feb 10',
    name: 'Orbital Sciences Corp.',
    Location: 'Washington:Dulles, Virginia',
    lat: 39.01,
    lon: -77.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FAIR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '2000',
    name: 'OSC Germantown',
    Location: 'Germantown, Maryland',
    lat: 39.18,
    lon: -77.27,
    alt: 0,
    Parent: 'OSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010 Apr',
    TStop: '2015 Feb 10',
    name: 'Orbital Sciences Corp./Gilbert',
    Location: 'Gilbert, Arizona',
    lat: 33.35,
    lon: -111.79,
    alt: 0,
    Parent: 'OSC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2000',
    name: 'OSC McLean',
    Location: 'Washington:McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: 'OSC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '1986',
    name: 'Orbital Sciences Corp.',
    Location: 'Vienna, Virginia',
    lat: 38.9,
    lon: -77.27,
    alt: 0,
    Parent: 'OSC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSCW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '2015 Feb 10',
    name: 'Orbital Sciences HIF, Mid-Atlantic Regional Spaceport',
    Location: 'Wallops Island, Virginia',
    lat: 37.84,
    lon: -75.49,
    alt: 0,
    Parent: 'OSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSLO',
    StateC: 'N',
    C: 'Academic',
    TStart: '1811',
    TStop: '',
    name: 'Universitetet i Oslo',
    Location: 'Oslo',
    lat: 59.94,
    lon: 10.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSM',
    StateC: 'MC',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Orbital Solutions Monaco',
    Location: 'Monaco: Fontvielle',
    lat: 43.73,
    lon: 7.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Open Space Network',
    Location: 'San Jose:Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSSI',
    StateC: 'KR',
    C: 'Academic',
    TStart: '2011',
    TStop: '',
    name: 'Open Source Satellite Initiative',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSSS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2002',
    name: 'One Stop Satellite Solutions (Weber CAST)',
    Location: 'Ogden, Utah',
    lat: 41.19,
    lon: -111.94,
    alt: 0,
    Parent: 'WEB',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1870',
    TStop: '',
    name: 'Ohio State University',
    Location: 'Columbus, Ohio',
    lat: 40,
    lon: -83.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OTEAM',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'OneTeam',
    Location: 'Tokyo',
    lat: 35.66,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OTR',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1975',
    TStop: '1980',
    name: 'Orbital Transport und Raketen AG, Stuttgart factory',
    Location: 'Stuttgart:Vaihingen, Baden-Wurttemberg',
    lat: 48.78,
    lon: 9.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OTR',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1980',
    TStop: '1987',
    name: 'Orbital Transport und Raketen AG, Garching factory',
    Location: 'Garching bei Munchen',
    lat: 48.25,
    lon: 11.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OVHO',
    StateC: 'S',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'OverHorizon AB',
    Location: 'Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OX',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1096',
    TStop: '',
    name: 'Oxford University',
    Location: 'Oxford',
    lat: 51.76,
    lon: -1.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PACSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '',
    name: 'Pacific Scientific Energetic Materials Co.',
    Location: 'Chandler, Arizona',
    lat: 33.3,
    lon: -111.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PAEC',
    StateC: 'PK',
    C: 'Military',
    TStart: '1955',
    TStop: '',
    name: 'Pakistan Atomic Energy Commission',
    Location: 'Islamabad',
    lat: 33.72,
    lon: 73.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PAI',
    StateC: 'PL',
    C: 'Government',
    TStart: '1926',
    TStop: '',
    name: 'Instytut Lotnictwa',
    Location: 'Warsawa',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PAN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2006 Jul',
    name: 'Panamsat Corp',
    Location: 'Greenwich/Wilton, Connecticut',
    lat: 41.2,
    lon: -73.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARA',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2015 Jan 1',
    name: 'Paradigm Secure Comms, Astrium Services',
    Location: 'Corsham, Wiltshire',
    lat: 51.43,
    lon: -2.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAHU',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '1992',
    TStop: '1994',
    name: 'Paracom SA',
    Location: 'Buenos Aires, Argentina',
    lat: -34.6,
    lon: -58.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARD',
    StateC: 'US',
    C: 'Government',
    TStart: '1945',
    TStop: '1959 May',
    name: 'NACA Pilotless Aircraft Research Division, Langley Aero. Lab.',
    Location: 'Wallops Island, Virginia',
    lat: 37.84,
    lon: -75.49,
    alt: 0,
    Parent: 'NACA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARIS',
    StateC: 'F',
    C: 'Academic',
    TStart: '1808',
    TStop: '1970',
    name: 'Universite de Paris-la Sorbonne, Faculte des Sciences',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARST',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'Parsons Corp./Torrance',
    Location: 'Torrance, California',
    lat: 33.83,
    lon: -118.34,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PASI',
    StateC: 'PH',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'Philippine Agila Satellite Inc.',
    Location: 'Manila',
    lat: 14.58,
    lon: 121,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PATRAS',
    StateC: 'GR',
    C: 'Academic',
    TStart: '1968',
    TStop: '',
    name: 'Panepistimio Patron',
    Location: 'Patras',
    lat: 38.25,
    lon: 21.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PAVKH',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Pavlograd Khimmash',
    Location: 'Pavlograd',
    lat: 48.52,
    lon: 35.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ICO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011 Jul',
    TStop: '',
    name: 'Pendrell Corp.',
    Location: 'Kirkland, Washington',
    lat: 47.69,
    lon: -122.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PEOSS',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USN Program Executive Office for Space Systems',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: 'SPAWAR',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PER',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '1974',
    TStop: '1991',
    name: 'PT Perusahaan Umum Telekomunikasi (PT Perumtel)',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PERC',
    StateC: 'J',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Chiba kogyo daigaku wakusei tansa senta (PERC)',
    Location: 'Narashino, Chiba',
    lat: 35.68,
    lon: 140.03,
    alt: 0,
    Parent: 'CHIBA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PERI',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Perigee Aerospace Inc',
    Location: 'Daejeon',
    lat: 36.37,
    lon: 127.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PERM',
    StateC: 'RU',
    C: 'Government',
    TStart: '1992',
    TStop: '1997',
    name: 'KB Perm Motorostroitel',
    Location: 'Perm\', Permskiy Krai',
    lat: 58,
    lon: 56.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PERM',
    StateC: 'RU',
    C: 'Government',
    TStart: '1997',
    TStop: '',
    name: 'KB Perm Motorostroitel',
    Location: 'Perm\', Permskiy Krai',
    lat: 58,
    lon: 56.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Military',
    TStart: '1977 Feb',
    TStop: '1984',
    name: 'Rocket Propulsion Establishment',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: 'MOD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PERVK',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1991',
    TStop: '',
    name: 'Perviy Kanal',
    Location: 'Moskva',
    lat: 55.82,
    lon: 37.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PESU',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1988',
    TStop: '',
    name: 'PES (People\'s Education Society) University',
    Location: 'Bengaluru, Karnataka',
    lat: 12.93,
    lon: 77.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PFAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Process Fab Inc',
    Location: 'Santa Fe Springs, California',
    lat: 33.94,
    lon: -118.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PFRR',
    StateC: 'US',
    C: 'Academic',
    TStart: '1968',
    TStop: '',
    name: 'Poker Flat Research Range',
    Location: 'Poker Flat, Fairbanks, Alaska',
    lat: 65.12,
    lon: -147.47,
    alt: 0,
    Parent: 'UAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PH4',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Phase Four, Inc.',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORNB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1966',
    TStop: '1975',
    name: 'Philco-Ford',
    Location: 'Newport Beach, California',
    lat: 33.62,
    lon: -117.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1966',
    TStop: '1975',
    name: 'Philco-Ford WDL',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'PHFO',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PHIL',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '1891',
    TStop: '',
    name: 'Phillips',
    Location: 'Eindhoven',
    lat: 51.43,
    lon: 5.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PHILR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1952 Aug 1',
    TStop: '1958',
    name: 'Phillips Petroleum, Rocket Fuels Division, Air Force Plant 66',
    Location: 'McGregor, Texas',
    lat: 31.43,
    lon: -97.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORNB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1966',
    name: 'Philco',
    Location: 'Newport Beach, California',
    lat: 33.62,
    lon: -117.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '1966',
    name: 'Philco WDL',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'PHLO',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PICA',
    StateC: 'US',
    C: 'Military',
    TStart: '1880',
    TStop: '',
    name: 'Picatinny Arsenal, USA ARSEC',
    Location: 'Dover:Lake Denmark, New Jersey',
    lat: 40.96,
    lon: -74.54,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PIHM',
    StateC: 'PL',
    C: 'Government',
    TStart: '1945',
    TStop: '1973',
    name: 'Panstwowego Instytut Hydrologiczno-Meterologicznego',
    Location: 'Warsawa',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PITT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1908',
    TStop: '',
    name: 'University of Pittsburgh',
    Location: 'Pittsburg:Oakland, Pennsylvania',
    lat: 40.44,
    lon: -79.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKAFSC',
    StateC: 'PK',
    C: 'Military',
    TStart: '2000 Mar',
    TStop: '',
    name: 'Air Force Strategic Command, Pakistan Air Force',
    Location: 'Islamabad',
    lat: 33.72,
    lon: 73.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1968',
    TStop: '1990 May',
    name: 'Perkin-Elmer Corp.',
    Location: 'Danbury, Connecticut',
    lat: 41.4,
    lon: -73.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKNDC',
    StateC: 'PK',
    C: 'Military',
    TStart: '1993',
    TStop: '2001',
    name: 'Pakistan National Defense Complex',
    Location: 'Fateh Jang',
    lat: 33.57,
    lon: 72.64,
    alt: 0,
    Parent: 'PAEC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKPMO',
    StateC: 'PK',
    C: 'Government',
    TStart: '1994',
    TStop: '2001',
    name: 'Project Management Organization, Pakistan',
    Location: 'Khanpur',
    lat: 28.65,
    lon: 70.68,
    alt: 0,
    Parent: 'PAEC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKO',
    StateC: 'SU',
    C: 'Military',
    TStart: '1963',
    TStop: '',
    name: 'Protivo-Kosmicheskaya Oborona, VS SSSR',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'PVO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLA',
    StateC: 'CN',
    C: 'Military',
    TStart: '1927 Aug',
    TStop: '',
    name: 'Zhonggou Renmin Jiefangjun',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLA2AC',
    StateC: 'CN',
    C: 'Military',
    TStart: '1966 Jul 1',
    TStop: '2016 Jan 1',
    name: 'Di Er Paobing Budui, Zhongguo Renmin Jeifangjun',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLAAF',
    StateC: 'CN',
    C: 'Military',
    TStart: '1949 Nov 11',
    TStop: '',
    name: 'Zhongguo Renmin Jiefangjun Kongjun',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COSMOG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013 Jun',
    TStop: '2016 Jun',
    name: 'Planet Labs, Inc',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'REYE',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2015 Aug',
    TStop: '',
    name: 'Planet Labs/Berlin',
    Location: 'Brandenburg an der Havel, Brandenburg',
    lat: 52.42,
    lon: 12.53,
    alt: 0,
    Parent: 'PLABS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYBOX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017 Apr',
    TStop: '',
    name: 'Terra Bella (Planet)',
    Location: 'San Jose:Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: 'PLABS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'COSMOG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016 Jun',
    TStop: '',
    name: 'Planet Labs, Inc. (Planet)',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLANQ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'PlanetiQ',
    Location: 'Washington/Bethesda, Maryland',
    lat: 38.98,
    lon: -77.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLANS',
    StateC: 'CN',
    C: 'Military',
    TStart: '1949',
    TStop: '',
    name: 'North Sea Fleet, People\'s Liberation Army Navy',
    Location: 'Qingdao',
    lat: 36.07,
    lon: 120.38,
    alt: 0,
    Parent: 'PLA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLA2AC',
    StateC: 'CN',
    C: 'Military',
    TStart: '2016 Jan 1',
    TStop: '',
    name: 'Zhongguo Renmin Jiefangjun Huojian Jun',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLRES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'Planetary Resources Inc.',
    Location: 'Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PLSYS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2007 Oct',
    name: 'Payload Systems, Inc.',
    Location: 'Cambridge, Massachusetts',
    lat: 42.37,
    lon: -71.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PMOD',
    StateC: 'CH',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Physikalisch-Meteorologisches Observatorium Davos, World Radiation Center',
    Location: 'Davos, Dorf',
    lat: 46.8,
    lon: 9.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PMOOS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1948',
    TStop: '1961',
    name: 'Patterson-Moos Research',
    Location: 'Jamaica, New York',
    lat: 40.7,
    lon: -73.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PMR',
    StateC: 'US',
    C: 'Military',
    TStart: '1958 Jun',
    TStop: '1959 Jan',
    name: 'Pacific Missile Range - Pt Mugu',
    Location: 'Pt Mugu. California',
    lat: 34.12,
    lon: -119.12,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAMTC',
    StateC: 'US',
    C: 'Military',
    TStart: '1975 Apr 26',
    TStop: '1992 Jan',
    name: 'Pacific Missile Test Center',
    Location: 'Pt Mugu. California',
    lat: 34.12,
    lon: -119.12,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PMW146',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'SPAWAR PMW 146 Com Sat Program Office',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: 'PEOSS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PNTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'PointView Tech LLC',
    Location: 'Wilmington, Delaware',
    lat: 39.75,
    lon: -75.55,
    alt: 0,
    Parent: 'FBK',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'POL',
    StateC: 'SU',
    C: 'Government',
    TStart: '1990',
    TStop: '2007',
    name: 'PO Polyot',
    Location: 'Omsk',
    lat: 54.98,
    lon: 73.37,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'POL',
    StateC: 'SU',
    C: 'Government',
    TStart: '2007',
    TStop: '',
    name: 'PO Polyot, Filial GKNPTs Khrunichev',
    Location: 'Omsk',
    lat: 54.98,
    lon: 73.37,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'POLY',
    StateC: 'F',
    C: 'Academic',
    TStart: '1794',
    TStop: '',
    name: 'Ecole Polytechnique',
    Location: 'Paris:Saclay',
    lat: 48.73,
    lon: 2.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDP',
    StateC: 'F',
    C: 'Government',
    TStart: '1660',
    TStop: '1873',
    name: 'Poudrerie Royale (Poudrerie Nationale)',
    Location: 'Saint-Medard-en-Jalles, Gironde',
    lat: 44.9,
    lon: -0.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'POPACS',
    StateC: 'US',
    C: 'Academic',
    TStart: '2013',
    TStop: '',
    name: 'Project POPACS (Gil Moore)',
    Location: 'Monument, Colorado',
    lat: 39.08,
    lon: -104.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PORTO',
    StateC: 'PT',
    C: 'Academic',
    TStart: '1911',
    TStop: '',
    name: 'Universidade do Porto',
    Location: 'Porto',
    lat: 41.15,
    lon: -8.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRC',
    StateC: 'UK',
    C: 'Government',
    TStart: '1994',
    TStop: '2007',
    name: 'UK Particle Physics and Astronomy Research Council',
    Location: 'Swindon, England',
    lat: 51.56,
    lon: -1.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2001',
    name: 'PRIMEX Technologies',
    Location: 'Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MARQ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2000',
    name: 'PRIMEX Technologies/Van Nuys (transfer to Redmond)',
    Location: 'Van Nuys, California',
    lat: 34.18,
    lon: -118.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PRIN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1756',
    TStop: '',
    name: 'Princeton University',
    Location: 'Princeton, New Jersey',
    lat: 40.35,
    lon: -74.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FUSEI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1966',
    name: 'Prince Motor Co Ltd',
    Location: 'Tokyo:Suginami (Ogikubo)',
    lat: 35.68,
    lon: 139.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PRIR',
    StateC: 'SU',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Priroda Center GUGK',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'GUGK',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PRL',
    StateC: 'IN',
    C: 'Government',
    TStart: '1947 Nov 11',
    TStop: '',
    name: 'Physical Research Lab, Ahmedabad',
    Location: 'Ahmedabad, Gujarat',
    lat: 23.03,
    lon: 72.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PRO',
    StateC: 'SU',
    C: 'Military',
    TStart: '1963',
    TStop: '',
    name: 'Protivo-Raketnaya Oborona',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'PVO',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PROG',
    StateC: 'RU',
    C: 'Government',
    TStart: '1961',
    TStop: '1996 Apr',
    name: 'Zavod Progress',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PROG',
    StateC: 'RU',
    C: 'Government',
    TStart: '1996 Apr 12',
    TStop: '',
    name: 'Zavod GNPTKTs TsSKB-Progress',
    Location: 'Samara (Kubyshev), Samara Oblast',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: 'TSSKBP',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PROTO',
    StateC: 'BM',
    C: 'Commercial',
    TStart: '2001 Sep',
    TStop: '',
    name: 'Protostar Ltd',
    Location: 'Bermuda',
    lat: 32.93,
    lon: -64.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PROTS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005 Mar',
    TStop: '',
    name: 'Protostar Satellite Systems',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: 'PROTO',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998',
    TStop: '',
    name: 'Planetary Systems Corporation',
    Location: 'Washington/Silver Spring, Maryland',
    lat: 39,
    lon: -77.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSCI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Physical Sciences, Inc.',
    Location: 'Andover, MA',
    lat: 42.66,
    lon: -71.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021',
    TStop: '',
    name: 'Planetary Systems Corporation',
    Location: 'Washington/Silver Spring, Maryland',
    lat: 39,
    lon: -77.03,
    alt: 0,
    Parent: 'RLABU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSN',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '1992',
    TStop: '',
    name: 'PT Pasifik Satelit Nusantara',
    Location: 'Jakarta:Bekasi, West Java',
    lat: -6.23,
    lon: 106.99,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSNS',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Palapa Satelit Nusantara Sejahtera',
    Location: 'Jakarta:Bekasi, West Java',
    lat: -6.23,
    lon: 106.99,
    alt: 0,
    Parent: 'PSN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1998 Aug',
    name: 'Pacific Sierra Research Corp.',
    Location: 'Los Angeles, California',
    lat: 34.05,
    lon: 118.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1855',
    TStop: '',
    name: 'Penn State University',
    Location: 'State College, Pennsylvania',
    lat: 40.79,
    lon: -77.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PSUA',
    StateC: 'UA',
    C: 'Military',
    TStart: '1992',
    TStop: '',
    name: 'Povitryani Sili Ukraini',
    Location: 'Vinnytsia',
    lat: 49.23,
    lon: 28.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PU',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1992',
    TStop: '',
    name: 'ZAO Puskovie Uslugi',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PUCP',
    StateC: 'PE',
    C: 'Academic',
    TStart: '1917',
    TStop: '',
    name: 'Pontifica Universidad Catolica del Peru',
    Location: 'Lima',
    lat: -12.07,
    lon: -77.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PUMPK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Pumpkin Inc.',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PURDUE',
    StateC: 'US',
    C: 'Academic',
    TStart: '1869',
    TStop: '',
    name: 'Purdue University',
    Location: 'West Lafayette, Indiana',
    lat: 40.42,
    lon: -86.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PUSTEK',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Pusat Teknology Elektronika, Dirgantara Indonesia',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PVO',
    StateC: 'SU',
    C: 'Military',
    TStart: '1949',
    TStop: '',
    name: 'Proto-Vozdhusnoy Oborony',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PWAR',
    StateC: 'PL',
    C: 'Academic',
    TStart: '1826',
    TStop: '',
    name: 'Politechnika Warszawska',
    Location: 'Warszawa',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996',
    TStop: '2004',
    name: 'UTC Pratt and Whitney Space Propulsion Chemical Systems Div.',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: 'UTC2',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PWFL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '2013 Jun',
    name: 'Pratt & Whitney Florida Research and Development Center',
    Location: 'West Palm Beach, Florida',
    lat: 26.71,
    lon: -80.06,
    alt: 0,
    Parent: 'UAC',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RDYNE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005 Aug',
    TStop: '2013 Jun',
    name: 'Pratt & Whitney Rocketdyne Inc',
    Location: 'Canoga Park, California',
    lat: 34.2,
    lon: -118.6,
    alt: 0,
    Parent: 'UTC2',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QB50',
    StateC: 'B',
    C: 'Academic',
    TStart: '2012',
    TStop: '',
    name: 'QB50 Consortium',
    Location: 'Brussel/Sint-Genesius-Rode, Brabant',
    lat: 50.75,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QBUS',
    StateC: 'US',
    C: 'Academic',
    TStart: '2014',
    TStop: '',
    name: 'QBUS Consortium (Stanford/APL/UC Boulder/U MIch/U del Turabo)',
    Location: 'Laurel, Maryland',
    lat: 39.17,
    lon: -76.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QIANC',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Beijing Qiancheng Tansuo Keji YG',
    Location: 'Beijing',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2001 Jul 1',
    TStop: '',
    name: 'Qinetiq',
    Location: 'Farnborough, Hants',
    lat: 51.29,
    lon: -0.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VER',
    StateC: 'B',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'QinetiQ Space nv',
    Location: 'Kruibeke',
    lat: 51.17,
    lon: 4.3,
    alt: 0,
    Parent: 'QINQ',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QMW',
    StateC: 'UK',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Queen Mary Westfield College, University of London',
    Location: 'London:Mile End',
    lat: 51.52,
    lon: -0.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QPS',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Kabushikigaisha QPS kenkyujo',
    Location: 'Fukuoka City, Fukuoka',
    lat: 33.58,
    lon: 130.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QTD',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Qingteng daxue',
    Location: 'Shenzhen',
    lat: 22.52,
    lon: 113.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QTK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2019 Mar',
    TStop: '',
    name: 'Shenzhen Qiyuan Taikong Keji YG',
    Location: 'Shenzhen',
    lat: 22.52,
    lon: 113.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QTT',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Quan Tu Tong gongsi',
    Location: 'Beijing:Yizhuang',
    lat: 39.8,
    lon: 116.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QUAFI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '',
    name: 'QuakeFinder LLC, Palo Alto',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QUB',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1849',
    TStop: '',
    name: 'Queen\'s University, Belfast',
    Location: 'Belfast, Northern Ireland',
    lat: 54.58,
    lon: -5.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QUETZ',
    StateC: 'MX',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Quetzsat S.A. de C.V',
    Location: 'Ciudad de Mexico',
    lat: 19.43,
    lon: -99.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'QUK',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1841',
    TStop: '',
    name: 'Queen\'s University (Kingston, Ontario)',
    Location: 'Kingston, Ontario',
    lat: 44.22,
    lon: -76.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAAF',
    StateC: 'AU',
    C: 'Military',
    TStart: '1921 Mar',
    TStop: '',
    name: 'Royal Australian Air Force',
    Location: 'Canberra',
    lat: -35.31,
    lon: 149.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RACE',
    StateC: 'F',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Radio Amateur Club de L\'Espace',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ORBI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017 Oct',
    TStop: '',
    name: 'Radiant Solutions (Herndon)',
    Location: 'Herndon, Virginia',
    lat: 38.97,
    lon: -77.39,
    alt: 0,
    Parent: 'MAXAR',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAE',
    StateC: 'UK',
    C: 'Military',
    TStart: '1918 Apr 1',
    TStop: '1991 Apr 1',
    name: 'Royal Aircraft Establishment',
    Location: 'Farnborough, Hants.',
    lat: 51.29,
    lon: -0.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Military',
    TStart: '1947',
    TStop: '1958 Aug',
    name: 'RAE Rocket Propulsion Department',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: 'RAE',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAF',
    StateC: 'UK',
    C: 'Military',
    TStart: '1940',
    TStop: '1968',
    name: 'Royal Air Force Bomber Command',
    Location: 'High Wycombe',
    lat: 51.63,
    lon: -0.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAFSO',
    StateC: 'UK',
    C: 'Military',
    TStart: '1957',
    TStop: '2016',
    name: 'UK Space Operations Coordination Centre, RAF High Wycombe',
    Location: 'High Wycombe',
    lat: 51.63,
    lon: -0.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAFL',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '1965',
    TStop: '',
    name: 'Rafael Advanced Defense Systems Ltd.',
    Location: 'Haifa',
    lat: 32.82,
    lon: 34.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOM',
    StateC: 'RU',
    C: 'Government',
    TStart: '1999',
    TStop: '2004',
    name: 'Rosaviakosmos (Rossiskoe aviatsionno-kosmicheskoe agentstvo)',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAL',
    StateC: 'UK',
    C: 'Government',
    TStart: '1979',
    TStop: '',
    name: 'Rutherford Appleton Laboratory',
    Location: 'Chilton, Oxfordshire',
    lat: 51.57,
    lon: -1.29,
    alt: 0,
    Parent: 'SERC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAST',
    StateC: 'T',
    C: 'Academic',
    TStart: '1963',
    TStop: '',
    name: 'Smakhm withyu smakhr len haeng prathesthiy',
    Location: 'Bangkok',
    lat: 13.75,
    lon: 100.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BLCAN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021',
    TStop: '',
    name: 'Raytheon Intelligence and Space/Blue Canyon',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'RAYTH',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTVE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Raytheon IIS (Dallas)',
    Location: 'Dallas:Garland, Texas',
    lat: 32.91,
    lon: -96.64,
    alt: 0,
    Parent: 'RAYTH',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAYM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '',
    name: 'Raymond Engineering Laboratories',
    Location: 'Middletown, Connecticut',
    lat: 41.56,
    lon: -72.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAYHSV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'Raytheon Missile Systems/Huntsville',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: 'RAYTH',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HUMS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Raytheon Missile Systems',
    Location: 'Tucson, Arizona',
    lat: 32.22,
    lon: -110.93,
    alt: 0,
    Parent: 'RAYTH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAYTH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Raytheon Space and Information Systems',
    Location: 'Sudbury, Mass.',
    lat: 42.38,
    lon: -71.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RBOW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '2005 Jan',
    name: 'Rainbow DBS Company LLC',
    Location: 'Bethpage:Jericho, New York',
    lat: 40.79,
    lon: -73.54,
    alt: 0,
    Parent: 'CABVS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '1986',
    name: 'RCA Astro Electronics (Astro Space)',
    Location: 'East Windsor, New Jersey (Princeton)',
    lat: 40.26,
    lon: -74.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAF',
    StateC: 'CA',
    C: 'Military',
    TStart: '1924',
    TStop: '1968',
    name: 'Royal Canadian Air Force',
    Location: 'North Bay, Ontario (or RCAR)',
    lat: 46.3,
    lon: -79.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAR',
    StateC: 'CA',
    C: 'Military',
    TStart: '1750',
    TStop: '',
    name: 'Royal Canadian Artillery',
    Location: 'Shilo, Manitoba',
    lat: 49.8,
    lon: -99.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAV',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1958',
    TStop: '1977',
    name: 'RCA Victor Ltd.',
    Location: 'Montreal:St Henri',
    lat: 45.48,
    lon: -73.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RDYNE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955 Nov 7',
    TStop: '1996 Dec',
    name: 'Rocketdyne',
    Location: 'Canoga Park, California',
    lat: 34.2,
    lon: -118.6,
    alt: 0,
    Parent: 'NAA',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PHILR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1959 Sep 30',
    TStop: '1978',
    name: 'Rocketdyne Solid Propulsion',
    Location: 'McGregor, Texas',
    lat: 31.43,
    lon: -97.42,
    alt: 0,
    Parent: 'RDYNE',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RDYNN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1968',
    name: 'Rocketdyne, Neosho Plant',
    Location: 'Neosho, Missouri',
    lat: 36.86,
    lon: -94.38,
    alt: 0,
    Parent: 'RDYNE',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'REAKT',
    StateC: 'FI',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Reaktor Space Lab Ltd',
    Location: 'Helsinki',
    lat: 60.17,
    lon: 24.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'REP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1939',
    TStop: '1965',
    name: 'Republic Aircraft',
    Location: 'Farmingdale, New York',
    lat: 40.73,
    lon: -73.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'REP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1965',
    TStop: '1987',
    name: 'Fairchild Republic Aircraft Division',
    Location: 'Farmingdale, New York',
    lat: 40.73,
    lon: -73.45,
    alt: 0,
    Parent: 'FAIR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NPOPM',
    StateC: 'RU',
    C: 'Government',
    TStart: '2006',
    TStop: '',
    name: 'OAO M. Reshetnev Information Satellite Systems',
    Location: 'Zheleznogorsk (Krasnoyarsk-26)',
    lat: 56.25,
    lon: 93.53,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'REYE',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1998',
    TStop: '2013 Nov 6',
    name: 'RapidEye AG',
    Location: 'Brandenburg an der Havel, Brandenburg',
    lat: 52.42,
    lon: 12.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GMS',
    StateC: 'RU',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Rosgidromet NITs Planeta',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RHI',
    StateC: 'I',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Rheinmetall Italia SpA.',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RICE',
    StateC: 'US',
    C: 'Academic',
    TStart: '1912',
    TStop: '',
    name: 'Rice University',
    Location: 'Houston, Texas',
    lat: 29.72,
    lon: -95.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RIKEN',
    StateC: 'J',
    C: 'Government',
    TStart: '1963',
    TStop: '',
    name: 'RIKEN, Wako site',
    Location: 'Tokyo:Wako',
    lat: 35.78,
    lon: 139.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RIKK',
    StateC: 'J',
    C: 'Academic',
    TStart: '1874',
    TStop: '',
    name: 'Rikkyo University',
    Location: 'Tokyo:Toshima',
    lat: 35.73,
    lon: 139.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RIMSAT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1992 Apr',
    TStop: '1995',
    name: 'Rimsat',
    Location: 'Fort Wayne, Indiana',
    lat: 41.08,
    lon: -85.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RIU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1951',
    TStop: '',
    name: 'Rhode Island University',
    Location: 'Kingston, Rhode Island',
    lat: 41.48,
    lon: -71.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOM',
    StateC: 'RU',
    C: 'Government',
    TStart: '1992 Feb',
    TStop: '1999',
    name: 'Rossiskoe aviatsionno-kosmicheskoe agentsvo (Rosaviakosmos)',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB1',
    StateC: 'RU',
    C: 'Government',
    TStart: '1994',
    TStop: '',
    name: 'RKK Energiya',
    Location: 'Korolev:Podlipki, Moskva, Rossiya',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NIIKP',
    StateC: 'SU',
    C: 'Government',
    TStart: '2009',
    TStop: '',
    name: 'OAO Rossiiskie Kosmicheskie Sistemi',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RLABN',
    StateC: 'NZ',
    C: 'Academic',
    TStart: '2009',
    TStop: '',
    name: 'Rocket Lab Ltd.',
    Location: 'Parnell, Auckland, North Island',
    lat: -36.87,
    lon: 174.78,
    alt: 0,
    Parent: 'RLABU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RLABU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'Rocket Lab USA',
    Location: 'Los Angeles, California',
    lat: 34.05,
    lon: -118.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RMAF',
    StateC: 'MA',
    C: 'Military',
    TStart: '1956',
    TStop: '',
    name: 'Al-Quwwat al-Mushallaha al-Malakiyah al-Maghribiyah',
    Location: 'Rabat',
    lat: 34.01,
    lon: -6.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RMD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958 Apr 30',
    TStop: '1972 Jun',
    name: 'Thiokol Chemical Corp. Reaction Motors Division',
    Location: 'Denville, New Jersey',
    lat: 40.89,
    lon: -74.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RMI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1958 Apr 30',
    name: 'Reaction Motors Incorporated (Denville)',
    Location: 'Denville, New Jersey',
    lat: 40.89,
    lon: -74.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RMILD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1946',
    TStop: '1970',
    name: 'Reaction Motors Incorporated, Picatinny Arsenal',
    Location: 'Dover:Lake Denmark, New Jersey',
    lat: 40.97,
    lon: -74.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RMIPL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1942',
    TStop: '1946',
    name: 'Reaction Motors Incorporated, Pompton Plains',
    Location: 'Pequannock:Pompton Plains, New Jersey',
    lat: 40.96,
    lon: -74.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RN',
    StateC: 'UK',
    C: 'Military',
    TStart: '1964',
    TStop: '',
    name: 'Royal Navy Submarine Service, HMS Neptune, Faslane Naval Base',
    Location: 'Gare Loch:Faslane, Argyll and Bute, Scotland',
    lat: 56.07,
    lon: -4.82,
    alt: 0,
    Parent: 'UKRN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RNAF',
    StateC: 'NL',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: 'Koninklijke Luchtmacht (KLu), Groep Geleide Wapens, LMB De Peel',
    Location: 'Venray',
    lat: 51.53,
    lon: 5.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RNII',
    StateC: 'SU',
    C: 'Government',
    TStart: '1945',
    TStop: '1950',
    name: 'Reaktivniy nauchno-issledovatel\'niy institut',
    Location: 'Moskva:Khovrino',
    lat: 55.87,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROAF',
    StateC: 'RO',
    C: 'Military',
    TStart: '1913',
    TStop: '',
    name: 'Fortele Aeriene Romane',
    Location: 'Bucuresti',
    lat: 44.43,
    lon: 26.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROB',
    StateC: 'B',
    C: 'Government',
    TStart: '1890',
    TStop: '',
    name: 'Koninklijke Sterrenwacht van Belgie (Observatoire Royal de Belgique)',
    Location: 'Brussel:Uccle',
    lat: 50.8,
    lon: 4.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROBMS',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Robertsville Middle School, Oak Ridge',
    Location: 'Oak Ridge, Tennessee',
    lat: 36.01,
    lon: -84.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROE',
    StateC: 'UK',
    C: 'Government',
    TStart: '1896',
    TStop: '*',
    name: 'Royal Observatory, Edinburgh, Blackford Hill',
    Location: 'Edinburgh, Scotland',
    lat: 55.92,
    lon: -3.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROHR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1940',
    TStop: '',
    name: 'Rohr Corp.',
    Location: 'Chula Vista, California',
    lat: 32.63,
    lon: -117.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROKN',
    StateC: 'KR',
    C: 'Military',
    TStart: '2015',
    TStop: '',
    name: 'Dahean-minguk Haegun, jamsuahmsalyeongbuneun',
    Location: 'Jinhae',
    lat: 35.15,
    lon: 128.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROKSN',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '1988',
    TStop: '',
    name: 'Roketsan Roket Sanayii ve Ticaret A.S.',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Military',
    TStart: '1984',
    TStop: '1998',
    name: 'Royal Ordnance',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROSAP',
    StateC: 'I',
    C: 'Academic',
    TStart: '1303',
    TStop: '',
    name: 'Universita di Roma la Sapienaza (Scoula di Ingengneria Aerospaziale)',
    Location: 'Roma',
    lat: 41.9,
    lon: 12.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROGAU',
    StateC: 'I',
    C: 'Academic',
    TStart: '',
    TStop: '2011',
    name: 'Gruppo di Astrodinamica dell\'Universita degli Studi di Roma \'La Sapienza\'',
    Location: 'Roma',
    lat: 41.9,
    lon: 12.52,
    alt: 0,
    Parent: 'ROSAP',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROISS',
    StateC: 'RO',
    C: 'Government',
    TStart: '1990',
    TStop: '',
    name: 'Institutul de Stiinte Spatiale',
    Location: 'Bucharest:Magurele',
    lat: 44.39,
    lon: 26.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MOM',
    StateC: 'RU',
    C: 'Government',
    TStart: '2016 Jan 1',
    TStop: '',
    name: 'Korporatsii Roskosmos',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DOSAAF',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1991 Sep 25',
    TStop: '',
    name: 'Rossiskaya oboronnaya sportivno-tekhnicheskaya organizatsiya',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROWAN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1923',
    TStop: '',
    name: 'Rowan University',
    Location: 'Camden, New Jersey',
    lat: 39.71,
    lon: -75.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ROYAL',
    StateC: 'KH',
    C: 'Commercial',
    TStart: '1991',
    TStop: '',
    name: 'The Royal Group, Cambodia',
    Location: 'Phnom Penh',
    lat: 11.55,
    lon: 104.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPEW',
    StateC: 'UK',
    C: 'Military',
    TStart: '1958 Aug',
    TStop: '1977 Feb',
    name: 'Propellants, Explosives and Rocket Motor Establishment',
    Location: 'Westcott, Buckinghamshire',
    lat: 51.85,
    lon: -0.96,
    alt: 0,
    Parent: 'MOD',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RPI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1959',
    TStop: '1964',
    name: 'Rocket Power Inc.',
    Location: 'Tempe, Arizona',
    lat: 33.41,
    lon: -111.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1985',
    name: 'Rocket Research Corp.',
    Location: 'Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRR',
    StateC: 'CA',
    C: 'Military',
    TStart: '1957',
    TStop: '1962 Nov 1',
    name: 'Rocket Research Facility, Fort Churchill',
    Location: 'Churchill, Manitoba',
    lat: 58.73,
    lon: -93.82,
    alt: 0,
    Parent: 'AOMC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RRL',
    StateC: 'J',
    C: 'Government',
    TStart: '1952',
    TStop: '1985',
    name: 'Denpaken Kyuusho',
    Location: 'Kashima, Ibaraki, Japan',
    lat: 35.97,
    lon: 140.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RROY',
    StateC: 'UK',
    C: 'Government',
    TStart: '1906',
    TStop: '',
    name: 'Rolls-Royce Ltd.',
    Location: 'Derby',
    lat: 52.92,
    lon: -1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASID',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1966',
    TStop: '1994',
    name: 'Rolls Royce Engines (Coventry)',
    Location: 'Coventry',
    lat: 52.41,
    lon: -1.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1966',
    TStop: '1993',
    name: 'Rolls-Royce Engines, Leavesden',
    Location: 'Watford:Leavesden, Hertfordshire',
    lat: 51.7,
    lon: -0.4,
    alt: 0,
    Parent: 'RROY',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RSRS',
    StateC: 'UK',
    C: 'Government',
    TStart: '1924',
    TStop: '1965',
    name: 'Radio Research Station',
    Location: 'Ditton Park, Buckinghamshire',
    lat: 51.48,
    lon: -0.57,
    alt: 0,
    Parent: 'SERC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RSC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1990 Jul 5',
    TStop: '2006 Mar 31',
    name: 'Rocket Systems Corporation',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RSLP',
    StateC: 'US',
    C: 'Military',
    TStart: '1990',
    TStop: '',
    name: 'USAF Space and Missile Center, Rocket Systems Launch Program',
    Location: 'Kirtland AFB, Albequerque',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'AFSMC',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RSP',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Rimansatto purojekuto',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RSQ',
    StateC: 'MU',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'RASCOMStar-QAF',
    Location: 'Port-Louis, Maurice',
    lat: -20.16,
    lon: 57.5,
    alt: 0,
    Parent: 'I-RASC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RSRS',
    StateC: 'UK',
    C: 'Government',
    TStart: '1965',
    TStop: '1974',
    name: 'Radio and Space Research Station',
    Location: 'Ditton Park, Buckinghamshire',
    lat: 51.48,
    lon: -0.57,
    alt: 0,
    Parent: 'SERC',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RTAF',
    StateC: 'T',
    C: 'Military',
    TStart: '1913',
    TStop: '',
    name: 'Kong Thap Akat Thai',
    Location: 'Bangkok',
    lat: 13.91,
    lon: 100.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RTG',
    StateC: 'S',
    C: 'Government',
    TStart: '1961',
    TStop: '1972 Jul 1',
    name: 'Rymdtekniska Gruppen',
    Location: 'Stockholm:Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RUAF',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1992',
    TStop: '',
    name: 'Russian Astronautical Federation',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '2008 Sep',
    TStop: '',
    name: 'RUAG Aerospace Sweden AB, Limkoping factory',
    Location: 'Linkoping',
    lat: 58.42,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CONTR',
    StateC: 'CH',
    C: 'Commercial',
    TStart: '2009 Jul',
    TStop: '',
    name: 'RUAG Space, Zurich',
    Location: 'Zurich',
    lat: 47.37,
    lon: 8.55,
    alt: 0,
    Parent: 'RUAG',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RUAGD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2019',
    TStop: '',
    name: 'RUAG Space, Decatur',
    Location: 'Decatur, Alabama',
    lat: 34.61,
    lon: -86.98,
    alt: 0,
    Parent: 'RUAG',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAL',
    StateC: 'UK',
    C: 'Government',
    TStart: '1957',
    TStop: '1957',
    name: 'Rutherford Laboratory',
    Location: 'Chilton, Oxfordshire',
    lat: 51.57,
    lon: -1.29,
    alt: 0,
    Parent: 'SERC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RVSN',
    StateC: 'SU',
    C: 'Military',
    TStart: '1959 Dec 17',
    TStop: '1991 Dec',
    name: 'Rakentiye Voiska Strategicheskogo Naznacheniye',
    Location: 'Mosvka',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RVSN',
    StateC: 'RU',
    C: 'Military',
    TStart: '1991 Dec',
    TStop: '',
    name: 'Rakentiye Voiska Strategicheskogo Naznacheniye (Rossisk. Fed.)',
    Location: 'Mosvka',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RWI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1973',
    TStop: '1996 Dec',
    name: 'Rockwell International (Air Force Plant 42, Palmdale)',
    Location: 'Palmdale, California',
    lat: 34.58,
    lon: -118.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VULT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1973',
    TStop: '1996 Dec',
    name: 'Rockwell/Downey',
    Location: 'Downey, California',
    lat: 33.94,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NAASB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1973',
    TStop: '1996 Dec',
    name: 'Rockwell/Seal Beach',
    Location: 'Seal Beach, California',
    lat: 33.76,
    lon: -118.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RWMTI',
    StateC: 'RW',
    C: 'Government',
    TStart: '1962',
    TStop: '',
    name: 'Ministry of Trade and Industry, Republic of Rwanda',
    Location: 'Kigali',
    lat: -1.94,
    lon: 30.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'S7',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'S7 Space',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SISP',
    StateC: 'CN',
    C: 'Military',
    TStart: '1965',
    TStop: '2007 Jan',
    name: 'Hangtian gongye zong gongsi 801 suo',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'S394I',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USAF Strategic Air Command, 394th ICBM Test Maintenance Sqn',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'S4300',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USAF Strategic Air Command, 4300th Support Sqn.',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '1937',
    TStop: '1969',
    name: 'Svenska Aeroplan Aktiebolaget',
    Location: 'Linkoping',
    lat: 58.42,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '1983',
    TStop: '1992',
    name: 'Saab Space, Linkoping factory',
    Location: 'Linkoping',
    lat: 58.42,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '1969',
    TStop: '1983',
    name: 'SAAB-SCANIA AB',
    Location: 'Linkoping',
    lat: 58.42,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '1992',
    TStop: '2006',
    name: 'Saab Ericsson Space, Linkoping factory',
    Location: 'Linkoping',
    lat: 58.42,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '2006',
    TStop: '2008 Sep',
    name: 'Saab Space AB, Limkoping factory',
    Location: 'Linkoping',
    lat: 58.42,
    lon: 15.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAAF',
    StateC: 'ZA',
    C: 'Military',
    TStart: '1957',
    TStop: '1994',
    name: 'South African Air Force, AFB Waterkloof',
    Location: 'Pretoria:Verwoerdburg (Tshwane:Centurion)',
    lat: -25.86,
    lon: 28.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SABCZ',
    StateC: 'CZ',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'S.A.B. Aerospace s.r.o',
    Location: 'Brno',
    lat: 49.23,
    lon: 16.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SABCA',
    StateC: 'B',
    C: 'Commercial',
    TStart: '1920 Dec 16',
    TStop: '',
    name: 'SA Belge de Construction Aeronautique',
    Location: 'Brussel:Haren',
    lat: 50.89,
    lon: 4.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAC',
    StateC: 'US',
    C: 'Military',
    TStart: '1948 Nov 9',
    TStop: '1992 Jan 1',
    name: 'USAF Strategic Air Command, Offutt AFB',
    Location: 'Omaha, Nebraska',
    lat: 41.25,
    lon: -96,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAFRAN',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2005 May',
    TStop: '',
    name: 'SAFRAN',
    Location: 'Paris:Evry',
    lat: 48.62,
    lon: 2.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1969',
    TStop: '1974 May 20',
    name: 'Safeguard Systems Command',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAFSP',
    StateC: 'US',
    C: 'Military',
    TStart: '1961 Sep',
    TStop: '1992 Dec 31',
    name: 'Secretary of the Air Force, Office of Special Projects (NRO Program A)',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'NRO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAIC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1969',
    TStop: '',
    name: 'Science Applications International Corp.',
    Location: 'San Diego:La Jolla, California',
    lat: 32.85,
    lon: -117.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAIUS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Space AI Inc.',
    Location: 'San Francisco',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFBSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1967 Jul',
    TStop: '1979 Oct',
    name: 'USAF Space and Missile Systems Organization (Norton AFB)',
    Location: 'Norton AFB, San Bernardino, California',
    lat: 34.1,
    lon: -117.24,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '1967 Jul',
    TStop: '1979 Oct',
    name: 'USAF Space and Missile Systems Organization',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAMX',
    StateC: 'MX',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2014 Mar 7',
    name: 'Satelites Mexicanos SA de CV',
    Location: 'Ciudad de Mexico:Lomas de Sotelo',
    lat: 19.44,
    lon: -99.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAND',
    StateC: 'US',
    C: 'Military',
    TStart: '1948 Apr 1',
    TStop: '1979',
    name: 'Sandia Laboratories',
    Location: 'Albequerque, New Mexico',
    lat: 35.11,
    lon: -106.61,
    alt: 0,
    Parent: 'DOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SANDF',
    StateC: 'ZA',
    C: 'Military',
    TStart: '1994',
    TStop: '',
    name: 'South African National Defense Force',
    Location: 'Pretoria',
    lat: -25.75,
    lon: 28.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SANH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1952',
    TStop: '1986',
    name: 'Sanders Associates',
    Location: 'Nashua, New Hampshire',
    lat: 42.76,
    lon: -71.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SANH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '1995',
    name: 'Lockheed/Sanders Associates',
    Location: 'Nashua, New Hampshire',
    lat: 42.76,
    lon: -71.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SANJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1969 Aug',
    TStop: '2011',
    name: 'Sanjiang hangtian jituan (Base 066)',
    Location: 'Hankou, Wuhan, Hubei',
    lat: 30.58,
    lon: 114.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SANJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Zhongguo sanjiang hangtian jituan',
    Location: 'Hankou, Wuhan, Hubei',
    lat: 30.58,
    lon: 114.27,
    alt: 0,
    Parent: 'CASIC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAND',
    StateC: 'US',
    C: 'Military',
    TStart: '1979',
    TStop: '',
    name: 'Sandia National Laboratories (SNL-NM)',
    Location: 'Albequerque, New Mexico',
    lat: 35.11,
    lon: -106.61,
    alt: 0,
    Parent: 'DOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SAO',
    StateC: 'US',
    C: 'Government',
    TStart: '1955',
    TStop: '',
    name: 'Smithsonian Astrophysical Observatory',
    Location: 'Cambridge, MA',
    lat: 42.38,
    lon: -71.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SASG',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Sky and Space Global (UK)',
    Location: 'London',
    lat: 51.51,
    lon: -0.11,
    alt: 0,
    Parent: 'SASGA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SASGA',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Sky and Space Global Ltd (Australia)',
    Location: 'Perth, W Australia',
    lat: -31.95,
    lon: 115.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SASK',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1907',
    TStop: '',
    name: 'University of Saskatchewan',
    Location: 'Saskatoon, Saskatchewan',
    lat: 52.13,
    lon: -106.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SASMAC',
    StateC: 'CN',
    C: 'Government',
    TStart: '2009',
    TStop: '',
    name: 'Weixing cehui yingyong zhongxin',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'GCDX',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBA',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1993',
    TStop: '',
    name: 'Shanghai hangtian jishu yanjiuyuan',
    Location: 'Shanghai:Minghan',
    lat: 31.11,
    lon: 121.38,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SATBYUL',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Satbyul Co. Ltd.',
    Location: 'Suwon-si, Gyoenggi-do',
    lat: 37.27,
    lon: 127.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SATEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '',
    name: 'Satellife Inc',
    Location: 'Boston, MA',
    lat: 42.36,
    lon: -71.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SATELOG',
    StateC: 'AR',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Satellogic S.A.',
    Location: 'San Carlos de Bariloche, Rio Negro',
    lat: -41.15,
    lon: -71.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SATGE',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '2007 Jun',
    TStop: '',
    name: 'SAT-GE, GE International Holdings',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SATHYA',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1987',
    TStop: '',
    name: 'Sathyabama University',
    Location: 'Chennai:Sholinganallur',
    lat: 12.9,
    lon: 80.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SATLAN',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2014 Sep',
    TStop: '',
    name: 'SATLANTIS',
    Location: 'Leioa, Bizkaia',
    lat: 43.3289,
    lon: -2.9847,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAISR',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2021 Jan',
    name: 'SatRec Initiative',
    Location: 'Daejeon',
    lat: 36.35,
    lon: 127.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAISR',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2021 Jan',
    TStop: '',
    name: 'Hanwha SatRec Initiative',
    Location: 'Daejeon',
    lat: 36.35,
    lon: 127.39,
    alt: 0,
    Parent: 'HANWHA',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SATRV',
    StateC: 'PL',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'SatRevolution S.A.',
    Location: 'Wroclaw',
    lat: 51.1,
    lon: 17.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBA',
    StateC: 'CN',
    C: 'Military',
    TStart: '1980',
    TStop: '1993',
    name: 'Shanghai hangtian ju (Bureau 805)',
    Location: 'Shanghai:Minhang',
    lat: 31.11,
    lon: 121.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBA',
    StateC: 'CN',
    C: 'Military',
    TStart: '1961 Aug 1',
    TStop: '1980',
    name: 'Shanghai shidi er jidian gongye ju',
    Location: 'Shanghai:Minhang',
    lat: 31.11,
    lon: 121.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBEL',
    StateC: 'B',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'Spacebel',
    Location: 'Liege',
    lat: 50.63,
    lon: 5.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '1960s',
    name: 'Santa Barbara Research Corp.',
    Location: 'Santa Barbara:Goleta',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960s',
    TStop: '1997',
    name: 'Hughes Santa Barbara Research Corp.',
    Location: 'Santa Barbara:Goleta',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBRC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Raytheon Santa Barbara Research Corp.',
    Location: 'Santa Barbara:Goleta',
    lat: 34.44,
    lon: -119.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SBS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1975 Dec 15',
    TStop: '1985 Jul',
    name: 'Satellite Business Systems, Inc. (IBM/Aetna/Comsat)',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCAL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '',
    name: 'Scaled Composites',
    Location: 'Mojave, California',
    lat: 35.05,
    lon: -118.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1985 Mar 22',
    TStop: '2008 Aug',
    name: 'Space Communications Corp',
    Location: 'Tokyo:Shinagawa',
    lat: 35.68,
    lon: 139.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCC',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2008 Aug',
    TStop: '2009',
    name: 'Space Communications Corp (Sky Perfect JSAT)',
    Location: 'Tokyo:Shinagawa',
    lat: 35.68,
    lon: 139.73,
    alt: 0,
    Parent: 'SKPJ',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRDL',
    StateC: 'US',
    C: 'Military',
    TStart: '1949',
    TStop: '1962',
    name: 'US Army Signal Corps Engineering Labs',
    Location: 'Fort Monmouth, New Jersey',
    lat: 40.31,
    lon: -74.05,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCHJ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1955',
    TStop: '1974',
    name: 'G T Schjeldahl Inc.',
    Location: 'Northfield, Minnesota',
    lat: 44.46,
    lon: -93.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCO',
    StateC: 'US',
    C: 'Military',
    TStart: '2012',
    TStop: '',
    name: 'Strategic Capabilities Office, USD(R&E)',
    Location: 'Arlington, Virginia',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCSS',
    StateC: 'ZA',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'SCS-Space',
    Location: 'Cape Town',
    lat: -33.93,
    lon: 18.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCT',
    StateC: 'MX',
    C: 'Commercial',
    TStart: '1891',
    TStop: '2010 Jul',
    name: 'Secretaria de Comunicaciones y Transportes',
    Location: 'Ciudad de Mexico',
    lat: 19.43,
    lon: -99.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1851',
    TStop: '',
    name: 'Santa Clara University',
    Location: 'Santa Clara, California',
    lat: 37.35,
    lon: -121.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDA',
    StateC: 'US',
    C: 'Military',
    TStart: '2019 Mar',
    TStop: '',
    name: 'Space Development Agency',
    Location: 'Arlington, Virginia:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1985 Jul',
    TStop: '1992 Aug',
    name: 'US Army Strategic Defense Command (USASDC)',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1963',
    TStop: '1988',
    name: 'Space Data Corp.',
    Location: 'Phoenix:Tempe/Chandler, Arizona',
    lat: 33.3,
    lon: -111.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDIITI',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Shandong changye jishu yanjiuyuan',
    Location: 'Jinan',
    lat: 36.67,
    lon: 117.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDIO',
    StateC: 'US',
    C: 'Military',
    TStart: '1984',
    TStop: '1993',
    name: 'Strategic Defense Initiative Organization, DoD',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDLP',
    StateC: 'CZ',
    C: 'Commercial',
    TStart: '1991',
    TStop: '',
    name: 'Space Devices s.r.o.',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDP',
    StateC: 'F',
    C: 'Government',
    TStart: '1873',
    TStop: '1971',
    name: 'Services des Poudres',
    Location: 'Saint-Medard-en-Jalles, Gironde',
    lat: 44.9,
    lon: -0.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHAR',
    StateC: 'IN',
    C: 'Government',
    TStart: '2002',
    TStop: '',
    name: 'Satish Dhawan Space Center',
    Location: 'Sriharikota',
    lat: 13.62,
    lon: 80.3,
    alt: 0,
    Parent: 'ISRO',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEAL',
    StateC: 'CH',
    C: 'Commercial',
    TStart: '2010',
    TStop: '2014 Apr',
    name: 'Sea Launch AG',
    Location: 'Bern',
    lat: 46.95,
    lon: 7.45,
    alt: 0,
    Parent: 'RKKE',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEALP',
    StateC: 'CYM',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2000 Sep',
    name: 'Sea Launch Limited Partnership',
    Location: 'Georgetown, Cayman Islands',
    lat: 19.3,
    lon: -81.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEAL',
    StateC: 'CH',
    C: 'Commercial',
    TStart: '2014 Apr',
    TStop: '',
    name: 'Sea Launch AG',
    Location: 'Nyon, Vaud',
    lat: 46.38,
    lon: 6.23,
    alt: 0,
    Parent: 'RKKE',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEALP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000 Sep',
    TStop: '2010',
    name: 'Sea Launch Limited Partnership',
    Location: 'Long Beach, California',
    lat: 33.77,
    lon: -118.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SECM',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2003',
    TStop: '',
    name: 'Shanghai weixiao weixing gongcheng zhongxin',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: 'SIMIT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SECT',
    StateC: 'F',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Service d\'Equipement de Champs de Tir',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEDENA',
    StateC: 'MX',
    C: 'Military',
    TStart: '1934',
    TStop: '',
    name: 'Secreteria de la Defensa Nacional',
    Location: 'Ciudad de Mexico',
    lat: 19.43,
    lon: -99.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEDSH',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Students for the Exploration and Development of Space (HSV)',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '1969',
    name: 'Stanford Electronics Laboratory',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SELEN',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1968',
    TStop: '1990',
    name: 'Selenia Spazio SpA',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SELGR',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1961',
    TStop: '1964',
    name: 'Berthold Seliger Forschungs- und Entwicklungsgesellschaft mbH',
    Location: 'Cuxhaven',
    lat: 53.86,
    lon: 8.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SELM',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2016',
    TStop: '',
    name: 'Shaanxi sheng weixiao weixing gongcheng shiyan shi',
    Location: 'Xi\'an',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: 'NWPU',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SENER',
    StateC: 'E',
    C: 'Commercial',
    TStart: '1956',
    TStop: '',
    name: 'SENER',
    Location: 'Bilbao',
    lat: 43.26,
    lon: -2.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1967',
    TStop: '1969',
    name: 'Sentinel System Command',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEP',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1971',
    TStop: '1997',
    name: 'Soci\\\'et\\\'e Europ\\\'eene de Propulsion (Vernon)',
    Location: 'Vernon, Hte Normandie',
    lat: 49.09,
    lon: 1.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPR',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1969',
    TStop: '1997',
    name: 'Soci\\\'et\\\'e Europ\\\'eene de Propulsion',
    Location: 'Bordeaux:Le Haillan',
    lat: 44.87,
    lon: -0.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNECBL',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1969',
    TStop: '1997',
    name: 'SEP Division Moteurs Spatiaux - Blanquefort',
    Location: 'Bordeaux:Blanquefort',
    lat: 44.91,
    lon: -0.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPR',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1964',
    TStop: '1969',
    name: 'Soci\\\'et\\\'e d\'Etudes de la Propulsion par Reaction',
    Location: 'Bordeaux:Le Haillan',
    lat: 44.87,
    lon: -0.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPRV',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1944',
    TStop: '1969',
    name: 'Soci\\\'et\\\'e d\'Etudes de la Propulsion par Reaction (Villejuif)',
    Location: 'Paris:Villejuif',
    lat: 48.79,
    lon: 2.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPVR',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1947',
    TStop: '1997',
    name: 'Soci\\\'et\\\'e Europ\\\'eene de Propulsion (Villaroche)',
    Location: 'Villaroche, Seine-et-Marne',
    lat: 48.61,
    lon: 2.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRC',
    StateC: 'UK',
    C: 'Government',
    TStart: '1981',
    TStop: '1994',
    name: 'UK Science and Engineering Research Council',
    Location: 'Swindon, England',
    lat: 51.56,
    lon: -1.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEREB',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1959 Sep',
    TStop: '1970 Jul 1',
    name: 'Soci\\\'et\\\'e pour l\'etude et la r\\\'ealisation d\'engins ballistiques',
    Location: 'Paris:Courbevoie, Hauts-de-Seine',
    lat: 48.9,
    lon: 2.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SES',
    StateC: 'L',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2001',
    name: 'Soci\\\'et\\\'e Europeene des Satellites, Luxembourg',
    Location: 'Betzdorf',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SESA',
    StateC: 'L',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2011',
    name: 'SES Astra',
    Location: 'Betzdorf',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SESBM',
    StateC: 'BM',
    C: 'Commercial',
    TStart: '2010 Nov 2',
    TStop: '',
    name: 'SES Satellites (Bermuda) Ltd.',
    Location: 'Hamilton',
    lat: 32.93,
    lon: -64.78,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SESBR',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'SES DTH do Brasil Ltda.',
    Location: 'Sao Paolo',
    lat: -23.61,
    lon: -46.7,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SESE',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2005 Dec',
    TStop: '',
    name: 'SES Engineering (Luxembourg)',
    Location: 'Betzdorf',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GECAP',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'SES Satellites (Gibraltar) Ltd.',
    Location: 'Gibraltar',
    lat: 36.13,
    lon: -5.35,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SES',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2006',
    name: 'SES Global',
    Location: 'Betzdorf',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEOPS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '2019 Feb',
    name: 'SEOPS LLC',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STP',
    StateC: 'US',
    C: 'Military',
    TStart: '1965 May',
    TStop: '1971 Jun',
    name: 'USAF SAMSO/DoD Space Experiments Support Program',
    Location: 'Los Angeles:El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'AFSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSAB',
    StateC: 'S',
    C: 'Commercial',
    TStart: '2005 Dec 1',
    TStop: '',
    name: 'SES Sirius AB',
    Location: 'Stockholm:Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SES',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2006',
    TStop: '',
    name: 'SES S.A.',
    Location: 'Betzdorf',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SESSL',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2005 Dec',
    TStop: '',
    name: 'SES Satellite Leasing Ltd. (Isle of Man)',
    Location: 'Douglas, Isle of Man',
    lat: 54.15,
    lon: 4.48,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2006 Sep',
    TStop: '2009 Sep',
    name: 'SES New Skies Satellites B.V.',
    Location: '\'s:Gravenhage',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SESW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '2005 Feb',
    name: 'Worldsat LLC',
    Location: 'Princeton, New Jersey',
    lat: 40.35,
    lon: -74.66,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NSS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2009 Sep',
    TStop: '2011',
    name: 'SES World Skies (The Hague)',
    Location: '\'s:Gravenhage',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009 Sep',
    TStop: '2011',
    name: 'SES World Skies (Princeton)',
    Location: 'Princeton, New Jersey',
    lat: 40.35,
    lon: -74.66,
    alt: 0,
    Parent: 'SES',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ANDRW',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Spaceflight Industries Inc.',
    Location: 'Seattle:Tukwila, Washington',
    lat: 47.47,
    lon: -122.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SFLINC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013',
    TStop: '',
    name: 'Spaceflight Inc.',
    Location: 'Seattle:Tukwila, Washington',
    lat: 47.47,
    lon: -122.26,
    alt: 0,
    Parent: 'SFLIN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SFP',
    StateC: 'US',
    C: 'Government',
    TStart: '1983',
    TStop: '1990',
    name: 'Spaceflight participant program, NASA JSC',
    Location: 'Houston:Clear Lake, Texas',
    lat: 29.56,
    lon: -95.12,
    alt: 0,
    Parent: 'JSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '2021 Aug',
    TStop: '',
    name: 'US Space Force Space Systems Command',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USSF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAI',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1992',
    TStop: '2016 Apr',
    name: 'Samarskiy Gosudarstvenniy Aerokosmicheskiy Univ. im. S.P. Koroleva',
    Location: 'Samara (Kubyshev)',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CLSR',
    StateC: 'BGN',
    C: 'Academic',
    TStart: '1969',
    TStop: '1975',
    name: 'Sci. Group of Space Physics, Bulg. Acad. Sci.',
    Location: 'Sofia',
    lat: 42.7,
    lon: 23.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2009',
    name: 'Spacehab Inc.',
    Location: 'Vienna, Virginia',
    lat: 38.9,
    lon: -77.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHABH',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2009',
    name: 'Spacehab Inc.',
    Location: 'Webster, Texas',
    lat: 29.54,
    lon: -95.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHABT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2009',
    name: 'Spacehab Inc.',
    Location: 'Austin, Texas',
    lat: 30.27,
    lon: -97.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHANDZ',
    StateC: 'CN',
    C: 'Government',
    TStart: '1945',
    TStop: '',
    name: 'Shangdong sheng zhenfu',
    Location: 'Jinan',
    lat: 36.67,
    lon: 117.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHANGT',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2013',
    TStop: '',
    name: 'Shanghai kexue daxue',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHANT',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Shantou dianzi jishu yanjiusuo',
    Location: 'Shantou',
    lat: 23.35,
    lon: 116.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHAOX',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Zhongguo Shaonian Weixing Jihua',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHAR',
    StateC: 'IN',
    C: 'Government',
    TStart: '1971 Oct',
    TStop: '2002',
    name: 'Sriharikota Range',
    Location: 'Sriharikota',
    lat: 13.62,
    lon: 80.3,
    alt: 0,
    Parent: 'ISRO',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHEF',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1905',
    TStop: '',
    name: 'Sheffield University',
    Location: 'Sheffield, South Yorks.',
    lat: 53.38,
    lon: -1.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SCHJ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1974',
    TStop: '',
    name: 'Sheldahl Inc. (former GT Schjeldahl)',
    Location: 'Northfield, Minnesota',
    lat: 44.46,
    lon: -93.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHIN',
    StateC: 'T',
    C: 'Commercial',
    TStart: '1999 Aug',
    TStop: '2008 Apr 10',
    name: 'Shin Satellite Plc.',
    Location: 'Bangkok:Nonthaburi',
    lat: 13.85,
    lon: 100.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHINSHU',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Shinshu Daigaku, Engineering Dept., Wakasato campus',
    Location: 'Nagano:Wakasato',
    lat: 36.63,
    lon: 138.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHIN',
    StateC: 'T',
    C: 'Commercial',
    TStart: '1991',
    TStop: '1999 Aug',
    name: 'Shinawatra Satellite Co. Ltd.',
    Location: 'Bangkok:Nonthaburi',
    lat: 13.85,
    lon: 100.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHIZ',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Shizuoka Daigaku',
    Location: 'Shizuoka, Shizuoka',
    lat: 34.96,
    lon: 138.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIBGAU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Sibirskiy Gosudarstvenniy Aerokosmicheskiy Universitet',
    Location: 'Krasnoyarsk',
    lat: 56.01,
    lon: 92.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIENV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Sierra Nevada Corp.',
    Location: 'Sparks, Nevada',
    lat: 39.55,
    lon: -119.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIET',
    StateC: 'IN',
    C: 'Academic',
    TStart: '2006',
    TStop: '',
    name: 'Sri Shakthi Institute of Engineering and Technology',
    Location: 'Coimbatore, Tamil Nade',
    lat: 11.02,
    lon: 76.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SII',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1982',
    TStop: '1993 Jul',
    name: 'Space Industries Inc',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SII',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993 Jul',
    TStop: '',
    name: 'Space Industries International/Calspan',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIL',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Space Innovations Ltd',
    Location: 'Newbury, Berkshire',
    lat: 51.4,
    lon: -1.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SILK',
    StateC: 'CYM',
    C: 'Commercial',
    TStart: '2016 Apr',
    TStop: '',
    name: 'Silkwave Holdings Ltd',
    Location: 'George Town, Grand Cayman',
    lat: 19.3,
    lon: -81.39,
    alt: 0,
    Parent: 'CMMB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIMED',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1958',
    TStop: '1968',
    name: 'Shanghai jidian sheji yuan',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIMIT',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1928',
    TStop: '',
    name: 'Shanghai wei xitong yu xinxi jishu yanjiu',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIMG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '2006',
    name: 'Space Imaging Inc',
    Location: 'Thornton, Colorado',
    lat: 39.9,
    lon: -104.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'EOSAT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1996 Nov',
    TStop: '',
    name: 'Space Imaging EOSAT',
    Location: 'Washington, DC/Lanham, Md.',
    lat: 38.97,
    lon: -76.86,
    alt: 0,
    Parent: 'SIMG',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SINDO',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '1993',
    TStop: '2003',
    name: 'PT Satellit Palapa Indonesia (Satelindo)',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SINO',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '1994 May',
    TStop: '',
    name: 'Xinnuo weixing tongxin gongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999 Nov 18',
    TStop: '2008 Aug 5',
    name: 'Sirius Satellite Radio Inc',
    Location: 'New York, New York',
    lat: 40.71,
    lon: -74.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIRION',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2013',
    TStop: '2019 Oct',
    name: 'Sirion Global Pty Ltd.',
    Location: 'Gold Coast:Southport, Queensland',
    lat: -27.96,
    lon: 153.4,
    alt: 0,
    Parent: 'HELW',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIROTS',
    StateC: 'RU',
    C: 'Academic',
    TStart: '2014',
    TStop: '',
    name: 'Obrazovatel\'niy Tsentr Sirius',
    Location: 'Sochi',
    lat: 43.59,
    lon: 39.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008 Aug 5',
    TStop: '',
    name: 'Sirius XM Radio Inc',
    Location: 'New York, New York',
    lat: 40.71,
    lon: -74.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SIS',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'Space International Services',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SISE',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Shanghai weixing gongcheng yanjiu suog',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: 'SAST',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SISP',
    StateC: 'CN',
    C: 'Military',
    TStart: '2007 Jan',
    TStop: '',
    name: 'Shanghai kongjian tuijin yanjiu sup',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SITAEL',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'SITAEL SpA.',
    Location: 'Forli',
    lat: 44.23,
    lon: 12.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SITP',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1958',
    TStop: '',
    name: 'Shanghai jishu wuli yanjiu suo',
    Location: 'Shanghai',
    lat: 31.23,
    lon: 121.47,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SJSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1857',
    TStop: '',
    name: 'San Jose State University',
    Location: 'San Jose, California',
    lat: 37.34,
    lon: -121.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SJTU',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1896',
    TStop: '',
    name: 'Shanghai Jiaotong Daxue',
    Location: 'Shanghai',
    lat: 31.2,
    lon: 121.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKB30',
    StateC: 'SU',
    C: 'Military',
    TStart: '1960',
    TStop: '1975',
    name: 'SKB-30 (G B Kisunko)',
    Location: 'Mosvka:Sokol',
    lat: 55.8,
    lon: 37.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKB385',
    StateC: 'SU',
    C: 'Government',
    TStart: '1959',
    TStop: '1993',
    name: 'SKB-385 (Makeev)',
    Location: 'Miass',
    lat: 55,
    lon: 60.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKB385',
    StateC: 'SU',
    C: 'Government',
    TStart: '1949',
    TStop: '1959',
    name: 'SKB-385, Zlatoust',
    Location: 'Zlatoust',
    lat: 55.17,
    lon: 59.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1977',
    TStop: '',
    name: 'Salish Kootenai College',
    Location: 'Pablo, Montana',
    lat: 47.6,
    lon: -114.11,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKI',
    StateC: 'IN',
    C: 'Academic',
    TStart: '2016',
    TStop: '',
    name: 'Space Kids India',
    Location: 'Chennai',
    lat: 13.08,
    lon: 80.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'JCSAT',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2008 Aug',
    TStop: '',
    name: 'Sky Perfect JSAT Corp.',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKTEL',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '1997 Mar',
    TStop: '',
    name: 'SK Telecom',
    Location: 'Seoul:Jung-gu',
    lat: 37.56,
    lon: 126.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUMED',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'SK Telink',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: 'SKTEL',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYBOX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012',
    TStop: '2016 Mar',
    name: 'Skybox Imaging',
    Location: 'San Jose:Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYB',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'DirecTV Latin America/Sky Brasil',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'DTV',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYFOX',
    StateC: 'CZ',
    C: 'Commercial',
    TStart: '2014',
    TStop: '',
    name: 'SkyFox Labs s.r.o.',
    Location: 'Praha',
    lat: 50.11,
    lon: 14.53,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYM',
    StateC: 'MX',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'SKY Mexico',
    Location: 'Ciudad de Mexico',
    lat: 19.43,
    lon: -99.13,
    alt: 0,
    Parent: 'DTV',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYNET',
    StateC: 'UK',
    C: 'Military',
    TStart: '1984',
    TStop: '1987',
    name: 'Skynet 4 Payload Specialist Team, Ministry of Defence',
    Location: 'Whitehall, London',
    lat: 51.51,
    lon: -0.13,
    alt: 0,
    Parent: 'MOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYR',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Skyrora Ltd.',
    Location: 'Edinburgh',
    lat: 55.95,
    lon: -3.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYTC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '2010 Jul',
    name: 'SkyTerra Comms',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYTCA',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'SkyTerra Canada',
    Location: 'Ottawa, Ontario',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: 'SKYTC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MSV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008 Dec',
    TStop: '',
    name: 'SkyTerra LP',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'SKYTC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLAF',
    StateC: 'SK',
    C: 'Military',
    TStart: '1993 Jan 1',
    TStop: '',
    name: 'Slovak Air Force',
    Location: 'Zvolen',
    lat: 48.57,
    lon: 19.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLAUNCH',
    StateC: 'AU',
    C: 'Commercial',
    TStart: '2017 Aug',
    TStop: '',
    name: 'Southern Launch',
    Location: 'Adelaide, S Australia',
    lat: -34.92,
    lon: 138.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLII',
    StateC: 'US',
    C: 'Academic',
    TStart: '1900',
    TStop: '1960',
    name: 'Southwest Louisiana Industrial Institute',
    Location: 'Lafayette, Louisiana',
    lat: 30.22,
    lon: -92.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLOBO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'Sierra Lobo, Inc.',
    Location: 'Fremont, Ohio',
    lat: 41.35,
    lon: -83.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLPS',
    StateC: 'US',
    C: 'Government',
    TStart: '1978',
    TStop: '2000',
    name: 'Spacelab Payload Specialist group',
    Location: 'Houston:Clear Lake, Texas',
    lat: 29.56,
    lon: -95.12,
    alt: 0,
    Parent: 'JSC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLREC',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'Hangtian tujin jishu yanjiuyuan',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: 'CASC',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1818',
    TStop: '',
    name: 'Saint Louis University',
    Location: 'St Louis, Missouri',
    lat: 38.64,
    lon: -90.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFWDD',
    StateC: 'US',
    C: 'Military',
    TStart: '2019 Dec 20',
    TStop: '2021 Aug',
    name: 'US Space Force Space and Missile Center',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: 'USSF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SMCTV',
    StateC: 'US',
    C: 'Military',
    TStart: '1995 Jul',
    TStop: '2001 Jun 29',
    name: 'USAF Space and Missile Center, TEV directorate',
    Location: 'Kirtland AFB, Albequerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SMCTE',
    StateC: 'US',
    C: 'Military',
    TStart: '1995 Jul',
    TStop: '2001 Jun 29',
    name: 'USAF Space and Missile Center, TE directorate',
    Location: 'Kirtland AFB, Albequerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SMCXR',
    StateC: 'US',
    C: 'Military',
    TStart: '2005',
    TStop: '',
    name: 'USAF Space and Missile Center, Development Planning Directorate',
    Location: 'Kirtland AFB, Albequerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1997 Oct 1',
    TStop: '',
    name: 'US Army Space and Missile Defense Command (USASMDC)',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SMSA',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '1963 Dec 1',
    name: 'US Army Signal Missile Support Agency',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1937 Feb 1',
    TStop: '1957 Mar 1',
    name: 'SNCAE (Soci\\\'et\\\'e Nationale des cons. a\\\'ero. du sud-est,Ch.Romano)',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNCASO',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1945',
    TStop: '1957 Mar 1',
    name: 'Soc. Nat. des cons.aero. du sud-Ouest, Ch. Courbevoie',
    Location: 'Paris:Courbevoie',
    lat: 48.9,
    lon: 2.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNECMA',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1966',
    TStop: '2005 Apr',
    name: 'SNECMA (SN d\'Etude et de Construction de Moteurs d\'Aviation) Moteurs',
    Location: 'Paris:Evry',
    lat: 48.62,
    lon: 2.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNECMA',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2005 Apr',
    TStop: '',
    name: 'SAFRAN SNECMA Moteurs',
    Location: 'Paris:Evry',
    lat: 48.62,
    lon: 2.43,
    alt: 0,
    Parent: 'SAFRAN',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNECDE',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1962',
    TStop: '1969',
    name: 'SNECMA Divsion des Engins et de l\'Espace',
    Location: 'Paris:Evry',
    lat: 48.62,
    lon: 2.43,
    alt: 0,
    Parent: 'SNECMA',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPR',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2002 Feb 28',
    name: 'SNECMA Division SEP',
    Location: 'Bordeaux:Le Haillan/St-Medard',
    lat: 44.87,
    lon: -0.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNECBL',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1965',
    TStop: '1969',
    name: 'SNECMA Division Moteurs Spatiaux - Blanquefort',
    Location: 'Bordeaux:Blanquefort',
    lat: 44.91,
    lon: -0.63,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPR',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2002 Feb 28',
    TStop: '2012 Apr',
    name: 'SNECMA Propulsion Solide',
    Location: 'Bordeaux:Le Haillan',
    lat: 44.87,
    lon: -0.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEP',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'SNECMA Moteurs Spatiaux (Vernon)',
    Location: 'Vernon, Eure',
    lat: 49.09,
    lon: 1.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SEPVR',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2006',
    name: 'SNECMA-Villaroche',
    Location: 'Villaroche, Seine-et-Marne',
    lat: 48.61,
    lon: 2.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KAI',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2016 Apr',
    TStop: '',
    name: 'Samarskiy Natsional\'niy Issledovatel\'skiy Univ. im. S.P Koroleva',
    Location: 'Samara (Kubyshev)',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SDP',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1971 Mar 8',
    TStop: '2012 Apr',
    name: 'Societe Nationale de Poudres et Explosifs (SNPE)',
    Location: 'Saint-Medard-en-Jalles, Gironde',
    lat: 44.9,
    lon: -0.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNSB',
    StateC: 'S',
    C: 'Government',
    TStart: '1972 Jul',
    TStop: '',
    name: 'Rymdstyrelsen',
    Location: 'Stockholm:Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPDEV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'Sierra Nevada Corp. Space Systems (SpaceDev)',
    Location: 'San Diego:Poway, California',
    lat: 32.97,
    lon: -117.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNU',
    StateC: 'KR',
    C: 'Academic',
    TStart: '1946',
    TStop: '',
    name: 'Seoul Deahakgyo',
    Location: 'Seoul:Gwanak',
    lat: 37.46,
    lon: 126.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNVL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Sierra Nevada Corp. Space Systems (Louisville)',
    Location: 'Boulder:Louisville, Colorado',
    lat: 39.98,
    lon: -105.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOCOM',
    StateC: 'US',
    C: 'Military',
    TStart: '1987',
    TStop: '',
    name: 'US Special Operations Command',
    Location: 'MacDill AFB, Tampa, Florida',
    lat: 27.85,
    lon: -82.52,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOHLA',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'Space Oriented Higashiosaka Leading Association',
    Location: 'Osaka:Higashiosaka (E Osaka)',
    lat: 34.68,
    lon: 135.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOKA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1969',
    TStop: '',
    name: 'Soka Daigaku',
    Location: 'Tokyo:Hachioji',
    lat: 35.67,
    lon: 139.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ECHOM',
    StateC: 'IE',
    C: 'Commercial',
    TStart: '2008',
    TStop: '2015 Mar',
    name: 'Solaris Mobile',
    Location: 'Dublin',
    lat: 53.35,
    lon: -6.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SONY',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Sony Computer Science Laboratories, Inc.',
    Location: 'Tokyo:Shinagawa',
    lat: 35.68,
    lon: 139.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOR',
    StateC: 'US',
    C: 'Military',
    TStart: '1993',
    TStop: '',
    name: 'USAF Starfire Optical Range, AFRL',
    Location: 'Kirtland AFB, Albuquerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SORUN',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'Sorun Corporation',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOSA',
    StateC: 'SK',
    C: 'Academic',
    TStart: '2013',
    TStop: '',
    name: 'Slovenska organizacia pre vesmirne aktivity',
    Location: 'Bratislava/Vel\'ka Paka',
    lat: 48.04,
    lon: 17.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOSU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Sonoma State University',
    Location: 'Santa Rosa:Rohnert Park, California',
    lat: 38.34,
    lon: -122.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOTI',
    StateC: 'IQ',
    C: 'Military',
    TStart: '1974',
    TStop: '1987 Aug 1',
    name: 'State Organization for Technical Industries (SOTI)',
    Location: 'Baghdad, Iraq',
    lat: 33.33,
    lon: 44.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOTON',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1952',
    TStop: '',
    name: 'University of Southampton',
    Location: 'Southampton, Hampshire',
    lat: 50.93,
    lon: -1.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NII125',
    StateC: 'RU',
    C: 'Government',
    TStart: '1980',
    TStop: '',
    name: 'NPO Soyuz',
    Location: 'Mosvka:Lyubertsy/Dzerzhinskiy',
    lat: 55.67,
    lon: 37.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SOVA',
    StateC: 'SU',
    C: 'Military',
    TStart: '1946',
    TStop: '1992',
    name: 'Sovietskaya Armiya (Sukhotniye Voiska, Vooruzhyonniye Sili SSSR)',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'VS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1988',
    TStop: '2004',
    name: 'Spectrum Astro',
    Location: 'Gilbert, Arizona',
    lat: 33.35,
    lon: -111.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPABD',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'SpaceBD Corp',
    Location: 'Tokyo',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAC',
    StateC: 'J',
    C: 'Government',
    TStart: '2007',
    TStop: '',
    name: 'Eisei sokui riyo suishin senta',
    Location: 'Tokyo:Chiyoda',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998',
    TStop: '',
    name: 'Space Adventures, Inc.',
    Location: 'Vienna, Virginia',
    lat: 38.9,
    lon: -77.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAIL',
    StateC: 'IL',
    C: 'Academic',
    TStart: '2011',
    TStop: '',
    name: 'SpaceIL',
    Location: 'Tel Aviv',
    lat: 32.11,
    lon: 34.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAR',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1992 Jan',
    TStop: '1999 Mar',
    name: 'Spar Aerospace Robotics Div. (Brampton)',
    Location: 'Brampton, Ontario',
    lat: 43.68,
    lon: -79.77,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEHAVT',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1967',
    TStop: '',
    name: 'Spar Aerospace',
    Location: 'Toronto:Downsview, Ontario',
    lat: 43.73,
    lon: -79.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPARM',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1967',
    TStop: '1999',
    name: 'Spar Aerospace Space Systems',
    Location: 'Montreal:St-Anne-de-Bellevue, Quebec',
    lat: 45.4,
    lon: -73.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RCAV',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1977',
    TStop: '1985',
    name: 'Spar Aerospace (Montreal-St Henri)',
    Location: 'Montreal:St Henri',
    lat: 45.48,
    lon: -73.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAWAR',
    StateC: 'US',
    C: 'Military',
    TStart: '1987',
    TStop: '',
    name: 'Space and Naval Warfare Systems Command, Space Field Activity',
    Location: 'Chantilly, Virginia',
    lat: 38.88,
    lon: -77.4,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAWSD',
    StateC: 'US',
    C: 'Military',
    TStart: '2004',
    TStop: '',
    name: 'Space and Naval Warfare Systems Command, San Diego',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: 'SPAWAR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPCOK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Shanghai OK wei hangtian keji YG',
    Location: 'Shanghai:Jiading',
    lat: 31.34,
    lon: 121.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPCOM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1976',
    TStop: '1993',
    name: 'Contel Space Communications Co. (Spacecom)',
    Location: 'Gaithersburg, Maryland',
    lat: 39.13,
    lon: -77.23,
    alt: 0,
    Parent: 'CONTF',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPDEV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2008',
    name: 'SpaceDev',
    Location: 'San Diego:Poway, California',
    lat: 32.97,
    lon: -117.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPER',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960',
    TStop: '1986',
    name: 'Sperry Utah Co.',
    Location: 'Salt Lake City, Utah',
    lat: 40.75,
    lon: -111.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB9',
    StateC: 'SU',
    C: 'Military',
    TStart: '1970',
    TStop: '',
    name: 'AO Spetztekhnika',
    Location: 'Sverdlovsk (Ekaterinburg)',
    lat: 56.83,
    lon: 60.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPFL',
    StateC: 'US',
    C: 'Government',
    TStart: '1989',
    TStop: '2000',
    name: 'Spaceport Florida Authority',
    Location: 'Cape Canaveral, Florida',
    lat: 28.39,
    lon: -80.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1961',
    TStop: '',
    name: 'Space General Div, Aerojet-General Corp.',
    Location: 'El Monte, California',
    lat: 34.07,
    lon: -118.03,
    alt: 0,
    Parent: 'AJ',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPHARM',
    StateC: 'IL',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'SpacePharma R&D group',
    Location: 'Herzliya',
    lat: 32.17,
    lon: 34.85,
    alt: 0,
    Parent: 'SPHARS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPHARS',
    StateC: 'CL',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'SpacePharma',
    Location: 'Basel:Courgenay',
    lat: 47.4,
    lon: 7.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NANSFI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2014 Aug',
    TStop: '',
    name: 'Spire',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPIREG',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2015 Jun',
    TStop: '',
    name: 'Spire/Glasgow',
    Location: 'Glasgow',
    lat: 55.86,
    lon: -4.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPIREL',
    StateC: 'L',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Spire Global Luxembourg',
    Location: 'Luxembourg',
    lat: 49.96,
    lon: 6.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPLOG',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Space Logistics LLC',
    Location: 'Washington:Dulles, Virginia',
    lat: 39.01,
    lon: -77.43,
    alt: 0,
    Parent: 'NGISD',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPMIC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2002',
    TStop: '',
    name: 'Space Micro',
    Location: 'San Diego',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPOG',
    StateC: 'UK',
    C: 'Military',
    TStart: '1945',
    TStop: '1945',
    name: 'Special Projectiles Operation Group',
    Location: 'Cuxhaven, Germany',
    lat: 53.86,
    lon: 8.69,
    alt: 0,
    Parent: 'UKWO',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPOT',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1982',
    TStop: '',
    name: 'SPOT Image',
    Location: 'Toulouse',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPQ',
    StateC: 'US',
    C: 'Academic',
    TStart: '1994',
    TStop: '2020 Oct',
    name: 'SpaceQuest',
    Location: 'Fairfax, Virginia',
    lat: 38.85,
    lon: -77.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPQ',
    StateC: 'US',
    C: 'Academic',
    TStart: '2020 Oct',
    TStop: '',
    name: 'AAC SpaceQuest',
    Location: 'Fairfax, Virginia',
    lat: 38.85,
    lon: -77.3,
    alt: 0,
    Parent: 'AACM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFORS',
    StateC: 'US',
    C: 'Military',
    TStart: '2018',
    TStop: '',
    name: 'Space Rapid Capabilities Office, US Space Force',
    Location: 'Kirtland AFB, Albuquerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPSI',
    StateC: 'SI',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Center odlicnosti Vesolje-SI',
    Location: 'Ljubljana',
    lat: 46.05,
    lon: 14.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPUT',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'OOO Sputnikovie Innovatsionnie Kosmicheskie Sistemi',
    Location: 'Moskva:Rumyantsevo',
    lat: 55.63,
    lon: 37.44,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPVR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Jan',
    TStop: '',
    name: 'SpaceVR',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2007 Aug',
    TStop: '',
    name: 'SpaceX',
    Location: 'Hawthorne, California',
    lat: 33.92,
    lon: -118.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2002',
    TStop: '2007 Aug',
    name: 'SpaceX (El Segundo)',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPXS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015 Jun',
    TStop: '',
    name: 'SpaceX (Seattle)',
    Location: 'Seattle:Redmond, Washington',
    lat: 47.67,
    lon: -122.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPXT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'SpaceX spaceflight passengers',
    Location: 'Hawthorne, California',
    lat: 33.92,
    lon: -118.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPXTX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'SpaceX (McGregor)',
    Location: 'McGregor, Texas',
    lat: 31.43,
    lon: -97.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRC',
    StateC: 'UK',
    C: 'Government',
    TStart: '1965',
    TStop: '1981',
    name: 'UK Science Research Council',
    Location: 'Swindon, England',
    lat: 51.56,
    lon: -1.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HARP',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1966',
    TStop: '1980',
    name: 'Space Research Coporation',
    Location: 'Highwater, Quebec',
    lat: 45.02,
    lon: -72.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRDL',
    StateC: 'US',
    C: 'Military',
    TStart: '1929',
    TStop: '1949',
    name: 'US Army Signal Corps R&D Labs',
    Location: 'Ft Monmouth, New Jersey',
    lat: 40.31,
    lon: -74.05,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1970',
    TStop: '1977',
    name: 'SRI',
    Location: 'Menlo Park, California',
    lat: 37.45,
    lon: -122.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1977',
    TStop: '',
    name: 'SRI International',
    Location: 'Menlo Park, California',
    lat: 37.45,
    lon: -122.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1946',
    TStop: '1970',
    name: 'Stanford Research Institute',
    Location: 'Menlo Park, California',
    lat: 37.45,
    lon: -122.18,
    alt: 0,
    Parent: 'STAN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CLSR',
    StateC: 'BG',
    C: 'Academic',
    TStart: '1987',
    TStop: '',
    name: 'Space Research Inst, Bulgarian Acad. Sci.',
    Location: 'Sofia',
    lat: 42.7,
    lon: 23.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRMU',
    StateC: 'IN',
    C: 'Academic',
    TStart: '1985',
    TStop: '2006',
    name: 'SRM (Sri Ramaswamy Memorial) Engineering College, Anna University',
    Location: 'Chennai',
    lat: 12.82,
    lon: 80.04,
    alt: 0,
    Parent: 'ANNAU',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRMU',
    StateC: 'IN',
    C: 'Academic',
    TStart: '2006',
    TStop: '',
    name: 'SRM (Sri Ramaswamy Memorial) University',
    Location: 'Chennai',
    lat: 12.82,
    lon: 80.04,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SROE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1929',
    TStop: '1965',
    name: 'Saunders-Roe (Saro)',
    Location: 'Cowes, Isle of Wight',
    lat: 50.76,
    lon: -1.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRON',
    StateC: 'NL',
    C: 'Government',
    TStart: '1983',
    TStop: '',
    name: 'Space Research Org. of the Netherlands (SRON)',
    Location: 'Utrecht',
    lat: 52.09,
    lon: 5.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRSES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '',
    name: 'Space Recovery Systems',
    Location: 'El Segundo, California',
    lat: 33.92,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SS500',
    StateC: 'DR',
    C: 'Military',
    TStart: '1944',
    TStop: '1945',
    name: 'SS Werfer-Abteilung 500',
    Location: 'Den Haag',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RTG',
    StateC: 'S',
    C: 'Government',
    TStart: '1972 Jul',
    TStop: '',
    name: 'Svenska Rymdaktiebolaget (Rymd AB, Swedish Space Corporation)',
    Location: 'Stockholm:Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Seattle Scientific Corp.',
    Location: 'Seattle, Washington',
    lat: 47.61,
    lon: -122.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSCS',
    StateC: 'S',
    C: 'Commercial',
    TStart: '1972 Jul',
    TStop: '2011 Jun',
    name: 'SSC Space Systems Group',
    Location: 'Stockholm:Solna',
    lat: 59.35,
    lon: 18,
    alt: 0,
    Parent: 'SSC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARGMA',
    StateC: 'US',
    C: 'Military',
    TStart: '1992 Aug',
    TStop: '1997 Aug',
    name: 'US Army Space and Strategic Defense Command',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '1990 Dec',
    name: 'Space Services Inc.',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSICE',
    StateC: 'US',
    C: 'Academic',
    TStart: '1994',
    TStop: '',
    name: 'Celestis, Inc. (SSI)',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: 'SSI',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'Space Services Inc.',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSIM',
    StateC: 'MC',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Space Systems International - Monaco S.A.M.',
    Location: 'Monaco',
    lat: 43.73,
    lon: 7.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Nov',
    TStop: '2017 Oct',
    name: 'SS/Loral (MDA)',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'MDABC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FORDA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017 Oct',
    TStop: '2019 Mar',
    name: 'SS/Loral (Maxar)',
    Location: 'Palo Alto, California',
    lat: 37.43,
    lon: -122.14,
    alt: 0,
    Parent: 'MAXAR',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNSPO',
    StateC: 'US',
    C: 'Military',
    TStart: '1968',
    TStop: '1987',
    name: 'USN Strategic Systems Programs Office',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSTARS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1993',
    TStop: '',
    name: 'Southern Stars Group LLC',
    Location: 'San Francisco, California',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSTL',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2009',
    name: 'Surrey Satellite Technology Ltd',
    Location: 'Guildford, Surrey, England',
    lat: 51.24,
    lon: -0.59,
    alt: 0,
    Parent: 'SURREY',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSTL',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Surrey Satellite Technology Ltd/Astrium',
    Location: 'Guildford, Surrey, England',
    lat: 51.24,
    lon: -0.59,
    alt: 0,
    Parent: 'ASTUK',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SSTUS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '2017 Nov 13',
    name: 'Surrey Satellite Technology US LLC',
    Location: 'Denver:Englewood, Colorado',
    lat: 39.65,
    lon: -104.99,
    alt: 0,
    Parent: 'SSTL',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ST2V',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '2008',
    TStop: '',
    name: 'ST-2 Satellite Ventures Pte Ltd (STS) (STEL/CHUNG)',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: 'STEL',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1958',
    TStop: '2001 Jan',
    name: 'Kagaku gijutsu shinko kiko',
    Location: 'Tokyo',
    lat: 35.68,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STADK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2012',
    TStop: '2014 Jun',
    name: 'STADOKO UG',
    Location: 'Aachen',
    lat: 50.78,
    lon: 6.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STAN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1885',
    TStop: '',
    name: 'Stanford University',
    Location: 'Stanford, California',
    lat: 37.42,
    lon: -122.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STARA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Stara Space',
    Location: 'Los Angeles:Manhattan Beach',
    lat: 33.89,
    lon: -118.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STBO',
    StateC: 'ZA',
    C: 'Academic',
    TStart: '1866',
    TStop: '',
    name: 'Stellenbosch University',
    Location: 'Cape Town, South Africa',
    lat: -33.93,
    lon: 18.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STEAM',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'SteamJet Space Systems',
    Location: 'Ashford, Kent',
    lat: 51.15,
    lon: 1.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STEL',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '1992 Mar',
    TStop: '',
    name: 'Singapore Telecom',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STELEC',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '1969',
    TStop: '',
    name: 'Singapore Technologies Electronics Ltd',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STELLT',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2001 Feb',
    TStop: '2002 Aug',
    name: 'Stellat',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STEN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1999',
    TStop: '',
    name: 'STENSAT',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'MTF',
    StateC: 'US',
    C: 'Government',
    TStart: '1988',
    TStop: '',
    name: 'NASA Stennis Space Center',
    Location: 'Pearl River, Mississippi',
    lat: 30.62,
    lon: -89.6,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STESS',
    StateC: 'SG',
    C: 'Commercial',
    TStart: '2011 May',
    TStop: '',
    name: 'Singapore Technologies Electronics (Satellite Systems)',
    Location: 'Singapore',
    lat: 1.3,
    lon: 103.8,
    alt: 0,
    Parent: 'STELEC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SRC',
    StateC: 'UK',
    C: 'Government',
    TStart: '2007',
    TStop: '',
    name: 'UK Science and Technology Facilities Council',
    Location: 'Swindon, England',
    lat: 51.56,
    lon: -1.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STG',
    StateC: 'US',
    C: 'Government',
    TStart: '1963 Jan 3',
    TStop: '',
    name: 'NASA Space Task Group',
    Location: 'Langley Field, Virginia',
    lat: 37.09,
    lon: -76.38,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STG',
    StateC: 'US',
    C: 'Government',
    TStart: '1958 Oct',
    TStop: '1963 Jan 3',
    name: 'NASA Langley Research Center, Space Task Group',
    Location: 'Langley Field, Virginia',
    lat: 37.09,
    lon: -76.38,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STIOT',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Sateliot',
    Location: 'Barcelona',
    lat: 41.38,
    lon: 2.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '1958',
    name: 'Space Technology Laboratories',
    Location: 'LA:Redondo Beach, California',
    lat: 33.86,
    lon: -118.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STLC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1986',
    TStop: '1990 Apr',
    name: 'IBM Satellite Transponder Leasing Corp.',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STLC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990 Apr',
    TStop: '2001',
    name: 'Satellite Transponder Leasing Corp.',
    Location: 'McLean, Virginia',
    lat: 38.93,
    lon: -77.18,
    alt: 0,
    Parent: 'HCI',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STMS',
    StateC: 'US',
    C: 'Academic',
    TStart: '1944',
    TStop: '',
    name: 'St. Thomas More Cathedral School',
    Location: 'Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STO',
    StateC: 'S',
    C: 'Academic',
    TStart: '1878',
    TStop: '',
    name: 'Stockholms universitet',
    Location: 'Stockholm',
    lat: 59.37,
    lon: 18.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STONE',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2000 Dec',
    TStop: '',
    name: 'Star One',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'EMBR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STP',
    StateC: 'US',
    C: 'Military',
    TStart: '1971 Jun',
    TStop: '',
    name: 'USAF SMC/DoD Space Test Program',
    Location: 'Kirtland AFB, Albuquerque, New Mexico',
    lat: 35.04,
    lon: -106.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZAV47',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1986 Apr 7',
    TStop: '',
    name: 'PO Strela',
    Location: 'Orenburg',
    lat: 51.78,
    lon: 55.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STSM',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1996 Aug 6',
    TStop: '*',
    name: 'Starsem',
    Location: 'Paris:Evry',
    lat: 48.62,
    lon: 2.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STST',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '1985',
    name: 'Starstruck Inc.',
    Location: 'San Francisco:Redwood City, California',
    lat: 37.48,
    lon: -122.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SU190',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Unknown USSR manufacturer 190',
    Location: '::',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SU523',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Unknown USSR manufacturer 523',
    Location: '::',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SU782',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Unknown USSR manufacturer 782',
    Location: '::',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1957 Mar 1',
    TStop: '1970 Jan 1',
    name: 'Sud Aviation',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SNCASO',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1957 Mar 1',
    TStop: '1970 Jan 1',
    name: 'Sud Aviation, Ch. Courbevoie (SEREB)',
    Location: 'Paris:Courbevoie',
    lat: 48.9,
    lon: 2.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPER',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1956',
    TStop: '1960',
    name: 'Sperry Utah Engineering Labs',
    Location: 'Salt Lake City, Utah',
    lat: 40.75,
    lon: -111.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1847',
    TStop: '1964',
    name: 'State University of Iowa (Iowa University)',
    Location: 'Iowa City, Iowa',
    lat: 41.66,
    lon: -91.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUPA',
    StateC: 'PK',
    C: 'Government',
    TStart: '1961 Sep',
    TStop: '',
    name: 'Space and Upper Atmosphere Research Commission',
    Location: 'Islamabad',
    lat: 33.72,
    lon: 73.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUPAER',
    StateC: 'F',
    C: 'Academic',
    TStart: '1909',
    TStop: '2007',
    name: 'Ecole Nationale Superieure de l\'aeronautique et de l\'espace',
    Location: 'Toulouse',
    lat: 43.6,
    lon: 1.44,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUPSAT',
    StateC: 'LK',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'SupremeSAT (Pvt) Ltd.',
    Location: 'Colombo',
    lat: 6.93,
    lon: -79.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUPSI',
    StateC: 'CH',
    C: 'Academic',
    TStart: '1997',
    TStop: '',
    name: 'Scuola Universitaria Professionale della Svizzera, Dipart. Tecn. Innovative',
    Location: 'Manno, Repubblica e Cantone Ticino',
    lat: 46.32,
    lon: 8.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SURREY',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1985',
    TStop: '',
    name: 'Surrey Space Centre, University of Surrey',
    Location: 'Guildford, Surrey',
    lat: 51.24,
    lon: -0.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUT',
    StateC: 'IR',
    C: 'Academic',
    TStart: '1966',
    TStop: '',
    name: 'Daneshgah-e San\'ati-ye Sharif',
    Location: 'Tehran',
    lat: 35.69,
    lon: 51.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SVC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1969',
    TStop: '',
    name: 'Space Vector Corp',
    Location: 'LA:Chatsworth/Canoga Park, California',
    lat: 34.26,
    lon: -118.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SVEC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1985',
    TStop: '2002',
    name: 'Space Vacuum Epitaxy Center',
    Location: 'Houston, Texas',
    lat: 29.76,
    lon: -95.38,
    alt: 0,
    Parent: 'HOUS',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWALES',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1978',
    TStop: '2007 Jun',
    name: 'Swales Aerospace',
    Location: 'Beltsville, Maryland',
    lat: 39.04,
    lon: -76.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWARM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '2021 Aug',
    name: 'Swarm Technologies',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWARMX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021 Aug',
    TStop: '',
    name: 'Swarm Technologies (SpaceX)',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: 'SPX',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWARNZ',
    StateC: 'NZ',
    C: 'Commercial',
    TStart: '2020',
    TStop: '',
    name: 'Swarm Technologies New Zealand',
    Location: 'Wellington',
    lat: -41.29,
    lon: 174.77,
    alt: 0,
    Parent: 'SWARM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTD',
    StateC: 'US',
    C: 'Academic',
    TStart: '1961',
    TStop: '1969',
    name: 'Southwest Center for Advanced Studies',
    Location: 'Dallas, Texas',
    lat: 32.78,
    lon: -96.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWRI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1947',
    TStop: '',
    name: 'SouthWest Research Institute',
    Location: 'San Antonio, Texas',
    lat: 29.42,
    lon: -98.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SWRB',
    StateC: 'US',
    C: 'Academic',
    TStart: '1994',
    TStop: '',
    name: 'SouthWest Research Institute (Boulder)',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: 'SWRI',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUSX',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1961 Aug',
    TStop: '',
    name: 'University of Sussex',
    Location: 'Brighton:Falmer, Sussex, England',
    lat: 50.87,
    lon: -0.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SYAAF',
    StateC: 'SY',
    C: 'Military',
    TStart: '1948',
    TStop: '',
    name: 'al-Quwwat al-Jawwiyah al-\'Arabiyah as-Suriyah',
    Location: 'Aleppo',
    lat: 36.22,
    lon: 37.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SYMC',
    StateC: 'SY',
    C: 'Military',
    TStart: '1980',
    TStop: '',
    name: 'Syrian Missile Command',
    Location: 'Aleppo',
    lat: 36.22,
    lon: 37.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SYNSP',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2018 Feb',
    TStop: '',
    name: 'Synspective Inc.',
    Location: 'Tokyo:Koto',
    lat: 35.67,
    lon: 139.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SYRU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1870',
    TStop: '',
    name: 'Syracuse University',
    Location: 'Syracuse, New York',
    lat: 43.05,
    lon: -76.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SZRTC',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'Shaanxi Zhongtian huojian jishu gufen youxian gongsi',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: 'ARMT',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TAC',
    StateC: 'US',
    C: 'Military',
    TStart: '1946',
    TStop: '1992',
    name: 'US Air Force Tactical Air Command',
    Location: 'Langley AFB, Virginia',
    lat: 37.08,
    lon: -76.36,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'IEM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1980',
    TStop: '',
    name: 'NPO Taifun (Insitut Eksperimental\'niy Meteolorologii)',
    Location: 'Obninsk, Kaluga Oblast',
    lat: 55.09,
    lon: 36.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TAMA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1950',
    TStop: '',
    name: 'Tama bijutsu daigaku',
    Location: 'Tokyo:Hachioji',
    lat: 35.67,
    lon: 139.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TAMU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1876',
    TStop: '',
    name: 'Texas A&M University',
    Location: 'College Station, Texas',
    lat: 30.6,
    lon: -96.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TAO',
    StateC: 'J',
    C: 'Academic',
    TStart: '1924',
    TStop: '1988',
    name: 'Tokyo tenmondai',
    Location: 'Tokyo:Mitaka',
    lat: 35.68,
    lon: 139.56,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSCJ',
    StateC: 'J',
    C: 'Academic',
    TStart: '1992 Oct',
    TStop: '',
    name: 'Telecommunications Advancement Organazation of Japan',
    Location: 'Tokyo:Minato',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TARTU',
    StateC: 'EE',
    C: 'Academic',
    TStart: '1632',
    TStop: '',
    name: 'Tartu Ulikool',
    Location: 'Tartu',
    lat: 58.38,
    lon: 26.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TAU',
    StateC: 'IL',
    C: 'Academic',
    TStart: '1956',
    TStop: '',
    name: 'Universitat Tel Aviv',
    Location: 'Tel Aviv',
    lat: 32.11,
    lon: 34.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TAYLU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1846',
    TStop: '',
    name: 'Taylor University',
    Location: 'Upland, Indiana',
    lat: 40.46,
    lon: -85.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SKYBOX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016 Mar',
    TStop: '2017 Apr',
    name: 'Google Terra Bella',
    Location: 'San Jose:Mountain View, California',
    lat: 37.39,
    lon: -122.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TBS',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1960',
    TStop: '',
    name: 'Kabushiki gaisha Tokyohoso',
    Location: 'Tokyo',
    lat: 35.66,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TCAN',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1969 Sep 1',
    TStop: '2007 Oct 5',
    name: 'Telesat Canada',
    Location: 'Ottawa, Ontario',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TCAN',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2007 Oct 5',
    TStop: '',
    name: 'Telesat Canada (Loral)',
    Location: 'Ottawa, Ontario',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: 'LORC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TCI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990',
    TStop: '1998',
    name: 'Telecommunications Satellite Inc. (Tempo Satellite Inc)',
    Location: 'Denver:Littleton/Englewood, Colorado',
    lat: 39.6,
    lon: -105.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CFTH',
    StateC: 'F',
    C: 'Commercial',
    TStart: '1968',
    TStop: '2000',
    name: 'Thomson-CSF',
    Location: 'Paris',
    lat: 48.86,
    lon: 2.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TECN',
    StateC: 'IL',
    C: 'Academic',
    TStart: '1924',
    TStop: '',
    name: 'Technion University',
    Location: 'Haifa',
    lat: 32.82,
    lon: 34.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TEIK',
    StateC: 'J',
    C: 'Academic',
    TStart: '1931',
    TStop: '',
    name: 'Teikyo daigaku',
    Location: 'Tokyo:Itabashi',
    lat: 35.76,
    lon: 139.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMIRK',
    StateC: 'IR',
    C: 'Academic',
    TStart: '1928',
    TStop: '1979',
    name: 'Tehran Polytechnic',
    Location: 'Tehran',
    lat: 35.7,
    lon: 51.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TEKEV',
    StateC: 'P',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'TEKEVER',
    Location: 'Lisboa',
    lat: 38.71,
    lon: -9.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TELB',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '1972',
    TStop: '1998 Jun',
    name: 'Telebras (Telecomunicacoes Brasileiras SA)',
    Location: 'Brasilia',
    lat: -15.79,
    lon: -47.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TELBR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1966',
    TStop: '',
    name: 'Teledyne Brown Engineering, Huntsville',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TELD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990 Jun',
    TStop: '2002',
    name: 'Teledesic LLC.',
    Location: 'Seattle:Bellevue, Washington',
    lat: 47.6,
    lon: -122.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TELED',
    StateC: 'I',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Dir. Gen.delle Telecom. dell\'Informatica e delle Tecnologie Avanzate',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: 'MDDI',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PER',
    StateC: 'ID',
    C: 'Commercial',
    TStart: '1991',
    TStop: '',
    name: 'PT Telekomunikasi Indonesia Tbk (Telkom)',
    Location: 'Jakarta',
    lat: -6.2,
    lon: 106.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TELMX',
    StateC: 'MX',
    C: 'Commercial',
    TStart: '1989',
    TStop: '',
    name: 'Telecomunicaciones de Mexico',
    Location: 'Ciudad de Mexico',
    lat: 19.43,
    lon: -99.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TELTN',
    StateC: 'TN',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'TELNET Holding',
    Location: 'Tunis',
    lat: 36.81,
    lon: 10.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TELTRU',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'RUS Telnet LLC',
    Location: 'Moscow',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'TELTN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TEMIS',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2010',
    TStop: '',
    name: 'Temis S.r.l.',
    Location: 'Milano:Corbetta',
    lat: 45.47,
    lon: 8.92,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CRI',
    StateC: 'DK',
    C: 'Commercial',
    TStart: '1997',
    TStop: '',
    name: 'Terma A/S, Birkerod',
    Location: 'Kobenhavn:Rudersdal/Birkerod',
    lat: 55.83,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TERRN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011 Jul 7',
    TStop: '',
    name: 'Terrestar Networks Inc. (Dish Network Corp)',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'DISH',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AMSC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2007',
    TStop: '2011 Jul 7',
    name: 'Terrestar Corp.',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TERRN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '2011 Jul 7',
    name: 'Terrestar Networks Inc.',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'TERRE',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TESLA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2003',
    TStop: '',
    name: 'Tesla, Inc.',
    Location: 'Fremont, California',
    lat: 37.55,
    lon: -121.99,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TETHA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1989',
    TStop: '',
    name: 'Tether Applications',
    Location: 'San Diego:Chula Vista, California',
    lat: 32.63,
    lon: -117.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TF88',
    StateC: 'US',
    C: 'Military',
    TStart: '1958 Apr 28',
    TStop: '1958 Sep 6',
    name: 'USN TF88',
    Location: 'USS Norton Sound, Atlantic Ocean',
    lat: 36.82,
    lon: -76.3,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SHIN',
    StateC: 'T',
    C: 'Commercial',
    TStart: '2008 Apr 10',
    TStop: '',
    name: 'Thaicom Public Company Ltd.',
    Location: 'Bangkok:Nonthaburi',
    lat: 13.85,
    lon: 100.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'FIAT',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2007 Apr 10',
    TStop: '',
    name: 'Thales Alenia Space/Torino (TAS-I)',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: 'THALP',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'CFTH',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2000',
    TStop: '',
    name: 'Thales Group',
    Location: 'Paris:Neuilly',
    lat: 48.89,
    lon: 2.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SELEN',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2007 Apr 10',
    TStop: '',
    name: 'Thales Alenia Space/Roma',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: 'THALP',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUD',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2007 Apr 10',
    TStop: '',
    name: 'Thales Alenia Space/Cannes (TAS-F)',
    Location: 'Cannes',
    lat: 43.55,
    lon: 7.01,
    alt: 0,
    Parent: 'THALP',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1929',
    TStop: '1982',
    name: 'Thiokol Chemical Co. (THKE or THKX)',
    Location: 'Elkton, Maryland',
    lat: 39.61,
    lon: -75.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2000',
    TStop: '2001',
    name: 'Alcoa Industrial Components/Thiokol',
    Location: 'Salt Lake City, Utah',
    lat: 40.75,
    lon: -111.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1989 Jul 1',
    TStop: '1998',
    name: 'Thiokol Corp.',
    Location: 'Ogden, Utah',
    lat: 41.19,
    lon: -111.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998',
    TStop: '2000',
    name: 'Cordant Technologies, ThiokolPropulsion',
    Location: 'Salt Lake City, Utah',
    lat: 40.75,
    lon: -111.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1947',
    TStop: '2001',
    name: 'Thiokol-Elkton',
    Location: 'Elkton, Maryland',
    lat: 39.61,
    lon: -75.83,
    alt: 0,
    Parent: 'THK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1957',
    TStop: '2001',
    name: 'Thiokol Wasatch Div/Air Force Plant 78',
    Location: 'Brigham City/Promontory, Utah',
    lat: 41.62,
    lon: -112.55,
    alt: 0,
    Parent: 'THK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1949',
    TStop: '1996',
    name: 'Thiokol/Huntsville',
    Location: 'Huntsville, Alabama',
    lat: 34.68,
    lon: -86.65,
    alt: 0,
    Parent: 'THK',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THKXM',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1952',
    TStop: '1971',
    name: 'Thiokol Longhorn Division',
    Location: 'Marshall, Texas',
    lat: 32.55,
    lon: -94.37,
    alt: 0,
    Parent: 'THK',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THUR',
    StateC: 'UAE',
    C: 'Commercial',
    TStart: '1997',
    TStop: '2018 Apr',
    name: 'Thuraya Satellite',
    Location: 'Abu Dhabi',
    lat: 24.47,
    lon: 54.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'THUR',
    StateC: 'UAE',
    C: 'Commercial',
    TStart: '2018 Apr',
    TStop: '',
    name: 'Thuraya Satellite (Yahsat)',
    Location: 'Abu Dhabi',
    lat: 24.47,
    lon: 54.37,
    alt: 0,
    Parent: 'ALYAH',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TIANJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Tianjin hangtian changzheng huojian zhizao youxian gongsi',
    Location: 'Tianjin',
    lat: 39.13,
    lon: 117.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TIANJU',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1895',
    TStop: '',
    name: 'Tianjin daxue',
    Location: 'Tianjin',
    lat: 39.11,
    lon: 117.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TIFR',
    StateC: 'IN',
    C: 'Government',
    TStart: '1945 Jun 1',
    TStop: '',
    name: 'Tata Inst. for Fundamental Research',
    Location: 'Mumbai',
    lat: 18.91,
    lon: 72.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TIGER',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '',
    name: 'Tiger Innovations, Inc.',
    Location: 'Herndon, Virginia',
    lat: 38.97,
    lon: -77.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TIS',
    StateC: 'US',
    C: 'Academic',
    TStart: '2010',
    TStop: '',
    name: 'Teachers in Space Inc.',
    Location: 'New York, New York',
    lat: 40.71,
    lon: -74.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TISPACE',
    StateC: 'TW',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Taiwan Innovative Space Inc.',
    Location: 'Zhunan, Maoli County',
    lat: 24.72,
    lon: 120.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TIT',
    StateC: 'J',
    C: 'Academic',
    TStart: '1881',
    TStop: '',
    name: 'Tokyo Kogyo Daigaku',
    Location: 'Tokyo:Meguro',
    lat: 35.51,
    lon: 139.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TJHS',
    StateC: 'US',
    C: 'Academic',
    TStart: '1985',
    TStop: '',
    name: 'Thomas Jefferson High School for Science and Technology',
    Location: 'Alexandria, Virginia',
    lat: 38.8,
    lon: -77.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TLS',
    StateC: 'F',
    C: 'Academic',
    TStart: '1961',
    TStop: '',
    name: 'Universite de Toulouse-Paul Sabatier (Rangueil)',
    Location: 'Toulouse:Rangueil',
    lat: 43.56,
    lon: 1.47,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TMI',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '1988',
    TStop: '2002',
    name: 'Telesat Mobile Inc.',
    Location: 'Ottawa:Gloucester, Ontario',
    lat: 45.44,
    lon: -75.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TMILES',
    StateC: 'US',
    C: 'Academic',
    TStart: '2015',
    TStop: '',
    name: 'Team Miles',
    Location: 'Tampa, Florida',
    lat: 27.97,
    lon: -82.48,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TMINUS',
    StateC: 'NL',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'T-Minus Engineering',
    Location: 'Delft',
    lat: 52.01,
    lon: 4.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TMSAT',
    StateC: 'T',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Thai Microsatellite Co. Ltd. (Mahanakorn UT)',
    Location: 'Bangkok',
    lat: 13.75,
    lon: 100.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TMTEL',
    StateC: 'TM',
    C: 'Government',
    TStart: '1991',
    TStop: '',
    name: 'Ministry of Communications of Turkmenistan',
    Location: 'Ashgabat',
    lat: 37.93,
    lon: 58.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TMU',
    StateC: 'J',
    C: 'Academic',
    TStart: '2005',
    TStop: '',
    name: 'Shuto Daigaku Tokyo',
    Location: 'Tokyo:Hachioji',
    lat: 35.67,
    lon: 139.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TMU',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '2005',
    name: 'Tokyo Toritsu Daigaku',
    Location: 'Tokyo:Hachioji',
    lat: 35.67,
    lon: 139.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TNO',
    StateC: 'NL',
    C: 'Government',
    TStart: '1932',
    TStop: '',
    name: 'Nederlandse Organisatie voor Toegepast Natuurwetenschappelijk Onderzoek',
    Location: 'Den Haag',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TNOR',
    StateC: 'N',
    C: 'Commercial',
    TStart: '1855',
    TStop: '',
    name: 'Telenor',
    Location: 'Oslo:Fornebu',
    lat: 59.88,
    lon: 10.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TNSA',
    StateC: 'TM',
    C: 'Government',
    TStart: '2011',
    TStop: '',
    name: 'Turkmenistanyn prezidentin yanynda Milli kosmos agentligi',
    Location: 'Ashgabat',
    lat: 37.93,
    lon: 58.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOHO',
    StateC: 'J',
    C: 'Academic',
    TStart: '1907',
    TStop: '',
    name: 'Tohoku daigaku',
    Location: 'Sendai, Tohoku',
    lat: 38.25,
    lon: 140.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOK',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Tokyo daigaku (Todai)',
    Location: 'Tokyo:Komaba',
    lat: 35.66,
    lon: 139.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOKAI',
    StateC: 'J',
    C: 'Academic',
    TStart: '1924',
    TStop: '',
    name: 'Tokai daigaku',
    Location: 'Tokyo:Shibuya',
    lat: 35.66,
    lon: 139.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TONG',
    StateC: 'TO',
    C: 'Commercial',
    TStart: '1993',
    TStop: '',
    name: 'Tongasat (Friendly Islands Satellite Co.)',
    Location: 'Nuku\'alofa',
    lat: -21.13,
    lon: -175.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TORP',
    StateC: 'I',
    C: 'Academic',
    TStart: '1906',
    TStop: '',
    name: 'Politecnico di Torino',
    Location: 'Torino',
    lat: 45.06,
    lon: 7.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOSH',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1966',
    TStop: '',
    name: 'Toshiba Komukai Works, Space Div',
    Location: 'Kawasaki City, Kanagawa',
    lat: 35.52,
    lon: 139.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOSHKE',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1966',
    TStop: '2001',
    name: 'Toshiba Keihin Works, Space Div',
    Location: 'Kawasaki City, Kanagawa',
    lat: 35.52,
    lon: 139.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOYA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1990',
    TStop: '',
    name: 'Toyama kenritsu daigaku',
    Location: 'Imizu, Toyama',
    lat: 36.71,
    lon: 137.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TOYON',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1980',
    TStop: '',
    name: 'Toyon Research Corporation',
    Location: 'Goleta, California',
    lat: 34.43,
    lon: -119.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TPS',
    StateC: 'US',
    C: 'Academic',
    TStart: '1980',
    TStop: '',
    name: 'The Planetary Society',
    Location: 'LA:Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TPU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1896',
    TStop: '',
    name: 'Tomskiy Politekhnicheskiy Universitet',
    Location: 'Tomsk',
    lat: 56.5,
    lon: 84.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TRACR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Tracor Aerospace',
    Location: 'Austin, Texas',
    lat: 30.27,
    lon: -97.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TRORB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '',
    name: 'TransOrbital, Inc',
    Location: 'San Diego:La Jolla,California',
    lat: 32.85,
    lon: -117.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NICP',
    StateC: 'N',
    C: 'Academic',
    TStart: '1972 Jan',
    TStop: '',
    name: 'Universitet i Tromso',
    Location: 'Tromso',
    lat: 69.68,
    lon: 18.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STADK',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'TRSI Club (Paul Kocyla)',
    Location: 'Aachen',
    lat: 50.78,
    lon: 6.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'STL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1958',
    TStop: '2002 Jul 1',
    name: 'TRW Inc.',
    Location: 'Redondo Beach, California',
    lat: 33.86,
    lon: -118.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ASTA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999 Jan',
    TStop: '2002',
    name: 'TRW Astro Aerospace, Carpinteria',
    Location: 'Carpinteria, California',
    lat: 34.4,
    lon: -119.52,
    alt: 0,
    Parent: 'TRW',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TRWC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'TRW Inc. Chantilly',
    Location: 'Chantilly, Virginia',
    lat: 38.88,
    lon: -77.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ESL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1978',
    TStop: '2001',
    name: 'TRW ESL Inc.',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'TRW',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TRWRC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1965',
    TStop: '1965',
    name: 'TRW Radio Club, Redondo Beach',
    Location: 'Los Angeles:Redondo Beach, California',
    lat: 33.86,
    lon: -118.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSAO',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1941',
    TStop: '',
    name: 'Tsentralniya Aerologicheskaya Observatoriya, GMS',
    Location: 'Moskva:Dolgoprudny',
    lat: 55.93,
    lon: 37.5,
    alt: 0,
    Parent: 'GMS',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSBM',
    StateC: 'RU',
    C: 'Commercial',
    TStart: '1990 Jul 13',
    TStop: '',
    name: 'Tsentral\'niy Bank RF',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSCJ',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1979',
    TStop: '1992 Oct',
    name: 'Telecommunications Satellite Corp of Japan',
    Location: 'Kimitsu',
    lat: 35.33,
    lon: 139.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSCO',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'The Spaceship Co. (Virgin Galactic/NGAS-Scaled)',
    Location: 'Mojave, California',
    lat: 35.05,
    lon: -118.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSEPT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'TriSept Corporation',
    Location: 'Chantilly, Virginia',
    lat: 38.88,
    lon: -77.4,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSHUA',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1911',
    TStop: '',
    name: 'Qinghua Daxue',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ARSL',
    StateC: 'SU',
    C: 'Government',
    TStart: '1949 Nov 21',
    TStop: '1965',
    name: 'KB Arsenal (TsKB-7) im MV Frunze',
    Location: 'Sankt-Peterburg (Leningrad)',
    lat: 59.94,
    lon: 30.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSSKB',
    StateC: 'SU',
    C: 'Government',
    TStart: '1967',
    TStop: '1974',
    name: 'TsKBEM Filial No. 3',
    Location: 'Samara',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: 'TSKBEM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB1',
    StateC: 'SU',
    C: 'Government',
    TStart: '1966 Mar 6',
    TStop: '1974',
    name: 'Tsentral\'niy KB Ekspermental\'novo Mashinostroeniya',
    Location: 'Korolev:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OKB52',
    StateC: 'SU',
    C: 'Military',
    TStart: '1966 Mar',
    TStop: '1983',
    name: 'TSKB Mashinostroenie',
    Location: 'Moskva:Reutov',
    lat: 55.75,
    lon: 37.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSKHM',
    StateC: 'RU',
    C: 'Military',
    TStart: '1969',
    TStop: '',
    name: 'TsNII Khimii i Mekhaniki',
    Location: 'Mosvka',
    lat: 55.68,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSKY',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2007 Oct',
    TStop: '',
    name: 'Telesat (former Loral Skynet), Ottawa',
    Location: 'Ottawa',
    lat: 45.42,
    lon: -75.68,
    alt: 0,
    Parent: 'TCAN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ATTS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2007 Oct',
    TStop: '',
    name: 'Telesat (former Loral Skynet)',
    Location: 'Bedminster, New Jersey',
    lat: 40.67,
    lon: -74.69,
    alt: 0,
    Parent: 'TCAN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LSKYB',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2007 Oct 31',
    TStop: '',
    name: 'Telesat Brasil Capacidade de Satelites Ltda.',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'TCAN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSLKY',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Twiggs Space Lab',
    Location: 'Morehead, Kentucky',
    lat: 38.19,
    lon: -83.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NII88',
    StateC: 'SU',
    C: 'Government',
    TStart: '1967',
    TStop: '1992',
    name: 'TsNIIMash (Tsenral\'niy NII Mashinostroeniya)',
    Location: 'Moskva:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NII88',
    StateC: 'RU',
    C: 'Government',
    TStart: '1992',
    TStop: '',
    name: 'TsNIIMash (Tsenral\'niy NII Mashinostroeniya)',
    Location: 'Moskva:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSN108',
    StateC: 'SU',
    C: 'Military',
    TStart: '1946',
    TStop: '1991',
    name: 'TsNII-108 GKRE (Zaslavskiy)',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSN108',
    StateC: 'SU',
    C: 'Military',
    TStart: '1991',
    TStop: '',
    name: 'TsNIRTI (Zaslavskiy)',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSPK',
    StateC: 'SU',
    C: 'Military',
    TStart: '1960',
    TStop: '2009 Jul 1',
    name: 'Tsentr Podgotovki Kosmonavtov im. Yu. A. Gagarina',
    Location: 'Zvyozdniy',
    lat: 55.87,
    lon: 38.12,
    alt: 0,
    Parent: 'VVS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSPK',
    StateC: 'RU',
    C: 'Government',
    TStart: '2009 Jul 1',
    TStop: '',
    name: 'Tsentr Podgotovki Kosmonavtov im. Yu. A. Gagarina',
    Location: 'Zvyozdniy',
    lat: 55.87,
    lon: 38.12,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSPZ',
    StateC: 'I',
    C: 'Commercial',
    TStart: '1965',
    TStop: '',
    name: 'Telespazio SpA',
    Location: 'Roma',
    lat: 41.89,
    lon: 12.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSSKB',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1974',
    TStop: '1996 Apr 12',
    name: 'Tsentral\'nogo Spetsializirovannogo Konstruktorskogo Byuro',
    Location: 'Samara (Kubyshev), Samara Oblast',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSSKB',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1996 Apr 12',
    TStop: '',
    name: 'GNPRKTs TsSKB-Progress',
    Location: 'Samara (Kubyshev), Samara Oblast',
    lat: 53.2,
    lon: 50.14,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSUK',
    StateC: 'J',
    C: 'Academic',
    TStart: '1972',
    TStop: '',
    name: 'Tsukuba Space Center (NASDA, JAXA)',
    Location: 'Tsukuba, Ibaraki',
    lat: 36.08,
    lon: 140.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1964 Oct',
    TStop: '1970 Mar',
    name: 'Tsentral\'noye Upravleniye Kosmicheskhikh Sredstv',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'MO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TSUKU',
    StateC: 'J',
    C: 'Academic',
    TStart: '1872',
    TStop: '',
    name: 'Tsukuba daigaku',
    Location: 'Tsukuba, Ibaraki',
    lat: 36.08,
    lon: 140.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VTS',
    StateC: 'RU',
    C: 'Military',
    TStart: '2010',
    TStop: '',
    name: 'Topografichecskaya Sluzhba Vooruzhyonnikh Sil RF',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TTU',
    StateC: 'EE',
    C: 'Academic',
    TStart: '1918',
    TStop: '',
    name: 'Tallinna Tehnikaulikool',
    Location: 'Tallinn',
    lat: 59.4,
    lon: 24.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TTY',
    StateC: 'FI',
    C: 'Academic',
    TStart: '1965',
    TStop: '',
    name: 'Tampereen teknillinen yliopisto',
    Location: 'Tampere:Hervanta, Pirkanmaa, Lansi,Suomen',
    lat: 61.45,
    lon: 23.86,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUAF',
    StateC: 'TR',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Turk Hava Kuvvetleri (Turkish Air Force), Cigli Air Base, Izmir',
    Location: 'Izmir',
    lat: 38.51,
    lon: 27.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUAFA',
    StateC: 'TR',
    C: 'Military',
    TStart: '1951',
    TStop: '',
    name: 'Hava Harp Okulu',
    Location: 'Istanbul:Yesilyurt',
    lat: 40.98,
    lon: 28.85,
    alt: 0,
    Parent: 'TUAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUB',
    StateC: 'D',
    C: 'Academic',
    TStart: '1989',
    TStop: '2014',
    name: 'Technische Universitat Berlin - TUBSAT Team',
    Location: 'Berlin',
    lat: 52.51,
    lon: 13.33,
    alt: 0,
    Parent: 'TUB1',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUB1',
    StateC: 'D',
    C: 'Academic',
    TStart: '1946 Apr 9',
    TStop: '',
    name: 'Technische Universitat Berlin',
    Location: 'Berlin',
    lat: 52.51,
    lon: 13.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUBI',
    StateC: 'D',
    C: 'Academic',
    TStart: '1477',
    TStop: '',
    name: 'Eberhard-Karls-Universitat Tubingen',
    Location: 'Tubingen, Baden:Wuttemberg',
    lat: 48.53,
    lon: 9.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUBT',
    StateC: 'TR',
    C: 'Academic',
    TStart: '1963 Jul',
    TStop: '',
    name: 'TUBITAK (Turkiye Bilimsel ve Teknolojik Arastirma Kurumu)',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUBTK',
    StateC: 'TR',
    C: 'Academic',
    TStart: '1985',
    TStop: '2006 May',
    name: 'TUBITAK-BILTEN (Bilgi Teknolojileri ve Elektronik Enstitusu)',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: 'TUBT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUBTK',
    StateC: 'TR',
    C: 'Academic',
    TStart: '2006 May',
    TStop: '',
    name: 'TUBITAK UZAY (Uzay Teknolojileri Arastirma Enstitusu)',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: 'TUBT',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUC',
    StateC: 'AR',
    C: 'Academic',
    TStart: '1914',
    TStop: '',
    name: 'Universidad Nacional de Tucuman (UNT)',
    Location: 'San Miguel de Tucuman, Tucuman',
    lat: -26.84,
    lon: -65.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUD',
    StateC: 'D',
    C: 'Academic',
    TStart: '1828',
    TStop: '',
    name: 'Technische Universitat Dresden',
    Location: 'Dresden, Sachsen',
    lat: 51.03,
    lon: 13.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUG',
    StateC: 'AT',
    C: 'Academic',
    TStart: '1811',
    TStop: '',
    name: 'Technische Universitat Graz',
    Location: 'Graz, Steiermark',
    lat: 47.07,
    lon: 15.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1994',
    TStop: '',
    name: 'Tethers Unlimited Inc (TUI)',
    Location: 'Seattle:Bothell, Washington',
    lat: 47.77,
    lon: -122.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUKE',
    StateC: 'SK',
    C: 'Academic',
    TStart: '1952',
    TStop: '',
    name: 'Technicka univezita v Kosiciach',
    Location: 'Kosice',
    lat: 48.73,
    lon: 21.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TULF',
    StateC: 'TR',
    C: 'Military',
    TStart: '1949',
    TStop: '',
    name: 'Turk Kara Kuvvetleri',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUM',
    StateC: 'D',
    C: 'Academic',
    TStart: '1868',
    TStop: '',
    name: 'Technische Universtitat Munchen',
    Location: 'Munchen',
    lat: 48.15,
    lon: 11.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUMD',
    StateC: 'MD',
    C: 'Academic',
    TStart: '1964',
    TStop: '',
    name: 'Universitatea Technica a Moldovei',
    Location: 'Chisinau',
    lat: 47.03,
    lon: 28.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUMED',
    StateC: 'KR',
    C: 'Commercial',
    TStart: '2004',
    TStop: '2010',
    name: 'SK Telecom TU Media',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.97,
    alt: 0,
    Parent: 'SKTEL',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TURAB',
    StateC: 'PR',
    C: 'Commercial',
    TStart: '1972',
    TStop: '',
    name: 'Universidad del Turabo',
    Location: 'Gurabo, Puerto Rico',
    lat: 18.25,
    lon: -65.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TURKP',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '1989',
    TStop: '1995',
    name: 'Turkish PTT',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TURKP',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '2004 Jul',
    TStop: '',
    name: 'Turksat Satellite Communication and Cable TV Operation AS',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TURKP',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '1995',
    TStop: '2004 Jul',
    name: 'Turk Telekomunikasyon AS',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUSAS',
    StateC: 'TR',
    C: 'Commercial',
    TStart: '1984',
    TStop: '',
    name: 'Turk Havacilik ve Uzay Sanayii AS (TUSAS)',
    Location: 'Ankara',
    lat: 39.93,
    lon: 32.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TUUT',
    StateC: 'TW',
    C: 'Academic',
    TStart: '1998',
    TStop: '',
    name: 'Taiwan Universities United Team , c/o China Inst. of Technology',
    Location: 'Taipei',
    lat: 25.03,
    lon: 121.61,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TXWC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1914',
    TStop: '1967',
    name: 'Schellinger Labs, Texas Western College, El Paso',
    Location: 'El Paso, Texas',
    lat: 31.77,
    lon: -106.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TYVAK',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2011',
    TStop: '',
    name: 'Tyvak Nanosatellite Systems LLC',
    Location: 'San Luis Obispo, California',
    lat: 35.27,
    lon: -120.66,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TYVI',
    StateC: 'I',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Tyvak International',
    Location: 'Torino',
    lat: 45.08,
    lon: 7.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TZJ',
    StateC: 'CN',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Tao Zhixing Jiaoyu jijin hui',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'U9900',
    StateC: 'IL',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Yachiyd 9900, IDF',
    Location: 'Tel Aviv',
    lat: 32.08,
    lon: 34.82,
    alt: 0,
    Parent: 'IDF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAB',
    StateC: 'US',
    C: 'Academic',
    TStart: '1969',
    TStop: '',
    name: 'University of Alabama at Birmingham',
    Location: 'Birmingham, Alabama',
    lat: 33.52,
    lon: -86.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1934',
    TStop: '1975 May 1',
    name: 'United Aircraft Corp.',
    Location: 'Hartford, Connecticut',
    lat: 41.76,
    lon: -72.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAEAF',
    StateC: 'UAE',
    C: 'Military',
    TStart: '1951',
    TStop: '',
    name: 'Al-Quwwat al-Musallaha li-Dawlat al-\'Imarat al-\'Arabiyyah al-Muttahidah',
    Location: 'Abu Dhabi',
    lat: 24.47,
    lon: 54.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAF',
    StateC: 'US',
    C: 'Academic',
    TStart: '1917',
    TStop: '',
    name: 'U. Alaska Fairbanks',
    Location: 'Fairbanks, Alaska',
    lat: 64.86,
    lon: -147.84,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAH',
    StateC: 'US',
    C: 'Academic',
    TStart: '1969',
    TStop: '',
    name: 'University of Alabama-Huntsville',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAHCM',
    StateC: 'US',
    C: 'Academic',
    TStart: '1985',
    TStop: '',
    name: 'UAH Consortium for Materials Development in Space',
    Location: 'Huntsville, Alabama',
    lat: 34.73,
    lon: -86.64,
    alt: 0,
    Parent: 'UAH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAP',
    StateC: 'PE',
    C: 'Academic',
    TStart: '1996',
    TStop: '',
    name: 'Universidad Alas Peruanas',
    Location: 'Lima',
    lat: -12.07,
    lon: -77.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAZ',
    StateC: 'US',
    C: 'Academic',
    TStart: '1885',
    TStop: '',
    name: 'University of Arizona-Tucson',
    Location: 'Tucson, Arizona',
    lat: 32.23,
    lon: -110.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UBC',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1915',
    TStop: '',
    name: 'University of British Columbia',
    Location: 'Vancouver:Point Grey, British Columbia',
    lat: 49.26,
    lon: -213.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UBIQ',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017 Jan',
    TStop: '2019 Oct',
    name: 'UbiquitiLink Inc.',
    Location: 'Falls Church, Virginia',
    lat: 38.89,
    lon: -77.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCAN',
    StateC: 'NZ',
    C: 'Academic',
    TStart: '1873',
    TStop: '',
    name: 'University of Cantebury',
    Location: 'Christchurgh:Ilam, New Zealand',
    lat: -43.52,
    lon: 172.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCB',
    StateC: 'US',
    C: 'Academic',
    TStart: '1868 Mar 23',
    TStop: '',
    name: 'University of California Berkeley',
    Location: 'Berkeley, California',
    lat: 37.87,
    lon: -122.26,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCD',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'University of California Davis',
    Location: 'Davis, California',
    lat: 38.54,
    lon: -121.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCF',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'University of Central Florida',
    Location: 'Orlando, Florida',
    lat: 28.6,
    lon: -81.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCH',
    StateC: 'CL',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Space and Planetary Exploration Lab, University of Chile',
    Location: 'Santiago, Chile',
    lat: -33.45,
    lon: -70.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCL',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1826',
    TStop: '',
    name: 'University College, London',
    Location: 'London:GowerSt',
    lat: 51.52,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCLA',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'University of California Los Angeles',
    Location: 'Los Angeles:Santa Monica, California',
    lat: 34.07,
    lon: -118.44,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCO',
    StateC: 'US',
    C: 'Academic',
    TStart: '1876',
    TStop: '',
    name: 'University of Colorado, Boulder',
    Location: 'Boulder, Colorado',
    lat: 40.01,
    lon: -105.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCSD',
    StateC: 'US',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'University of California San Diego',
    Location: 'San Diego:La Jolla, California',
    lat: 32.85,
    lon: -117.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCSFMC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1907',
    TStop: '',
    name: 'University of California, San Francisco Medical Center',
    Location: 'San Francisco, California',
    lat: 37.76,
    lon: -122.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCW',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1872',
    TStop: '1996',
    name: 'University College of Wales',
    Location: 'Aberystwyth, Wales',
    lat: 52.42,
    lon: -4.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UDAYT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1850',
    TStop: '',
    name: 'University of Dayton',
    Location: 'Dayton, Ohio',
    lat: 39.74,
    lon: -84.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UDEFA',
    StateC: 'MX',
    C: 'Military',
    TStart: '1975',
    TStop: '',
    name: 'Universidad del Ejercito y Fuerza Aerea Mexicanos',
    Location: 'Popotla, Mexico City',
    lat: 19.45,
    lon: -99.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UESTC',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1956',
    TStop: '',
    name: 'Dianzi keji daxue',
    Location: 'Chengdu, Sichuan',
    lat: 30.76,
    lon: 103.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UFA',
    StateC: 'CZ',
    C: 'Academic',
    TStart: '1964',
    TStop: '',
    name: 'Ustav fyziky atmosfery AV CR',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: 'ANCZ',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UFL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1853',
    TStop: '',
    name: 'University of Florida',
    Location: 'Gainesville, Florida',
    lat: 29.65,
    lon: -82.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UFSC',
    StateC: 'BR',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Universidade Federal de Santa Catarina',
    Location: 'Florianopolis, Santa Catarina',
    lat: 27.6,
    lon: -48.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UFSM',
    StateC: 'BR',
    C: 'Academic',
    TStart: '1960',
    TStop: '',
    name: 'Universidade Federal de Santa Maria',
    Location: 'Santa Maria, Rio Grande do Sul',
    lat: -29.71,
    lon: -53.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UGA',
    StateC: 'US',
    C: 'Academic',
    TStart: '1785',
    TStop: '',
    name: 'University of Georgia',
    Location: 'Athens, Georgia',
    lat: 33.96,
    lon: -83.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UGATU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1932',
    TStop: '',
    name: 'Ufimskiy Gosudarstvenniy Aviatsionniy Tekhnicheskiy Universitet',
    Location: 'Ufa, Bashkortostan (RU:BA)',
    lat: 54.73,
    lon: 55.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UHI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1907',
    TStop: '',
    name: 'University of Hawaii, Manoa',
    Location: 'Honolulu:Manoa, Oahu',
    lat: 21.3,
    lon: -157.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SUI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1964',
    TStop: '',
    name: 'University of Iowa (=SUI)',
    Location: 'Iowa CIty, Iowa',
    lat: 41.66,
    lon: -91.54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UIO',
    StateC: 'N',
    C: 'Academic',
    TStart: '1952',
    TStop: '1986',
    name: 'Uppsala Ionospheric Observatory',
    Location: 'Uppsala',
    lat: 59.86,
    lon: 17.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UIPRB',
    StateC: 'PR',
    C: 'Academic',
    TStart: '1956',
    TStop: '',
    name: 'Universidad Interamericana de Puerto Rico - Recinto de Bayamon',
    Location: 'Bayamon, Puerto Rico',
    lat: 18.35,
    lon: -66.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UITM',
    StateC: 'MY',
    C: 'Academic',
    TStart: '1956',
    TStop: '',
    name: 'Universiti Teknologi MARA',
    Location: 'Shah Alam, Selangor',
    lat: 3.07,
    lon: 101.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UIUC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1867',
    TStop: '',
    name: 'University of Illinois Urbana-Champaign',
    Location: 'Urbana/Champaign, Illinois',
    lat: 40.11,
    lon: -88.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UKMO',
    StateC: 'UK',
    C: 'Government',
    TStart: '1962',
    TStop: '2003',
    name: 'UK Meteorological Office, Air Ministry',
    Location: 'Bracknell',
    lat: 51.42,
    lon: -0.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UKRN',
    StateC: 'UK',
    C: 'Military',
    TStart: '1540',
    TStop: '1660',
    name: 'Navy Royal',
    Location: 'London, Admiralty',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UKRN',
    StateC: 'UK',
    C: 'Military',
    TStart: '1660',
    TStop: '',
    name: 'Royal Navy',
    Location: 'London, Admiralty',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UKS',
    StateC: 'US',
    C: 'Academic',
    TStart: '1865',
    TStop: '',
    name: 'University of Kansas',
    Location: 'Lawrence, Kansas',
    lat: 38.96,
    lon: -95.25,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'BNSC',
    StateC: 'UK',
    C: 'Government',
    TStart: '2010 Apr 1',
    TStop: '',
    name: 'UK Space Agency',
    Location: 'Swindon',
    lat: 51.56,
    lon: -1.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'RAFSO',
    StateC: 'UK',
    C: 'Military',
    TStart: '2016',
    TStop: '',
    name: 'UK Space Operations Centre, Royal Air Force High Wycombe',
    Location: 'High Wycombe',
    lat: 51.63,
    lon: -0.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UKTSB',
    StateC: 'UK',
    C: 'Government',
    TStart: '2007 Jul 1',
    TStop: '',
    name: 'Technology Strategy Board, Dept. for Business, Innovation and Skills',
    Location: 'Swindon',
    lat: 51.56,
    lon: -1.78,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UKWO',
    StateC: 'UK',
    C: 'Military',
    TStart: '1684',
    TStop: '1964',
    name: 'UK War Office',
    Location: 'London:Whitehall',
    lat: 51.5,
    lon: -0.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UKY',
    StateC: 'US',
    C: 'Academic',
    TStart: '1865',
    TStop: '',
    name: 'University of Kentucky',
    Location: 'Lexington, Kentucky',
    lat: 38.03,
    lon: -84.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ULAB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2006 Dec',
    TStop: '',
    name: 'United Launch Alliance/Boeing',
    Location: 'Denver:Centennial, Colorado',
    lat: 39.59,
    lon: -104.87,
    alt: 0,
    Parent: 'BOE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ULAD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2006',
    TStop: '',
    name: 'United Launch Alliance, Decatur',
    Location: 'Decatur, Alabama',
    lat: 34.61,
    lon: -86.98,
    alt: 0,
    Parent: 'ULAL',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ULAL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2006 Dec',
    TStop: '',
    name: 'United Launch Alliance/Lockheed Martin Astronautics',
    Location: 'Denver:Centennial, Colorado',
    lat: 39.59,
    lon: -104.87,
    alt: 0,
    Parent: 'LM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLII',
    StateC: 'US',
    C: 'Academic',
    TStart: '1999',
    TStop: '',
    name: 'University of Louisiana-Lafayette',
    Location: 'Lafayette, Louisiana',
    lat: 30.21,
    lon: -92.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ULM',
    StateC: 'D',
    C: 'Academic',
    TStart: '1967',
    TStop: '',
    name: 'Universitat Ulm',
    Location: 'Ulm, Baden:Wurttemburg',
    lat: 48.4,
    lon: 9.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMAL',
    StateC: 'US',
    C: 'Academic',
    TStart: '1975',
    TStop: '',
    name: 'University of Massachusetts Lowell',
    Location: 'Lowell, Massachusetts',
    lat: 42.64,
    lon: -71.33,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMARB',
    StateC: 'SI',
    C: 'Academic',
    TStart: '1975',
    TStop: '',
    name: 'Univerza v Mariboru',
    Location: 'Maribor',
    lat: 46.56,
    lon: 15.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMBC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1966',
    TStop: '',
    name: 'University of Maryland, Baltimore County',
    Location: 'Baltimore:Catonsville, Maryland',
    lat: 39.26,
    lon: -76.71,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMBRA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Umbra Labs',
    Location: 'Santa Barbara, California',
    lat: 34.42,
    lon: -119.7,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMD',
    StateC: 'US',
    C: 'Academic',
    TStart: '1856',
    TStop: '',
    name: 'University of Maryland',
    Location: 'College Park, Maryland',
    lat: 38.99,
    lon: -76.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1837',
    TStop: '',
    name: 'University of Michigan',
    Location: 'Ann Arbor, Michigan',
    lat: 42.28,
    lon: -83.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMIAMI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1925',
    TStop: '',
    name: 'University of Miami',
    Location: 'Coral Gables, Florida',
    lat: 25.72,
    lon: -80.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UMN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1861',
    TStop: '',
    name: 'University of Minnesota',
    Location: 'Minneapolis:St. Paul, Minnesota',
    lat: 44.97,
    lon: -93.24,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNAM',
    StateC: 'MX',
    C: 'Academic',
    TStart: '1910',
    TStop: '',
    name: 'Universidad Nacional Autonoma de Mexico (UNAM)',
    Location: 'Ciudad de Mexico',
    lat: 19.33,
    lon: -99.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNB',
    StateC: 'BR',
    C: 'Academic',
    TStart: '1962',
    TStop: '',
    name: 'Universidade de Brasilia',
    Location: 'Brasilia',
    lat: -15.76,
    lon: -47.87,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNCW',
    StateC: 'US',
    C: 'Academic',
    TStart: '1947',
    TStop: '',
    name: 'University of North Carolina, Wilmington',
    Location: 'Wilmington, North Carolina',
    lat: 34.23,
    lon: -77.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNH',
    StateC: 'US',
    C: 'Academic',
    TStart: '1866',
    TStop: '',
    name: 'University of New Hampshire',
    Location: 'Durham, New Hampshire',
    lat: 43.14,
    lon: -70.93,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNIPE',
    StateC: 'PE',
    C: 'Academic',
    TStart: '1876',
    TStop: '',
    name: 'Universidad Nacional de Ingenieria',
    Location: 'Lima:Rimac',
    lat: -12.02,
    lon: -77.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNIS',
    StateC: 'J',
    C: 'Academic',
    TStart: '2008',
    TStop: '',
    name: 'University Space Engineering Consortium',
    Location: 'Tokyo:Yayoi',
    lat: 35.72,
    lon: 139.76,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNITS',
    StateC: 'I',
    C: 'Academic',
    TStart: '1924',
    TStop: '',
    name: 'Universita degli Studi di Trieste',
    Location: 'Trieste, Friuli:Venezia Giulia',
    lat: 45.66,
    lon: 13.79,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNKCN',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Unknown Chinese operator',
    Location: '::',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1986 Apr 24',
    TStop: '1991',
    name: 'Upravleniye Nachalnika Kosmicheskikh Sredstv',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'MO',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'RU',
    C: 'Military',
    TStart: '1991',
    TStop: '1992',
    name: 'Upravleniye Nachalnika Kosmicheskikh Sredstv RF',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'RVSNR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNKJ',
    StateC: 'J',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Unknown (probably Japanese) cubesat operator',
    Location: 'Tokyo',
    lat: 35.71,
    lon: 139.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNKUS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Unknown US manufacturer (classified satellite)',
    Location: '::',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNKUS1',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Unknown US commercial operator',
    Location: '::',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNMC',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'COSMIAC, University of New Mexico-Albequerque',
    Location: 'Albequerque, New Mexico',
    lat: 35.08,
    lon: -106.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAU4',
    StateC: 'SU',
    C: 'Military',
    TStart: '1955 Mar',
    TStop: '1959',
    name: 'Upravlenie Nachal\'nika Reaktivnoy Vooruzhenie',
    Location: 'Moskva',
    lat: 55.72,
    lon: 37.67,
    alt: 0,
    Parent: 'GAU',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNSEEN',
    StateC: 'F',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'UnseenLabs SAS',
    Location: 'Rennes, Bretagne',
    lat: 48.11,
    lon: -1.68,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ONUSJ',
    StateC: 'AR',
    C: 'Academic',
    TStart: '1973',
    TStop: '',
    name: 'Universidad Nacional de San Juan',
    Location: 'Mendoza:San Juan',
    lat: -31.54,
    lon: -68.58,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNSW',
    StateC: 'AU',
    C: 'Academic',
    TStart: '2011',
    TStop: '',
    name: 'University of New South Wales Center for Space Eng. Research',
    Location: 'Sydney',
    lat: -33.92,
    lon: 151.23,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UNSWC',
    StateC: 'AU',
    C: 'Academic',
    TStart: '2011',
    TStop: '',
    name: 'University of New South Wales/Canberra',
    Location: 'Canberra',
    lat: -35.31,
    lon: 149.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SURREY',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1968',
    TStop: '1985',
    name: 'University of Surrey Dept. of Electronic and Electrical Eng.',
    Location: 'Guildford, Surrey',
    lat: 51.24,
    lon: -0.59,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UPAE',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'UP Aerospace',
    Location: 'Denver:Highlands Ranch, Colorado',
    lat: 39.54,
    lon: -104.97,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UPAEP',
    StateC: 'MX',
    C: 'Academic',
    TStart: '1973',
    TStop: '',
    name: 'Universidad Popular Autonoma del Estado de Puebla',
    Location: 'Ciudad Puebla, Puebla',
    lat: 19.05,
    lon: -98.22,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UPC',
    StateC: 'E',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Universitat Politecnica de Catalunya',
    Location: 'Barcelona, prov. Barcelona, CA Catalonia',
    lat: 41.39,
    lon: 2.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UPD',
    StateC: 'PH',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Pamantasan ng Pilipinas Diliman',
    Location: 'Quezon City/Diliman',
    lat: 14.65,
    lon: 121.05,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UPM',
    StateC: 'E',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Universita Politecnica de Madrid',
    Location: 'Madrid',
    lat: 40.45,
    lon: -3.73,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UPMIM',
    StateC: 'E',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Instituto Universitario de Microgravidad "Ingacio Da Riva", UPM',
    Location: 'Madrid',
    lat: 40.45,
    lon: -3.73,
    alt: 0,
    Parent: 'UPM',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UQU',
    StateC: 'AU',
    C: 'Academic',
    TStart: '1997',
    TStop: '',
    name: 'University of Queensland, Centre for Hypersonics',
    Location: 'Brisbane:St Lucia, Queensland',
    lat: -27.49,
    lon: 153.01,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'DEIMI',
    StateC: 'E',
    C: 'Commercial',
    TStart: '2015 Aug',
    TStop: '',
    name: 'UrtheCast Deimos Imaging',
    Location: 'Boecillo, Valladolid',
    lat: 41.53,
    lon: -4.7,
    alt: 0,
    Parent: 'URTHE',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'URTHE',
    StateC: 'CA',
    C: 'Commercial',
    TStart: '2013',
    TStop: '',
    name: 'UrtheCast',
    Location: 'Vancouver, British Columbia',
    lat: 49.25,
    lon: -123.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'URUGUS',
    StateC: 'UY',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'URUGUS S.A., Satellogic S.A., Montevideo satellite factory',
    Location: 'Montevideo',
    lat: -34.88,
    lon: -56.18,
    alt: 0,
    Parent: 'SATELOG',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'US7A',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US 7th Army (Germany), Pershing battalions',
    Location: 'Schwabisch Gmuend, Baden:Wurttemberg, Germany',
    lat: 48.8,
    lon: 9.8,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'US8A',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US 8th Army (Korea), ATACMS group',
    Location: 'Seoul:Yongsan',
    lat: 37.53,
    lon: 126.98,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USA',
    StateC: 'US',
    C: 'Military',
    TStart: '1775 Jun 14',
    TStop: '*',
    name: 'United States Army',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USAF',
    StateC: 'US',
    C: 'Military',
    TStart: '1947 Sep 18',
    TStop: '',
    name: 'United States Air Force',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USAFA',
    StateC: 'US',
    C: 'Military',
    TStart: '1954',
    TStop: '',
    name: 'United States Air Force Academy',
    Location: 'Colorado Springs, Colorado',
    lat: 39.01,
    lon: -104.89,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USAIC',
    StateC: 'US',
    C: 'Military',
    TStart: '1971',
    TStop: '',
    name: 'US Army Intelligence Center',
    Location: 'Fort Huachuca, Arizona',
    lat: 31.56,
    lon: -110.35,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'OCO',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '2009',
    name: 'United States Army Materiel Command',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USASC',
    StateC: 'US',
    C: 'Military',
    TStart: '1917',
    TStop: '',
    name: 'US Army Signal Corps, Ft Monmouth',
    Location: 'Ft Monmouth, New Jersey',
    lat: 40.31,
    lon: -74.05,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USCG',
    StateC: 'US',
    C: 'Military',
    TStart: '1915',
    TStop: '',
    name: 'US Coast Guard',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USCGR',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US Coast Guard Research and Development Center',
    Location: 'New London, Connecticut',
    lat: 41.36,
    lon: -72.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USCLA',
    StateC: 'US',
    C: 'Academic',
    TStart: '1880',
    TStop: '',
    name: 'University of Southern California',
    Location: 'Los Angeles:University Park, California',
    lat: 34.02,
    lon: -118.28,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USCMR',
    StateC: 'US',
    C: 'Academic',
    TStart: '1880',
    TStop: '',
    name: 'ISI-SERC, USC Marina Del Rey Campus',
    Location: 'Los Angeles:Marina Del Rey, California',
    lat: 33.98,
    lon: -118.44,
    alt: 0,
    Parent: 'USCLA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USDI',
    StateC: 'US',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'US Dept of the Interior, Bureau of Land Management',
    Location: 'Washington DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ACE',
    StateC: 'US',
    C: 'Military',
    TStart: '1972 Jul 1',
    TStop: '1996 Oct 1',
    name: 'Defense Mapping Agency, Topographic Center (DMATC)',
    Location: 'Bethesda, Maryland',
    lat: 38.98,
    lon: -77.11,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USEF',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1986',
    TStop: '2012 Mar',
    name: 'Zaidan houjin mujin uchuu jikken shisutemu kenkyuu kaihatsu kikou',
    Location: 'Tokyo:Chiyoda',
    lat: 35.69,
    lon: 139.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USERAR',
    StateC: 'CO',
    C: 'Academic',
    TStart: '1984',
    TStop: '',
    name: 'Universidad Sergio Arboleda',
    Location: 'Bogota',
    lat: 4.71,
    lon: -74.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USF',
    StateC: 'US',
    C: 'Academic',
    TStart: '1956',
    TStop: '',
    name: 'University of South Florida',
    Location: 'Tampa, Florida',
    lat: 28.0546,
    lon: -82.4131,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USGS',
    StateC: 'US',
    C: 'Government',
    TStart: '1973',
    TStop: '',
    name: 'US Geological Survey EROS Data Center',
    Location: 'Sioux Falls, South Dakota',
    lat: 43.54,
    lon: -96.73,
    alt: 0,
    Parent: 'USGSR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USGSR',
    StateC: 'US',
    C: 'Government',
    TStart: '1973',
    TStop: '',
    name: 'US Geological Survey (Reston)',
    Location: 'Reston, Virginia',
    lat: 38.95,
    lon: -77.35,
    alt: 0,
    Parent: 'USDI',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USHREP',
    StateC: 'US',
    C: 'Government',
    TStart: '1789 Mar',
    TStop: '',
    name: 'United States House of Representatives',
    Location: 'Washington DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USIN',
    StateC: 'US',
    C: 'Academic',
    TStart: '1965',
    TStop: '',
    name: 'University of Southern Indiana',
    Location: 'Evansville, Indiana',
    lat: 37.96,
    lon: -87.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USMA',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'US Military Academy, West Point',
    Location: 'West Point, New York',
    lat: 41.38,
    lon: -73.97,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USMC',
    StateC: 'US',
    C: 'Military',
    TStart: '1798',
    TStop: '',
    name: 'United States Marine Corps',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USN',
    StateC: 'US',
    C: 'Military',
    TStart: '1775',
    TStop: '',
    name: 'United States Navy',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNA',
    StateC: 'US',
    C: 'Military',
    TStart: '1845',
    TStop: '',
    name: 'US Naval Academy',
    Location: 'Annapolis, Maryland',
    lat: 39.97,
    lon: -76.5,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNAEG',
    StateC: 'US',
    C: 'Military',
    TStart: '1976',
    TStop: '',
    name: 'AEGIS TECHREP, Combat System Engineering Development Site (NAVSEA)',
    Location: 'Moorestown, New Jersey',
    lat: 39.98,
    lon: -74.9,
    alt: 0,
    Parent: 'NAVSEA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNB',
    StateC: 'US',
    C: 'Military',
    TStart: '1837',
    TStop: '1975',
    name: 'Boston Navy Yard, US Navy',
    Location: 'Charlestown, Massachusetts',
    lat: 42.38,
    lon: -71.05,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SPAWAR',
    StateC: 'US',
    C: 'Military',
    TStart: '1966 May 1',
    TStop: '1987',
    name: 'Navy Electronic Systems Command',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNMYP',
    StateC: 'US',
    C: 'Military',
    TStart: '1942',
    TStop: '',
    name: 'Naval Station Mayport',
    Location: 'Jacksonville, Florida',
    lat: 30.39,
    lon: -81.42,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNPH',
    StateC: 'US',
    C: 'Military',
    TStart: '1899',
    TStop: '',
    name: 'Naval Station Pearl Harbor',
    Location: 'Pearl Harbor, Hawaii',
    lat: 21.35,
    lon: -157.94,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNPS',
    StateC: 'US',
    C: 'Military',
    TStart: '1909',
    TStop: '',
    name: 'US Naval Postgraduate School',
    Location: 'Monterey, California',
    lat: 36.6,
    lon: -121.89,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNROT',
    StateC: 'US',
    C: 'Military',
    TStart: '1953',
    TStop: '',
    name: 'Naval Station Rota',
    Location: 'Rota, Cadiz, Spain',
    lat: 36.62,
    lon: -6.33,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1922',
    TStop: '',
    name: 'Naval Base San Diego',
    Location: 'San Diego, California',
    lat: 32.68,
    lon: -117.12,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNSP',
    StateC: 'US',
    C: 'Military',
    TStart: '1971 Jan 14',
    TStop: '1973 Jun',
    name: 'Navy Space Project Office, NAVMAT PM-16',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'NAVMAT',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNSP',
    StateC: 'US',
    C: 'Military',
    TStart: '1973 Jun',
    TStop: '',
    name: 'Navy Space Project Office, NESC PME-106 (NAVELEXSYSCOM)',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USNESC',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNSPO',
    StateC: 'US',
    C: 'Military',
    TStart: '1955',
    TStop: '1968',
    name: 'USN Special Projects Office (FBM)',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNSSD',
    StateC: 'US',
    C: 'Military',
    TStart: '1981',
    TStop: '',
    name: 'USN Space Systems Division, OP-943',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNSPO',
    StateC: 'US',
    C: 'Military',
    TStart: '1987',
    TStop: '',
    name: 'USN Strategic Systems Programs PMO (NAVPMOSSP)',
    Location: 'Sunnyvale, California',
    lat: 37.37,
    lon: -122.04,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNTB',
    StateC: 'US',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'USN TBMD office, OCNO',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNVA',
    StateC: 'US',
    C: 'Military',
    TStart: '1915',
    TStop: '',
    name: 'Naval Station Norfolk',
    Location: 'Norfolk, Virginia',
    lat: 36.95,
    lon: -76.31,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USNYOK',
    StateC: 'US',
    C: 'Military',
    TStart: '1945',
    TStop: '',
    name: 'United States Fleet Activities Yokosuka',
    Location: 'Yokosuka, Japan',
    lat: 35.29,
    lon: 139.67,
    alt: 0,
    Parent: 'USN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USPS',
    StateC: 'US',
    C: 'Government',
    TStart: '1971 Jul',
    TStop: '',
    name: 'US Postal Service, Philatelic Division',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USSEN',
    StateC: 'US',
    C: 'Government',
    TStart: '1789 Mar 4',
    TStop: '',
    name: 'United States Senate',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'AFSPC',
    StateC: 'US',
    C: 'Military',
    TStart: '2019 Dec 20',
    TStop: '',
    name: 'United States Space Force',
    Location: 'Washington, DC:Pentagon',
    lat: 38.87,
    lon: -77.06,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USSPC',
    StateC: 'US',
    C: 'Military',
    TStart: '1985',
    TStop: '2002',
    name: 'US Space Command',
    Location: 'Peterson SFB, Colorado',
    lat: 38.82,
    lon: -104.7,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USSPC',
    StateC: 'US',
    C: 'Military',
    TStart: '2019 Aug 29',
    TStop: '',
    name: 'US Space Command',
    Location: 'Peterson SFB, Colorado',
    lat: 38.82,
    lon: -104.7,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USSPC',
    StateC: 'US',
    C: 'Military',
    TStart: '2002',
    TStop: '2019 Aug 29',
    name: 'US Strategic Command',
    Location: 'Offutt AFB, Nebraska',
    lat: 41.12,
    lon: -95.91,
    alt: 0,
    Parent: 'DOD',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USTC',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1970',
    TStop: '',
    name: 'Zhongguo kexue jishu daxue',
    Location: 'Hefei, Anhui',
    lat: 31.87,
    lon: -117.28,
    alt: 0,
    Parent: 'CAS',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1959',
    TStop: '',
    name: 'Utah State University, Space Dynamics Lab, (SDL)',
    Location: 'Logan, Utah',
    lat: 41.74,
    lon: -111.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SLII',
    StateC: 'US',
    C: 'Academic',
    TStart: '1960',
    TStop: '1999',
    name: 'University of Southwest Louisiana',
    Location: 'Lafayette, Louisiana',
    lat: 30.21,
    lon: -92.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'USYD',
    StateC: 'AU',
    C: 'Academic',
    TStart: '1850',
    TStop: '',
    name: 'University of Sydney',
    Location: 'Sydney, New South Wales',
    lat: -33.89,
    lon: 151.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1883',
    TStop: '',
    name: 'University of Texas - Austin',
    Location: 'Austin, Texas',
    lat: 30.29,
    lon: -97.74,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTAT',
    StateC: 'CA',
    C: 'Academic',
    TStart: '2014',
    TStop: '',
    name: 'University of Toronto Aerospace Team',
    Location: 'Toronto, Ontario',
    lat: 43.75,
    lon: -79.47,
    alt: 0,
    Parent: 'UTIAS0',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1959',
    TStop: '1975 May 1',
    name: 'United Technology Corp',
    Location: 'San Jose, California',
    lat: 37.33,
    lon: -121.9,
    alt: 0,
    Parent: 'UAC',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UAC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1975 May 1',
    TStop: '',
    name: 'United Technologies Corp.',
    Location: 'Hartford, Connecticut',
    lat: 41.76,
    lon: -72.67,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'HASTD',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Jul',
    TStop: '2018 Nov',
    name: 'UTC Aerospace Systems (Windsor Locks)',
    Location: 'Windsor Locks, Connecticut',
    lat: 41.93,
    lon: -72.65,
    alt: 0,
    Parent: 'UTC2',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PKEL',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2012 Jul',
    TStop: '',
    name: 'ISR Systems, UTC Aerospace Systems, Danbury',
    Location: 'Danbury, Connecticut',
    lat: 41.4,
    lon: -73.47,
    alt: 0,
    Parent: 'UTC2',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTD',
    StateC: 'US',
    C: 'Academic',
    TStart: '1969',
    TStop: '',
    name: 'University of Texas-Dallas',
    Location: 'Dallas, Texas',
    lat: 32.99,
    lon: -96.75,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTE',
    StateC: 'EC',
    C: 'Academic',
    TStart: '1971',
    TStop: '',
    name: 'Universidad Tecnologica Equinoccial',
    Location: 'Quito',
    lat: -0.18,
    lon: -78.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'TXWC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1967',
    TStop: '',
    name: 'University of Texas -El Paso',
    Location: 'El Paso, Texas',
    lat: 31.77,
    lon: -106.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTIAS',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1998',
    TStop: '',
    name: 'UTIAS Space Flight Laboratory',
    Location: 'Toronto:York U. Heights',
    lat: 43.76,
    lon: -79.5,
    alt: 0,
    Parent: 'UTIAS0',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTIAS0',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1963',
    TStop: '',
    name: 'University of Toronto Inst. of Aerospace Studies',
    Location: 'Toronto:York U. Heights',
    lat: 43.76,
    lon: -79.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTMB',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'University of Texas Medical Branch',
    Location: 'Galveston, Texas',
    lat: 29.28,
    lon: -94.83,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTIAS0',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1949',
    TStop: '1963',
    name: 'University of Toronto Inst. of Aerophysics',
    Location: 'Toronto:York U. Heights',
    lat: 43.76,
    lon: -79.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTR',
    StateC: 'NL',
    C: 'Academic',
    TStart: '1636',
    TStop: '1974',
    name: 'Universiteit Utrecht',
    Location: 'Utrecht:De Uithof',
    lat: 52.09,
    lon: 5.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UTR',
    StateC: 'NL',
    C: 'Academic',
    TStart: '1974',
    TStop: '',
    name: 'Universiteit Utrecht, Dept. Natuur-en Sterrenkunde',
    Location: 'Utrecht:De Uithof',
    lat: 52.09,
    lon: 5.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UUT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1850',
    TStop: '',
    name: 'University of Utah',
    Location: 'Salt Lake City',
    lat: 40.77,
    lon: -111.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UVA',
    StateC: 'US',
    C: 'Academic',
    TStart: '1819',
    TStop: '',
    name: 'University of Virgina',
    Location: 'Charlottesville, Virginia',
    lat: 38.04,
    lon: -78.51,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UVG',
    StateC: 'GT',
    C: 'Academic',
    TStart: '1966',
    TStop: '',
    name: 'Universidad del Valle de Guatemala',
    Location: 'Guatemala City',
    lat: 14.605,
    lon: -90.49,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UVIE',
    StateC: 'AT',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Institute for Astronomie, Universitat Wien',
    Location: 'Wien',
    lat: 48.2,
    lon: 16.37,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UVSQ',
    StateC: 'F',
    C: 'Academic',
    TStart: '1991',
    TStop: '',
    name: 'Universite de Versailles Saint-Quentin-en-Yvelines',
    Location: 'Paris:Versailles',
    lat: 48.8,
    lon: 2.14,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UVT',
    StateC: 'US',
    C: 'Academic',
    TStart: '1791',
    TStop: '',
    name: 'University of Vermont',
    Location: 'Burlington, Vermont',
    lat: 44.48,
    lon: -73.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UWA',
    StateC: 'US',
    C: 'Academic',
    TStart: '1861',
    TStop: '',
    name: 'University of Washington',
    Location: 'Seattle, Washington',
    lat: 47.66,
    lon: -122.31,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UCW',
    StateC: 'UK',
    C: 'Academic',
    TStart: '1996',
    TStop: '2007 Sep',
    name: 'University of Wales, Aberystwyth',
    Location: 'Aberystwyth, Wales',
    lat: 52.42,
    lon: -4.07,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UWI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1848',
    TStop: '',
    name: 'University of Wisconsin',
    Location: 'Madison, Wisconsin',
    lat: 43.08,
    lon: -89.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'UWO',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1878',
    TStop: '',
    name: 'University of Western Ontario',
    Location: 'London, Ontario',
    lat: 43.01,
    lon: -81.27,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GAU4',
    StateC: 'SU',
    C: 'Military',
    TStart: '1953 Apr',
    TStop: '1955 Mar',
    name: 'Upravlenie Zam. Kom. Artill.',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'GAU',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VANDU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1873',
    TStop: '',
    name: 'Vanderbilt University',
    Location: 'Nashville, Tennessee',
    lat: 36.15,
    lon: -86.8,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VANST',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1995',
    TStop: '',
    name: 'Vanguard Space Technologies',
    Location: 'San Diego, California',
    lat: 32.72,
    lon: -117.16,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VAP',
    StateC: 'US',
    C: 'Academic',
    TStart: '1872',
    TStop: '',
    name: 'Virginia Polytechnic Institute and State University',
    Location: 'Blacksburg, Virginia',
    lat: 37.23,
    lon: -80.43,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VAST',
    StateC: 'VN',
    C: 'Government',
    TStart: '1975',
    TStop: '',
    name: 'Vien Khoa Hoc Va Cong Nghe Viet Name',
    Location: 'Ho Chi Minh CIty',
    lat: 10.8,
    lon: 106.65,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VATP',
    StateC: 'LV',
    C: 'Commercial',
    TStart: '2005',
    TStop: '',
    name: 'Ventspils Augsto Tehnologiju Parks',
    Location: 'Ventspils',
    lat: 57.39,
    lon: 21.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VSCFA',
    StateC: 'US',
    C: 'Government',
    TStart: '1995',
    TStop: '',
    name: 'Virginia Commercial Spaceflight Authority',
    Location: 'Norfolk, Virginia',
    lat: 36.9,
    lon: -76.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VDNKH',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1939',
    TStop: '',
    name: 'Vystavki Dostizheniy Narodnogo Khozyaystva',
    Location: 'Moskva, Rossiya',
    lat: 55.83,
    lon: 37.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VENT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '2016',
    name: 'Ventions LLC',
    Location: 'San Francisco',
    lat: 37.78,
    lon: -122.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VER',
    StateC: 'B',
    C: 'Commercial',
    TStart: '2005',
    TStop: '2010',
    name: 'Verheart Design and Development NV (VDD)',
    Location: 'Kruibeke',
    lat: 51.17,
    lon: 4.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VER',
    StateC: 'B',
    C: 'Commercial',
    TStart: '1984',
    TStop: '2005',
    name: 'Verhaert/SI',
    Location: 'Kruibeke',
    lat: 51.17,
    lon: 4.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VFW',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1964',
    TStop: '1969 Jan 1',
    name: 'Vereinigte Flugtechnische Werke (VFW)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VFW',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1980',
    TStop: '1981',
    name: 'Vereinigte Flugtechnische Werke (VFW)',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VFW',
    StateC: 'D',
    C: 'Commercial',
    TStart: '1969 Jan 1',
    TStop: '1980',
    name: 'Zentralgesellschaft VFW-Fokker GmbH',
    Location: 'Bremen',
    lat: 53.08,
    lon: 8.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VGLB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Virgin Galactic, Long Beach Facility',
    Location: 'Long Beach, California',
    lat: 33.77,
    lon: -118.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VGX',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2004',
    TStop: '',
    name: 'Virgin Galactic',
    Location: 'Pasadena, California',
    lat: 34.16,
    lon: -118.13,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VGXT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2021',
    TStop: '',
    name: 'Virgin Galactic passengers',
    Location: 'Upham, New Mexico',
    lat: 32.99,
    lon: -106.97,
    alt: 0,
    Parent: 'VGX',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VIA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2007',
    TStop: '',
    name: 'ViaSat Inc.',
    Location: 'Carlsbad, California',
    lat: 33.12,
    lon: -117.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VIGO',
    StateC: 'E',
    C: 'Academic',
    TStart: '1990',
    TStop: '',
    name: 'Universidade de Vigo',
    Location: 'Vigo, Galicia',
    lat: 42.17,
    lon: -8.69,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VILN',
    StateC: 'LT',
    C: 'Academic',
    TStart: '1579',
    TStop: '',
    name: 'Vilniaus universitetas',
    Location: 'Vilnius',
    lat: 54.68,
    lon: 25.29,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VISTE',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'VISIONA Tecnologia Espacial S.A. (Embraer/Telebras)',
    Location: 'Sao Jose de Campos',
    lat: -23.19,
    lon: -45.88,
    alt: 0,
    Parent: 'TELB',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VITA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1960',
    TStop: '2005',
    name: 'Volunteers in Technical Assistance',
    Location: 'Washington, DC:Arlington, Virginia',
    lat: 38.88,
    lon: -77.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VKI',
    StateC: 'B',
    C: 'Academic',
    TStart: '1956 Oct',
    TStop: '',
    name: 'Von Karman Institute for Fluid Dynamics',
    Location: 'Brussels/Sint-Genesius-Rode, Brabant',
    lat: 50.75,
    lon: 4.35,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'RU',
    C: 'Military',
    TStart: '1992 Aug 10',
    TStop: '1997 Jul',
    name: 'Voenno-Kosmicheskiye Sili (Military Space Forces)',
    Location: 'Mosvka:Solnechnogorsk, Rossiya',
    lat: 56.18,
    lon: 36.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'RU',
    C: 'Military',
    TStart: '1997 Jul',
    TStop: '2001 Jun 1',
    name: 'Voenno-Kosmicheskiye Sili (Military Space Forces), RVSN',
    Location: 'Mosvka:Solnechnogorsk, Rossiya',
    lat: 56.18,
    lon: 36.98,
    alt: 0,
    Parent: 'RVSN',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VMF',
    StateC: 'SU',
    C: 'Military',
    TStart: '1917',
    TStop: '1991 Dec',
    name: 'Voenno-Morskoy Flot SSSR',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VMF',
    StateC: 'RU',
    C: 'Military',
    TStart: '1991 Dec',
    TStop: '',
    name: 'Voenno-Morskoy Flot RF',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VNIEM',
    StateC: 'SU',
    C: 'Government',
    TStart: '1959',
    TStop: '1992',
    name: 'Vsesoyuzniy nauchno-issledovatel\'skiy institute elektromekhaniki',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'METP',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VNIEM',
    StateC: 'RU',
    C: 'Government',
    TStart: '2011 Dec 30',
    TStop: '',
    name: 'OAO NPK VNIIEM im. A.G. Iosif\'yan',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VNIEM',
    StateC: 'RU',
    C: 'Government',
    TStart: '1992',
    TStop: '2011 Dec 30',
    name: 'FGUP Vsesoyuzniy nauchno-issledovatel\'skiy institute elektromekhaniki (FKA)',
    Location: 'Moskva, Rossiya',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'FKA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VNPT',
    StateC: 'VN',
    C: 'Government',
    TStart: '1992',
    TStop: '',
    name: 'Tap Doan Buu Chinh Vien Thong Viet Nam',
    Location: 'Dong Da, Ha Noi',
    lat: 21.03,
    lon: 105.85,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VNSC',
    StateC: 'VN',
    C: 'Government',
    TStart: '2011 Sep',
    TStop: '',
    name: 'Trung tam Ve tinh Quoc gia, Vien Han Iam Khoa hoc va Cong nghe Viet Nam',
    Location: 'Ha Noi:Hoa Lac',
    lat: 21.03,
    lon: 105.85,
    alt: 0,
    Parent: 'VAST',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VOENT',
    StateC: 'RU',
    C: 'Military',
    TStart: '2012',
    TStop: '',
    name: 'Voentelekom',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VVS',
    StateC: 'RU',
    C: 'Military',
    TStart: '2015 Aug',
    TStop: '',
    name: 'Vozdushno-Kosmicheksiye Sili VS RF',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VORB',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Virgin Orbit LLC',
    Location: 'Long Beach, California',
    lat: 33.77,
    lon: -118.2,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VORO',
    StateC: 'RU',
    C: 'Unknown',
    TStart: '',
    TStop: '',
    name: 'Voronezh Mech. Zavod',
    Location: 'Voronezh',
    lat: 51.67,
    lon: 39.21,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VOTK',
    StateC: 'RU',
    C: 'Unknown',
    TStart: '',
    TStop: '',
    name: 'Votkinskiy Zavod',
    Location: 'Votkinsk, Udmurt Oblast',
    lat: 57.05,
    lon: 54,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'LTV',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1949',
    TStop: '1962',
    name: 'Chance Vought Aircraft (Missiles Div)',
    Location: 'Dallas:Grand Prairie, Texas',
    lat: 32.72,
    lon: -97.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1946',
    TStop: '1992',
    name: 'Vooruzhyonniye Sili SSSR',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VSHE',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1992',
    TStop: '',
    name: 'Natsional\'niy issledovatelsikiy universitet Vysshaya Shkola Ekonomiki',
    Location: 'Moskva',
    lat: 55.8,
    lon: 37.41,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VSSC',
    StateC: 'IN',
    C: 'Government',
    TStart: '1971',
    TStop: '',
    name: 'Vikram Sarabhai Space Center',
    Location: 'Trivandrum, Kerala',
    lat: 8.53,
    lon: 76.87,
    alt: 0,
    Parent: 'ISRO',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VTC',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'Vermont Technical College',
    Location: 'Randolph Center, Vermont',
    lat: 43.94,
    lon: -72.6,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VTS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1941',
    TStop: '1991',
    name: 'Voenno-Topograficheskaya Sluzhba Sovetskiy Amrii',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VTS',
    StateC: 'RU',
    C: 'Military',
    TStart: '1991',
    TStop: '2010',
    name: 'Voenno-Topografichecskaya Sluzhba Vooruzhyonnikh Sil Rossii',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VULT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1943',
    TStop: '1948 Jul',
    name: 'Consolidated Vultee Aircraft Corp., Downey (former Vultee AC)',
    Location: 'Downey, California',
    lat: 33.94,
    lon: -118.13,
    alt: 0,
    Parent: 'CONV',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'RU',
    C: 'Military',
    TStart: '2011 Dec 1',
    TStop: '2015',
    name: 'Voisk Vosdushno-Kosmicheskoi Oborona',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'GUKOS',
    StateC: 'RU',
    C: 'Military',
    TStart: '2015',
    TStop: '',
    name: 'Voisk Vosdushno-Kosmicheskoi Oborona, Vosdushno-Kosmocheskie Sili',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: 'VOKS',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VVS',
    StateC: 'SU',
    C: 'Military',
    TStart: '1918 May 24',
    TStop: '1992 May 7',
    name: 'Voenno-Vosdushniye Sili',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VVSBG',
    StateC: 'BG',
    C: 'Military',
    TStart: '1906',
    TStop: '',
    name: 'Voennovazdushni Sili B\'lgariya',
    Location: 'Sofia',
    lat: 42.68,
    lon: 23.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VVS',
    StateC: 'RU',
    C: 'Military',
    TStart: '1992 May 7',
    TStop: '',
    name: 'Voenno-Vosdushniye Sili Rossii',
    Location: 'Moskva',
    lat: 55.75,
    lon: 37.62,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VX4',
    StateC: 'US',
    C: 'Military',
    TStart: '1952',
    TStop: '1994',
    name: 'VX-4, Air Test and Evaluation Squadron 4',
    Location: 'Point Mugu, California',
    lat: 34.12,
    lon: -119.12,
    alt: 0,
    Parent: 'OPTEV',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'VZLU',
    StateC: 'CZ',
    C: 'Government',
    TStart: '1922',
    TStop: '',
    name: 'Vyzkumny a zkusebni letecky ustav',
    Location: 'Praha',
    lat: 50.08,
    lon: 14.42,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1948',
    TStop: '1951',
    name: 'Wright Air Development Center/Equipment Laboratory',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1951',
    TStop: '1961',
    name: 'Wright Air Development Division, ARDC',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WAKA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1949',
    TStop: '',
    name: 'Wakayama Daigaku',
    Location: 'Wakayama, Wakayama-ken',
    lat: 34.27,
    lon: 135.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WAML',
    StateC: 'US',
    C: 'Military',
    TStart: '1940',
    TStop: '1951',
    name: 'Wright Aeromedical Laboratory, WADC',
    Location: 'Wright-Patterson AFB, Dayton, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WARP',
    StateC: 'J',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Kabushikigaisha Wapusupesu',
    Location: 'Tsukuba',
    lat: 36.08,
    lon: 140.08,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WASEDA',
    StateC: 'J',
    C: 'Academic',
    TStart: '1902',
    TStop: '',
    name: 'Waseda Daigaku (Sodai)',
    Location: 'Tokyo:Shinjuku',
    lat: 35.71,
    lon: 139.72,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WBLU',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1998',
    TStop: '',
    name: 'WildBlue Communications Inc.',
    Location: 'Denver:Greenwood Village, Colorado',
    lat: 39.62,
    lon: -104.91,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WEB',
    StateC: 'US',
    C: 'Academic',
    TStart: '1889',
    TStop: '',
    name: 'Weber State Univ., Utah',
    Location: 'Ogden, Utah',
    lat: 41.19,
    lon: -111.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WEBC',
    StateC: 'US',
    C: 'Academic',
    TStart: '1982',
    TStop: '2002',
    name: 'CAST, Weber State Univ., Utah',
    Location: 'Ogden, Utah',
    lat: 41.19,
    lon: -111.94,
    alt: 0,
    Parent: 'WEB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WEHR',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht',
    Location: 'Berlin',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WEINA',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017 Aug',
    TStop: '',
    name: 'Beijing Weina xingkong keji YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WEISS',
    StateC: 'US',
    C: 'Academic',
    TStart: '',
    TStop: '',
    name: 'The Weiss School',
    Location: 'Palm Beach Gardens, Florida',
    lat: 26.85,
    lon: -80.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WELEC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1942',
    TStop: '1991',
    name: 'Western Electric Co. Burlington Works',
    Location: 'Burlington, North Carolina',
    lat: 36.09,
    lon: -79.45,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER271-1',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 271-1',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER444',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 444',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER485',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 485',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER485-1',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 485-1',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER485-2',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 485-2',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER485-3',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 485-3',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER500',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 500',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER836',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht Artillerie-Abteilung 836',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER836-1',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht Artillerie-Abteilung 1./836',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER836-2',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht Artillerie-Abteilung 2./836',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER836-3',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht Artillerie-Abteilung 3./836',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WER902',
    StateC: 'DR',
    C: 'Military',
    TStart: '1939',
    TStop: '1945',
    name: 'Wehrmacht unit 902',
    Location: ':',
    lat: 52.52,
    lon: 13.39,
    alt: 0,
    Parent: 'WEHR',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'SROE',
    StateC: 'UK',
    C: 'Commercial',
    TStart: '1965',
    TStop: '',
    name: 'Westland/Osborne Works (Saunders-Roe)',
    Location: 'Cowes, Isle of Wight',
    lat: 50.76,
    lon: -1.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARD',
    StateC: 'US',
    C: 'Government',
    TStart: '1974 Apr',
    TStop: '1981',
    name: 'NASA Wallops Flight Center',
    Location: 'Wallops Island, Virginia',
    lat: 37.84,
    lon: -75.49,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARD',
    StateC: 'US',
    C: 'Government',
    TStart: '1981',
    TStop: '',
    name: 'NASA Wallops Flight Facility',
    Location: 'Wallops Island, Virginia',
    lat: 37.84,
    lon: -75.49,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'PARD',
    StateC: 'US',
    C: 'Government',
    TStart: '1959 May',
    TStop: '1974 Apr',
    name: 'NASA Wallops Station',
    Location: 'Wallops Island, Virginia',
    lat: 37.84,
    lon: -75.49,
    alt: 0,
    Parent: 'NASA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WLOP',
    StateC: 'PL',
    C: 'Military',
    TStart: '1918',
    TStop: '',
    name: 'Wojska Lotnicze i Obrony Powietrznej',
    Location: 'Warsawa',
    lat: 52.23,
    lon: 21.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WNI',
    StateC: 'J',
    C: 'Commercial',
    TStart: '1996',
    TStop: '',
    name: 'Weathernews Inc.',
    Location: 'Tokyo:Chiba',
    lat: 35.61,
    lon: 140.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WORSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1990',
    TStop: '2008 Jul',
    name: 'Worldspace Inc.',
    Location: 'Washington D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WORSP',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008 Jul',
    TStop: '2010',
    name: '1worldspace Inc.',
    Location: 'Washington D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WPI',
    StateC: 'US',
    C: 'Academic',
    TStart: '1865',
    TStop: '',
    name: 'Worcester Polytechnic Institute',
    Location: 'Worcester, Massachusetts',
    lat: 42.27,
    lon: -71.81,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WRE',
    StateC: 'AU',
    C: 'Military',
    TStart: '1955',
    TStop: '1978',
    name: 'Weapons Research Establishment',
    Location: 'Adelaide:Salisbury, S Australia',
    lat: -34.76,
    lon: 138.64,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WADC',
    StateC: 'US',
    C: 'Military',
    TStart: '1944',
    TStop: '1948',
    name: 'Special Weapons Branch, Wright Field',
    Location: 'Wright Field, Ohio',
    lat: 39.82,
    lon: -84.05,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WTR',
    StateC: 'US',
    C: 'Military',
    TStart: '1979',
    TStop: '1997',
    name: 'USAF Western Space and Missile Center',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WSMR',
    StateC: 'US',
    C: 'Military',
    TStart: '1958 May 1',
    TStop: '',
    name: 'White Sands Missile Range',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WSMR',
    StateC: 'US',
    C: 'Military',
    TStart: '1945 Jul 9',
    TStop: '1958 May 1',
    name: 'White Sands Proving Ground',
    Location: 'White Sands, New Mexico',
    lat: 32.4,
    lon: -106.38,
    alt: 0,
    Parent: 'USA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WTA',
    StateC: 'US',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Washington Technology Associates',
    Location: 'Washington, D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WTR',
    StateC: 'US',
    C: 'Military',
    TStart: '1964',
    TStop: '1979',
    name: 'USAF Western Test Range',
    Location: 'Vandenberg SFB, California',
    lat: 34.75,
    lon: -120.61,
    alt: 0,
    Parent: 'USAF',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WUHAN',
    StateC: 'CN',
    C: 'Academic',
    TStart: '2015',
    TStop: '',
    name: 'Wuhan daxue yuhang kexue yujishu yanjiuyuan',
    Location: 'Wuhan, Hubei',
    lat: 30.54,
    lon: 114.36,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WUPP',
    StateC: 'D',
    C: 'Academic',
    TStart: '1972',
    TStop: '',
    name: 'Bergische Universit\\"at Gesamthochschule Wuppertal (BUGW)',
    Location: 'Wuppertal, NordRhein:Westphalen',
    lat: 51.25,
    lon: 7.15,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WURZ',
    StateC: 'D',
    C: 'Academic',
    TStart: '1582',
    TStop: '',
    name: 'Julius-Maximilians-Universitat Wurzburg',
    Location: 'Wurzburg, Bayern',
    lat: 49.79,
    lon: 9.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WUTC',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1971',
    TStop: '',
    name: 'Western Union Telegraph Corp.',
    Location: 'Upper Saddle River, New Jersey',
    lat: 41.06,
    lon: -74.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WVU',
    StateC: 'US',
    C: 'Academic',
    TStart: '1867',
    TStop: '',
    name: 'West Virginia University',
    Location: 'Morgantown, West Virginia',
    lat: 39.64,
    lon: -79.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'WXB',
    StateC: 'US',
    C: 'Government',
    TStart: '1958',
    TStop: '1965',
    name: 'US Weather Bureau',
    Location: 'Suitland, Maryland',
    lat: 38.85,
    lon: -76.92,
    alt: 0,
    Parent: 'DOC',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'NESC',
    StateC: 'US',
    C: 'Government',
    TStart: '1958',
    TStop: '1965',
    name: 'US Weather Bureau, Meteorological Satellite Lab',
    Location: 'Suitland, Maryland',
    lat: 38.85,
    lon: -76.92,
    alt: 0,
    Parent: 'WXB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'X20',
    StateC: 'US',
    C: 'Military',
    TStart: '1962',
    TStop: '1964',
    name: 'X-20 Pilot Group',
    Location: 'Edwards AFB, California',
    lat: 34.91,
    lon: -117.88,
    alt: 0,
    Parent: 'AFASD',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XCK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Xigua Chuangke',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XCOR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1999',
    TStop: '2013',
    name: 'XCOR Aerospace',
    Location: 'Mojave, California',
    lat: 35.05,
    lon: -118.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XCOR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013',
    TStop: '2017',
    name: 'XCOR Aerospace (California)',
    Location: 'Mojave, California',
    lat: 35.05,
    lon: -118.17,
    alt: 0,
    Parent: 'XCORT',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XCORT',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2013',
    TStop: '2017',
    name: 'XCOR Aerospace (Texas)',
    Location: 'Midland, Texas',
    lat: 32,
    lon: -102.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XCYS',
    StateC: 'CN',
    C: 'Government',
    TStart: '2017',
    TStop: '',
    name: 'Xi\'an cehui yanjiu suo',
    Location: 'Xi\'an, Shaaxni',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XIAM',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1921',
    TStop: '',
    name: 'Xiamen Daxue',
    Location: 'Xiamen, Fujian',
    lat: 24.44,
    lon: 118.09,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XIDI',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1931',
    TStop: '',
    name: 'Xian Dianzi Keji Daxue',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XIDO',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Xinghe Dongli (Beijing) kongjian keji YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XINWEI',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Xinwei tongxin jishu gufen youxian gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XIOPM',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Xi\'an guangxe jingmi jixie yanjiu suo',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XJRY',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016 Oct',
    TStop: '',
    name: 'Beijing xingji rongyao kongjian keji youxian gongsi',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XMR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1988',
    TStop: '2008 Jul',
    name: 'XM Satellite Radio Holdings (XM)',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XMR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2008 Jul',
    TStop: '',
    name: 'XM Satellite Radio Holdings (Sirius XM)',
    Location: 'Washington, DC',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: 'SIRX',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XTAR',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2001',
    TStop: '',
    name: 'XTAR LLC (Hisdesat/Loral)',
    Location: 'Rockville, Maryland',
    lat: 39.08,
    lon: -77.15,
    alt: 0,
    Parent: 'HISD/LOR',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XYUN',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Sanjiang Hangtian Xingyun Keji YG',
    Location: 'Hankou, Wuhan, Hubei',
    lat: 30.58,
    lon: 114.27,
    alt: 0,
    Parent: 'SANJ9',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'XZTIA',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2017',
    TStop: '',
    name: 'Xi\'an zhongke tianta keji gufen YG',
    Location: 'Xi\'an, Shaanxi',
    lat: 34.27,
    lon: 108.95,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YAHBR',
    StateC: 'BR',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Yahsat Brasil',
    Location: 'Rio de Janeiro',
    lat: -22.91,
    lon: -43.2,
    alt: 0,
    Parent: 'ALYAH',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YAZMI',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Yamzi USA',
    Location: 'Washington D.C.',
    lat: 38.9,
    lon: -77.02,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YERK',
    StateC: 'US',
    C: 'Academic',
    TStart: '1897',
    TStop: '',
    name: 'Yerkes Observatory',
    Location: 'Williams Bay, Wisconsin',
    lat: 42.57,
    lon: -88.54,
    alt: 0,
    Parent: 'CHIC',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YINSGH',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Beijing Yingshiruida Keji Gufen YG',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YINHE',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018',
    TStop: '',
    name: 'Yinhe hangtian',
    Location: 'Beijing-Haidian',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YKVZ',
    StateC: 'RU',
    C: 'Unknown',
    TStart: '1758',
    TStop: '',
    name: 'Ust\'-Katavskiy Vagonostroitel\'niy Zavod',
    Location: 'Ust\'-Katav (Chelyabinsk)',
    lat: 54.93,
    lon: 58.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YONS',
    StateC: 'KR',
    C: 'Academic',
    TStart: '1885',
    TStop: '',
    name: 'Yonsei Daehaggyo',
    Location: 'Seoul',
    lat: 37.57,
    lon: 126.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YORK',
    StateC: 'CA',
    C: 'Academic',
    TStart: '1959',
    TStop: '',
    name: 'York University',
    Location: 'Toronto, Ontario',
    lat: 43.77,
    lon: -79.5,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YORKSS',
    StateC: 'US',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'York Space Systems',
    Location: 'Denver, Colorado',
    lat: 39.76,
    lon: -104.88,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YSP',
    StateC: 'YE',
    C: 'Military',
    TStart: '1994',
    TStop: '1994',
    name: 'Al-Hizb Al-Ishtiraki Al-Yamani',
    Location: 'South Yemen',
    lat: 12.8,
    lon: 45.03,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YUZGU',
    StateC: 'RU',
    C: 'Academic',
    TStart: '1964',
    TStop: '',
    name: 'Yugo-Zapadniy gosudarstvenniy universitet',
    Location: 'Kursk',
    lat: 51.72,
    lon: 36.18,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YUZH',
    StateC: 'UA',
    C: 'Commercial',
    TStart: '1965',
    TStop: '',
    name: 'KB Yuzhnoe im. M K Yangel',
    Location: 'Dnepropetrovsk',
    lat: 48.45,
    lon: 34.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YUZHM',
    StateC: 'UA',
    C: 'Commercial',
    TStart: '1966',
    TStop: '',
    name: 'PO Yuzhniy Mashinostroitel\'niy Zavod',
    Location: 'Dnepropetrovsk',
    lat: 48.45,
    lon: 34.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.ENGINE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YWZB',
    StateC: 'CN',
    C: 'Government',
    TStart: '2020 Aug 10',
    TStop: '',
    name: 'Yaogan Weixing Zongti Bu',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: 'CAST',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZARM',
    StateC: 'D',
    C: 'Academic',
    TStart: '1985',
    TStop: '',
    name: 'Zentrum fur Angewandte Raumfahrttechnologie und Mikrogravitation',
    Location: 'Bremen, FH Bremen',
    lat: 53.08,
    lon: 8.8,
    alt: 0,
    Parent: 'BREM',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KHRU',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1951',
    TStop: '1960 Oct',
    name: 'Zavod 23, OKB Myasishchev',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: 'OKB23',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZAV47',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1941',
    TStop: '1961 Oct 15',
    name: 'Zavod No. 47',
    Location: 'Orenburg',
    lat: 51.78,
    lon: 55.1,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZAV88',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1946',
    TStop: '1966',
    name: 'Zavod No. 88',
    Location: 'Moskva:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'YUZHM',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1954',
    TStop: '1966',
    name: 'Zavod No. 586',
    Location: 'Dnepropetrovsk',
    lat: 48.45,
    lon: 34.98,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZC3B',
    StateC: 'CN',
    C: 'Military',
    TStart: '',
    TStop: '',
    name: 'Jiefangjun zongcan san bu',
    Location: 'Beijing:Xishan',
    lat: 39.99,
    lon: 116.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZDFH',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2006',
    TStop: '',
    name: 'Zhongguo Dongfanghong Weixing gufen youxian gongsi',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZAV88',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1966',
    TStop: '',
    name: 'Zavod Eksperimental\'novo Mashinostroeniya',
    Location: 'Moskva:Podlipki',
    lat: 55.93,
    lon: 37.82,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.UNKNOWN,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZFT',
    StateC: 'D',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Zentrum fur Telematik e.V.',
    Location: 'Wurzburg, Bayern',
    lat: 49.79,
    lon: 9.94,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZGWK',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2016',
    TStop: '',
    name: 'Zhong\'an Guotong Weixing Keji Kaifa YG',
    Location: 'Shenzhen',
    lat: 22.8,
    lon: 113.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZHEJ',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1897',
    TStop: '',
    name: 'Zhejiang Daxue (ZJU, Zheda)',
    Location: 'Hangzhou, Zhejiang',
    lat: 30.26,
    lon: 120.12,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZHELZ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2012',
    TStop: '',
    name: 'Zhejiang Lizhui Dianzi Keji YG',
    Location: 'Hangzhou, Zhejiang',
    lat: 30.25,
    lon: 120.17,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZHIX',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018 May 10',
    TStop: '',
    name: 'Beijing Zhixing Kongjian Keji YG',
    Location: 'Beijing:Changping',
    lat: 40.1,
    lon: 116.46,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZHONG',
    StateC: 'CN',
    C: 'Academic',
    TStart: '1924',
    TStop: '',
    name: 'Zhongshan Daxue',
    Location: 'Shenzhen',
    lat: 22.8,
    lon: 113.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZHUORB',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2015',
    TStop: '',
    name: 'Zhuhai Orbita Kongzhi gongcheng gufen youxian gongsi',
    Location: 'Zhuhai, Guangdong',
    lat: 22.28,
    lon: 113.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'KHRU',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1960 Oct',
    TStop: '1994',
    name: 'ZIKh (Zavod im. M.V. Khrunichev)',
    Location: 'Moskva:Fili',
    lat: 55.75,
    lon: 37.5,
    alt: 0,
    Parent: 'KBSAL',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZIMN',
    StateC: 'US',
    C: 'Commercial',
    TStart: '1959',
    TStop: '1963',
    name: 'Zimney Corp.',
    Location: 'Monrovia, California',
    lat: 34.15,
    lon: -118,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_VEHICLE_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZKXR',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '2018 May',
    TStop: '',
    name: 'Zhongke Xingrui keji (Beijing) YG',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZRWC',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Zhongguancun ruichen weixing chuangxin yingyong yanjiuyuan',
    Location: 'Beijing:Haidian',
    lat: 39.96,
    lon: 116.3,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZSU',
    StateC: 'UA',
    C: 'Military',
    TStart: '1991',
    TStop: '',
    name: 'Zbroini Syly Ukrainy',
    Location: 'Kyiv',
    lat: 50.45,
    lon: 30.52,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZVEZ',
    StateC: 'SU',
    C: 'Commercial',
    TStart: '1952',
    TStop: '',
    name: 'NPP Zvezda',
    Location: 'Tomilino, Moskov. Oblast',
    lat: 55.65,
    lon: 37.95,
    alt: 0,
    Parent: 'MOM',
    type: SpaceObjectType.PAYLOAD_MANUFACTURER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZWO',
    StateC: 'NL',
    C: 'Government',
    TStart: '1950',
    TStop: '1988',
    name: 'Organisatie voor Zuiver-Wetenschappelijk Onderzoek',
    Location: '\'s-Gravenhage',
    lat: 52.08,
    lon: 4.32,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.SUBORBITAL_PAYLOAD_OPERATOR,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZZB',
    StateC: 'CN',
    C: 'Military',
    TStart: '2016 Jan 1',
    TStop: '',
    name: 'ZRJ Zhanlue Zhichi Budui',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'PLA',
    type: SpaceObjectType.LAUNCH_AGENCY,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZTZM',
    StateC: 'BY',
    C: 'Commercial',
    TStart: '2009',
    TStop: '',
    name: 'Zavod Tochnoi Elektromekhaniki',
    Location: 'Minsk',
    lat: 53.9,
    lon: 27.57,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZXKJ',
    StateC: 'CN',
    C: 'Commercial',
    TStart: '',
    TStop: '',
    name: 'Zhongxing kongjian yaogan (jiangsu) weixing jishu fuwu YG',
    Location: 'Yizheng',
    lat: 32.28,
    lon: 119.19,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZXW',
    StateC: 'CN',
    C: 'Government',
    TStart: '2021 May',
    TStop: '',
    name: 'Zhongguo Weixing Wangluo Jituan YG',
    Location: 'Xiong\'an, Hebei',
    lat: 39.05,
    lon: 115.9,
    alt: 0,
    Parent: '',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZZB',
    StateC: 'CN',
    C: 'Military',
    TStart: '1998 Apr',
    TStop: '2016 Jan',
    name: 'Zhongguo Renmin Jiefangjun Zong Zhuangbei Bu',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'PLA',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    Code: 'ZZWYZ',
    StateC: 'CN',
    C: 'Government',
    TStart: '',
    TStop: '',
    name: 'Zhongguo ziyuan weixing yingyong zhongxin',
    Location: 'Beijing',
    lat: 39.92,
    lon: 116.38,
    alt: 0,
    Parent: 'GZB',
    type: SpaceObjectType.PAYLOAD_OWNER,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  // Additional Locations

  // https://gssc.esa.int/navipedia/images/5/5d/Galileo_s_Global_Ground_Segment.jpg
  new ControlSite({
    Code: 'GGS',
    StateC: '',
    C: '',
    TStart: '',
    TStop: '',
    Location: 'Fucino Italy',
    Parent: '',
    name: 'Galileo Ground Station', // https://www.esa.int/Applications/Navigation/Galileo/Galileo_IOV_ground_stations_Fucino
    type: SpaceObjectType.CONTROL_FACILITY,
    lat: 41.978,
    lon: 13.604,
    alt: 0,
    linkAehf: false,
    linkWgs: false,
    linkGPS: false,
    linkGalileo: true,
    linkBeidou: false,
    linkGlonass: false,
  }),

  new ControlSite({
    name: 'Ramstein Air Base, Germany',
    type: SpaceObjectType.CONTROL_FACILITY,
    Code: 'RAM',
    StateC: '',
    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 49.44072898,
    lon: 7.59974957,
    alt: 0.236,
    linkAehf: true,
    linkWgs: true,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    name: 'Osan Air Base, South Korea',
    type: SpaceObjectType.CONTROL_FACILITY,
    Code: '',
    StateC: '',
    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 37.08996594,
    lon: 127.03177929,
    alt: 0.009,
    linkAehf: true,
    linkWgs: true,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),
  new ControlSite({
    name: 'Al Udeid Air Base, Qatar',
    type: SpaceObjectType.CONTROL_FACILITY,
    Code: '',
    StateC: '',
    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 25.1180877,
    lon: 51.32117271,
    alt: 0.036,
    linkAehf: true,
    linkWgs: true,
    linkGPS: false,
    linkGalileo: false,
    linkBeidou: false,
    linkGlonass: false,
  }),

  /*
   * Starlink Gatways
   * https://www.google.com/maps/d/viewer?mid=1H1x8jZs8vfjy60TvKgpbYs_grargieVw
   */
  new ControlSite({
    name: 'Conrad Gateway, Montana', // https://www.esa.int/Applications/Navigation/Galileo/Galileo_IOV_ground_stations_Fucino
    Code: 'CMTG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 48.203306,
    lon: -111.945278,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Loring Gateway, Maine',
    Code: 'LMEG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 46.91491700000001,
    lon: -67.91952799999999,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Redmon Gateway, Washington',
    Code: 'RWAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 47.694194,
    lon: -122.032139,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Greenville Gateway, Pennsylvania',
    Code: 'GPAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 41.43355599999999,
    lon: -80.33322199999999,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Merrillan Gateway, Wisconsin', // https://fcc.report/IBFS/SES-LIC-20190906-01171
    Code: 'GPAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 41.43355599999999,
    lon: -80.33322199999999,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Kalama Gateway, Washington',
    Code: 'KWAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 46.03897220000004,
    lon: -122.8082222,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Hawthorne Gateway, California',
    Code: 'HCAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 33.91750000000001,
    lon: -118.32811099999999,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Arbuckle Gateway, California',
    Code: 'ACAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 39.05700000000001,
    lon: -122.06000000000002,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Beekmantown Gateway, New York',
    Code: 'BNYG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 42.14548281389402,
    lon: -75.14151331143981,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Charleston Gateway, Oregon',
    Code: 'CORG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 43.24841700000003,
    lon: -124.381194,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Coalville Gateway, Utah',
    Code: 'CUTG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 40.94305600000004,
    lon: -111.285,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Panaca Gateway, Nevada',
    Code: 'PNVG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 37.78363900000003,
    lon: -114.69269399999999,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Boca Chica Gateway, Texas',
    Code: 'BTXG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 25.990694000000012,
    lon: -97.18274999999998,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'McGregor Gateway, Texas',
    Code: 'MTXG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 31.404917000000008,
    lon: -97.438139,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Litchfield Gateway, Connecticut',
    Code: 'LCTG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 42.14548281389402,
    lon: -75.14151331143981,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Warren Gateway, Missouri',
    Code: 'WMOG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 38.63516700000001,
    lon: -91.11602799999999,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Nemaha Gateway, Nebraska',
    Code: 'NNEG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 40.333667000000005,
    lon: -95.815278,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Manistique Gateway, Michigan',
    Code: 'MMIG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 45.908611,
    lon: -86.483583,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Slope County Gateway, North Dakota',
    Code: 'SNDG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 46.40838900000001,
    lon: -103.114583,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Los Angeles Gateway, California',
    Code: 'LCAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 34.604027999999985,
    lon: -117.45436100000003,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Cass County Gateway, North Dakota',
    Code: 'CNDG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 47.15169400000003,
    lon: -97.408889,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Prudhoe Bay Gateway, Alaska',
    Code: 'PAKG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 70.24655600000001,
    lon: -148.569,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Sanderson Gateway, Texas',
    Code: 'STXG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 30.193999999999996,
    lon: -102.89000000000001,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Springer Gateway, Oklahoma',
    Code: 'SOKG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 34.2685,
    lon: -97.213167,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Hitterdal Gateway, Montana',
    Code: 'HMNG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 46.978916999999996,
    lon: -96.25802800000001,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Tionesta Gateway, California',
    Code: 'TCAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 41.644,
    lon: -121.32997199999998,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Butte Gateway, Montana',
    Code: 'BMTG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 45.92405600000001,
    lon: -112.513194,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Colburn Gateway, Idaho',
    Code: 'CIDG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 48.34524999999999,
    lon: -116.43933300000002,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Baxley Gateway, Georgia',
    Code: 'BGAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 31.68216700000003,
    lon: -82.26897199999999,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Robertsdale Gateway, Alabama',
    Code: 'RALG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 30.567000000000025,
    lon: -87.646,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Roll Gateway, Arizona',
    Code: 'RAZG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 32.815500000000036,
    lon: -113.798056,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Prosser Gateway, Washington',
    Code: 'PWAG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 46.12727800000001,
    lon: -119.68430499999997,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Vernon Gateway, Utah',
    Code: 'VUTG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 40.07622200000002,
    lon: -112.35472200000001,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Inman Gateway, Kansas',
    Code: 'IKSG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 38.229000000000006,
    lon: -97.921972,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Evanston Gateway, Wyoming',
    Code: 'EWYG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 41.0925,
    lon: -110.842611,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Punta Gorda Gateway, Florida',
    Code: 'PFLG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 27.019667000000005,
    lon: -81.762028,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Tracy City Gateway, Tennessee',
    Code: 'TTNG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 35.19724999999999,
    lon: -85.666,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Kuparuk Gateway, Alaska',
    Code: 'KAKG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 70.31766700000001,
    lon: -148.941194,
    alt: 0,
    linkStarlink: true,
  }),
  new ControlSite({
    name: 'Gaffney Gateway, South Carolina',
    Code: 'GSCG',
    type: SpaceObjectType.CONTROL_FACILITY,

    StateC: '',

    C: '',
    TStart: '',
    TStop: '',
    Location: '',
    Parent: '',
    lat: 34.98530599999997,
    lon: -81.733083,
    alt: 0,
    linkStarlink: true,
  }),
];
